import React, { useRef, useState, useEffect, useContext, createElement, Component, forwardRef, useImperativeHandle, Fragment, useReducer, useCallback, useMemo } from 'react';
import { connect as connect$1, useDispatch, useSelector } from 'react-redux';
import { compose, applyMiddleware, createStore, combineReducers } from 'redux';
import styled, { css } from 'styled-components';
import { Message, Transition, Dimmer, Loader, Button, Icon, Input as Input$1, Label, Popup, Form as Form$1, Checkbox as Checkbox$1, Dropdown as Dropdown$1, Radio, TextArea as TextArea$1, Table as Table$1, List, Sidebar, Portal, Header, Menu, Divider, Modal as Modal$1, Breadcrumb as Breadcrumb$1, Pagination as Pagination$1 } from 'semantic-ui-react';
import { Route, Redirect, Switch, withRouter, Link, matchPath } from 'react-router-dom';
import moment from 'moment';
import reactDom, { findDOMNode } from 'react-dom';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator$1(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

function _toArray$1(arr) {
  return _arrayWithHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableRest$1();
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit$1(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toPrimitive$1(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");

  return _typeof(key) === "symbol" ? key : String(key);
}

var AbortProvider = /*#__PURE__*/function () {
  function AbortProvider() {
    var _this = this;

    _classCallCheck$1(this, AbortProvider);

    _defineProperty$1(this, "_aborted", false);

    _defineProperty$1(this, "_reason", undefined);

    _defineProperty$1(this, "_controller", void 0);

    _defineProperty$1(this, "_callbacks", []);

    _defineProperty$1(this, "abort", function (reason) {
      var _this$_controller;

      _this._aborted = true;
      _this._reason = reason;
      (_this$_controller = _this._controller) === null || _this$_controller === void 0 ? void 0 : _this$_controller.abort();

      _this._callbacks.forEach(function (c) {
        return c(reason);
      });
    });

    _defineProperty$1(this, "reset", function () {
      _this._aborted = false;
      _this._reason = undefined;
    });

    _defineProperty$1(this, "addListener", function (callback) {
      _this._callbacks.push(callback);
    });

    _defineProperty$1(this, "removeListener", function (callback) {
      _this._callbacks.filter(function (c) {
        return c !== callback;
      });
    });

    if (AbortController === undefined) return;
    this._controller = new AbortController();
  }

  _createClass$1(AbortProvider, [{
    key: "signal",
    get: function get() {
      var _this$_controller2;

      return (_this$_controller2 = this._controller) === null || _this$_controller2 === void 0 ? void 0 : _this$_controller2.signal;
    }
  }, {
    key: "aborted",
    get: function get() {
      return this._aborted;
    }
  }, {
    key: "reason",
    get: function get() {
      return this._reason;
    }
  }]);

  return AbortProvider;
}();

var NAMESPACE = "ABORT";
var ABORTABLE_PROVIDER = "".concat(NAMESPACE, "/PROVIDER");

var abortableApi = function abortableApi(action) {
  return {
    type: ABORTABLE_PROVIDER,
    abort: new AbortProvider(),
    action: action
  };
};

var defaultOptions = {
  lazy: true,
  actionSlowDelay: 200
};
/**
 * A hook to trigger an existing API action
 * @param {function} `action` API action creator
 * @param {object} `options` Additional options for the API request
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {number} `options.actionSlowDelay` Optional, time delay before the request indicates it is taking a long time, default 200ms
 * @param {*} `options.actionParams` Optional, additonal parameters to supply to the request action
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiAction = function useApiAction(action) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _options = _objectSpread2$1(_objectSpread2$1({}, defaultOptions), options);

  var loadingKey = useRef(0);
  var loadingAbort = useRef(undefined);

  var _useState = useState({
    busy: false,
    aborted: false
  }),
      _useState2 = _slicedToArray$1(_useState, 2),
      requestState = _useState2[0],
      setRequestState = _useState2[1];

  var dispatch = useDispatch();

  var sendRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var actionParams,
          requestKey,
          requestAction,
          abort,
          slowTimeout,
          _yield$dispatch,
          success,
          response,
          error,
          aborted,
          _args = arguments;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              actionParams = _args.length > 0 && _args[0] !== undefined ? _args[0] : _options.actionParams;
              requestKey = loadingKey.current = Date.now();
              requestAction = abortableApi(action(actionParams));
              abort = requestAction.abort;
              loadingAbort.current = abort;
              setRequestState({
                busy: true,
                aborted: abort.aborted,
                sentAt: Date.now()
              });
              slowTimeout = setTimeout(function () {
                setRequestState(function (state) {
                  return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
                    slow: true
                  });
                });
              }, _options.actionSlowDelay);
              _context.next = 9;
              return dispatch(requestAction);

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              response = _yield$dispatch.response;
              error = _yield$dispatch.error;
              aborted = abort.aborted;
              clearTimeout(slowTimeout); // prevent request race conditions

              if (!(requestKey !== loadingKey.current)) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return");

            case 17:
              setRequestState(function (state) {
                return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
                  success: success,
                  response: response,
                  error: error,
                  busy: false,
                  slow: false,
                  aborted: aborted,
                  receivedAt: aborted ? undefined : Date.now(),
                  abortedAt: aborted ? Date.now() : undefined
                });
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendRequest() {
      return _ref.apply(this, arguments);
    };
  }();

  var abortRequest = function abortRequest() {
    var _loadingAbort$current;

    (_loadingAbort$current = loadingAbort.current) === null || _loadingAbort$current === void 0 ? void 0 : _loadingAbort$current.abort();
  };

  useEffect(function () {
    if (!_options.lazy) sendRequest();
  }, []);
  return [requestState, sendRequest, abortRequest];
};

var strictUriEncode = function strictUriEncode(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */


var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

function encoderForArrayFormat(opts) {
  switch (opts.arrayFormat) {
    case 'index':
      return function (key, value, index) {
        return value === null ? [encode(key, opts), '[', index, ']'].join('') : [encode(key, opts), '[', encode(index, opts), ']=', encode(value, opts)].join('');
      };

    case 'bracket':
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '[]=', encode(value, opts)].join('');
      };

    default:
      return function (key, value) {
        return value === null ? encode(key, opts) : [encode(key, opts), '=', encode(value, opts)].join('');
      };
  }
}

function encode(value, opts) {
  if (opts.encode) {
    return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
  }

  return value;
}

var stringify = function stringify(obj, opts) {
  var defaults = {
    encode: true,
    strict: true,
    arrayFormat: 'none'
  };
  opts = objectAssign(defaults, opts);

  if (opts.sort === false) {
    opts.sort = function () {};
  }

  var formatter = encoderForArrayFormat(opts);
  return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key, opts);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.slice().forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }

        result.push(formatter(key, val2, result.length));
      });
      return result.join('&');
    }

    return encode(key, opts) + '=' + encode(val, opts);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : '';
};

var EventType;

(function (EventType) {
  EventType["Success"] = "Success";
  EventType["Info"] = "Info";
  EventType["Warning"] = "Warning";
  EventType["Error"] = "Error";
})(EventType || (EventType = {}));

var AddMethod;

(function (AddMethod) {
  AddMethod["AddTop"] = "AddTop";
  AddMethod["AddOrReplaceTop"] = "AddOrReplaceTop";
})(AddMethod || (AddMethod = {}));

var ADD = "NOTIFICATIONS/ADD";
var REMOVE = "NOTIFICATIONS/REMOVE";
var REMOVE_ALL = "NOTIFICATIONS/REMOVE_ALL";
/**
 * Action creator for sending a notification
 * @param {Object} `options` Options for the notification
 * @param {string} `options.title` The notification title text
 * @param {string} `options.eventType` The type of notification
 * @param {string} `options.message` The notification message text
 * @param {*} `options.customData` Optional custom data about the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear
 * @param {string} `options.method` How the notification is added. Options are "AddTop" and "AddOrReplaceTop". Defaults to "AddOrReplaceTop"
 */

var addNotification = function addNotification(options) {
  return function (dispatch) {
    var _options$title, _options$type, _options$message, _options$expiry, _options$method;

    return dispatch({
      type: ADD,
      title: (_options$title = options.title) !== null && _options$title !== void 0 ? _options$title : "",
      eventType: (_options$type = options.type) !== null && _options$type !== void 0 ? _options$type : EventType.Info,
      message: (_options$message = options.message) !== null && _options$message !== void 0 ? _options$message : "",
      customData: options.customData !== undefined ? options.customData : null,
      expiry: (_options$expiry = options.expiry) !== null && _options$expiry !== void 0 ? _options$expiry : 0,
      method: (_options$method = options.method) !== null && _options$method !== void 0 ? _options$method : AddMethod.AddOrReplaceTop
    });
  };
};
/**
 * Action creator for removing a single notification
 * @param {number} `id` The unique id of the notification event to remove
 */


var removeNotification = function removeNotification(id) {
  return function (dispatch) {
    return dispatch({
      type: REMOVE,
      id: id
    });
  };
};
/**
 * Action creator for clearing all notifications
 */


var removeAllNotifications = function removeAllNotifications() {
  return function (dispatch) {
    return dispatch({
      type: REMOVE_ALL
    });
  };
};
/**
 * Action creator for sending a success message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */


var notifySuccess = function notifySuccess(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    message: message,
    type: EventType.Success,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending an information message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */


var notifyInfo = function notifyInfo(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    message: message,
    type: EventType.Info,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending a warning message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear, defaults to 10 seconds
 */


var notifyWarning = function notifyWarning(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    message: message,
    type: EventType.Warning,
    expiry: options.expiry || 10000
  }));
};
/**
 * Action creator for sending an error message notification
 * @param {string} `message` Notification message text
 * @param {Object} `options` Additional options for the notification
 * @param {number} `options.expiry` Optional, expiry time in milliseconds for the notification to appear
 */


var notifyError = function notifyError(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return addNotification(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    message: message,
    type: EventType.Error
  }));
};

var getNotificationState = function getNotificationState(state) {
  return state.notifications;
};

var debounce = function debounce(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;
      if (!options.immediate) func.apply(context, args);
    };

    var callNow = options.immediate && !timeout;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

var DebounceMap = /*#__PURE__*/function () {
  function DebounceMap() {
    _classCallCheck$1(this, DebounceMap);

    _defineProperty$1(this, "_config", {});

    _defineProperty$1(this, "_debounces", {});
  }

  _createClass$1(DebounceMap, [{
    key: "_registerDebounce",
    value: function _registerDebounce(key) {
      var timeout;
      var config = this._config;
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var context = this;
        var options = config[key].options || {};

        var later = function later() {
          timeout = null;

          if (!options.immediate) {
            config[key].func.apply(context, args);
          }
        };

        var callNow = options.immediate && !timeout;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, config[key].wait);
        if (callNow) config[key].func.apply(context, args);
      };
    }
  }, {
    key: "debounce",
    value: function debounce(key, func, wait) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this._config[key] = {
        func: func,
        wait: wait,
        options: options
      };

      if (!this._debounces[key]) {
        this._debounces[key] = this._registerDebounce(key);
      }

      this._debounces[key]();
    }
  }]);

  return DebounceMap;
}();

var isPlainObject = function isPlainObject(value) {
  return value instanceof Object && Object.getPrototypeOf(value) == Object.prototype;
};

var applyObjectChanges = function applyObjectChanges(target, changes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Object.keys(changes).forEach(function (key) {
    if (!options.requireExistingKeys || target.hasOwnProperty(key)) {
      if (options.mergeValues && isPlainObject(changes[key])) {
        target[key] = target[key] || {};
        applyObjectChanges(target[key], changes[key]);
      } else {
        target[key] = changes[key];
      }
    }
  });
};

var ModuleConfig = /*#__PURE__*/function () {
  function ModuleConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$1(this, ModuleConfig);

    _defineProperty$1(this, "_options", void 0);

    this._options = _objectSpread2$1({}, config);
  }

  _createClass$1(ModuleConfig, [{
    key: "exists",
    value: function exists(key) {
      return this._options.hasOwnProperty(key);
    }
  }, {
    key: "isNullOrWhitespace",
    value: function isNullOrWhitespace(key) {
      if (this.exists(key)) {
        var value = this.get(key);

        if (typeof value === "string") {
          return value.trim() === "";
        }

        return value === undefined || value === null;
      }

      return false;
    }
  }, {
    key: "get",
    value: function get(key) {
      return this._options[key];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this._options;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this._options[key] = value;
    }
  }, {
    key: "setAll",
    value: function setAll(config) {
      var requireExistingKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var mergeValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      applyObjectChanges(this._options, config, {
        requireExistingKeys: requireExistingKeys,
        mergeValues: mergeValues
      });
    }
  }]);

  return ModuleConfig;
}();

var ModuleIntegration = /*#__PURE__*/function () {
  function ModuleIntegration(type) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$1(this, ModuleIntegration);

    _defineProperty$1(this, "_type", void 0);

    _defineProperty$1(this, "_config", void 0);

    _defineProperty$1(this, "_actions", void 0);

    _defineProperty$1(this, "_events", void 0);

    this._type = type;
    this._config = config instanceof ModuleConfig ? config : new ModuleConfig(config);
    this._actions = {};
    this._events = {};
  }

  _createClass$1(ModuleIntegration, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "config",
    get: function get() {
      return this._config;
    }
  }, {
    key: "addAction",
    value: function addAction(key, action) {
      this._actions[key] = action;
    }
  }, {
    key: "addActions",
    value: function addActions(actions) {
      this._actions = _objectSpread2$1(_objectSpread2$1({}, this._actions), actions);
    }
  }, {
    key: "findAction",
    value: function findAction(key) {
      return this._actions.hasOwnProperty(key) ? this._actions[key] : undefined;
    }
  }, {
    key: "addEvent",
    value: function addEvent(key, event) {
      this._events[key] = event;
    }
  }, {
    key: "addEvents",
    value: function addEvents(events) {
      this._events = _objectSpread2$1(_objectSpread2$1({}, this._events), events);
    }
  }, {
    key: "findEvent",
    value: function findEvent(key) {
      return this._events.hasOwnProperty(key) ? this._events[key] : undefined;
    }
  }]);

  return ModuleIntegration;
}();

var ModuleIntegrationPipeline = /*#__PURE__*/function () {
  function ModuleIntegrationPipeline() {
    _classCallCheck$1(this, ModuleIntegrationPipeline);

    _defineProperty$1(this, "_integrations", void 0);

    _defineProperty$1(this, "_default", void 0);

    this._integrations = [];
    this._default = undefined;
  }

  _createClass$1(ModuleIntegrationPipeline, [{
    key: "exists",
    value: function exists(integration) {
      return this._integrations.some(function (i) {
        return integration.type === i.type;
      });
    }
  }, {
    key: "any",
    value: function any() {
      return this._integrations.length > 0;
    }
  }, {
    key: "add",
    value: function add(integration, setDefault) {
      if (!this.exists(integration)) this._integrations.push(integration);

      if (setDefault || this._integrations.length === 1) {
        this._default = integration;
      }
    }
  }, {
    key: "setDefault",
    value: function setDefault(integration) {
      if (this.exists(integration)) this._default = integration;
    }
  }, {
    key: "getDefault",
    value: function getDefault() {
      return this._default;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _toConsumableArray$1(this._integrations);
    }
  }]);

  return ModuleIntegrationPipeline;
}();

var nameIdMap = {};

var createAutoName = function createAutoName(prefix) {
  var nextId = nameIdMap[prefix];

  if (!nextId) {
    nextId = 1;
  }

  nameIdMap[prefix] = nextId + 1;
  return "".concat(prefix).concat(nextId);
};

var getParamsKey = function getParamsKey(params) {
  var str = params ? JSON.stringify(params) : "";
  var len = str.length; // simple non-secure hashing
  // from https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript

  var key = 0;

  if (len === 0) {
    return key;
  }

  for (var i = 0; i < len; i++) {
    key = (key << 5) - key + str.charCodeAt(i);
    key = key & key; // Convert to 32bit integer
  }

  return key;
};

var compareParams = function compareParams(paramsA, paramsB) {
  return getParamsKey(paramsA) === getParamsKey(paramsB);
};

var concurrentPromise = function concurrentPromise() {
  var promise;
  return function (func) {
    if (!promise) promise = func();
    return promise.then(function (value) {
      promise = null;
      return Promise.resolve(value);
    }).catch(function (error) {
      promise = null;
      throw error;
    });
  };
};

var ConcurrentPromiseMap = /*#__PURE__*/function () {
  function ConcurrentPromiseMap() {
    _classCallCheck$1(this, ConcurrentPromiseMap);

    _defineProperty$1(this, "_promises", {});
  }

  _createClass$1(ConcurrentPromiseMap, [{
    key: "resolve",
    value: function resolve(key, func) {
      var _this = this;

      if (!this._promises[key]) {
        this._promises[key] = func();
      }

      return this._promises[key].then(function (value) {
        _this._promises[key] = null;
        return Promise.resolve(value);
      }).catch(function (error) {
        _this._promises[key] = null;
        throw error;
      });
    }
  }]);

  return ConcurrentPromiseMap;
}();
/**
 * Wrapper to create a simpler 'typed' version of react-redux connect()
 */


var createTypedConnect = function createTypedConnect() {
  return function (mapStateToProps, mapDispatchToProps) {
    return function (component) {
      return connect$1(mapStateToProps, mapDispatchToProps)(component);
    };
  };
};

var AjaxStatus;

(function (AjaxStatus) {
  AjaxStatus[AjaxStatus["Ready"] = 0] = "Ready";
  AjaxStatus[AjaxStatus["Loading"] = 1] = "Loading";
  AjaxStatus[AjaxStatus["Success"] = 2] = "Success";
  AjaxStatus[AjaxStatus["Error"] = 3] = "Error";
})(AjaxStatus || (AjaxStatus = {}));

var HttpStatus;

(function (HttpStatus) {
  HttpStatus[HttpStatus["OK"] = 200] = "OK";
  HttpStatus[HttpStatus["BadRequest"] = 400] = "BadRequest";
  HttpStatus[HttpStatus["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus[HttpStatus["Forbidden"] = 403] = "Forbidden";
  HttpStatus[HttpStatus["NotFound"] = 404] = "NotFound";
  HttpStatus[HttpStatus["InternalServerError"] = 500] = "InternalServerError";
  HttpStatus[HttpStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(HttpStatus || (HttpStatus = {}));

var ApiError = /*#__PURE__*/function () {
  function ApiError(response, status) {
    var _this = this;

    _classCallCheck$1(this, ApiError);

    _defineProperty$1(this, "status", void 0);

    _defineProperty$1(this, "response", void 0);

    _defineProperty$1(this, "format", function () {
      var omitCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var overrideMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof _this.response === "string" && _this.response.length > 0) {
        return [_this.response];
      } // takes an error message/code/data, shows only message if omitCodes=true
      // [{ code: 3, message: "foo", data: ["more", "details"] }];
      // becomes ["foo (more, details) [3]"];
      // [{ code: 3, message: "foo"}];
      // becomes ["foo [3]"];


      var prettyError = function prettyError(error) {
        var message = error.message,
            data = error.data,
            code = error.code;
        var messageStr = message !== undefined && overrideMessages.hasOwnProperty(message) ? overrideMessages[message] : code !== undefined && overrideMessages.hasOwnProperty(code) ? overrideMessages[code] : message;

        if (typeof messageStr === "function") {
          messageStr = messageStr(error);
        }

        if (typeof messageStr === "string") {
          var dataStr = typeof data === "string" ? " (".concat(data, ")") : Array.isArray(data) ? " (".concat(data.join(", "), ")") : "";
          var codeStr = omitCodes || code === null || code === undefined ? "" : " [".concat(code, "]");
          return "".concat(messageStr).concat(dataStr).concat(codeStr);
        }

        return /*#__PURE__*/ /*#__PURE__*/React.isValidElement(messageStr) ? messageStr : null;
      };

      if (Array.isArray(_this.response)) {
        return _this.response.reduce(function (acc, e) {
          var msg = prettyError(e);
          return msg ? [].concat(_toConsumableArray$1(acc), [msg]) : acc;
        }, []);
      }

      if (_typeof$1(_this.response) === "object") {
        var msg = prettyError(_this.response);
        return msg ? [msg] : [];
      }

      return [];
    });

    this.status = status !== undefined ? status : HttpStatus.InternalServerError;
    this.response = response;
  }

  _createClass$1(ApiError, [{
    key: "message",
    get: function get() {
      var messages = this.format();
      return messages.length > 0 ? messages.join(" / ") : "An unexpected error has occurred";
    }
  }]);

  return ApiError;
}();

var defaultOptions$1 = {
  apiUrl: "",
  onErrorNotification: function onErrorNotification(message) {
    return notifyError(message);
  },
  preventErrorNotification: false,
  preventResponseHandling: false,
  fetchFailureError: "Network connection unavailable",
  onErrorResponse: function onErrorResponse(response) {
    return new Promise(function (resolve) {
      response.json().then(function (data) {
        return resolve(new ApiError(data, response.status));
      }).catch(function (error) {
        return resolve(new ApiError(error.message));
      });
    });
  }
};
var config = new ModuleConfig(defaultOptions$1);

var getApiOptions = function getApiOptions() {
  return config.getAll();
};
/**
 * Configures options for the api module
 * @param {object} `options` Options to set
 * @param {string} `options.apiUrl` Default host address for API calls
 * @param {function} `options.onErrorNotification` Redux action creator that will be dispatched whenever an error notification event occurs, default implementation is to send the error to the Notifications module
 * @param {boolean} `options.preventErrorNotification` Whether to disable error notification events as a result of failed API calls, default false
 * @param {boolean} `options.preventResponseHandling` Whether to disable response handling for requests, default false
 * @param {string} `options.fetchFailureError` Error message to display when a fetch request fails, default "Network connection unavailable"
 * @param {function} `options.onErrorResponse` The function used to convert a response to an ApiError when a fetch request returns an error
 */


var setApiOptions = function setApiOptions(options) {
  return config.setAll(options);
}; // internal module helpers


var getApiUrl = function getApiUrl() {
  if (config.isNullOrWhitespace("apiUrl")) console.error("apiUrl not configured in api module");
  return config.get("apiUrl");
};

var getOnErrorNotification = function getOnErrorNotification() {
  return config.get("onErrorNotification");
};

var getPreventErrorNotification = function getPreventErrorNotification() {
  return config.get("preventErrorNotification");
};

var getPreventResponseHandling = function getPreventResponseHandling() {
  return config.get("preventResponseHandling");
};

var getFetchFailureError = function getFetchFailureError() {
  return config.get("fetchFailureError");
};

var getOnErrorResponse = function getOnErrorResponse() {
  return config.get("onErrorResponse");
};

var NAMESPACE$1 = "API";
var API_REQUEST = "".concat(NAMESPACE$1, "/REQUEST");
var ApiRequestMethod;

(function (ApiRequestMethod) {
  ApiRequestMethod["GET"] = "GET";
  ApiRequestMethod["POST"] = "POST";
  ApiRequestMethod["PUT"] = "PUT";
  ApiRequestMethod["PATCH"] = "PATCH";
  ApiRequestMethod["DELETE"] = "DELETE";
})(ApiRequestMethod || (ApiRequestMethod = {}));
/**
 * Generic action creator for API requests
 * (use apiGet, apiPost etc, common methods below for most requests, use apiRequest for non-standard requests)
 * @param {Object} `options` Specification for the API request
 * @param {string} `options.type` Redux action type
 * @param {string} `options.method` Request method type, e.g. GET, POST, PUT, DELETE
 * @param {string} `options.path` Combines the base project API URL with this route for the API endpoint
 * @param {string} `options.url` Use this instead of path to override the full URL for the API endpoint
 * @param {Object} `options.params` Optional, query string parameters to append to the request URL
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {*} `options.body` Optional, the body of the request
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiRequest = function apiRequest(options) {
  var url = options.path && options.path !== undefined ? getApiUrl() + options.path : options.url || "";
  var urlWithParams = options.params && !!Object.keys(options.params).length ? "".concat(url).concat(url.indexOf("?") === -1 ? "?" : "&").concat(stringify(options.params)) : url;
  return {
    type: API_REQUEST,
    requestType: options.type,
    method: options.method,
    url: urlWithParams,
    contentType: options.contentType !== undefined ? options.contentType : "application/json",
    headers: options.headers,
    body: options.body !== undefined ? options.body : null,
    auth: options.auth !== undefined ? options.auth : true,
    actionCustomData: options.actionCustomData,
    actionSlowDelay: options.actionSlowDelay !== undefined ? options.actionSlowDelay : 200,
    preventErrorNotification: options.preventErrorNotification || false,
    preventResponseHandling: options.preventResponseHandling || false,
    debounce: typeof options.debounce === "number" ? options.debounce : false,
    abort: options.abort
  };
};

var ApiRequestsErrorPriority;

(function (ApiRequestsErrorPriority) {
  ApiRequestsErrorPriority["First"] = "first";
  ApiRequestsErrorPriority["Last"] = "last";
  ApiRequestsErrorPriority["Earliest"] = "earliest";
  ApiRequestsErrorPriority["Latest"] = "latest";
})(ApiRequestsErrorPriority || (ApiRequestsErrorPriority = {}));
/**
 * Action creator for combining multiple API requests
 * @param {Object|Array} `apiActions` One or more API actions to be requested. Can be a keyed-object (the final response will be an object with matching keyed responses), or an array (the final response will be an array of responses)
 * @param {Object} `options` Additional options for handling the requests
 * @param {string} `options.errorPriority` Optional, give priority to errors for specific requests, can be one of "first", "last", "earliest", "latest" (default is earliest)
 * @returns {function} Redux action thunk
 */


var apiRequests = function apiRequests(apiActions) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var isArray, mapActions, mapResponses, mapErrors, keys, mappedActions, requests, results, errorResults, response, error;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              isArray = Array.isArray(apiActions);

              mapActions = function mapActions(a) {
                return a;
              };

              mapResponses = function mapResponses(r) {
                return r;
              };

              mapErrors = function mapErrors(e) {
                switch (options.errorPriority) {
                  case ApiRequestsErrorPriority.First:
                    return e[0].error;

                  case ApiRequestsErrorPriority.Last:
                    return e[e.length - 1].error;

                  case ApiRequestsErrorPriority.Earliest:
                  default:
                    return e.reduce(function (err, next) {
                      return !err || next.finish < err.finish ? next : err;
                    }).error;

                  case ApiRequestsErrorPriority.Latest:
                    return e.reduce(function (err, next) {
                      return !err || next.finish > err.finish ? next : err;
                    }).error;
                }
              };

              if (isArray) {
                mapResponses = function mapResponses(r) {
                  return r.map(function (x) {
                    return x.response;
                  });
                };
              } else {
                keys = Object.keys(apiActions);

                mapActions = function mapActions(a) {
                  return keys.map(function (k) {
                    return a[k];
                  });
                };

                mapResponses = function mapResponses(r) {
                  return r.reduce(function (acc, val, i) {
                    return _objectSpread2$1(_objectSpread2$1({}, acc), {}, _defineProperty$1({}, keys[i], val.response));
                  }, {});
                };
              }

              mappedActions = mapActions(apiActions);
              requests = mappedActions.map( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(a) {
                  var r;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return dispatch(a);

                        case 2:
                          r = _context.sent;
                          return _context.abrupt("return", _objectSpread2$1(_objectSpread2$1({}, r), {}, {
                            finish: Date.now()
                          }));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
              _context2.next = 9;
              return Promise.all(requests);

            case 9:
              results = _context2.sent;
              errorResults = results.filter(function (x) {
                return !!x.error;
              });

              if (!(errorResults.length === 0)) {
                _context2.next = 14;
                break;
              }

              response = mapResponses(results);
              return _context2.abrupt("return", {
                success: true,
                response: response
              });

            case 14:
              error = mapErrors(errorResults);
              return _context2.abrupt("return", {
                success: false,
                error: error
              });

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for HTTP "GET" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {Object} `params` Optional, query string parameters to append to the request URL
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiGet = function apiGet(type, path) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    type: type,
    method: ApiRequestMethod.GET,
    path: path,
    params: params
  }));
};
/**
 * Action creator for HTTP "POST" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiPost = function apiPost(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    type: type,
    method: ApiRequestMethod.POST,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "PUT" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiPut = function apiPut(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    type: type,
    method: ApiRequestMethod.PUT,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "PATCH" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiPatch = function apiPatch(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    type: type,
    method: ApiRequestMethod.PATCH,
    path: path,
    body: body
  }));
};
/**
 * Action creator for HTTP "DELETE" requests
 * @param {string} `type` Redux action type
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {Object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {Object} `options.headers` Optional, object containing key-value pairs for custom HTTP headers
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var apiDelete = function apiDelete(type, path) {
  var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return apiRequest(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    type: type,
    method: ApiRequestMethod.DELETE,
    path: path,
    body: body
  }));
}; // ajax lower-level action helpers


var AJAX_START = "AJAX_START";
var AJAX_SUCCESS = "AJAX_SUCCESS";
var AJAX_ERROR = "AJAX_ERROR";
var AJAX_SLOW = "AJAX_SLOW";
var AJAX_RESET = "AJAX_RESET";
var AJAX_ABORT = "AJAX_ABORT"; // helper functions

var isAjaxStart = function isAjaxStart(action) {
  return action.subtype === AJAX_START;
};

var isAjaxSuccess = function isAjaxSuccess(action) {
  return action.subtype === AJAX_SUCCESS;
};

var isAjaxError = function isAjaxError(action) {
  return action.subtype === AJAX_ERROR;
};

var isAjaxSlow = function isAjaxSlow(action) {
  return action.subtype === AJAX_SLOW;
};

var isAjaxReset = function isAjaxReset(action) {
  return action.subtype === AJAX_RESET;
};

var isAjaxAbort = function isAjaxAbort(action) {
  return action.subtype === AJAX_ABORT;
};

var ajaxActionsFor = function ajaxActionsFor(type) {
  var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var timeout = null;
  return {
    reset: function reset() {
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        type: type,
        subtype: AJAX_RESET
      });
    },
    start: function start(request) {
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        type: type,
        subtype: AJAX_START,
        sentAt: Date.now(),
        request: request
      });
    },
    slow: function slow(to) {
      return function (dispatch) {
        timeout = setTimeout(function () {
          dispatch(_objectSpread2$1(_objectSpread2$1({}, obj), {}, {
            type: type,
            subtype: AJAX_SLOW,
            slow: true
          }));
        }, to);
      };
    },
    success: function success(response) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        type: type,
        subtype: AJAX_SUCCESS,
        receivedAt: Date.now(),
        response: response
      });
    },
    error: function error(_error) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        type: type,
        subtype: AJAX_ERROR,
        receivedAt: Date.now(),
        error: _error
      });
    },
    abort: function abort(reason) {
      if (timeout) clearTimeout(timeout);
      return _objectSpread2$1(_objectSpread2$1({}, obj), {}, {
        type: type,
        subtype: AJAX_ABORT,
        abortedAt: Date.now(),
        reason: reason
      });
    }
  };
};
/**
 * Returns a boolean to indicate whether an api request action is in progress
 * @param {object} `action` Reducer action to handle
 * @returns {boolean} True if the request is in progress, otherwise false
 */


var requestIsBusy = function requestIsBusy(action) {
  if (isAjaxStart(action) || isAjaxSlow(action)) return true;
  return false;
};
/**
 * Returns a boolean to indicate whether an api request is taking longer than expected
 * @param {object} `action` Reducer action to handle
 * @returns {boolean|null} True if a request is taking a long time, false if a request is not, or null if no request is in progress
 */


var requestIsSlow = function requestIsSlow(action) {
  if (isAjaxStart(action)) return false;
  if (isAjaxSlow(action)) return true;
  return null;
};
/**
 * Returns a boolean to indicate whether an api request was successful
 * @param {object} `action` Reducer action to handle
 * @returns {boolean|null} True if a request is successful, false if an error occurred, or null if a request is incomplete
 */


var requestIsSuccess = function requestIsSuccess(action) {
  if (isAjaxSuccess(action)) return true;
  if (isAjaxError(action)) return false;
  return null;
};
/**
 * Returns a boolean to indicate whether an api request was aborted
 * @param {object} `action` Reducer action to handle
 * @returns {boolean} True if the request has been aborted, otherwise false
 */


var requestIsAborted = function requestIsAborted(action) {
  if (isAjaxAbort(action)) return true;
  return false;
};
/**
 * Returns the response for a successful api request
 * @param {object} `action` Reducer action to handle
 * @returns {*} Returns the response from a request, or null if a request is incomplete or failed
 */


var requestResponse = function requestResponse(action) {
  if (isAjaxSuccess(action)) return action.response;
  return null;
};
/**
 * Returns the error for a failed api request
 * @param {object} `action` Reducer action to handle
 * @returns {*} Returns the error from a request, or null if a request is incomplete or successful
 */


var requestError = function requestError(action) {
  if (isAjaxError(action)) return action.error;
  return null;
};
/**
 * Returns a boolean to indicate whether a failed api request contained one or more error codes
 * @param {object} `action` Reducer action to handle
 * @param {number|number[]} `code` code or codes
 * @returns {boolean|null} Returns true if a failed request contains the code(s), false if it does not, or null if a request is incomplete or successful
 */


var requestErrorHasCode = function requestErrorHasCode(action, code) {
  if (isAjaxError(action)) {
    if (!action.error || !Array.isArray(action.error.response)) return false;
    var codes = Array.isArray(code) ? code : [code];
    return !!action.error.response.find(function (e) {
      return e.code !== undefined && ~codes.indexOf(e.code);
    });
  }

  return null;
};
/**
 * Returns a numeric status value that corresponds to the AjaxStatus type
 * @param {object} `action` Reducer action to handle
 * @returns {number} AjaxStatus type
 */


var requestStatus = function requestStatus(action) {
  if (isAjaxSuccess(action)) return AjaxStatus.Success;
  if (isAjaxError(action)) return AjaxStatus.Error;
  if (isAjaxStart(action) || isAjaxSlow(action)) return AjaxStatus.Loading;
  return AjaxStatus.Ready;
};
/**
 * Returns the date an API request was sent
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was sent, or null if the request is complete
 */


var requestSentAt = function requestSentAt(action) {
  if (isAjaxStart(action)) return action.sentAt;
  return null;
};
/**
 * Returns the date an API request response was received
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was received, or null if the request is incomplete
 */


var requestReceivedAt = function requestReceivedAt(action) {
  if (isAjaxSuccess(action) || isAjaxError(action)) return action.receivedAt;
  return null;
};
/**
 * Returns the date an API request was aborted
 * @param {object} `action` Reducer action to handle
 * @returns {number|null} The date timestamp a request was aborted, or null if the request hasn't been aborted
 */


var requestAbortedAt = function requestAbortedAt(action) {
  if (isAjaxAbort(action)) return action.abortedAt;
  return null;
}; // mock request action


var MOCK_REQUEST = "MOCK_REQUEST";
/**
 * Generic action creator for mocking API requests
 * @param {Object} `options` Specification for the mock request
 * @param {string} `options.type` Redux action type
 * @param {boolean} `options.success` Whether the mock request should return a success (HTTP 200) response
 * @param {*} `options.response` The response data to return for a successful mock request
 * @param {*} `options.error` The error to return
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */

var mockRequest = function mockRequest(options) {
  return {
    type: MOCK_REQUEST,
    requestType: options.type,
    success: options.success,
    response: options.response,
    error: options.error,
    delay: options.delay !== undefined ? options.delay : 100,
    actionCustomData: options.actionCustomData,
    actionSlowDelay: options.actionSlowDelay !== undefined ? options.actionSlowDelay : 200,
    preventErrorNotification: options.preventErrorNotification || false,
    preventResponseHandling: options.preventResponseHandling || false,
    debounce: typeof options.debounce === "number" ? options.debounce : false,
    abort: options.abort
  };
};
/**
 * Action creator for mocking a successful api request
 * @param {string} `type` Redux action type
 * @param {Object} `options` Optional, additional options to pass to the request
 * @param {*} `options.response` The response data to return
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var mockSuccess = function mockSuccess(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var response = options.response,
      delay = options.delay,
      actionCustomData = options.actionCustomData,
      debounce = options.debounce,
      abort = options.abort;
  return mockRequest({
    type: type,
    success: true,
    response: response,
    delay: delay,
    actionCustomData: actionCustomData,
    debounce: debounce,
    abort: abort
  });
};
/**
 * Action creator for mocking an error api request
 * @param {string} `type` Redux action type
 * @param {Object} `options` Optional, additional options to pass to the request
 * @param {number} `options.code` Numeric code which correlates to the type of error returned
 * @param {string} `options.message` Error message to return
 * @param {string|Array} `options.data` Additional data which correlates to the error
 * @param {number} `options.delay` Optional, time delay (ms) for the mock request to take, default 100ms
 * @param {boolean} `options.preventNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @returns {Object} Redux action object
 */


var mockError = function mockError(type) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var code = options.code,
      message = options.message,
      data = options.data,
      delay = options.delay,
      preventNotification = options.preventNotification,
      debounce = options.debounce,
      abort = options.abort;
  var error = code || message || data ? [{
    code: code,
    message: message,
    data: data
  }] : "";
  return mockRequest({
    type: type,
    success: false,
    error: error,
    delay: delay,
    preventErrorNotification: preventNotification,
    debounce: debounce,
    abort: abort
  });
}; // helper for mocking array data


var MockArrayData = function MockArrayData() {
  var _this = this;

  var initialData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortFunc = arguments.length > 1 ? arguments[1] : undefined;

  _classCallCheck$1(this, MockArrayData);

  _defineProperty$1(this, "_data", void 0);

  _defineProperty$1(this, "_sort", void 0);

  _defineProperty$1(this, "get", function () {
    var data = _toConsumableArray$1(_this._data);

    if (_this._sort) data.sort(_this._sort);
    return data;
  });

  _defineProperty$1(this, "getPaged", function (pageSize, pageNumber) {
    var data = _this.get();

    return {
      results: _this._paginate(data, pageSize, pageNumber),
      totalResults: data.length
    };
  });

  _defineProperty$1(this, "filter", function (func) {
    var data = _this._data.filter(func);

    if (_this._sort) data.sort(_this._sort);
    return data;
  });

  _defineProperty$1(this, "filterPaged", function (func, pageSize, pageNumber) {
    var data = _this.filter(func);

    return {
      results: _this._paginate(data, pageSize, pageNumber),
      totalResults: data.length
    };
  });

  _defineProperty$1(this, "_paginate", function (array, pageSize, pageNumber) {
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
  });

  _defineProperty$1(this, "add", function (item) {
    _this._data = [].concat(_toConsumableArray$1(_this._data), [item]);
  });

  _defineProperty$1(this, "addMany", function (items) {
    _this._data = [].concat(_toConsumableArray$1(_this._data), _toConsumableArray$1(items));
  });

  _defineProperty$1(this, "remove", function (item) {
    var i = _this._data.indexOf(item);

    if (i >= 0) {
      _this._data.splice(i, 1);
    }
  });

  _defineProperty$1(this, "removeWhere", function (func) {
    var i = _this._data.length;

    while (i--) {
      if (func(_this._data[i], i, _this._data)) {
        _this._data.splice(i, 1);
      }
    }
  });

  _defineProperty$1(this, "replaceFirst", function (func, item) {
    var i = 0;

    while (i < _this._data.length) {
      if (func(_this._data[i], i, _this._data)) {
        _this._data.splice(i, 1, item);

        return true;
      }

      i++;
    }

    return false;
  });

  _defineProperty$1(this, "update", function (searchFunc, updateFunc) {
    var i = _this._data.length;
    var updated = false;

    while (i--) {
      if (searchFunc(_this._data[i], i, _this._data)) {
        var updatedItem = updateFunc(_this._data[i], i);

        _this._data.splice(i, 1, updatedItem);

        updated = true;
      }
    }

    return updated;
  });

  _defineProperty$1(this, "find", function (func) {
    return _this._data.find(func);
  });

  this._data = initialData;
  this._sort = sortFunc;
};

var defaultOptions$2 = {
  method: ApiRequestMethod.GET,
  lazy: true,
  autoNamePrefix: "USE_API_REQUEST/"
};
/**
 * A hook to trigger a generic API request
 * @param {object} `options` Specification for the API request
 * @param {string} `options.method` Request method type, e.g. GET, POST, PUT, DELETE
 * @param {string} `options.path` Combines the base project API URL with this route for the API endpoint
 * @param {string} `options.url` Use this instead of path to override the full URL for the API endpoint
 * @param {object} `options.params` Optional, query string parameters to append to the request URL
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {*} `options.body` Optional, the body of the request
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */

var useApiRequest = function useApiRequest(options) {
  var _options = _objectSpread2$1(_objectSpread2$1({}, defaultOptions$2), options);

  var actionCreator = useRef();

  if (!actionCreator.current) {
    var type = createAutoName(_options.autoNamePrefix);

    actionCreator.current = function () {
      return apiRequest(_objectSpread2$1(_objectSpread2$1({}, _options), {}, {
        type: type
      }));
    };
  }

  return useApiAction(actionCreator.current, _options);
};
/**
 * A hook to trigger HTTP "GET" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {object} `params` Optional, query string parameters to append to the request URL
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default false
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */


var useApiGet = function useApiGet(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2$1(_objectSpread2$1({
    lazy: false,
    autoNamePrefix: "USE_API_GET/"
  }, options), {}, {
    method: ApiRequestMethod.GET,
    path: path,
    params: params
  }));
};
/**
 * A hook to trigger HTTP "POST" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */


var useApiPost = function useApiPost(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2$1(_objectSpread2$1({
    autoNamePrefix: "USE_API_POST/"
  }, options), {}, {
    method: ApiRequestMethod.POST,
    path: path,
    body: body
  }));
};
/**
 * A hook to trigger HTTP "PUT" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */


var useApiPut = function useApiPut(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2$1(_objectSpread2$1({
    autoNamePrefix: "USE_API_PUT/"
  }, options), {}, {
    method: ApiRequestMethod.PUT,
    path: path,
    body: body
  }));
};
/**
 * A hook to trigger HTTP "PATCH" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */


var useApiPatch = function useApiPatch(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2$1(_objectSpread2$1({
    autoNamePrefix: "USE_API_PATCH/"
  }, options), {}, {
    method: ApiRequestMethod.PATCH,
    path: path,
    body: body
  }));
};
/**
 * A hook to trigger HTTP "DELETE" requests
 * @param {string} `path` The route for the API endpoint (combined with the base project API URL)
 * @param {*} `body` Optional, the body of the request
 * @param {object} `options` Optional, additional specification for the API request
 * @param {string} `options.contentType` Optional, the content type for the request, defaults to 'application/json'
 * @param {boolean} `options.auth` Optional, whether the request should be authenticated (using the auth module/JWT), defaults to true. Can be supplied a string to use a custom authentication method / Authorization header
 * @param {*} `options.actionCustomData` Optional, additional data that can be added to the Redux action and will be available in a reducer as an action.customData property
 * @param {number} `options.actionSlowDelay` Optional, time delay (ms) for an additional action to be dispatched to indicate the request is taking longer than expected, default 200ms
 * @param {boolean} `options.preventErrorNotification` Optional, prevents error notifications being sent by the API middleware, default false
 * @param {boolean} `options.preventResponseHandling` Optional, prevents the default response handling, default false
 * @param {number|boolean} `options.debounce` Optional, debounces multiple API requests with the same type in milliseconds. A positive value uses trailing-edge debounce, a negative value uses leading-edge debounce, false or zero indicates no debounce
 * @param {ApiProvider} `options.abort` Optional, instance of ApiProvider class which can be used to abort the API request before it completes
 * @param {boolean} `options.lazy` Optional, whether the API request should be fired on demand or immediately, default true
 * @param {string} `options.autoNamePrefix` Optional, prefix to use for naming dispatched API actions
 * @returns {[]} An array in the format: [requestState, sendRequest, abortRequest]
 * @returns {object} `requestState` The current state of the request: { success, error, response, busy, slow, aborted, sentAt, receivedAt, abortedAt }
 * @returns {function} `sendRequest` A function to fire the request
 * @returns {function} `abortRequest` A function to abort the request
 */


var useApiDelete = function useApiDelete(path) {
  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useApiRequest(_objectSpread2$1(_objectSpread2$1({
    autoNamePrefix: "USE_API_DELETE/"
  }, options), {}, {
    method: ApiRequestMethod.DELETE,
    path: path,
    body: body
  }));
};

var defaultOptions$3 = {
  tokenKey: "",
  useEmailVerification: false,
  jwtClaims: {},
  // all options must be declared even if undefined
  onRefreshJwt: undefined,
  onAuthenticate: undefined,
  onAuthenticated: undefined,
  onDeauthenticate: undefined,
  onDeauthenticated: undefined
};
var jwtConfig = new ModuleConfig(defaultOptions$3);

var getTokenKey = function getTokenKey() {
  if (jwtConfig.isNullOrWhitespace("tokenKey")) console.error("tokenKey not configured for JWT auth module");
  return jwtConfig.get("tokenKey");
};

var getJwtClaims = function getJwtClaims() {
  return jwtConfig.get("jwtClaims");
};

var getOnRefreshJwt = function getOnRefreshJwt() {
  if (jwtConfig.isNullOrWhitespace("onRefreshJwt")) console.error("onRefreshJwt not configured for JWT auth module");
  return jwtConfig.get("onRefreshJwt");
};

var getOnAuthenticate = function getOnAuthenticate() {
  return jwtConfig.get("onAuthenticate");
};

var getOnAuthenticated = function getOnAuthenticated() {
  return jwtConfig.get("onAuthenticated");
};

var getOnDeauthenticate = function getOnDeauthenticate() {
  return jwtConfig.get("onDeauthenticate");
};

var getOnDeauthenticated = function getOnDeauthenticated() {
  return jwtConfig.get("onDeauthenticated");
};

var defaultOptions$4 = {
  environment: "default",
  release: "1.0",
  debug: false,
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  stateTransformer: function stateTransformer(state) {
    return state;
  }
};
var config$1 = new ModuleConfig(defaultOptions$4);
var loggers = {};

var getLoggingOptions = function getLoggingOptions() {
  return config$1.getAll();
};
/**
 * Configures options for the logging module
 * @param {object} `options` Options to set
 * @param {string} `options.environment` Environment name to tag tracking events with
 * @param {string} `options.release` Release version to tag tracking events with
 * @param {boolean} `options.debug` Enables debug console log messages when tracking events occur, default false
 * @param {function} `options.actionTransformer` Transform function to optimise Redux action data saved against tracking events
 * @param {function} `options.stateTransformer` Transform function to optimise Redux state data saved against tracking events
 */


var setLoggingOptions = function setLoggingOptions(options) {
  return config$1.setAll(options);
}; // integration functions


var loggerExists = function loggerExists(type) {
  return !!loggers[type];
};

var addLogger = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(createFunc) {
    var logger;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return createFunc();

          case 2:
            logger = _context.sent;

            if (!(!logger || loggerExists(logger.type))) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return");

          case 5:
            if (logger.initialize) {
              logger.initialize();
            }

            loggers[logger.type] = logger;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function addLogger(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Configures and enables a custom logging integration
 * @param {object} `logger` Logger configuration
 * @param {string} `logger.type` Unique type for the logger
 * @param {function} `logger.initialize` Optional, initialization function
 * @param {function} `logger.getMiddleware` Optional, allows the logger to use its own Redux middleware
 * @param {function} `logger.logNavigation` Optional, callback when a navigation event is triggered
 * @param {function} `logger.logError` Optional, callback when an error event is triggered
 * @param {function} `logger.setUserIdentity` Optional, callback when the current user has changed
 * @param {function} `logger.clearUserIdentity` Optional, callback when there is no longer a current user
 */


var enableCustomLogger = function enableCustomLogger(logger) {
  return addLogger(function () {
    return Promise.resolve(logger);
  });
}; // internal logging functions


var processLoggers = function processLoggers(loggerFunc) {
  Object.keys(loggers).forEach(function (key) {
    return loggerFunc(loggers[key]);
  });
};

var isDebuggingLogging = function isDebuggingLogging() {
  return config$1.get("debug");
};

var LoggerType;

(function (LoggerType) {
  LoggerType["Sentry"] = "Sentry";
  LoggerType["Segment"] = "Segment";
  LoggerType["Hotjar"] = "Hotjar";
  LoggerType["GoogleAnalytics"] = "GoogleAnalytics";
})(LoggerType || (LoggerType = {}));
/**
 * Logs an error event
 * @param {string} `error` Error message
 * @param {object} `data` Additional data for tbe event
 */


var logError = function logError(error, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logError event:", error, data);
  }

  processLoggers(function (logger) {
    if (logger.logError) {
      logger.logError(error, data);
    }
  });
};
/**
 * Logs a navigation event
 * @param {string} `location` New location
 * @param {object} `data` Additional data for tbe event
 */


var logNavigation = function logNavigation(location, data) {
  if (isDebuggingLogging()) {
    console.log("logging module logNavigation event:", location, data);
  }

  processLoggers(function (logger) {
    if (logger.logNavigation) {
      logger.logNavigation(location, data);
    }
  });
};
/**
 * Sets the current user for logged events
 * @param {string} `id` User ID
 * @param {object} `data` Additional data for the user
 */


var setUserIdentity = function setUserIdentity(id, data) {
  if (isDebuggingLogging()) {
    console.log("logging module setUserIdentity event:", id, data);
  }

  processLoggers(function (logger) {
    if (logger.setUserIdentity) {
      logger.setUserIdentity(id, data);
    }
  });
};
/**
 * Resets the current user for logged events
 */


var clearUserIdentity = function clearUserIdentity() {
  if (isDebuggingLogging()) {
    console.log("logging module clearUserIdentity event");
  }

  processLoggers(function (logger) {
    if (logger.clearUserIdentity) {
      logger.clearUserIdentity();
    }
  });
};

var JwtClaimType;

(function (JwtClaimType) {
  JwtClaimType["String"] = "string";
  JwtClaimType["Number"] = "number";
  JwtClaimType["Boolean"] = "boolean";
  JwtClaimType["Join"] = "join";
  JwtClaimType["Object"] = "object";
  JwtClaimType["Array"] = "array";
})(JwtClaimType || (JwtClaimType = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var base64 = createCommonjsModule(function (module, exports) {
  (function (root) {
    // Detect free variables `exports`.
    var freeExports = exports; // Detect free variable `module`.

    var freeModule = module && module.exports == freeExports && module; // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.

    var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal;

    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }
    /*--------------------------------------------------------------------------*/


    var InvalidCharacterError = function InvalidCharacterError(message) {
      this.message = message;
    };

    InvalidCharacterError.prototype = new Error();
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';

    var error = function error(message) {
      // Note: the error messages used throughout this file match those used by
      // the native `atob`/`btoa` implementation in Chromium.
      throw new InvalidCharacterError(message);
    };

    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // http://whatwg.org/html/common-microsyntaxes.html#space-character

    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g; // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396

    var decode = function decode(input) {
      input = String(input).replace(REGEX_SPACE_CHARACTERS, '');
      var length = input.length;

      if (length % 4 == 0) {
        input = input.replace(/==?$/, '');
        length = input.length;
      }

      if (length % 4 == 1 || // http://whatwg.org/C#alphanumeric-ascii-characters
      /[^+a-zA-Z0-9/]/.test(input)) {
        error('Invalid character: the string to be decoded is not correctly encoded.');
      }

      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = '';
      var position = -1;

      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer; // Unless this is the first of a group of 4 characters…

        if (bitCounter++ % 4) {
          // …convert the first 8 bits to a single ASCII character.
          output += String.fromCharCode(0xFF & bitStorage >> (-2 * bitCounter & 6));
        }
      }

      return output;
    }; // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa


    var encode = function encode(input) {
      input = String(input);

      if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error('The string to be encoded contains characters outside of the ' + 'Latin1 range.');
      }

      var padding = input.length % 3;
      var output = '';
      var position = -1;
      var a;
      var b;
      var c;
      var buffer; // Make sure any padding is handled outside of the loop.

      var length = input.length - padding;

      while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c; // Turn the 24 bits into four chunks of 6 bits each, and append the
        // matching character for each of them to the output.

        output += TABLE.charAt(buffer >> 18 & 0x3F) + TABLE.charAt(buffer >> 12 & 0x3F) + TABLE.charAt(buffer >> 6 & 0x3F) + TABLE.charAt(buffer & 0x3F);
      }

      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += TABLE.charAt(buffer >> 10) + TABLE.charAt(buffer >> 4 & 0x3F) + TABLE.charAt(buffer << 2 & 0x3F) + '=';
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += TABLE.charAt(buffer >> 2) + TABLE.charAt(buffer << 4 & 0x3F) + '==';
      }

      return output;
    };

    var base64 = {
      'encode': encode,
      'decode': decode,
      'version': '1.0.0'
    }; // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:

    if (freeExports && !freeExports.nodeType) {
      if (freeModule) {
        // in Node.js or RingoJS v0.8.0+
        freeModule.exports = base64;
      } else {
        // in Narwhal or RingoJS v0.7.0-
        for (var key in base64) {
          base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
        }
      }
    } else {
      // in Rhino or a web browser
      root.base64 = base64;
    }
  })(commonjsGlobal);
});

var JWTExpiry = /*#__PURE__*/function () {
  function JWTExpiry(expiry) {
    _classCallCheck$1(this, JWTExpiry);

    _defineProperty$1(this, "expiry", void 0);

    this.expiry = expiry;
  }

  _createClass$1(JWTExpiry, [{
    key: "hasExpired",
    value: function hasExpired() {
      // convert expiry from seconds to milliseconds
      return this.expiry * 1000 <= Date.now();
    }
  }, {
    key: "willExpireSoon",
    value: function willExpireSoon() {
      var thresholdInSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30; // convert expiry from seconds to milliseconds

      return (this.expiry - thresholdInSeconds) * 1000 <= Date.now();
    }
  }]);

  return JWTExpiry;
}();

var JWT = /*#__PURE__*/function () {
  function JWT(token) {
    _classCallCheck$1(this, JWT);

    _defineProperty$1(this, "payload", void 0);

    this.payload = {};
    var jwtArray = token.split(".");

    if (jwtArray.length > 1) {
      var payloadBase64 = jwtArray[1].replace("-", "+").replace("_", "/");
      this.payload = JSON.parse(this.decodePayloadUtf8(payloadBase64));
    }
  }

  _createClass$1(JWT, [{
    key: "decodePayloadUtf8",
    value: function decodePayloadUtf8(str) {
      return decodeURIComponent(Array.prototype.map.call(base64.decode(str), function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }
  }, {
    key: "hasExpired",
    value: function hasExpired() {
      if (this.payload.exp !== undefined) {
        var expiry = new JWTExpiry(this.payload.exp);
        return expiry.hasExpired();
      }

      return true;
    }
  }, {
    key: "getExpiry",
    value: function getExpiry() {
      return this.payload.exp !== undefined ? this.payload.exp : 0;
    }
  }, {
    key: "getSubject",
    value: function getSubject() {
      return this.payload.sub !== undefined ? this.payload.sub : "";
    } // dynamic claim handling

  }, {
    key: "parseClaims",
    value: function parseClaims(config) {
      var _this = this;

      return Object.keys(config).reduce(function (acc, key) {
        var options = config[key];
        if (options) acc[key] = _this._getClaim(options);
        return acc;
      }, {});
    }
  }, {
    key: "parseIdentityClaims",
    value: function parseIdentityClaims(config) {
      var _this2 = this;

      return Object.keys(config).reduce(function (acc, key) {
        var options = config[key];

        if (options && options.identity) {
          acc[options.identity] = _this2._getClaim(options);
        }

        return acc;
      }, {});
    }
  }, {
    key: "_getClaim",
    value: function _getClaim(options) {
      var type = options.type,
          key = options.key,
          keys = options.keys,
          separator = options.separator;

      if (type === JwtClaimType.String && key) {
        return this._getClaimOrDefault(key, "");
      }

      if (type === JwtClaimType.Number && key) {
        return this._getClaimAsNumber(key);
      }

      if (type === JwtClaimType.Boolean && key) {
        return this._getClaimAsBoolean(key);
      }

      if (type === JwtClaimType.Join && keys && separator) {
        return this._getClaimsAsJoin(keys, separator);
      }

      if (type === JwtClaimType.Object && key) {
        return this._getClaimOrDefault(key, {});
      }

      if (type === JwtClaimType.Object && keys) {
        return this._getClaimsAsObject(keys);
      }

      if (type === JwtClaimType.Array && key) {
        return this._getClaimOrDefault(key, []);
      }

      if (type === JwtClaimType.Array && keys) {
        return this._getClaimsAsArray(keys);
      }

      return null;
    }
  }, {
    key: "_getClaimOrDefault",
    value: function _getClaimOrDefault(key, defaultValue) {
      if (this.payload.hasOwnProperty(key)) {
        return this.payload[key];
      }

      return defaultValue;
    }
  }, {
    key: "_getClaimAsNumber",
    value: function _getClaimAsNumber(key) {
      if (this.payload.hasOwnProperty(key)) {
        var val = this.payload[key];

        if (!Number.isNaN(val)) {
          return Number(val);
        }
      }

      return 0;
    }
  }, {
    key: "_getClaimAsBoolean",
    value: function _getClaimAsBoolean(key) {
      if (this.payload.hasOwnProperty(key)) {
        var val = this.payload[key];

        if (typeof val === "string") {
          return val.toLowerCase() === "true";
        }

        return val === true;
      }

      return false;
    }
  }, {
    key: "_getClaimsAsJoin",
    value: function _getClaimsAsJoin(keys, separator) {
      var _this3 = this;

      var claims = this._findClaimKeys(keys);

      if (claims.length > 0) {
        var claimValues = claims.map(function (key) {
          return _this3.payload[key];
        });
        return claimValues.join(separator);
      }

      return "";
    }
  }, {
    key: "_getClaimsAsObject",
    value: function _getClaimsAsObject(keys) {
      var claims = this._getClaimsAsArray(keys);

      return claims.reduce(function (acc, claim) {
        acc[claim.key] = claim.value;
        return acc;
      }, {});
    }
  }, {
    key: "_getClaimsAsArray",
    value: function _getClaimsAsArray(keys) {
      var _this4 = this;

      var searchKeys = typeof keys === "string" ? new RegExp(keys) : keys;

      var claims = this._findClaimKeys(searchKeys);

      if (claims.length > 0) {
        return claims.map(function (key) {
          var claimKey = key; // match first parantheses in keys pattern if specified

          if (searchKeys instanceof RegExp) {
            var match = key.match(searchKeys);

            if (match && match[1]) {
              claimKey = match[1];
            }
          }

          return {
            key: claimKey,
            value: _this4.payload[key]
          };
        });
      }

      return [];
    }
  }, {
    key: "_findClaimKeys",
    value: function _findClaimKeys(keys) {
      var jwt = this.payload;

      if (Array.isArray(keys)) {
        return keys.filter(function (k) {
          return jwt.hasOwnProperty(k);
        });
      }

      if (typeof keys === "string" || keys instanceof RegExp) {
        var allKeys = Object.keys(jwt);
        return allKeys.filter(function (k) {
          return k.match(keys);
        });
      }

      return [];
    }
  }]);

  return JWT;
}();
/**
 * Selects Redux state for auth data
 * @param {Object} `state` Redux state
 */


var getAuthState = function getAuthState(state) {
  return state.auth;
};
/**
 * Selects Redux state for parsed JWT claim data
 * @param {Object} `state` Redux state
 */


var getAuthClaims = function getAuthClaims(state) {
  var authState = getAuthState(state);
  return authState.claims || {};
};
/**
 * Finds the jwt claim value for the given claim key
 * @param {Object} `state` Redux state
 * @param {string} `key` Claim key to find
 */


var getAuthClaim = function getAuthClaim(state, key) {
  var claims = getAuthClaims(state);
  return claims[key];
};
/**
 * Returns the current JWT refresh token
 * @param {Object} `state` Redux state
 */


var getAuthRefreshToken = function getAuthRefreshToken(state) {
  var authState = getAuthState(state);
  return authState.refreshToken;
};

var refreshJwtAction = function refreshJwtAction(authenticate, deauthenticate, invalidate) {
  return function (dispatch, getState) {
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
        var auth, jwtExpiry, onRefreshJwt, refreshAction, _yield$dispatch, success, response, error;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                auth = getAuthState(getState());

                if (!(auth.accessToken && auth.refreshToken && auth.expiry)) {
                  _context.next = 32;
                  break;
                }

                jwtExpiry = new JWTExpiry(auth.expiry);

                if (!(invalidate || jwtExpiry.willExpireSoon())) {
                  _context.next = 28;
                  break;
                } // get the refresh api action to perform


                onRefreshJwt = getOnRefreshJwt();
                refreshAction = typeof onRefreshJwt === "function" ? onRefreshJwt(auth.refreshToken) : null;

                if (refreshAction) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return dispatch(deauthenticate());

              case 9:
                reject("Unable to refresh JWT");
                return _context.abrupt("return");

              case 11:
                _context.next = 13;
                return dispatch(refreshAction);

              case 13:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                response = _yield$dispatch.response;
                error = _yield$dispatch.error;

                if (!(success && response && response.tokens)) {
                  _context.next = 23;
                  break;
                }

                _context.next = 20;
                return dispatch(authenticate(response.tokens.access, response.tokens.refresh));

              case 20:
                resolve(response.tokens.access);
                _context.next = 26;
                break;

              case 23:
                _context.next = 25;
                return dispatch(deauthenticate());

              case 25:
                reject(error);

              case 26:
                _context.next = 30;
                break;

              case 28:
                // valid
                resolve(auth.accessToken);

                if (auth.subject && auth.identity) {
                  setUserIdentity(auth.subject, auth.identity);
                }

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.next = 34;
                return dispatch(deauthenticate());

              case 34:
                reject("Unauthorised request");

              case 35:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  };
};

var refreshJwtPromise = concurrentPromise();

var refreshJwt = function refreshJwt(dispatch, authenticate, deauthenticate) {
  var invalidate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return refreshJwtPromise(function () {
    return dispatch(refreshJwtAction(authenticate, deauthenticate, invalidate));
  });
};

var tokenStoreProvider = null;

var getTokenStoreProvider = function getTokenStoreProvider() {
  return tokenStoreProvider;
};

var setTokenStoreProvider = function setTokenStoreProvider(provider) {
  if (_typeof$1(provider) === "object") {
    tokenStoreProvider = provider;
  } else {
    console.warn("Unable to set default token store provider, provider is invalid");
  }
};

var accessTokenKey = function accessTokenKey() {
  return "".concat(getTokenKey(), "-access");
};

var refreshTokenKey = function refreshTokenKey() {
  return "".concat(getTokenKey(), "-refresh");
};

var storeToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, token) {
    var provider;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.storeToken(key, token);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function storeToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
    var provider;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context2.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.getToken(key);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var clearToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
    var provider;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            provider = getTokenStoreProvider();
            _context3.next = 3;
            return provider === null || provider === void 0 ? void 0 : provider.clearToken(key);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function clearToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var storeAccessToken = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(token) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return storeToken(accessTokenKey(), token);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function storeAccessToken(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

var storeRefreshToken = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(token) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return storeToken(refreshTokenKey(), token);

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function storeRefreshToken(_x6) {
    return _ref5.apply(this, arguments);
  };
}();

var getAccessToken = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getToken(accessTokenKey());

          case 2:
            return _context6.abrupt("return", _context6.sent);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getAccessToken() {
    return _ref6.apply(this, arguments);
  };
}();

var getRefreshToken = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getToken(refreshTokenKey());

          case 2:
            return _context7.abrupt("return", _context7.sent);

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getRefreshToken() {
    return _ref7.apply(this, arguments);
  };
}();

var clearAllTokens = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Promise.all([clearToken(accessTokenKey()), clearToken(refreshTokenKey())]);

          case 2:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function clearAllTokens() {
    return _ref8.apply(this, arguments);
  };
}();

var onApiRequest = function onApiRequest(store, action, authenticate, deauthenticate) {
  if (action.auth === true) {
    return refreshJwt(store.dispatch, authenticate, deauthenticate, false).then(function (token) {
      return Promise.resolve({
        auth: "Bearer " + token
      });
    }).catch(function (error) {
      return Promise.reject(error);
    });
  } else if (typeof action.auth === "string") {
    // legacy support to override 'Authorization' header
    return Promise.resolve({
      auth: action.auth
    });
  }

  return Promise.resolve({});
};

var onAuthenticate = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, accessToken, refreshToken) {
    var authAction, jwt, config, identityClaims;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authAction = getOnAuthenticate();

            if (!authAction) {
              _context.next = 4;
              break;
            }

            _context.next = 4;
            return dispatch(authAction(accessToken, refreshToken));

          case 4:
            _context.next = 6;
            return storeAccessToken(accessToken);

          case 6:
            _context.next = 8;
            return storeRefreshToken(refreshToken);

          case 8:
            jwt = accessToken ? new JWT(accessToken) : null;

            if (jwt) {
              config = getJwtClaims();
              identityClaims = jwt.parseIdentityClaims(config);
              setUserIdentity(jwt.getSubject(), identityClaims);
            }

            return _context.abrupt("return", {
              accessToken: accessToken,
              refreshToken: refreshToken,
              jwt: jwt
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onAuthenticate(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var onAuthenticated = function onAuthenticated(dispatch, result) {
  var authAction = getOnAuthenticated();
  if (authAction) dispatch(authAction(result));
};

var onDeauthenticate = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
    var deauthAction;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            deauthAction = getOnDeauthenticate();

            if (!deauthAction) {
              _context2.next = 4;
              break;
            }

            _context2.next = 4;
            return dispatch(deauthAction());

          case 4:
            _context2.next = 6;
            return clearAllTokens();

          case 6:
            clearUserIdentity();

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function onDeauthenticate(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

var onDeauthenticated = function onDeauthenticated(dispatch) {
  var deauthAction = getOnDeauthenticated();
  if (deauthAction) dispatch(deauthAction());
};

var onMapAuthenticatedState = function onMapAuthenticatedState(result) {
  var jwt = result.jwt;
  var config = getJwtClaims();
  return {
    loggedIn: jwt != null,
    accessToken: result.accessToken,
    refreshToken: result.refreshToken,
    expiry: jwt ? jwt.getExpiry() : null,
    subject: jwt ? jwt.getSubject() : null,
    claims: jwt ? jwt.parseClaims(config) : {},
    identity: jwt ? jwt.parseIdentityClaims(config) : {}
  };
};

var onMapDeauthenticatedState = function onMapDeauthenticatedState() {
  return {
    loggedIn: false,
    accessToken: null,
    refreshToken: null,
    expiry: null,
    subject: null,
    claims: {},
    identity: {}
  };
};

var onReauthenticate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, authenticate, deauthenticate) {
    var accessToken, refreshToken, jwt, config, identityClaims;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getAccessToken();

          case 2:
            accessToken = _context3.sent;
            _context3.next = 5;
            return getRefreshToken();

          case 5:
            refreshToken = _context3.sent;
            jwt = accessToken ? new JWT(accessToken) : null;

            if (jwt) {
              _context3.next = 9;
              break;
            }

            return _context3.abrupt("return");

          case 9:
            config = getJwtClaims();
            identityClaims = jwt.parseIdentityClaims(config);
            setUserIdentity(jwt.getSubject(), identityClaims);
            _context3.next = 14;
            return dispatch(authenticate(accessToken, refreshToken));

          case 14:
            _context3.next = 16;
            return refreshJwt(dispatch, authenticate, deauthenticate, false);

          case 16:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function onReauthenticate(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

var jwtAuth = new ModuleIntegration("JwtAuth", jwtConfig);
jwtAuth.addActions({
  refreshToken: refreshJwt
});
jwtAuth.addEvents({
  onApiRequest: onApiRequest,
  onAuthenticate: onAuthenticate,
  onAuthenticated: onAuthenticated,
  onDeauthenticate: onDeauthenticate,
  onDeauthenticated: onDeauthenticated,
  onMapAuthenticatedState: onMapAuthenticatedState,
  onMapDeauthenticatedState: onMapDeauthenticatedState,
  onReauthenticate: onReauthenticate
});
var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': jwtAuth,

  get JwtClaimType() {
    return JwtClaimType;
  }

});
var integrations = new ModuleIntegrationPipeline();

var getAuthIntegrations = function getAuthIntegrations() {
  return integrations;
};

var getJwtOptions = function getJwtOptions() {
  return jwtAuth.config.getAll();
};

var setJwtOptions = function setJwtOptions(options) {
  return jwtAuth.config.setAll(options);
};
/**
 * Configures options for the JWT token auth integration
 * @param {object} `options` Options to set
 * @param {string} `options.tokenKey` Unique key for this app for cookie and local storage of tokens
 * @param {boolean} `options.useEmailVerification` Whether to require email verification for authentication, default false
 * @param {object} `options.jwtClaims` Object describing claims to parse from JWT tokens
 * @param {function} `options.onRefreshJwt` API action creator that will be dispatched when a JWT token refresh is required, should return a new set of tokens
 * @param {function} `options.onAuthenticated` Optional, action creator that will be dispatched when a user has been successfully authenticated
 * @param {function} `options.onDeauthenticated` Optional, action creator that will be dispatched when a user has been deauthenticated
 * @param {boolean} `setDefault` Optional, if using multiple auth integrations whether to make this the default
 */


var enableJwtAuth = function enableJwtAuth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  integrations.add(jwtAuth, setDefault);
  jwtAuth.config.setAll(options);
};
/**
 * Configures a custom auth integration
 * @param {ModuleIntegration} `integration` Instance of the auth module integration
 * @param {boolean} `setDefault` Optional, if using multiple auth integrations whether to make this the default
 */


var enableCustomAuth = function enableCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  integrations.add(integration, setDefault);
}; // --- legacy methods ---

/**
 * @deprecated replaced by getJwtOptions
 */


var getAuthOptions = function getAuthOptions() {
  return getJwtOptions();
};
/**
 * @deprecated replaced by enableJwtAuth
 */


var setAuthOptions = function setAuthOptions(options) {
  return enableJwtAuth(options);
};
/**
 * @deprecated replaced by enableJwtAuth
 */


var useJwtAuth = function useJwtAuth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return enableJwtAuth(options, setDefault);
};
/**
 * @deprecated replaced by enableCustomAuth
 */


var useCustomAuth = function useCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return enableCustomAuth(integration, setDefault);
};

var AuthIntegrationAction;

(function (AuthIntegrationAction) {
  AuthIntegrationAction["RefreshToken"] = "refreshToken";
})(AuthIntegrationAction || (AuthIntegrationAction = {}));

var AuthIntegrationEvent;

(function (AuthIntegrationEvent) {
  AuthIntegrationEvent["ApiRequest"] = "onApiRequest";
  AuthIntegrationEvent["Authenticate"] = "onAuthenticate";
  AuthIntegrationEvent["Deauthenticate"] = "onDeauthenticate";
  AuthIntegrationEvent["Authenticated"] = "onAuthenticated";
  AuthIntegrationEvent["Deauthenticated"] = "onDeauthenticated";
  AuthIntegrationEvent["MapAuthenticatedState"] = "onMapAuthenticatedState";
  AuthIntegrationEvent["MapDeauthenticatedState"] = "onMapDeauthenticatedState";
  AuthIntegrationEvent["Reauthenticate"] = "onReauthenticate";
  AuthIntegrationEvent["Restore"] = "onRestore";
})(AuthIntegrationEvent || (AuthIntegrationEvent = {})); // (in future multiple auth integrations should be supported)


var integrations$1 = getAuthIntegrations(); // action types

var NAMESPACE$2 = "AUTH";
var AUTHENTICATE = "".concat(NAMESPACE$2, "/AUTHENTICATE");
var DEAUTHENTICATE = "".concat(NAMESPACE$2, "/DEAUTHENTICATE");
/**
 * Action creator for authenticating access to the app (using JWT tokens)
 * @param {string} `accessToken` JWT access token to be stored
 * @param {string} `refreshToken` JWT refresh token to be stored
 */

var authenticate = function authenticate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var integration, authEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              authEvent = integration.findEvent(AuthIntegrationEvent.Authenticate);

              if (authEvent) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return authEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t0 = {};

            case 11:
              result = _context.t0;
              dispatch({
                type: AUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Authenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for deauthenticating access to the app (using JWT tokens)
 */


var deauthenticate = function deauthenticate() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var integration, deauthEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              deauthEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticate);

              if (deauthEvent) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return deauthEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 11;
                break;
              }

              _context2.t0 = {};

            case 11:
              result = _context2.t0;
              dispatch({
                type: DEAUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for ensuring the current JWT token is still valid and refreshing if required
 * @param {boolean} `invalidate` Whether the existing token should be invalidated, if true a new JWT token will always be requested, otherwise a new token will only be obtained if the current one has expired, default true
 * @returns {string} Returns a promise that when resolved gives the current JWT token
 */


var refreshJwt$1 = function refreshJwt() {
  var invalidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch) {
    var refreshAction = jwtAuth.findAction(AuthIntegrationAction.RefreshToken);
    if (!refreshAction) return;
    return refreshAction(dispatch, authenticate, deauthenticate, invalidate);
  };
};

var reauthenticate = function reauthenticate() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var integration, restoreEvent, restoreSuccess, reauthenticateEvent;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              integration = integrations$1.getDefault();

              if (integration) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              // legacy support for OnRestore event
              restoreEvent = integration.findEvent(AuthIntegrationEvent.Restore);

              if (!restoreEvent) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return restoreEvent(dispatch, authenticate, deauthenticate);

            case 7:
              restoreSuccess = _context3.sent;

              if (restoreSuccess) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return");

            case 10:
              reauthenticateEvent = integration.findEvent(AuthIntegrationEvent.Reauthenticate);

              if (reauthenticateEvent) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return");

            case 13:
              _context3.next = 15;
              return reauthenticateEvent.apply(void 0, [dispatch, authenticate, deauthenticate].concat(args));

            case 15:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AUTHENTICATE: AUTHENTICATE,
  DEAUTHENTICATE: DEAUTHENTICATE,
  authenticate: authenticate,
  deauthenticate: deauthenticate,
  refreshJwt: refreshJwt$1,
  reauthenticate: reauthenticate
}); // currently only a single 'default' integration can be used
// (in future multiple auth integrations should be supported)

var integrations$2 = getAuthIntegrations();

var onApiRequest$1 = function onApiRequest(store, action) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.ApiRequest);
    if (event) return event(store, action, authenticate, deauthenticate);
  }

  return Promise.resolve({});
};

var onMapAuthenticatedState$1 = function onMapAuthenticatedState(result) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapAuthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: true
  };
};

var onMapDeauthenticatedState$1 = function onMapDeauthenticatedState(result) {
  var integration = integrations$2.getDefault();

  if (integration) {
    var event = integration.findEvent(AuthIntegrationEvent.MapDeauthenticatedState);
    if (event) return event(result);
  }

  return {
    loggedIn: false
  };
};

var events = /*#__PURE__*/Object.freeze({
  __proto__: null,
  onApiRequest: onApiRequest$1,
  onMapAuthenticatedState: onMapAuthenticatedState$1,
  onMapDeauthenticatedState: onMapDeauthenticatedState$1
});
/**
 * A hook to return Redux state for parsed JWT claim data
 * @returns {object} JWT claim data
 */

var useAuthClaims = function useAuthClaims() {
  return useSelector(getAuthClaims);
};
/**
 * Wrapper component that will only render its children when authorisation claim conditions are met
 */


var ClaimCheck = function ClaimCheck(props) {
  var claim = props.claim,
      value = props.value,
      renderFailure = props.renderFailure,
      children = props.children;

  var _useAuthClaims = useAuthClaims(),
      claimData = _useAuthClaims[claim];

  var _ref = getAuthOptions().jwtClaims || {},
      claimOptions = _ref[claim];

  var claimWarning = useRef(false);

  if (!claimOptions && !claimWarning.current) {
    console.warn("".concat(claim, " does not exist in claim options for ClaimCheck"));
    claimWarning.current = true;
  }

  if (!claimData || !claimOptions) return null;
  var valid = false;
  var testValue = Array.isArray(value) ? value : [value];
  valid = testValue.every(function (test) {
    // custom value check callback
    if (typeof test === "function") {
      return test(claimData);
    } // for objects/arrays check key/values, otherwise direct value comparison


    if (claimOptions.type === "object") {
      return claimData.hasOwnProperty(test.key) && claimData[test.key] === test.value;
    }

    if (claimOptions.type === "array") {
      return claimData.some(function (x) {
        return x.key === test.key && x.value === test.value;
      });
    }

    return claimData === test;
  });

  if (!valid) {
    return renderFailure ? renderFailure() : null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var reactIs_production_min = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: !0
  });
  var b = "function" === typeof Symbol && Symbol.for,
      c = b ? Symbol.for("react.element") : 60103,
      d = b ? Symbol.for("react.portal") : 60106,
      e = b ? Symbol.for("react.fragment") : 60107,
      f = b ? Symbol.for("react.strict_mode") : 60108,
      g = b ? Symbol.for("react.profiler") : 60114,
      h = b ? Symbol.for("react.provider") : 60109,
      k = b ? Symbol.for("react.context") : 60110,
      l = b ? Symbol.for("react.async_mode") : 60111,
      m = b ? Symbol.for("react.concurrent_mode") : 60111,
      n = b ? Symbol.for("react.forward_ref") : 60112,
      p = b ? Symbol.for("react.suspense") : 60113,
      q = b ? Symbol.for("react.suspense_list") : 60120,
      r = b ? Symbol.for("react.memo") : 60115,
      t = b ? Symbol.for("react.lazy") : 60116,
      v = b ? Symbol.for("react.fundamental") : 60117,
      w = b ? Symbol.for("react.responder") : 60118;

  function x(a) {
    if ("object" === _typeof(a) && null !== a) {
      var u = a.$$typeof;

      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;

            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case h:
                  return a;

                default:
                  return u;
              }

          }

        case t:
        case r:
        case d:
          return u;
      }
    }
  }

  function y(a) {
    return x(a) === m;
  }

  exports.typeOf = x;
  exports.AsyncMode = l;
  exports.ConcurrentMode = m;
  exports.ContextConsumer = k;
  exports.ContextProvider = h;
  exports.Element = c;
  exports.ForwardRef = n;
  exports.Fragment = e;
  exports.Lazy = t;
  exports.Memo = r;
  exports.Portal = d;
  exports.Profiler = g;
  exports.StrictMode = f;
  exports.Suspense = p;

  exports.isValidElementType = function (a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === _typeof(a) && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w);
  };

  exports.isAsyncMode = function (a) {
    return y(a) || x(a) === l;
  };

  exports.isConcurrentMode = y;

  exports.isContextConsumer = function (a) {
    return x(a) === k;
  };

  exports.isContextProvider = function (a) {
    return x(a) === h;
  };

  exports.isElement = function (a) {
    return "object" === _typeof(a) && null !== a && a.$$typeof === c;
  };

  exports.isForwardRef = function (a) {
    return x(a) === n;
  };

  exports.isFragment = function (a) {
    return x(a) === e;
  };

  exports.isLazy = function (a) {
    return x(a) === t;
  };

  exports.isMemo = function (a) {
    return x(a) === r;
  };

  exports.isPortal = function (a) {
    return x(a) === d;
  };

  exports.isProfiler = function (a) {
    return x(a) === g;
  };

  exports.isStrictMode = function (a) {
    return x(a) === f;
  };

  exports.isSuspense = function (a) {
    return x(a) === p;
  };
});
unwrapExports(reactIs_production_min);
reactIs_production_min.typeOf;
reactIs_production_min.AsyncMode;
reactIs_production_min.ConcurrentMode;
reactIs_production_min.ContextConsumer;
reactIs_production_min.ContextProvider;
reactIs_production_min.Element;
reactIs_production_min.ForwardRef;
reactIs_production_min.Fragment;
reactIs_production_min.Lazy;
reactIs_production_min.Memo;
reactIs_production_min.Portal;
reactIs_production_min.Profiler;
reactIs_production_min.StrictMode;
reactIs_production_min.Suspense;
reactIs_production_min.isValidElementType;
reactIs_production_min.isAsyncMode;
reactIs_production_min.isConcurrentMode;
reactIs_production_min.isContextConsumer;
reactIs_production_min.isContextProvider;
reactIs_production_min.isElement;
reactIs_production_min.isForwardRef;
reactIs_production_min.isFragment;
reactIs_production_min.isLazy;
reactIs_production_min.isMemo;
reactIs_production_min.isPortal;
reactIs_production_min.isProfiler;
reactIs_production_min.isStrictMode;
reactIs_production_min.isSuspense;
var reactIs_development = createCommonjsModule(function (module, exports) {
  if (process.env.NODE_ENV !== "production") {
    (function () {
      Object.defineProperty(exports, '__esModule', {
        value: true
      }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
      // nor polyfill, then a plain number is used for performance.

      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
      // (unstable) APIs that have been removed. Can we remove the symbols?

      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;

      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || _typeof(type) === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE);
      }
      /**
       * Forked from fbjs/warning:
       * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
       *
       * Only change is we use console.warn instead of console.error,
       * and do nothing when 'console' is not supported.
       * This really simplifies the code.
       * ---
       * Similar to invariant but only logs a warning if the condition is not met.
       * This can be used to log issues in development environments in critical
       * paths. Removing the logging code for production environments will keep the
       * same logic and follow the same code paths.
       */


      var lowPriorityWarning = function lowPriorityWarning() {};

      {
        var printWarning = function printWarning(format) {
          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          var argIndex = 0;
          var message = 'Warning: ' + format.replace(/%s/g, function () {
            return args[argIndex++];
          });

          if (typeof console !== 'undefined') {
            console.warn(message);
          }

          try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
          } catch (x) {}
        };

        lowPriorityWarning = function lowPriorityWarning(condition, format) {
          if (format === undefined) {
            throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
          }

          if (!condition) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
              args[_key2 - 2] = arguments[_key2];
            }

            printWarning.apply(undefined, [format].concat(args));
          }
        };
      }
      var lowPriorityWarning$1 = lowPriorityWarning;

      function typeOf(object) {
        if (_typeof(object) === 'object' && object !== null) {
          var $$typeof = object.$$typeof;

          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;

              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;

                default:
                  var $$typeofType = type && type.$$typeof;

                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;

                    default:
                      return $$typeof;
                  }

              }

            case REACT_LAZY_TYPE:
            case REACT_MEMO_TYPE:
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }

        return undefined;
      } // AsyncMode is deprecated along with isAsyncMode


      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }

      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }

      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }

      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }

      function isElement(object) {
        return _typeof(object) === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }

      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }

      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }

      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }

      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }

      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }

      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }

      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }

      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }

      exports.typeOf = typeOf;
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isValidElementType = isValidElementType;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
    })();
  }
});
unwrapExports(reactIs_development);
reactIs_development.typeOf;
reactIs_development.AsyncMode;
reactIs_development.ConcurrentMode;
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isValidElementType;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
var reactIs = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function printWarning() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + _typeof(typeSpecs[typeSpecName]) + '`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + _typeof(error) + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;
var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning$1 = function printWarning$1() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function printWarning$1(text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function factoryWithTypeCheckers(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];

        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (!checker) {
          continue;
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from
      // props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (_typeof(propValue)) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = _typeof(propValue);

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function factoryWithThrowingShims() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }

  shim.isRequired = shim;

  function getShim() {
    return shim;
  } // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.


  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod

    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
});

var DefaultAuthLoadable = function DefaultAuthLoadable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

DefaultAuthLoadable.propTypes = {
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any,
  fluid: propTypes.bool
};
var authLoadable = DefaultAuthLoadable;

var getDefaultAuthLoadable = function getDefaultAuthLoadable() {
  return authLoadable;
};

var setDefaultAuthLoadable = function setDefaultAuthLoadable(component) {
  if (typeof component === "function") {
    authLoadable = component;
  } else {
    console.warn("Unable to set default auth loadable, component is invalid");
  }
};
/**
 * A hook to return Redux state for auth data
 * @returns {object} Auth data
 * @returns {boolean} `loggedIn` Whether the current user is logged in
 * @returns {string} `accessToken` JWT access token (when logged in using JWT authentication)
 * @returns {string} `refreshToken` JWT refresh token (when logged in using JWT authentication)
 * @returns {number} `expiry` JWT expiry date (when logged in using JWT authentication)
 * @returns {string} `subject` JWT subject claim (when logged in using JWT authentication)
 * @returns {object} `claims` JWT claim data (when logged in using JWT authentication)
 * @returns {object} `identity` JWT data for claims with an 'identity' tag (when logged in using JWT authentication)
 */


var useAuthState = function useAuthState() {
  return useSelector(getAuthState);
};
/**
 * A hook to return the authenticated status of the current user
 * @returns {boolean} Whether the current user is logged in
 */


var useLoggedIn = function useLoggedIn() {
  var _useAuthState = useAuthState(),
      loggedIn = _useAuthState.loggedIn;

  return loggedIn;
};
/**
 * High level wrapper component that forces a JWT refresh if not logged in
 * and will only render its children if logged in
 */


var AuthenticatedApp = function AuthenticatedApp(props) {
  var loggedIn = useLoggedIn();
  var dispatch = useDispatch();

  var _useState = useState(false),
      _useState2 = _slicedToArray$1(_useState, 2),
      hasAttemptedReauthentication = _useState2[0],
      sethasAttemptedReauthentication = _useState2[1];

  useEffect(function () {
    var attemptReauthenticate = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (loggedIn) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return dispatch(reauthenticate());

              case 3:
                sethasAttemptedReauthentication(true);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function attemptReauthenticate() {
        return _ref.apply(this, arguments);
      };
    }();

    attemptReauthenticate();
  }, []);
  var LoadableComponent = props.loadable || getDefaultAuthLoadable();
  return hasAttemptedReauthentication ? /*#__PURE__*/React.createElement(React.Fragment, null, props.children) : /*#__PURE__*/React.createElement(LoadableComponent, {
    fluid: true,
    loading: true
  });
};

var DefaultBuilderLoadable = function DefaultBuilderLoadable(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

DefaultBuilderLoadable.propTypes = {
  loading: propTypes.bool,
  slowLoading: propTypes.bool,
  error: propTypes.any
};
var builderLoadable = DefaultBuilderLoadable;

var getDefaultBuilderLoadable = function getDefaultBuilderLoadable() {
  return builderLoadable;
};

var setDefaultBuilderLoadable = function setDefaultBuilderLoadable(component) {
  if (typeof component === "function") {
    builderLoadable = component;
  } else {
    console.warn("Unable to set default builder loadable, component is invalid");
  }
};

var ContentBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ContentBase, _React$Component);

  var _super = _createSuper$1(ContentBase);

  function ContentBase(_props) {
    var _this;

    _classCallCheck$1(this, ContentBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultInitialState", function (props) {
      return _objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultResetState", function (props) {
      var resetData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), resetData ? _this.defaultDataState(props) : {});
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_loadingKey", undefined);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _data, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;

              if (onLoad) {
                _data = onLoad(loadParams);

                _this.setState({
                  data: _data
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function () {
      var defaultState = _this.defaultResetState(_this.props);

      _this.setState(function (prevState) {
        return _objectSpread2$1(_objectSpread2$1({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onRefresh", function () {
      var defaultState = _this.defaultResetState(_this.props, false);

      _this.setState(function (prevState) {
        return _objectSpread2$1(_objectSpread2$1({}, prevState), defaultState);
      }, _this.loadData);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass$1(ContentBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          error = _this$state.error,
          data = _this$state.data;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ContentBase;
}(React.Component);

_defineProperty$1(ContentBase, "propTypes", {
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  render: propTypes.func.isRequired,
  dispatch: propTypes.any.isRequired
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase = function connectBase() {
  return connect$1(null, mapDispatchToProps)(ContentBase);
};

var ContentBaseComponent = connectBase();

var ContentBase$1 = function ContentBase$1(props) {
  return /*#__PURE__*/React.createElement(ContentBaseComponent, props);
};

var FormBuilderResetStateType;

(function (FormBuilderResetStateType) {
  FormBuilderResetStateType["Data"] = "data";
  FormBuilderResetStateType["ReadOnly"] = "readOnly";
})(FormBuilderResetStateType || (FormBuilderResetStateType = {}));

var ListBuilderResetStateType;

(function (ListBuilderResetStateType) {
  ListBuilderResetStateType["Data"] = "data";
  ListBuilderResetStateType["Filters"] = "filters";
  ListBuilderResetStateType["Pagination"] = "pagination";
  ListBuilderResetStateType["Selection"] = "selection";
})(ListBuilderResetStateType || (ListBuilderResetStateType = {}));

var ALL_FORM_RESET_OPTIONS = [FormBuilderResetStateType.Data, FormBuilderResetStateType.ReadOnly];

var FormBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FormBase, _React$Component);

  var _super = _createSuper$1(FormBase);

  function FormBase(_props) {
    var _this;

    _classCallCheck$1(this, FormBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultCommonState", function () {
      return {
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultDataState", function (props) {
      return {
        formData: props.value || props.initialData,
        readOnlyData: props.value || props.initialData,
        loading: false,
        slowLoading: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultReadOnlyState", function (props) {
      return {
        readOnly: !!props.initialReadOnly
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultInitialState", function (props) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), _this.defaultDataState(props)), _this.defaultReadOnlyState(props));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), resetOptions.includes(FormBuilderResetStateType.Data) ? _this.defaultDataState(props) : {}), resetOptions.includes(FormBuilderResetStateType.ReadOnly) ? _this.defaultReadOnlyState(props) : {});
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof$1(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_FORM_RESET_OPTIONS;
      return _typeof$1(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_loadingKey", undefined);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          value = _this$props.value,
          loadParams = _this$props.loadParams;

      if (value && value !== prevProps.value) {
        _this.setState({
          formData: value
        });
      }

      if (!compareParams(loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _formData, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;

              if (onLoad) {
                _formData = onLoad(loadParams);

                _this.setState({
                  formData: _formData,
                  readOnlyData: _formData
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  formData: loadResponse,
                  readOnlyData: loadResponse
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormChange", function (field, data, applyChanges) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onChange) {
          _this.props.onChange(_this.state.formData);
        }
      };

      _this.setState(function (state) {
        return {
          formData: applyChanges(state.formData),
          dirty: true
        };
      }, onStateUpdated);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormValidated", function (formValid) {
      var onStateUpdated = function onStateUpdated() {
        if (_this.props.onValidated) {
          _this.props.onValidated(formValid);
        }
      };

      _this.setState({
        formValid: formValid
      }, onStateUpdated);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options) {
        var _this$props3, submitAction, _submitParams, submitSlowDelay, onSubmit, onSubmitted, loadAction, _loadParams, loadTransform, onLoad, onLoaded, reloadOnSubmit, _dispatch, slowTimeout, _submitResponse, submittingAction, _yield$_dispatch, success, error, response, reloadOption, resetOptions, resetState, defaultState, _formData2, _loadResponse, loadingKey, loadingAction, _yield$_dispatch2, _success, _error, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.formValid) {
                  _context2.next = 4;
                  break;
                }

                _this.setState({
                  showErrors: true
                });

                _context2.next = 59;
                break;

              case 4:
                _this$props3 = _this.props, submitAction = _this$props3.submitAction, _submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, loadAction = _this$props3.loadAction, _loadParams = _this$props3.loadParams, loadTransform = _this$props3.loadTransform, onLoad = _this$props3.onLoad, onLoaded = _this$props3.onLoaded, reloadOnSubmit = _this$props3.reloadOnSubmit, _dispatch = _this$props3.dispatch;
                slowTimeout = null;

                if (onSubmit) {
                  onSubmit(_this.state.formData, _submitParams);
                }

                _submitResponse = undefined;

                if (!submitAction) {
                  _context2.next = 28;
                  break;
                }

                submittingAction = abortableApi(submitAction(_this.state.formData, _submitParams));

                _this.setState({
                  submittingAbort: submittingAction.abort,
                  submitting: true,
                  error: undefined
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 14;
                return _dispatch(submittingAction);

              case 14:
                _yield$_dispatch = _context2.sent;
                success = _yield$_dispatch.success;
                error = _yield$_dispatch.error;
                response = _yield$_dispatch.response;
                if (!loadAction || !_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 21;
                  break;
                }

                return _context2.abrupt("return");

              case 21:
                if (success) {
                  _context2.next = 26;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 26:
                _submitResponse = response;

                _this.setState({
                  readOnlyData: _this.state.formData
                });

              case 28:
                if (onSubmitted) onSubmitted(_submitResponse, _submitParams); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 31;
                  break;
                }

                return _context2.abrupt("return");

              case 31:
                reloadOption = _this.parseReloadOption(options, !!reloadOnSubmit); // for legacy compatibility

                resetOptions = _this.parseResetOptions(options, []);

                if (reloadOption) {
                  _context2.next = 40;
                  break;
                }

                if (!(resetOptions.length > 0)) {
                  _context2.next = 38;
                  break;
                }

                resetState = _this.defaultResetState(_this.props, resetOptions);

                _this.setState(function (prevState) {
                  return _objectSpread2$1(_objectSpread2$1({}, prevState), resetState);
                });

                return _context2.abrupt("return");

              case 38:
                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  dirty: false
                });

                return _context2.abrupt("return");

              case 40:
                // re-load the form with latest data
                defaultState = _this.defaultResetState(_this.props, resetOptions.length > 0 ? resetOptions : ALL_FORM_RESET_OPTIONS);

                if (onLoad) {
                  _formData2 = onLoad(_loadParams);

                  _this.setState(function (prevState) {
                    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, prevState), defaultState), {}, {
                      formData: _formData2,
                      readOnlyData: _formData2
                    });
                  });
                }

                _loadResponse = undefined;

                if (!loadAction) {
                  _context2.next = 58;
                  break;
                }

                loadingKey = _this._loadingKey = Date.now();
                loadingAction = abortableApi(loadAction(_loadParams));
                _context2.next = 48;
                return _dispatch(loadingAction);

              case 48:
                _yield$_dispatch2 = _context2.sent;
                _success = _yield$_dispatch2.success;
                _error = _yield$_dispatch2.error;
                _response = _yield$_dispatch2.response;
                if (slowTimeout) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 55;
                  break;
                }

                return _context2.abrupt("return");

              case 55:
                if (!(loadingKey !== _this._loadingKey)) {
                  _context2.next = 57;
                  break;
                }

                return _context2.abrupt("return");

              case 57:
                if (!_success) {
                  _this.setState(function (prevState) {
                    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, prevState), defaultState), {}, {
                      error: _error
                    });
                  });
                } else {
                  if (_response) {
                    _loadResponse = loadTransform(_response);
                  }

                  _this.setState(function (prevState) {
                    return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, prevState), defaultState), {}, {
                      formData: _loadResponse !== undefined ? _loadResponse : prevState.formData,
                      readOnlyData: _loadResponse !== undefined ? _loadResponse : prevState.readOnlyData
                    });
                  });
                }

              case 58:
                if (onLoaded) onLoaded(_loadResponse, _loadParams);

              case 59:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2$1(_objectSpread2$1({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: []
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onToggleReadOnly", function () {
      var _this$state = _this.state,
          readOnly = _this$state.readOnly,
          readOnlyData = _this$state.readOnlyData,
          formData = _this$state.formData;

      if (readOnly) {
        _this.setState({
          readOnly: false,
          readOnlyData: formData
        });
      } else {
        // revert to data when previously read-only if known
        _this.setState({
          readOnly: true,
          formData: readOnlyData || formData
        });
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    return _this;
  }

  _createClass$1(FormBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          submitting = _this$state2.submitting,
          slowSubmitting = _this$state2.slowSubmitting,
          formData = _this$state2.formData,
          formValid = _this$state2.formValid,
          error = _this$state2.error,
          showErrors = _this$state2.showErrors,
          dirty = _this$state2.dirty,
          readOnly = _this$state2.readOnly;
      var formProps = {
        value: formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors && !readOnly,
        readOnly: readOnly
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        formValid: formValid,
        error: error,
        dirty: dirty,
        readOnly: readOnly
      };
      var events = {
        onSubmit: this.onSubmit,
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onToggleReadOnly: this.onToggleReadOnly,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(formProps, state, events);
    }
  }]);

  return FormBase;
}(React.Component);

_defineProperty$1(FormBase, "propTypes", {
  initialData: propTypes.any.isRequired,
  initialReadOnly: propTypes.bool.isRequired,
  value: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  reloadOnSubmit: propTypes.bool,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onChange: propTypes.func,
  onValidated: propTypes.func,
  render: propTypes.func.isRequired,
  abortSubmitOnUnmount: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$1 = function connectBase() {
  return connect$1(null, mapDispatchToProps$1)(FormBase);
};

var FormBaseComponent = connectBase$1();

var FormBase$1 = function FormBase$1(props) {
  return /*#__PURE__*/React.createElement(FormBaseComponent, props);
};

var PreferenceSource;

(function (PreferenceSource) {
  PreferenceSource["None"] = "None";
  PreferenceSource["LocalStorage"] = "LocalStorage";
  PreferenceSource["Api"] = "Api";
})(PreferenceSource || (PreferenceSource = {}));

var source = PreferenceSource.None;
var options = {};
var defaults = {};

var getPreferenceSource = function getPreferenceSource() {
  return source;
};

var getPreferenceOptions = function getPreferenceOptions() {
  return _objectSpread2$1({}, options);
};

var getPreferenceDefaults = function getPreferenceDefaults() {
  return _objectSpread2$1({}, defaults);
};
/**
 * Sets default preference values that will be used initially, or when preferences are reset
 * @param {object} `values` Default values to set
 */


var setPreferenceDefaults = function setPreferenceDefaults(values) {
  defaults = _objectSpread2$1({}, values);
};
/**
 * Configures preferences to be saved and loaded from browser local storage
 * @param {string} `key` Local storage key for where to store the data
 */


var enablePreferencesFromLocalStorage = function enablePreferencesFromLocalStorage(key) {
  source = PreferenceSource.LocalStorage;
  options = {
    key: key
  };
};
/**
 * Configures preferences to be saved and loaded from an external API
 * @param {function} `loadAction` API action creator for loading preferences data
 * @param {function} `saveAction` API action creator for saving preferences data
 */


var enablePreferencesFromApi = function enablePreferencesFromApi(loadAction, saveAction) {
  source = PreferenceSource.Api;
  options = {
    loadAction: loadAction,
    saveAction: saveAction
  };
}; // --- legacy methods ---

/**
 * @deprecated replaced by enablePreferencesFromLocalStorage
 */


var usePreferencesFromLocalStorage = function usePreferencesFromLocalStorage(key) {
  return enablePreferencesFromLocalStorage(key);
};
/**
 * @deprecated replaced by enablePreferencesFromApi
 */


var usePreferencesFromApi = function usePreferencesFromApi(loadAction, saveAction) {
  return enablePreferencesFromApi(loadAction, saveAction);
};

var getPreferenceState = function getPreferenceState(state) {
  return state.preferences;
};
/**
 * Selects Redux state for a single preference value
 * @param {object} `state` Redux state
 * @param {string} `key` Preference key to find
 */


var getPreferenceValue = function getPreferenceValue(state, key) {
  var preferenceState = getPreferenceState(state);
  return preferenceState[key];
};

var UPDATE_PREFERENCE = "PREFERENCES/UPDATE";
var RESET_PREFERENCES = "PREFERENCES/RESET";
var LOAD_PREFERENCES = "PREFERENCES/LOAD";
/**
 * Action creator for updating a single preference value
 * @param {string} `key` Preference key to update
 * @param {*} `value` New preference value
 */

var updatePreference = function updatePreference(key, value) {
  return {
    type: UPDATE_PREFERENCE,
    key: key,
    value: value
  };
};
/**
 * Action creator for resetting all preferences to default values
 */


var resetPreferences = function resetPreferences() {
  return {
    type: RESET_PREFERENCES
  };
};
/**
 * Action creator to load preferences from previously saved data (if configured)
 */


var loadPreferences = function loadPreferences() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var source, options, value, data, _options, _yield$dispatch, success, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              source = getPreferenceSource();
              _context.t0 = source;
              _context.next = _context.t0 === PreferenceSource.LocalStorage ? 4 : _context.t0 === PreferenceSource.Api ? 11 : 21;
              break;

            case 4:
              options = getPreferenceOptions();
              value = localStorage.getItem(options.key);

              if (!(value === null)) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", false);

            case 8:
              data = JSON.parse(value);
              dispatch({
                type: LOAD_PREFERENCES,
                values: data
              });
              return _context.abrupt("return", true);

            case 11:
              _options = getPreferenceOptions();
              _context.next = 14;
              return dispatch(typeof _options.loadAction === "function" ? _options.loadAction() : _options.loadAction);

            case 14:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              response = _yield$dispatch.response;

              if (!(success && response)) {
                _context.next = 20;
                break;
              }

              dispatch({
                type: LOAD_PREFERENCES,
                values: response
              });
              return _context.abrupt("return", true);

            case 20:
              return _context.abrupt("return", false);

            case 21:
              console.error("loadPreferences not supported by the current preference source");
              return _context.abrupt("return", false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator to save preferences for re-loading later (if configured)
 */


var savePreferences = function savePreferences() {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var source, state, options, _options2, _yield$dispatch2, success;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              source = getPreferenceSource();
              state = getPreferenceState(getState());
              _context2.t0 = source;
              _context2.next = _context2.t0 === PreferenceSource.LocalStorage ? 5 : _context2.t0 === PreferenceSource.Api ? 8 : 14;
              break;

            case 5:
              options = getPreferenceOptions();
              localStorage.setItem(options.key, JSON.stringify(state));
              return _context2.abrupt("return", true);

            case 8:
              _options2 = getPreferenceOptions();
              _context2.next = 11;
              return dispatch(_options2.saveAction(state));

            case 11:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              return _context2.abrupt("return", success);

            case 14:
              console.error("savePreferences not supported by the current preference source");
              return _context2.abrupt("return", false);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var RESET_LIST = "BUILDERS/RESET_LIST";
var CHANGE_FILTERS = "BUILDERS/CHANGE_FILTERS";
var CHANGE_PAGINATION = "BUILDERS/CHANGE_PAGINATION";
var CHANGE_SELECTION = "BUILDERS/CHANGE_SELECTION";
var CLEAR_STATE = "BUILDERS/CLEAR_STATE";

var resetList = function resetList(id, filters, pagination, selection) {
  return {
    type: RESET_LIST,
    id: id,
    filters: filters,
    pagination: pagination,
    selection: selection
  };
};

var changeFilters = function changeFilters(id, filters) {
  var resetPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: CHANGE_FILTERS,
    id: id,
    filters: filters,
    resetPage: resetPage
  };
};

var changePagination = function changePagination(id, pagination) {
  return {
    type: CHANGE_PAGINATION,
    id: id,
    pagination: pagination
  };
};

var changeSelection = function changeSelection(id, selection) {
  return {
    type: CHANGE_SELECTION,
    id: id,
    selection: selection
  };
};

var clearState = function clearState(id) {
  return {
    type: CLEAR_STATE,
    id: id
  };
};

var getBuilderState = function getBuilderState(state) {
  return state.builders;
};

var getBuilderData = function getBuilderData(state, id) {
  var builderState = getBuilderState(state);
  return builderState[id] || {};
};

var ALL_LIST_RESET_OPTIONS = [ListBuilderResetStateType.Data, ListBuilderResetStateType.Filters, ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection];

var ListBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListBase, _React$Component);

  var _super = _createSuper$1(ListBase);

  function ListBase(_props) {
    var _this;

    _classCallCheck$1(this, ListBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultCommonState", function () {
      return {
        error: undefined
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultDataState", function (props) {
      return {
        data: props.initialData !== undefined && props.initialData !== null ? props.dataTransform(props.initialData) : [],
        total: props.initialData !== undefined && props.initialData !== null ? props.totalTransform(props.initialData) : 0,
        loading: false,
        slowLoading: false,
        loadingMore: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultInitialState", function (props) {
      return _objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), _this.defaultDataState(props));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultResetState", function (props, resetOptions) {
      return _objectSpread2$1(_objectSpread2$1({}, _this.defaultCommonState()), resetOptions.includes(ListBuilderResetStateType.Data) ? _this.defaultDataState(props) : {});
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "resetReduxState", function (props, resetOptions) {
      var resetList = props.resetList,
          filters = props.filters,
          pagination = props.pagination,
          selection = props.selection,
          initialFilterCalc = props.initialFilterCalc,
          initialPaginationCalc = props.initialPaginationCalc,
          initialSelectionCalc = props.initialSelectionCalc;
      resetList(resetOptions.includes(ListBuilderResetStateType.Filters) ? initialFilterCalc : filters, resetOptions.includes(ListBuilderResetStateType.Pagination) ? initialPaginationCalc : pagination, resetOptions.includes(ListBuilderResetStateType.Selection) ? initialSelectionCalc : selection);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "parseReloadOption", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return _typeof$1(options) === "object" && options.hasOwnProperty("reload") ? !!options.reload : defaultValue;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "parseResetOptions", function (options) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ALL_LIST_RESET_OPTIONS;
      return _typeof$1(options) === "object" && Array.isArray(options.reset) ? options.reset : defaultValue;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_loadingKey", undefined);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();

      _this.props.clearState();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onRefresh();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, dataTransform, totalTransform, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, filters, pagination, selection, _data, loadResponse, loadingKey, loadingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, dataTransform = _this$props.dataTransform, totalTransform = _this$props.totalTransform, loadAction = _this$props.loadAction, loadParams = _this$props.loadParams, loadTransform = _this$props.loadTransform, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch, filters = _this$props.filters, pagination = _this$props.pagination, selection = _this$props.selection;

              if (onLoad) {
                _data = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: dataTransform(_data),
                  total: totalTransform(_data)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 21;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 11;
              return dispatch(loadingAction);

            case 11:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: dataTransform(loadResponse),
                  total: totalTransform(loadResponse)
                });
              }

            case 21:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "loadMore", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props2, dataTransform, totalTransform, loadAction, loadParams, loadTransform, onLoad, onLoaded, dispatch, filters, selection, _this$state, data, total, prevPagination, pagination, response, loadResponse, loadingKey, loadingAction, _yield$dispatch2, success, error, _response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props2 = _this.props, dataTransform = _this$props2.dataTransform, totalTransform = _this$props2.totalTransform, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch, filters = _this$props2.filters, selection = _this$props2.selection; // work out pagination required to get more data

              _this$state = _this.state, data = _this$state.data, total = _this$state.total;

              if (!(data.length >= total)) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return");

            case 4:
              prevPagination = _this.props.pagination;
              pagination = _objectSpread2$1(_objectSpread2$1({}, prevPagination), {}, {
                pageNumber: (prevPagination.pageNumber || 0) + 1
              });

              _this.props.changePagination(pagination);

              if (onLoad) {
                response = onLoad({
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                }, loadParams);

                _this.setState({
                  data: [].concat(_toConsumableArray$1(data), _toConsumableArray$1(dataTransform(response))),
                  total: totalTransform(response)
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context2.next = 25;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction({
                filters: filters,
                pagination: pagination,
                selection: selection
              }, loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loadingMore: true,
                error: undefined
              });

              _context2.next = 16;
              return dispatch(loadingAction);

            case 16:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              _response = _yield$dispatch2.response;

              if (_this._isMounted) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return");

            case 22:
              if (!(loadingKey !== _this._loadingKey)) {
                _context2.next = 24;
                break;
              }

              return _context2.abrupt("return");

            case 24:
              if (!success || !_response) {
                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  error: error
                }); // revert state to allow retries


                _this.props.changePagination(prevPagination);
              } else {
                loadResponse = loadTransform(_response, {
                  filters: filters,
                  pagination: pagination,
                  selection: selection
                });

                _this.setState({
                  loadingAbort: undefined,
                  loadingMore: false,
                  data: [].concat(_toConsumableArray$1(data), _toConsumableArray$1(dataTransform(loadResponse))),
                  total: totalTransform(loadResponse)
                });
              }

            case 25:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function (options) {
      var reloadOption = _this.parseReloadOption(options);

      var resetOptions = _this.parseResetOptions(options);

      _this.resetReduxState(_this.props, resetOptions);

      var defaultState = _this.defaultResetState(_this.props, resetOptions);

      _this.setState(function (prevState) {
        return _objectSpread2$1(_objectSpread2$1({}, prevState), defaultState);
      }, reloadOption ? _this.loadData : undefined);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onRefresh", function () {
      return _this.onReset({
        reload: true,
        reset: [ListBuilderResetStateType.Pagination, ListBuilderResetStateType.Selection]
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onChangeFilters", function (filters) {
      _this.props.changeFilters(filters);

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onChangePagination", function (pagination) {
      _this.props.changePagination(pagination);

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onChangeSelection", function (selection) {
      _this.props.changeSelection(selection);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _this.state = _this.defaultInitialState(_props);
    _this.onChangeFilters = debounce(_this.onChangeFilters, _props.debounceFilters);
    _this.onChangePagination = debounce(_this.onChangePagination, _props.debouncePagination);

    _this.resetReduxState(_props, ALL_LIST_RESET_OPTIONS);

    return _this;
  }

  _createClass$1(ListBase, [{
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
          loading = _this$state2.loading,
          slowLoading = _this$state2.slowLoading,
          loadingMore = _this$state2.loadingMore,
          error = _this$state2.error,
          data = _this$state2.data,
          total = _this$state2.total;
      var _this$props3 = this.props,
          filters = _this$props3.filters,
          pagination = _this$props3.pagination,
          selection = _this$props3.selection;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        error: error,
        filters: filters,
        pagination: pagination,
        selection: selection,
        total: total,
        hasMore: data && data.length < total,
        loadingMore: loadingMore
      };
      var events = {
        onReset: this.onReset,
        onRefresh: this.onRefresh,
        onChangeFilters: this.onChangeFilters,
        onChangePagination: this.onChangePagination,
        onChangeSelection: this.onChangeSelection,
        onLoadMore: this.loadMore,
        onAbortLoad: this.onAbortLoad
      };
      return this.props.render(data, state, events);
    }
  }]);

  return ListBase;
}(React.Component);

_defineProperty$1(ListBase, "propTypes", {
  initialData: propTypes.any,
  initialFilters: propTypes.any.isRequired,
  initialPagination: propTypes.any.isRequired,
  initialSelection: propTypes.any.isRequired,
  dataTransform: propTypes.func.isRequired,
  totalTransform: propTypes.func.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  persistFilters: propTypes.string,
  debounceFilters: propTypes.number.isRequired,
  debouncePagination: propTypes.number.isRequired,
  render: propTypes.func.isRequired,
  id: propTypes.string.isRequired,
  initialFilterCalc: propTypes.any.isRequired,
  initialPaginationCalc: propTypes.any.isRequired,
  initialSelectionCalc: propTypes.any.isRequired,
  filters: propTypes.any.isRequired,
  pagination: propTypes.any.isRequired,
  selection: propTypes.any.isRequired,
  dispatch: propTypes.any.isRequired,
  resetList: propTypes.func.isRequired,
  changeFilters: propTypes.func.isRequired,
  changePagination: propTypes.func.isRequired,
  changeSelection: propTypes.func.isRequired,
  clearState: propTypes.func.isRequired
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var data = getBuilderData(state, ownProps.id);
  var preferenceFilters = ownProps.persistFilters ? getPreferenceValue(state, ownProps.persistFilters) : null;
  var initialFilterCalc = preferenceFilters || ownProps.initialFilters;
  var initialPaginationCalc = ownProps.initialPagination;
  var initialSelectionCalc = ownProps.initialSelection;
  return {
    initialFilterCalc: initialFilterCalc,
    initialPaginationCalc: initialPaginationCalc,
    initialSelectionCalc: initialSelectionCalc,
    filters: data.filters || initialFilterCalc,
    pagination: data.pagination || initialPaginationCalc,
    selection: data.selection || initialSelectionCalc
  };
};

var mapDispatchToProps$2 = function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch: dispatch,
    resetList: function resetList$1(filters, pagination, selection) {
      return dispatch(resetList(ownProps.id, filters, pagination, selection));
    },
    changeFilters: function changeFilters$1(filters) {
      dispatch(changeFilters(ownProps.id, filters));

      if (ownProps.persistFilters) {
        dispatch(updatePreference(ownProps.persistFilters, filters));
      }
    },
    changePagination: function changePagination$1(pagination) {
      return dispatch(changePagination(ownProps.id, pagination));
    },
    changeSelection: function changeSelection$1(selection) {
      return dispatch(changeSelection(ownProps.id, selection));
    },
    clearState: function clearState$1() {
      return dispatch(clearState(ownProps.id));
    }
  };
};

var connectBase$2 = function connectBase() {
  return connect$1(mapStateToProps, mapDispatchToProps$2)(ListBase);
};

var ListBaseComponent = connectBase$2();

var ListBase$1 = function ListBase$1(props) {
  return /*#__PURE__*/React.createElement(ListBaseComponent, props);
};

var ModalFormBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ModalFormBase, _React$Component);

  var _super = _createSuper$1(ModalFormBase);

  function ModalFormBase(_props) {
    var _this;

    _classCallCheck$1(this, ModalFormBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        formData: props.initialData,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_loadingKey", undefined);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      if (_this.props.visible) {
        _this.loadData();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          loadParams = _this$props.loadParams;

      if (visible && !prevProps.visible) {
        var defaultState = _this.defaultState(_this.props);

        _this.setState(defaultState, _this.loadData);
      } else if (visible && !compareParams(loadParams, prevProps.loadParams)) {
        _this.onReset();
      } else if (!visible && prevProps.visible) {
        _this.onAbortLoad();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "preventErrorNotification", function () {
      var _getApiOptions = getApiOptions(),
          preventErrorNotification = _getApiOptions.preventErrorNotification;

      if (_this.props.preventErrorNotification) {
        setApiOptions({
          preventErrorNotification: true
        });
      }

      return preventErrorNotification;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "resetErrorNotification", function (preventErrorNotification) {
      setApiOptions({
        preventErrorNotification: preventErrorNotification
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, _formData, loadResponse, loadingKey, loadingAction, slowTimeout, notification, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;

              if (onLoad) {
                _formData = onLoad(loadParams);

                _this.setState({
                  formData: _formData
                });
              }

              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 23;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              notification = _this.preventErrorNotification();
              _context.next = 12;
              return dispatch(loadingAction);

            case 12:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  formData: loadResponse
                });
              }

            case 23:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormChange", function (field, data, applyChanges) {
      _this.setState(function (state) {
        return {
          formData: applyChanges(state.formData),
          dirty: true
        };
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormValidated", function (formValid) {
      return _this.setState({
        formValid: formValid
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, _submitParams, submitSlowDelay, onSubmit, onSubmitted, _dispatch, _submitResponse, submittingAction, slowTimeout, notification, _yield$_dispatch, success, error, response, defaultState;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this.state.formValid) {
                _context2.next = 4;
                break;
              }

              _this.setState({
                showErrors: true
              });

              _context2.next = 31;
              break;

            case 4:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, _submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, _dispatch = _this$props3.dispatch;

              if (onSubmit) {
                onSubmit(_this.state.formData, _submitParams);
              }

              _submitResponse = undefined;

              if (!submitAction) {
                _context2.next = 30;
                break;
              }

              submittingAction = abortableApi(submitAction(_this.state.formData, _submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              notification = _this.preventErrorNotification();
              _context2.next = 14;
              return _dispatch(submittingAction);

            case 14:
              _yield$_dispatch = _context2.sent;
              success = _yield$_dispatch.success;
              error = _yield$_dispatch.error;
              response = _yield$_dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 22;
                break;
              }

              return _context2.abrupt("return");

            case 22:
              if (success) {
                _context2.next = 27;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 27:
              defaultState = _this.defaultState(_this.props);

              _this.setState(defaultState);

              _submitResponse = response;

            case 30:
              if (onSubmitted) onSubmitted(_submitResponse, _submitParams);

            case 31:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onCancel", function () {
      var _this$props4 = _this.props,
          onCancel = _this$props4.onCancel,
          onCancelled = _this$props4.onCancelled,
          abortSubmitOnCancel = _this$props4.abortSubmitOnCancel;

      if (onCancel) {
        var stop = onCancel();
        if (stop) return;
      }

      _this.onAbortLoad();

      if (abortSubmitOnCancel) _this.onAbortSubmit();
      if (onCancelled) onCancelled();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass$1(ModalFormBase, [{
    key: "render",
    value: function render() {
      if (!this.props.visible) return null;
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          formData = _this$state.formData,
          formValid = _this$state.formValid,
          error = _this$state.error,
          showErrors = _this$state.showErrors,
          dirty = _this$state.dirty;
      var modalProps = {
        open: true,
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit
      };
      var formProps = {
        value: formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        formValid: formValid,
        error: error,
        dirty: dirty
      };
      var events = {
        onReset: this.onReset,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(modalProps, formProps, state, events);
    }
  }]);

  return ModalFormBase;
}(React.Component);

_defineProperty$1(ModalFormBase, "propTypes", {
  visible: propTypes.bool.isRequired,
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  render: propTypes.func.isRequired,
  preventErrorNotification: propTypes.bool.isRequired,
  abortSubmitOnCancel: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$3 = function connectBase() {
  return connect$1(null, mapDispatchToProps$3)(ModalFormBase);
};

var ConnectedModalFormBase = connectBase$3();

var ModalFormBase$1 = function ModalFormBase$1(props) {
  return /*#__PURE__*/React.createElement(ConnectedModalFormBase, props);
};

var ModalBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ModalBase, _React$Component);

  var _super = _createSuper$1(ModalBase);

  function ModalBase(_props) {
    var _this;

    _classCallCheck$1(this, ModalBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: undefined,
        data: props.initialData
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_loadingKey", undefined);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      if (_this.props.visible) {
        _this.loadData();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;

      _this.onAbortLoad();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          loadParams = _this$props.loadParams;

      if (visible && !prevProps.visible) {
        var defaultState = _this.defaultState(_this.props);

        _this.setState(defaultState, _this.loadData);
      } else if (visible && !compareParams(loadParams, prevProps.loadParams)) {
        _this.onReset();
      } else if (!visible && prevProps.visible) {
        _this.onAbortLoad();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "preventErrorNotification", function () {
      var _getApiOptions = getApiOptions(),
          preventErrorNotification = _getApiOptions.preventErrorNotification;

      if (_this.props.preventErrorNotification) {
        setApiOptions({
          preventErrorNotification: true
        });
      }

      return preventErrorNotification;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "resetErrorNotification", function (preventErrorNotification) {
      setApiOptions({
        preventErrorNotification: preventErrorNotification
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadParams, loadTransform, loadSlowDelay, onLoad, onLoaded, dispatch, loadResponse, loadingKey, loadingAction, slowTimeout, notification, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadParams = _this$props2.loadParams, loadTransform = _this$props2.loadTransform, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dispatch = _this$props2.dispatch;
              if (onLoad) onLoad(loadParams);
              loadResponse = undefined;

              if (!loadAction) {
                _context.next = 23;
                break;
              }

              loadingKey = _this._loadingKey = Date.now();
              loadingAction = abortableApi(loadAction(loadParams)); // cancel any previous request

              _this.onAbortLoad();

              _this.setState({
                loadingAbort: loadingAction.abort,
                loading: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              notification = _this.preventErrorNotification();
              _context.next = 12;
              return dispatch(loadingAction);

            case 12:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return");

            case 20:
              if (!(loadingKey !== _this._loadingKey)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return");

            case 22:
              if (!success || !response) {
                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loadingAbort: undefined,
                  loading: false,
                  slowLoading: false,
                  data: loadResponse
                });
              }

            case 23:
              if (onLoaded) onLoaded(loadResponse, loadParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, submittingAction, slowTimeout, notification, _yield$dispatch2, success, error, response, defaultState;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, dispatch = _this$props3.dispatch;
              if (onSubmit) onSubmit(submitParams);
              submitResponse = undefined;

              if (!submitAction) {
                _context2.next = 26;
                break;
              }

              submittingAction = abortableApi(submitAction(submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              notification = _this.preventErrorNotification();
              _context2.next = 10;
              return dispatch(submittingAction);

            case 10:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              response = _yield$dispatch2.response;

              _this.resetErrorNotification(notification);

              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 18;
                break;
              }

              return _context2.abrupt("return");

            case 18:
              if (success) {
                _context2.next = 23;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 23:
              defaultState = _this.defaultState(_this.props);

              _this.setState(defaultState);

              submitResponse = response;

            case 26:
              if (onSubmitted) onSubmitted(submitResponse, submitParams);

            case 27:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onCancel", function () {
      var _this$props4 = _this.props,
          onCancel = _this$props4.onCancel,
          onCancelled = _this$props4.onCancelled,
          abortSubmitOnCancel = _this$props4.abortSubmitOnCancel;

      if (onCancel) {
        var stop = onCancel();
        if (stop) return;
      }

      _this.onAbortLoad();

      if (abortSubmitOnCancel) _this.onAbortSubmit();
      if (onCancelled) onCancelled();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortLoad", function () {
      var loadingAbort = _this.state.loadingAbort;
      if (loadingAbort) loadingAbort.abort();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass$1(ModalBase, [{
    key: "render",
    value: function render() {
      if (!this.props.visible) return null;
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error,
          data = _this$state.data;
      var modalProps = {
        open: true,
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onCancel: this.onCancel,
        onSubmit: this.onSubmit,
        onAbortLoad: this.onAbortLoad,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(modalProps, data, state, events);
    }
  }]);

  return ModalBase;
}(React.Component);

_defineProperty$1(ModalBase, "propTypes", {
  visible: propTypes.bool.isRequired,
  initialData: propTypes.any.isRequired,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func.isRequired,
  loadSlowDelay: propTypes.number.isRequired,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  render: propTypes.func.isRequired,
  preventErrorNotification: propTypes.bool.isRequired,
  abortSubmitOnCancel: propTypes.bool.isRequired,
  dispatch: propTypes.oneOfType([propTypes.any, propTypes.any]).isRequired
});

var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$4 = function connectBase() {
  return connect$1(null, mapDispatchToProps$4)(ModalBase);
};

var ConnectedModalBase = connectBase$4();

var ModalBase$1 = function ModalBase$1(props) {
  return /*#__PURE__*/React.createElement(ConnectedModalBase, props);
};

var TriggerBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(TriggerBase, _React$Component);

  var _super = _createSuper$1(TriggerBase);

  function TriggerBase(props) {
    var _this;

    _classCallCheck$1(this, TriggerBase);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        submitting: false,
        slowSubmitting: false,
        success: false,
        error: undefined,
        data: undefined
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
      if (_this.props.abortSubmitOnUnmount) _this.onAbortSubmit();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, data, submitResponse, submittingAction, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, submitAction = _this$props.submitAction, submitParams = _this$props.submitParams, submitSlowDelay = _this$props.submitSlowDelay, onSubmit = _this$props.onSubmit, onSubmitted = _this$props.onSubmitted, dispatch = _this$props.dispatch;

              if (onSubmit) {
                data = onSubmit(submitParams);

                _this.setState({
                  success: true,
                  data: data
                });
              }

              submitResponse = undefined;

              if (!submitAction) {
                _context.next = 23;
                break;
              }

              submittingAction = abortableApi(submitAction(submitParams));

              _this.setState({
                submittingAbort: submittingAction.abort,
                submitting: true,
                error: undefined
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              _context.next = 9;
              return dispatch(submittingAction);

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              if (success) {
                _context.next = 21;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: false,
                error: error
              });

              return _context.abrupt("return");

            case 21:
              _this.setState({
                submitting: false,
                slowSubmitting: false,
                success: true,
                data: response
              });

              submitResponse = response;

            case 23:
              if (onSubmitted) onSubmitted(submitResponse, submitParams);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onAbortSubmit", function () {
      var submittingAbort = _this.state.submittingAbort;
      if (submittingAbort) submittingAbort.abort();
    });

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass$1(TriggerBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          success = _this$state.success,
          error = _this$state.error,
          data = _this$state.data;
      var fireTrigger = this.onSubmit;
      var state = {
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        success: success,
        error: error,
        data: data
      };
      var events = {
        onReset: this.onReset,
        onAbortSubmit: this.onAbortSubmit
      };
      return this.props.render(fireTrigger, state, events);
    }
  }]);

  return TriggerBase;
}(React.Component);

_defineProperty$1(TriggerBase, "propTypes", {
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number.isRequired,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  render: propTypes.func.isRequired,
  abortSubmitOnUnmount: propTypes.bool.isRequired,
  dispatch: propTypes.any.isRequired
});

var mapDispatchToProps$5 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var connectBase$5 = function connectBase() {
  return connect$1(null, mapDispatchToProps$5)(TriggerBase);
};

var TriggerBaseComponent = connectBase$5();

var TriggerBase$1 = function TriggerBase$1(props) {
  return /*#__PURE__*/React.createElement(TriggerBaseComponent, props);
};

var WizardBaseContext = /*#__PURE__*/React.createContext({});

var WizardBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WizardBase, _React$Component);

  var _super = _createSuper$1(WizardBase);

  function WizardBase(_props) {
    var _this;

    _classCallCheck$1(this, WizardBase);

    _this = _super.call(this, _props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null,
        steps: props.initialSteps,
        childContext: {
          getStepData: _this.getStepData,
          setStepData: _this.setStepData
        }
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "mapDataToSteps", function (data, steps, dataKey) {
      var _this$props = _this.props,
          mapDataToSteps = _this$props.mapDataToSteps,
          initialSteps = _this$props.initialSteps; // component consumer override

      if (mapDataToSteps) return mapDataToSteps(data, steps, dataKey); // only data arrays currently supported

      if (!Array.isArray(data)) return steps; // default mapping implementations

      if (initialSteps.length > 0) {
        // append data when steps known
        return steps.map(function (s, i) {
          return data[i] ? _objectSpread2$1(_objectSpread2$1({}, s), {}, _defineProperty$1({}, dataKey, data[i])) : s;
        });
      } else {
        // use data for steps
        return _toConsumableArray$1(data);
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "getStepData", function (stepIndex) {
      var dataKey = _this.props.dataKey;
      var steps = _this.state.steps;
      var step = steps[stepIndex] || {};
      return step[dataKey];
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "setStepData", function (stepIndex, data) {
      var dataKey = _this.props.dataKey;

      var steps = _toConsumableArray$1(_this.state.steps);

      if (stepIndex < 0 || stepIndex >= steps.length) return;
      steps[stepIndex] = _objectSpread2$1(_objectSpread2$1({}, steps[stepIndex]), {}, _defineProperty$1({}, dataKey, data));

      _this.setState({
        steps: steps
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;

      _this.loadData();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      if (!compareParams(_this.props.loadParams, prevProps.loadParams)) {
        _this.onReset();
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "loadData", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dataKey, dispatch, data, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadAction = _this$props2.loadAction, loadTransform = _this$props2.loadTransform, loadParams = _this$props2.loadParams, loadSlowDelay = _this$props2.loadSlowDelay, onLoad = _this$props2.onLoad, onLoaded = _this$props2.onLoaded, dataKey = _this$props2.dataKey, dispatch = _this$props2.dispatch;

              if (onLoad) {
                data = onLoad(loadParams);

                _this.setState({
                  steps: _this.mapDataToSteps(data, _this.state.steps, dataKey)
                });
              }

              loadResponse = null;

              if (!loadAction) {
                _context.next = 19;
                break;
              }

              loadingKey = Date.now();

              _this.setState({
                loadingKey: loadingKey,
                loading: true,
                error: null
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowLoading: true
                });
              }, loadSlowDelay);
              _context.next = 9;
              return dispatch(loadAction(loadParams));

            case 9:
              _yield$dispatch = _context.sent;
              success = _yield$dispatch.success;
              error = _yield$dispatch.error;
              response = _yield$dispatch.response;
              clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return");

            case 16:
              if (!(loadingKey !== _this.state.loadingKey)) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return");

            case 18:
              if (!success) {
                _this.setState({
                  loading: false,
                  slowLoading: false,
                  error: error
                });
              } else {
                loadResponse = loadTransform(response);

                _this.setState({
                  loading: false,
                  slowLoading: false,
                  steps: _this.mapDataToSteps(loadResponse, _this.state.steps, dataKey)
                });
              }

            case 19:
              if (onLoaded) {
                onLoaded(loadResponse, loadParams);
              }

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$props3, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, steps, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props3 = _this.props, submitAction = _this$props3.submitAction, submitParams = _this$props3.submitParams, submitSlowDelay = _this$props3.submitSlowDelay, onSubmit = _this$props3.onSubmit, onSubmitted = _this$props3.onSubmitted, dispatch = _this$props3.dispatch;
              steps = _this.state.steps;

              if (onSubmit) {
                onSubmit(steps, submitParams);
              }

              submitResponse = null;

              if (!submitAction) {
                _context2.next = 23;
                break;
              }

              _this.setState({
                submitting: true,
                error: null
              });

              slowTimeout = setTimeout(function () {
                if (!_this._isMounted) return;

                _this.setState({
                  slowSubmitting: true
                });
              }, submitSlowDelay);
              _context2.next = 9;
              return dispatch(submitAction(steps, submitParams));

            case 9:
              _yield$dispatch2 = _context2.sent;
              success = _yield$dispatch2.success;
              error = _yield$dispatch2.error;
              response = _yield$dispatch2.response; // prevent state changes after unmounting

              if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

              if (_this._isMounted) {
                _context2.next = 16;
                break;
              }

              return _context2.abrupt("return");

            case 16:
              if (success) {
                _context2.next = 21;
                break;
              }

              _this.setState({
                submitting: false,
                slowSubmitting: false,
                error: error
              });

              return _context2.abrupt("return");

            case 21:
              submitResponse = response;

              _this.setState({
                submitting: false,
                slowSubmitting: false
              });

            case 23:
              if (onSubmitted) onSubmitted(submitResponse, submitParams, steps);

            case 24:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "onReset", function () {
      var defaultState = _this.defaultState(_this.props);

      _this.setState(defaultState, _this.loadData);
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass$1(WizardBase, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error,
          steps = _this$state.steps,
          childContext = _this$state.childContext;
      var wizardProps = {
        steps: steps
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onReset: this.onReset,
        onSubmit: this.onSubmit
      };
      return /*#__PURE__*/React.createElement(WizardBaseContext.Provider, {
        value: childContext
      }, this.props.render(wizardProps, state, events));
    }
  }]);

  return WizardBase;
}(React.Component);

_defineProperty$1(WizardBase, "propTypes", {
  initialSteps: propTypes.arrayOf(propTypes.object),
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  dataKey: propTypes.string,
  mapDataToSteps: propTypes.func,
  render: propTypes.func.isRequired
});

_defineProperty$1(WizardBase, "defaultProps", {
  initialSteps: [],
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  dataKey: "data"
});

var mapDispatchToProps$6 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardBase$1 = connect$1(null, mapDispatchToProps$6)(WizardBase);

var WizardStepBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WizardStepBase, _React$Component);

  var _super = _createSuper$1(WizardStepBase);

  function WizardStepBase(props) {
    var _this;

    _classCallCheck$1(this, WizardStepBase);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_stepIndex", null);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "getData", function () {
      var getStepData = _this.context.getStepData;
      if (!getStepData || _this._stepIndex === null) return null;
      return getStepData(_this._stepIndex);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "setData", function (data) {
      var setStepData = _this.context.setStepData;
      if (!setStepData || _this._stepIndex === null) return;
      setStepData(_this._stepIndex, data);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onActivate", function (newStepIndex) {
      _this._stepIndex = newStepIndex;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onDeactivate", function () {
      _this._stepIndex = null;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onLoad", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stepIndex, step) {
        var _this$props, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dispatch, data, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, loadAction = _this$props.loadAction, loadTransform = _this$props.loadTransform, loadParams = _this$props.loadParams, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;
                _this._stepIndex = stepIndex;

                if (onLoad) {
                  data = onLoad(loadParams);

                  _this.setData(data);
                }

                loadResponse = null;

                if (!loadAction) {
                  _context.next = 20;
                  break;
                }

                loadingKey = Date.now();

                _this.setState({
                  loadingKey: loadingKey,
                  loading: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowLoading: true
                  });
                }, loadSlowDelay);
                _context.next = 10;
                return dispatch(loadAction(loadParams));

              case 10:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                error = _yield$dispatch.error;
                response = _yield$dispatch.response;
                clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                if (!(loadingKey !== _this.state.loadingKey)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return");

              case 19:
                if (!success) {
                  _this.setState({
                    loading: false,
                    slowLoading: false,
                    error: error
                  });
                } else {
                  loadResponse = loadTransform(response);

                  _this.setState({
                    loading: false,
                    slowLoading: false
                  });

                  _this.setData(loadResponse);
                }

              case 20:
                if (onLoaded) {
                  onLoaded(loadResponse, loadParams);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(stepIndex, step) {
        var _this$props2, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = _this.props, submitAction = _this$props2.submitAction, submitParams = _this$props2.submitParams, submitSlowDelay = _this$props2.submitSlowDelay, onSubmit = _this$props2.onSubmit, onSubmitted = _this$props2.onSubmitted, dispatch = _this$props2.dispatch;

                if (onSubmit) {
                  onSubmit(step, submitParams);
                }

                submitResponse = null;

                if (!submitAction) {
                  _context2.next = 22;
                  break;
                }

                _this.setState({
                  submitting: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 8;
                return dispatch(submitAction(step, submitParams));

              case 8:
                _yield$dispatch2 = _context2.sent;
                success = _yield$dispatch2.success;
                error = _yield$dispatch2.error;
                response = _yield$dispatch2.response; // prevent state changes after unmounting

                if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 15;
                  break;
                }

                return _context2.abrupt("return");

              case 15:
                if (success) {
                  _context2.next = 20;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 20:
                submitResponse = response;

                _this.setState({
                  submitting: false,
                  slowSubmitting: false
                });

              case 22:
                if (onSubmitted) {
                  onSubmitted(submitResponse, submitParams, step);
                }

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass$1(WizardStepBase, [{
    key: "data",
    get: function get() {
      return this.getData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          error = _this$state.error;
      var data = this.data;
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error
      };
      var events = {
        onLoad: this.onLoad,
        onSubmit: this.onSubmit,
        onUpdateData: this.setData
      };
      var stepProps = {
        error: error,
        loading: loading,
        slowLoading: slowLoading,
        onLoad: this.onLoad,
        nextLoading: submitting,
        onNext: this.onSubmit,
        onActivate: this.onActivate,
        onDeactivate: this.onDeactivate,
        passThruProps: {
          data: data,
          state: state,
          events: events
        }
      };
      return this.props.render(stepProps, data, state, events);
    }
  }]);

  return WizardStepBase;
}(React.Component);

_defineProperty$1(WizardStepBase, "propTypes", {
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  render: propTypes.func.isRequired
});

_defineProperty$1(WizardStepBase, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});

_defineProperty$1(WizardStepBase, "contextType", WizardBaseContext);

var mapDispatchToProps$7 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardStepBase$1 = connect$1(null, mapDispatchToProps$7)(WizardStepBase);

var WizardStepFormBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WizardStepFormBase, _React$Component);

  var _super = _createSuper$1(WizardStepFormBase);

  function WizardStepFormBase(props) {
    var _this;

    _classCallCheck$1(this, WizardStepFormBase);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "defaultState", function (props) {
      return {
        loading: false,
        slowLoading: false,
        submitting: false,
        slowSubmitting: false,
        error: null,
        formValid: true,
        showErrors: false,
        dirty: false
      };
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_stepIndex", null);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "getData", function () {
      var getStepData = _this.context.getStepData;
      if (!getStepData || _this._stepIndex === null) return {};
      return getStepData(_this._stepIndex) || {};
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "setData", function (data) {
      var setStepData = _this.context.setStepData;
      if (!setStepData || _this._stepIndex === null) return;
      setStepData(_this._stepIndex, data);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onActivate", function (newStepIndex) {
      _this._stepIndex = newStepIndex;

      _this.setState({
        showErrors: false,
        dirty: false
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onDeactivate", function (stepIndex) {
      _this._stepIndex = null;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onLoad", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee(stepIndex, step) {
        var _this$props, loadAction, loadTransform, loadParams, loadSlowDelay, onLoad, onLoaded, dispatch, formData, loadResponse, loadingKey, slowTimeout, _yield$dispatch, success, error, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, loadAction = _this$props.loadAction, loadTransform = _this$props.loadTransform, loadParams = _this$props.loadParams, loadSlowDelay = _this$props.loadSlowDelay, onLoad = _this$props.onLoad, onLoaded = _this$props.onLoaded, dispatch = _this$props.dispatch;
                _this._stepIndex = stepIndex;

                if (onLoad) {
                  formData = onLoad(loadParams);

                  _this.setData(formData);
                }

                loadResponse = null;

                if (!loadAction) {
                  _context.next = 20;
                  break;
                }

                loadingKey = Date.now();

                _this.setState({
                  loadingKey: loadingKey,
                  loading: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowLoading: true
                  });
                }, loadSlowDelay);
                _context.next = 10;
                return dispatch(loadAction(loadParams));

              case 10:
                _yield$dispatch = _context.sent;
                success = _yield$dispatch.success;
                error = _yield$dispatch.error;
                response = _yield$dispatch.response;
                clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                if (!(loadingKey !== _this.state.loadingKey)) {
                  _context.next = 19;
                  break;
                }

                return _context.abrupt("return");

              case 19:
                if (!success) {
                  _this.setState({
                    loading: false,
                    slowLoading: false,
                    error: error
                  });
                } else {
                  loadResponse = loadTransform(response);

                  _this.setState({
                    loading: false,
                    slowLoading: false
                  });

                  _this.setData(loadResponse);
                }

              case 20:
                if (onLoaded) {
                  onLoaded(loadResponse, loadParams);
                }

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized$1(_this), "onSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(stepIndex, step) {
        var _this$props2, submitAction, submitParams, submitSlowDelay, onSubmit, onSubmitted, dispatch, submitResponse, slowTimeout, _yield$dispatch2, success, error, response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this.state.formValid) {
                  _context2.next = 5;
                  break;
                }

                _this.setState({
                  showErrors: true
                });

                return _context2.abrupt("return", false);

              case 5:
                _this$props2 = _this.props, submitAction = _this$props2.submitAction, submitParams = _this$props2.submitParams, submitSlowDelay = _this$props2.submitSlowDelay, onSubmit = _this$props2.onSubmit, onSubmitted = _this$props2.onSubmitted, dispatch = _this$props2.dispatch;

                if (onSubmit) {
                  onSubmit(step, submitParams);
                }

                submitResponse = null;

                if (!submitAction) {
                  _context2.next = 27;
                  break;
                }

                _this.setState({
                  submitting: true,
                  error: null
                });

                slowTimeout = setTimeout(function () {
                  if (!_this._isMounted) return;

                  _this.setState({
                    slowSubmitting: true
                  });
                }, submitSlowDelay);
                _context2.next = 13;
                return dispatch(submitAction(step, submitParams));

              case 13:
                _yield$dispatch2 = _context2.sent;
                success = _yield$dispatch2.success;
                error = _yield$dispatch2.error;
                response = _yield$dispatch2.response; // prevent state changes after unmounting

                if (!_this._isMounted) clearTimeout(slowTimeout); // prevent state changes after unmounting

                if (_this._isMounted) {
                  _context2.next = 20;
                  break;
                }

                return _context2.abrupt("return");

              case 20:
                if (success) {
                  _context2.next = 25;
                  break;
                }

                _this.setState({
                  submitting: false,
                  slowSubmitting: false,
                  error: error
                });

                return _context2.abrupt("return");

              case 25:
                submitResponse = response;

                _this.setState({
                  submitting: false,
                  slowSubmitting: false
                });

              case 27:
                if (onSubmitted) {
                  onSubmitted(submitResponse, submitParams, step);
                }

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormChange", function (field, data, applyChanges) {
      var newData = applyChanges(_this.getData());

      _this.setData(newData);

      _this.setState({
        dirty: true
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onFormValidated", function (formValid) {
      return _this.setState({
        formValid: formValid
      });
    });

    _this.state = _this.defaultState(props);
    return _this;
  }

  _createClass$1(WizardStepFormBase, [{
    key: "formData",
    get: function get() {
      return this.getData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          slowLoading = _this$state.slowLoading,
          submitting = _this$state.submitting,
          slowSubmitting = _this$state.slowSubmitting,
          formValid = _this$state.formValid,
          error = _this$state.error,
          showErrors = _this$state.showErrors,
          dirty = _this$state.dirty;
      var formProps = {
        value: this.formData,
        onChange: this.onFormChange,
        onValidated: this.onFormValidated,
        showErrors: showErrors
      };
      var state = {
        loading: loading,
        slowLoading: slowLoading,
        submitting: submitting,
        slowSubmitting: slowSubmitting,
        error: error,
        formValid: formValid,
        dirty: dirty
      };
      var events = {
        onLoad: this.onLoad,
        onSubmit: this.onSubmit,
        onUpdateData: this.setData
      };
      var stepProps = {
        error: error,
        loading: loading,
        slowLoading: slowLoading,
        onLoad: this.onLoad,
        nextLoading: submitting,
        onNext: this.onSubmit,
        onActivate: this.onActivate,
        onDeactivate: this.onDeactivate,
        passThruProps: {
          formProps: formProps,
          state: state,
          events: events
        }
      };
      return this.props.render(stepProps, formProps, state, events);
    }
  }]);

  return WizardStepFormBase;
}(React.Component);

_defineProperty$1(WizardStepFormBase, "propTypes", _objectSpread2$1({}, WizardStepBase$1.propTypes));

_defineProperty$1(WizardStepFormBase, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});

_defineProperty$1(WizardStepFormBase, "contextType", WizardBaseContext);

var mapDispatchToProps$8 = function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch
  };
};

var WizardStepFormBase$1 = connect$1(null, mapDispatchToProps$8)(WizardStepFormBase);
/**
 * A helper to load data and display content
 */

var ContentBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ContentBuilder, _React$Component);

  var _super = _createSuper$1(ContentBuilder);

  function ContentBuilder() {
    var _this;

    _classCallCheck$1(this, ContentBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "renderLoadableContent", function (data, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderContent = _this$props.renderContent,
          renderLoading = _this$props.renderLoading,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderContent(data, state, events));
    });

    return _this;
  }

  _createClass$1(ContentBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
      _this$props2.loadable;

      var renderContent = _this$props2.renderContent,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties$1(_this$props2, ["loadable", "renderContent", "renderLoading", "renderError"]);

      return /*#__PURE__*/React.createElement(ContentBase$1, _extends$1({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderError === false ? renderContent.apply(void 0, arguments) : _this2.renderLoadableContent.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ContentBuilder;
}(React.Component);

_defineProperty$1(ContentBuilder, "propTypes", {
  renderContent: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  loadable: propTypes.elementType
});

_defineProperty$1(ContentBuilder, "defaultProps", {
  initialData: {},
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200
});
/**
 * A helper to load and save data, and manage state for a form
 */


var FormBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FormBuilder, _React$Component);

  var _super = _createSuper$1(FormBuilder);

  function FormBuilder() {
    var _this;

    _classCallCheck$1(this, FormBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "renderLoadableForm", function (formProps, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderForm = _this$props.renderForm,
          renderLoading = _this$props.renderLoading,
          renderSubmitting = _this$props.renderSubmitting,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.submitting) {
        if (renderSubmitting) return renderSubmitting(state.slowSubmitting);

        if (renderSubmitting !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = loadableProps.slowLoading || state.slowSubmitting;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderForm(formProps, state, events));
    });

    return _this;
  }

  _createClass$1(FormBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
      _this$props2.loadable;

      var renderForm = _this$props2.renderForm,
          renderLoading = _this$props2.renderLoading,
          renderSubmitting = _this$props2.renderSubmitting,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties$1(_this$props2, ["loadable", "renderForm", "renderLoading", "renderSubmitting", "renderError"]);

      return /*#__PURE__*/React.createElement(FormBase$1, _extends$1({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderSubmitting === false && renderError === false ? renderForm.apply(void 0, arguments) : _this2.renderLoadableForm.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return FormBuilder;
}(React.Component);

_defineProperty$1(FormBuilder, "propTypes", {
  renderForm: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderSubmitting: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  initialReadOnly: propTypes.bool,
  value: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  loadable: propTypes.elementType,
  onChange: propTypes.func,
  onValidated: propTypes.func,
  abortSubmitOnUnmount: propTypes.bool
});

_defineProperty$1(FormBuilder, "defaultProps", {
  initialData: {},
  initialReadOnly: false,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  abortSubmitOnUnmount: false
});
/**
 * A helper to load data and manage state for a list or table
 */


var ListBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ListBuilder, _React$Component);

  var _super = _createSuper$1(ListBuilder);

  function ListBuilder(props) {
    var _this;

    _classCallCheck$1(this, ListBuilder);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "listWithData", function (data, state, events) {
      var _ref = _this.props,
          renderList = _ref.renderList;
      return renderList(data, state, events);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "listWithTable", function (tableProps, state, events) {
      var _ref2 = _this.props,
          renderList = _ref2.renderList;
      return renderList(tableProps, state, events);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "listWithTiles", function (tileProps, state, events) {
      var _ref3 = _this.props,
          renderList = _ref3.renderList;
      return renderList(tileProps, state, events);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "renderDefaultList", function (data, state, events) {
      var _this$props = _this.props,
          withTable = _this$props.withTable,
          withTiles = _this$props.withTiles;

      if (withTable) {
        return _this.listWithTable({
          data: data
        }, state, events);
      }

      if (withTiles) {
        return _this.listWithTiles({
          data: data
        }, state, events);
      }

      return _this.listWithData(data, state, events);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "renderLoadableList", function (data, state, events) {
      var _this$props2 = _this.props,
          withTable = _this$props2.withTable,
          withTiles = _this$props2.withTiles,
          loadable = _this$props2.loadable,
          renderLoading = _this$props2.renderLoading,
          renderError = _this$props2.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      if (withTable) {
        return _this.listWithTable(_objectSpread2$1(_objectSpread2$1({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      if (withTiles) {
        return _this.listWithTiles(_objectSpread2$1(_objectSpread2$1({}, loadableProps), {}, {
          data: data
        }), state, events);
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, _this.listWithData(data, state, events));
    });

    var id = props.id;

    if (!id) {
      id = createAutoName("list/");
    }

    _this.state = {
      id: id
    };
    return _this;
  }

  _createClass$1(ListBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props;
      _this$props3.withTable;
      _this$props3.loadable;
      _this$props3.renderList;

      var renderLoading = _this$props3.renderLoading,
          renderError = _this$props3.renderError,
          otherProps = _objectWithoutProperties$1(_this$props3, ["withTable", "loadable", "renderList", "renderLoading", "renderError"]);

      return /*#__PURE__*/React.createElement(ListBase$1, _extends$1({}, otherProps, {
        id: this.state.id,
        render: function render() {
          return renderLoading === false && renderError === false ? _this2.renderDefaultList.apply(_this2, arguments) : _this2.renderLoadableList.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return ListBuilder;
}(React.Component);

_defineProperty$1(ListBuilder, "propTypes", {
  id: propTypes.string,
  withTable: propTypes.any,
  withTiles: propTypes.any,
  renderList: propTypes.func.isRequired,
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  renderError: propTypes.oneOfType([propTypes.func, propTypes.oneOf([false])]),
  initialData: propTypes.any,
  initialFilters: propTypes.any,
  initialPagination: propTypes.any,
  initialSelection: propTypes.any,
  dataTransform: propTypes.func,
  totalTransform: propTypes.func,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  loadable: propTypes.elementType,
  persistFilters: propTypes.string,
  debounceFilters: propTypes.number,
  debouncePagination: propTypes.number
});

_defineProperty$1(ListBuilder, "defaultProps", {
  withTable: false,
  withTiles: false,
  initialFilters: {},
  initialPagination: {
    pageSize: 10,
    pageNumber: 1
  },
  initialSelection: {},
  dataTransform: function dataTransform(data) {
    return data;
  },
  totalTransform: function totalTransform(data) {
    return data.length;
  },
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  debounceFilters: 250,
  debouncePagination: -250
});
/**
 * A helper to load and save data, and manage state for a modal
 */


var ModalBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ModalBuilder, _React$Component);

  var _super = _createSuper$1(ModalBuilder);

  function ModalBuilder() {
    var _this;

    _classCallCheck$1(this, ModalBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "state", {
      active: false
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "showModal", function () {
      return _this.setState({
        active: true
      });
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "submitModal", function (response, params) {
      _this.setState({
        active: false
      });

      var onSubmitted = _this.props.onSubmitted;
      if (onSubmitted) onSubmitted(response, params);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "cancelModal", function () {
      _this.setState({
        active: false
      });

      var onCancelled = _this.props.onCancelled;
      if (onCancelled) onCancelled();
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "modalWithData", function () {
      var _ref = _this.props;
      _ref.withForm;

      var renderTrigger = _ref.renderTrigger,
          onSubmitted = _ref.onSubmitted,
          onCancelled = _ref.onCancelled,
          renderModal = _ref.renderModal,
          otherProps = _objectWithoutProperties$1(_ref, ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"]);

      return /*#__PURE__*/React.createElement(ModalBase$1, _extends$1({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "modalWithForm", function () {
      var _ref2 = _this.props;
      _ref2.withForm;

      var renderTrigger = _ref2.renderTrigger,
          onSubmitted = _ref2.onSubmitted,
          onCancelled = _ref2.onCancelled,
          renderModal = _ref2.renderModal,
          otherProps = _objectWithoutProperties$1(_ref2, ["withForm", "renderTrigger", "onSubmitted", "onCancelled", "renderModal"]);

      return /*#__PURE__*/React.createElement(ModalFormBase$1, _extends$1({}, otherProps, {
        onSubmitted: renderTrigger ? _this.submitModal : onSubmitted,
        onCancelled: renderTrigger ? _this.cancelModal : onCancelled,
        render: renderModal
      }));
    });

    return _this;
  }

  _createClass$1(ModalBuilder, [{
    key: "render",
    value: function render() {
      var active = this.state.active;
      var _this$props = this.props,
          withForm = _this$props.withForm,
          renderTrigger = _this$props.renderTrigger;
      var modal = withForm ? this.modalWithForm() : this.modalWithData();

      if (renderTrigger) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, renderTrigger(this.showModal), active && modal);
      }

      return modal;
    }
  }]);

  return ModalBuilder;
}(React.Component);

_defineProperty$1(ModalBuilder, "propTypes", {
  submitAction: propTypes.func,
  onSubmit: propTypes.func,
  withForm: propTypes.any,
  renderTrigger: propTypes.func,
  renderModal: propTypes.func.isRequired,
  visible: propTypes.bool,
  initialData: propTypes.any,
  loadAction: propTypes.func,
  loadParams: propTypes.any,
  loadTransform: propTypes.func,
  loadSlowDelay: propTypes.number,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmitted: propTypes.func,
  onCancel: propTypes.func,
  onCancelled: propTypes.func,
  preventErrorNotification: propTypes.bool,
  abortSubmitOnCancel: propTypes.bool
});

_defineProperty$1(ModalBuilder, "defaultProps", {
  withForm: false,
  visible: true,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  initialData: {},
  preventErrorNotification: true,
  abortSubmitOnCancel: true
});
/**
 * A helper to submit data from a trigger and display the response
 */


var TriggerBuilder = function TriggerBuilder(props) {
  var renderTrigger = props.renderTrigger,
      renderSubmitting = props.renderSubmitting,
      renderError = props.renderError,
      otherProps = _objectWithoutProperties$1(props, ["renderTrigger", "renderSubmitting", "renderError"]);

  return /*#__PURE__*/React.createElement(TriggerBase$1, _extends$1({}, otherProps, {
    render: function render(fireTrigger, state, events) {
      if (state.submitting && renderSubmitting) {
        return renderSubmitting(state.slowSubmitting);
      }

      if (state.error && renderError) {
        return renderError(state.error);
      }

      return renderTrigger(fireTrigger, state, events);
    }
  }));
};

TriggerBuilder.propTypes = {
  renderTrigger: propTypes.func.isRequired,
  renderSubmitting: propTypes.func,
  renderError: propTypes.func,
  submitAction: propTypes.func,
  submitParams: propTypes.any,
  submitSlowDelay: propTypes.number,
  onSubmit: propTypes.func,
  onSubmitted: propTypes.func,
  abortSubmitOnUnmount: propTypes.bool
};
TriggerBuilder.defaultProps = {
  submitSlowDelay: 200,
  abortSubmitOnUnmount: false
};
/**
 * A helper to manage data and state for a single step within a WizardBuilder
 */

var WizardBuilderStep = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WizardBuilderStep, _React$Component);

  var _super = _createSuper$1(WizardBuilderStep);

  function WizardBuilderStep() {
    _classCallCheck$1(this, WizardBuilderStep);

    return _super.apply(this, arguments);
  }

  _createClass$1(WizardBuilderStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withForm = _this$props.withForm,
          renderStep = _this$props.renderStep,
          otherProps = _objectWithoutProperties$1(_this$props, ["withForm", "renderStep"]);

      var BaseComponent = withForm ? WizardStepFormBase$1 : WizardStepBase$1;
      return /*#__PURE__*/React.createElement(BaseComponent, _extends$1({}, otherProps, {
        render: renderStep
      }));
    }
  }]);

  return WizardBuilderStep;
}(React.Component);

_defineProperty$1(WizardBuilderStep, "propTypes", {
  /**
   * Whether the step should manage state for a form internally, defaults to false
   */
  withForm: propTypes.bool,

  /**
   * Render function for displaying the step
   * @param {Object} `stepProps` Props to be passed to a <Wizard.Step /> component. When <Wizard.Step /> is used with the 'component' prop, then 'formProps/data/state/events' will all be passed into the step component as props.
   * @param {*} `formProps/data` If withForm is true then props to be passed to a <Form/> component, otherwise the current step data
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.loading` Whether the step is currently loading
   * @param {boolean} `state.slowLoading` Whether the step is taking longer than expected to load
   * @param {boolean} `state.submitting` Whether the step is currently submitting
   * @param {boolean} `state.slowSubmitting` Whether the step is taking longer than expected to submit
   * @param {boolean} `state.formValid` If withForm is true, whether the entire step form is valid or not
   * @param {*} `state.error` Error when the step fails to load or submit
   * @param {boolean} `state.dirty` If withForm is true, whether any fields have been edited in the form since it was loaded or submitted
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `onLoad` Loads the data for the step
   * @param {function} `onSubmit` Submits the step
   * @param {function} `onUpdateData` Updates the data for the step
   */
  renderStep: propTypes.func.isRequired,

  /**
   * API action creator that should be dispatched to get the step data
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {Object|function} API action
   */
  loadAction: propTypes.func,

  /**
   * Optional additional parameters to supply to loadAction
   */
  loadParams: propTypes.any,

  /**
   * Transform function applied to the response of loadAction, to modify step data as required
   * Override this to manipulate the structure of loaded data
   * @param {*} `data` Input response data
   * @returns {*} Output transformed data
   */
  loadTransform: propTypes.func,

  /**
   * Delay before the step indicates it is taking a long time to load
   */
  loadSlowDelay: propTypes.number,

  /**
   * Callback function when the step is about to be loaded
   * (can be used as an alternative to loadAction by returning the step data)
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {*} Step data
   */
  onLoad: propTypes.func,

  /**
   * Callback function when the step has finished loading
   * @param {*} `loadResponse` API response from loadAction
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   */
  onLoaded: propTypes.func,

  /**
   * API action creator that should be dispatched to save the step data
   * @param {Array} `step` The current state of the step
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @returns {Object|function} API action
   */
  submitAction: propTypes.func,

  /**
   * Optional additional parameters to supply to submitAction
   */
  submitParams: propTypes.any,

  /**
   * Delay before the step indicates it is taking a long time to save
   */
  submitSlowDelay: propTypes.number,

  /**
   * Callback function when the step is about to be submitted
   * (can be used as an alternative to submitAction)
   * @param {Array} `step` The current state of the step
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   */
  onSubmit: propTypes.func,

  /**
   * Callback function when the step has finished saving
   * @param {*} `submitResponse` API response from submitAction
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @param {Array} `step` The current state of the step
   */
  onSubmitted: propTypes.func
});

_defineProperty$1(WizardBuilderStep, "defaultProps", {
  withForm: false,
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200
});
/**
 * A helper to load and save data, and manage state for a wizard
 */


var WizardBuilder = /*#__PURE__*/function (_React$Component) {
  _inherits$1(WizardBuilder, _React$Component);

  var _super = _createSuper$1(WizardBuilder);

  function WizardBuilder() {
    var _this;

    _classCallCheck$1(this, WizardBuilder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "renderLoadableWizard", function (wizardProps, state, events) {
      var _this$props = _this.props,
          loadable = _this$props.loadable,
          renderWizard = _this$props.renderWizard,
          renderLoading = _this$props.renderLoading,
          renderSubmitting = _this$props.renderSubmitting,
          renderError = _this$props.renderError;
      var loadableProps = {};

      if (state.loading) {
        if (renderLoading) return renderLoading(state.slowLoading);

        if (renderLoading !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = state.slowLoading;
        }
      }

      if (state.submitting) {
        if (renderSubmitting) return renderSubmitting(state.slowSubmitting);

        if (renderSubmitting !== false) {
          loadableProps.loading = true;
          loadableProps.slowLoading = loadableProps.slowLoading || state.slowSubmitting;
        }
      }

      if (state.error) {
        if (renderError) return renderError(state.error);

        if (renderError !== false) {
          loadableProps.error = state.error;
        }
      }

      var LoadableComponent = loadable || getDefaultBuilderLoadable();
      return /*#__PURE__*/React.createElement(LoadableComponent, loadableProps, renderWizard(wizardProps, state, events));
    });

    return _this;
  }

  _createClass$1(WizardBuilder, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
      _this$props2.loadable;

      var renderWizard = _this$props2.renderWizard,
          renderLoading = _this$props2.renderLoading,
          renderSubmitting = _this$props2.renderSubmitting,
          renderError = _this$props2.renderError,
          otherProps = _objectWithoutProperties$1(_this$props2, ["loadable", "renderWizard", "renderLoading", "renderSubmitting", "renderError"]);

      return /*#__PURE__*/React.createElement(WizardBase$1, _extends$1({}, otherProps, {
        render: function render() {
          return renderLoading === false && renderSubmitting === false && renderError === false ? renderWizard.apply(void 0, arguments) : _this2.renderLoadableWizard.apply(_this2, arguments);
        }
      }));
    }
  }]);

  return WizardBuilder;
}(React.Component);

_defineProperty$1(WizardBuilder, "propTypes", {
  /**
   * Render function for displaying the wizard
   * @param {Object} `wizardProps` Props to be passed to a <Wizard/> component
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.loading` Whether the wizard is currently loading
   * @param {boolean} `state.slowLoading` Whether the wizard is taking longer than expected to load
   * @param {boolean} `state.submitting` Whether the wizard is currently submitting
   * @param {boolean} `state.slowSubmitting` Whether the wizard is taking longer than expected to submit
   * @param {*} `state.error` Error when the wizard fails to load or submit
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onSubmit` Submits the wizard
   * @param {function} `events.onReset` Resets the builder and reloads wizard data
   */
  renderWizard: propTypes.func.isRequired,

  /**
   * Optional render function when the wizard is in a loading state
   * If not supplied a default loading renderer will be used, alternatively can be set to false to disable completely
   * @param {boolean} `slowLoading` Whether the wizard is taking longer than expected to load
   */
  renderLoading: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Optional render function when the wizard is in a submitting state
   * If not supplied a default submitting renderer will be used, alternatively can be set to false to disable completely
   * @param {boolean} `slowSubmitting` Whether the wizard is taking longer than expected to submit
   */
  renderSubmitting: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Optional render function when the wizard is in an error state
   * If not supplied a default error renderer will be used, alternatively can be set to false to disable completely
   * @param {*} `error` Error when the wizard fails to load or submit
   */
  renderError: propTypes.oneOfType([propTypes.func, propTypes.bool]),

  /**
   * Initial steps for the wizard.
   * If not specified, steps will be loaded dynamically using the response from loadAction/onLoad
   */
  initialSteps: propTypes.arrayOf(propTypes.object),

  /**
   * API action creator that should be dispatched to get the wizard data
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {Object|function} API action
   */
  loadAction: propTypes.func,

  /**
   * Optional additional parameters to supply to loadAction
   */
  loadParams: propTypes.any,

  /**
   * Transform function applied to the response of loadAction, to modify wizard data as required
   * Override this to manipulate the structure of loaded data
   * @param {*} `data` Input response data
   * @returns {*} Output transformed data
   */
  loadTransform: propTypes.func,

  /**
   * Delay before the wizard indicates it is taking a long time to load
   */
  loadSlowDelay: propTypes.number,

  /**
   * Callback function when the wizard is about to be loaded
   * (can be used as an alternative to loadAction by returning the wizard data)
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   * @returns {*} Wizard data
   */
  onLoad: propTypes.func,

  /**
   * Callback function when the wizard has finished loading
   * @param {*} `loadResponse` API response from loadAction
   * @param {*} `loadParams` Additional parameters from loadParams if specified
   */
  onLoaded: propTypes.func,

  /**
   * Allows the default component used for rendering loading and error state to be overridden
   * (when renderLoading/renderError are not specified)
   * Will receive the output of renderList as its children
   */
  loadable: propTypes.elementType,

  /**
   * API action creator that should be dispatched to save the wizard data
   * @param {Array} `steps` The current state of the wizard steps
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @returns {Object|function} API action
   */
  submitAction: propTypes.func,

  /**
   * Optional additional parameters to supply to submitAction
   */
  submitParams: propTypes.any,

  /**
   * Delay before the wizard indicates it is taking a long time to save
   */
  submitSlowDelay: propTypes.number,

  /**
   * Callback function when the wizard is about to be submitted
   * (can be used as an alternative to submitAction)
   * @param {Array} `steps` The current state of the wizard steps
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   */
  onSubmit: propTypes.func,

  /**
   * Callback function when the wizard has finished saving
   * @param {*} `submitResponse` API response from submitAction
   * @param {*} `submitParams` Additional parameters from submitParams if specified
   * @param {Array} `steps` The current state of the wizard steps
   */
  onSubmitted: propTypes.func,

  /**
   * Name of a key property in step objects that step data should be stored against
   */
  dataKey: propTypes.string,

  /**
   * Optional, transform function applied when wizard data is loaded, to map it against the step state.
   * If not supplied and data is an array, each data item will be assigned to the corresponding step index, against the key specified by the 'dataKey' prop.
   * @param {*} `data` The data that was loaded
   * @param {Array} `steps` The current state of the wizard steps
   * @param {string} `dataKey` The current value of the dataKey prop
   * @returns {Array} The new state for the wizard steps
   */
  mapDataToSteps: propTypes.func
});

_defineProperty$1(WizardBuilder, "defaultProps", {
  loadTransform: function loadTransform(data) {
    return data;
  },
  loadSlowDelay: 200,
  submitSlowDelay: 200,
  dataKey: "data"
});

WizardBuilder.Step = WizardBuilderStep;
var PropagateUpdatesMethod;

(function (PropagateUpdatesMethod) {
  PropagateUpdatesMethod["Never"] = "never";
  PropagateUpdatesMethod["Parent"] = "parent";
  PropagateUpdatesMethod["Always"] = "always";
})(PropagateUpdatesMethod || (PropagateUpdatesMethod = {}));

var TriggerEvent;

(function (TriggerEvent) {
  TriggerEvent["OnChange"] = "onChange";
  TriggerEvent["OnClear"] = "onClear";
  TriggerEvent["OnSet"] = "onSet";
  TriggerEvent["OnMatch"] = "onMatch";
})(TriggerEvent || (TriggerEvent = {}));

var TriggerAction;

(function (TriggerAction) {
  TriggerAction["Change"] = "change";
  TriggerAction["Clear"] = "clear";
  TriggerAction["Set"] = "set";
})(TriggerAction || (TriggerAction = {}));

var omitProps = function omitProps(props, filterArray) {
  return filterArray.reduce(function (acc, p) {
    acc[p];

    var filtered = _objectWithoutProperties$1(acc, [p].map(_toPropertyKey$1));

    return filtered;
  }, _objectSpread2$1({}, props));
};

var fieldErrors = function fieldErrors(errors) {
  var showErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var allErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!showErrors || !errors || !errors.length) return [];
  return allErrors ? errors : [errors[0]];
};

var countErrors = function countErrors(errors) {
  return Object.values(errors).reduce(function (total, e) {
    if (Array.isArray(e) && _typeof$1(e[0]) === "object") return total + e.reduce(function (subtotal, f) {
      return subtotal + countErrors(f);
    }, 0);
    if (Array.isArray(e)) return total + e.length;
    if (_typeof$1(e) === "object") return total + countErrors(e);
    return total;
  }, 0);
};

var shallowCompareObjects = function shallowCompareObjects(a, b) {
  for (var key in a) {
    if (!(key in b) || a[key] !== b[key]) return false;
  }

  for (var _key in b) {
    if (!(_key in a) || a[_key] !== b[_key]) return false;
  }

  return true;
};

var shallowCompareArrays = function shallowCompareArrays(a, b) {
  if (a.length !== b.length) {
    return false;
  }

  for (var i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
};

var shouldFieldUpdate = function shouldFieldUpdate(currentProps, nextProps) // pass through updates for parent value changes (arrays/objects)
{
  var propagateUpdates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (propagateUpdates === PropagateUpdatesMethod.Always) {
    return true;
  }

  var propagateParent = propagateUpdates === PropagateUpdatesMethod.Parent || propagateUpdates === true; // update on props change

  if (currentProps && nextProps) {
    var removeChildrenProp = function removeChildrenProp(props) {
      // ignore these props
      if (props.children || props.passThruProps || props.parentValue || props.formValue || props.formState) {
        if (propagateParent) {
          props.children;
          props.passThruProps;

          var rest = _objectWithoutProperties$1(props, ["children", "passThruProps"]);

          return rest;
        } else {
          props.children;
          props.passThruProps;
          props.parentValue;
          props.formValue;
          props.formState;

          var _rest = _objectWithoutProperties$1(props, ["children", "passThruProps", "parentValue", "formValue", "formState"]);

          return _rest;
        }
      }

      return props;
    };

    var currentPropsToCompare = removeChildrenProp(currentProps);
    var nextPropsToCompare = removeChildrenProp(nextProps);

    if (!shallowCompareObjects(currentPropsToCompare, nextPropsToCompare)) {
      return true;
    }
  }

  return false;
};

var fieldFormState = function fieldFormState(context) {
  var value = context.value,
      errors = context.errors,
      parentValue = context.parentValue,
      formValue = context.formValue,
      arrayIndex = context.arrayIndex;
  return {
    fields: value,
    errors: errors,
    parentFields: parentValue,
    formFields: formValue,
    arrayIndex: arrayIndex
  };
};

var prettifyField = function prettifyField(field) {
  return field.replace(/([A-Z])/g, " $1").replace(/^./, function (c) {
    return c.toUpperCase();
  });
};

var isValueSet = function isValueSet(value) {
  return value !== undefined && value !== null && (!Array.isArray(value) || value.length > 0) && (_typeof$1(value) !== "object" || Object.values(value).some(function (el) {
    return isValueSet(el);
  })) && (typeof value !== "string" || value.trim() !== "");
};

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  omitProps: omitProps,
  fieldErrors: fieldErrors,
  countErrors: countErrors,
  shallowCompareObjects: shallowCompareObjects,
  shallowCompareArrays: shallowCompareArrays,
  shouldFieldUpdate: shouldFieldUpdate,
  fieldFormState: fieldFormState,
  prettifyField: prettifyField,
  isValueSet: isValueSet
});
var FormContext = /*#__PURE__*/React.createContext({
  value: {},
  onChange: function onChange() {},
  errors: {},
  onError: function onError() {},
  showErrors: false,
  allErrors: false,
  animateErrors: false,
  disabled: false,
  readOnly: false
});
FormContext.displayName = "FormContext";

var getDefaultOptions = function getDefaultOptions() {
  return {
    defaultProps: {},
    displayName: function displayName(props) {
      return props.field;
    },
    validators: []
  };
};

var connectForm = function connectForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions();
  return function (FieldComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions();
    var validators = options.validators || defaultOptions.validators || [];
    var validatorPropTypes = validators.reduce(function (acc, v) {
      return v.propTypes ? _objectSpread2$1(_objectSpread2$1({}, acc), v.propTypes) : acc;
    }, {});
    var validatorDefaultProps = validators.reduce(function (acc, v) {
      return v.defaultProps ? _objectSpread2$1(_objectSpread2$1({}, acc), v.defaultProps) : acc;
    }, {});
    var fieldDefaultProps = options.defaultProps || defaultOptions.defaultProps;

    var FieldProvider = /*#__PURE__*/function (_React$Component) {
      _inherits$1(FieldProvider, _React$Component);

      var _super = _createSuper$1(FieldProvider);

      function FieldProvider() {
        _classCallCheck$1(this, FieldProvider);

        return _super.apply(this, arguments);
      }

      _createClass$1(FieldProvider, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          return shouldFieldUpdate(this.props, nextProps);
        }
      }, {
        key: "render",
        value: function render() {
          return /*#__PURE__*/React.createElement(FieldComponent, this.props);
        }
      }]);

      return FieldProvider;
    }(React.Component);

    _defineProperty$1(FieldProvider, "propTypes", {
      value: propTypes.any,
      onChange: propTypes.func.isRequired,
      errors: propTypes.arrayOf(propTypes.string),
      passThruProps: propTypes.any.isRequired,
      formState: propTypes.any.isRequired
    });

    _defineProperty$1(FieldProvider, "defaultProps", {
      value: undefined
    });

    _defineProperty$1(FieldProvider, "displayName", "".concat(FieldComponent.displayName || FieldComponent.name, "Provider"));

    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits$1(FieldWrapper, _React$Component2);

      var _super2 = _createSuper$1(FieldWrapper);

      function FieldWrapper() {
        var _this;

        _classCallCheck$1(this, FieldWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty$1(_assertThisInitialized$1(_this), "_prevContext", void 0);

        _defineProperty$1(_assertThisInitialized$1(_this), "onChange", function (data) {
          var additionalFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var field = _this.props.field;

          var applyChanges = function applyChanges(prevValue) {
            return _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, prevValue), additionalFormData), {}, _defineProperty$1({}, field, data));
          };

          if (_this.context.onChange) {
            _this.context.onChange(field, data, applyChanges);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this), "validate", function (props, context) {
          var comparePreviousErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var field = props.field;
          var contextValue = context.value || {};
          var fieldValue = contextValue[field];
          var fieldName = options.displayName ? options.displayName(props) : defaultOptions.displayName ? defaultOptions.displayName(props) : "";

          if (props.customValidator) {
            props.customValidator(fieldName, fieldValue, props, context);
          }

          var errors = validators.reduce(function (acc, v) {
            if (!v.getErrors) return acc;
            if (v.shouldValidate && !v.shouldValidate(props, context)) return acc;
            return [].concat(_toConsumableArray$1(acc), _toConsumableArray$1(v.getErrors(fieldName, fieldValue, props, context)));
          }, []);

          if (comparePreviousErrors) {
            // stop if errors unchanged
            if (shallowCompareArrays(context.errors && context.errors[field] ? context.errors[field] : [], errors)) {
              return;
            }
          }

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, field, errors));
          };

          if (_this.context.onError) {
            _this.context.onError(field, errors, applyErrors);
          }
        });

        return _this;
      }

      _createClass$1(FieldWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.validate(this.props, this.context);
          this._prevContext = this.context;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clear validation errors so unmounted components don't invalidate forms
          var field = this.props.field;
          var errors = [];

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, field, errors));
          };

          if (this.context.onError) {
            this.context.onError(field, errors, applyErrors);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$_prevContext,
              _this2 = this;

          var currentContextValue = this.context.value || {};
          var prevContextValue = ((_this$_prevContext = this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
          var validate = currentContextValue[this.props.field] !== prevContextValue[prevProps.field];

          if (!validate) {
            // run validators if any validator props have changed
            var validatorPropKeys = Object.keys(validatorPropTypes);
            validate = validatorPropKeys.some(function (k) {
              return _this2.props[k] !== prevProps[k];
            });
          }

          if (!validate) {
            // run validators if need notification of other field changes
            var notifiedFields = validators.reduce(function (acc, v) {
              if (!v.getNotifiedFields) return acc;
              return [].concat(_toConsumableArray$1(acc), _toConsumableArray$1(v.getNotifiedFields(_this2.props)));
            }, this.props.notifiedFields || []);
            validate = notifiedFields.some(function (f) {
              return currentContextValue[f] !== prevContextValue[f];
            });
          }

          if (validate) {
            this.validate(this.props, this.context, true);
          }

          this._prevContext = this.context;
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              field = _this$props.field,
              showErrors = _this$props.showErrors,
              allErrors = _this$props.allErrors,
              animateErrors = _this$props.animateErrors,
              disabled = _this$props.disabled,
              readOnly = _this$props.readOnly,
              customErrors = _this$props.customErrors;
          var contextValue = this.context.value || {};
          var contextErrors = this.context.errors || {};
          var passThruProps = omitProps(this.props, Object.keys(FieldWrapper.propTypes));
          var fieldErrors = contextErrors[field];

          if (customErrors && customErrors.length) {
            fieldErrors = customErrors.concat(fieldErrors || []);
          }

          var formState = fieldFormState(this.context);
          return /*#__PURE__*/React.createElement(FieldProvider, _extends$1({}, this.props, {
            value: contextValue[field],
            onChange: this.onChange,
            errors: fieldErrors,
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly,
            passThruProps: passThruProps,
            formState: formState
          }));
        }
      }]);

      return FieldWrapper;
    }(React.Component), _defineProperty$1(_class, "propTypes", _objectSpread2$1({}, validatorPropTypes)), _defineProperty$1(_class, "defaultProps", _objectSpread2$1(_objectSpread2$1({}, fieldDefaultProps), validatorDefaultProps)), _defineProperty$1(_class, "contextType", FormContext), _defineProperty$1(_class, "displayName", "connectForm(".concat(FieldComponent.displayName || FieldComponent.name, ")")), _temp;
  };
};

function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function memoizeOne(resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = areInputsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  function memoized() {
    var newArgs = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      newArgs[_i] = arguments[_i];
    }

    if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
}

var getDefaultOptions$1 = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};

var withForm = function withForm() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$1();
  return function (FormComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$1();
    var formDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component) {
      _inherits$1(FormWrapper, _React$Component);

      var _super = _createSuper$1(FormWrapper);

      function FormWrapper() {
        var _this;

        _classCallCheck$1(this, FormWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty$1(_assertThisInitialized$1(_this), "defaultOnError", function (field, errors, applyErrors) {
          var onStateUpdated = function onStateUpdated() {
            if (!_this.props.onValidated) return;
            var totalErrors = countErrors(_this.state.errors);

            _this.props.onValidated(totalErrors === 0);
          };

          _this.setState(function (state) {
            return {
              errors: applyErrors(state.errors)
            };
          }, onStateUpdated);
        });

        _defineProperty$1(_assertThisInitialized$1(_this), "state", {
          errors: {}
        });

        _defineProperty$1(_assertThisInitialized$1(_this), "getFormContext", memoizeOne(function (value, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly) {
          return {
            value: value,
            onChange: onChange,
            errors: errors,
            onError: onError,
            showErrors: showErrors,
            allErrors: allErrors,
            animateErrors: animateErrors,
            disabled: disabled,
            readOnly: readOnly
          };
        }));

        return _this;
      }

      _createClass$1(FormWrapper, [{
        key: "render",
        value: function render() {
          var _ref = this.props,
              value = _ref.value,
              onChange = _ref.onChange,
              errors = _ref.errors,
              onError = _ref.onError,
              showErrors = _ref.showErrors,
              allErrors = _ref.allErrors,
              animateErrors = _ref.animateErrors,
              disabled = _ref.disabled,
              readOnly = _ref.readOnly,
              children = _ref.children;
          var passThruProps = omitProps(this.props, Object.keys(FormWrapper.propTypes));
          var formContext = this.getFormContext(value, onChange, errors !== null && errors !== void 0 ? errors : this.state.errors, onError !== null && onError !== void 0 ? onError : this.defaultOnError, showErrors, allErrors, animateErrors, disabled, readOnly);
          return /*#__PURE__*/React.createElement(FormComponent, _extends$1({}, this.props, {
            errors: errors || this.state.errors,
            onErrors: onError || this.defaultOnError,
            passThruProps: passThruProps
          }), /*#__PURE__*/React.createElement(FormContext.Provider, {
            value: formContext
          }, typeof children === "function" ? children(value, errors || this.state.errors) : children));
        }
      }]);

      return FormWrapper;
    }(React.Component), _defineProperty$1(_class, "propTypes", {}), _defineProperty$1(_class, "defaultProps", _objectSpread2$1({
      value: {},
      onChange: function onChange() {},
      showErrors: false,
      allErrors: false,
      animateErrors: false,
      disabled: false,
      readOnly: false
    }, formDefaultProps)), _defineProperty$1(_class, "displayName", "withForm(".concat(FormComponent.displayName || FormComponent.name, ")")), _temp;
  };
};

var confirmField = function confirmField() {
  return {
    propTypes: {
      confirmField: propTypes.string,
      confirmFieldError: propTypes.string
    },
    getNotifiedFields: function getNotifiedFields(props) {
      // we want to be notified if this field changes
      return props.confirmField ? [props.confirmField] : [];
    },
    shouldValidate: function shouldValidate(props) {
      return !!props.confirmField;
    },
    getErrors: function getErrors(field, value, props, context) {
      if (context.value && props.confirmField) {
        var otherField = context.value[props.confirmField];

        if (value && otherField && value !== otherField) {
          return [props.confirmFieldError || "".concat(field, " does not match")];
        }
      }

      return [];
    }
  };
}; // source: https://emailregex.com/


var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

var emailAddress = function emailAddress(validationDefault) {
  return {
    propTypes: {
      emailValidation: propTypes.bool.isRequired,
      emailError: propTypes.string
    },
    defaultProps: {
      emailValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.emailValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" && value.length > 0 && !regex.test(value)) {
        return [props.emailError || "".concat(field, " is not a valid email address")];
      }

      return [];
    }
  };
};

var isFileType = function isFileType(value) {
  return _typeof$1(value) === "object" && value !== null && ("name" in value || "type" in value);
};

var validateFile = function validateFile(value, props) {
  var _value$name = value.name,
      name = _value$name === void 0 ? "" : _value$name,
      _value$type = value.type,
      type = _value$type === void 0 ? "" : _value$type;
  var _props$fileMimeTypes = props.fileMimeTypes,
      fileMimeTypes = _props$fileMimeTypes === void 0 ? [] : _props$fileMimeTypes,
      _props$fileExtensionT = props.fileExtensionTypes,
      fileExtensionTypes = _props$fileExtensionT === void 0 ? [] : _props$fileExtensionT;
  var extensionValid = !fileExtensionTypes || fileExtensionTypes.length === 0 || fileExtensionTypes.some(function (t) {
    var ext = t.startsWith(".") ? t : "." + t;
    return name.toLowerCase().endsWith(ext.toLowerCase());
  });
  var mimeValid = !fileMimeTypes || fileMimeTypes.length === 0 || fileMimeTypes.some(function (t) {
    return type.toLowerCase() === t.toLowerCase();
  });
  return {
    extensionValid: extensionValid,
    mimeValid: mimeValid
  };
};

var fileTypes = function fileTypes() {
  return {
    propTypes: {
      fileMimeTypes: propTypes.arrayOf(propTypes.string.isRequired),
      fileExtensionTypes: propTypes.arrayOf(propTypes.string.isRequired),
      fileTypesError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return Array.isArray(props.fileMimeTypes) && props.fileMimeTypes.length > 0 || Array.isArray(props.fileExtensionTypes) && props.fileExtensionTypes.length > 0;
    },
    getErrors: function getErrors(field, value, props) {
      var values = Array.isArray(value) ? value : [value];
      var validation = values.map(function (v) {
        if (!isFileType(v) || !v.name) return null;
        return validateFile(v, props);
      });
      var extensionValid = validation.every(function (v) {
        return !v || v.extensionValid;
      });
      var mimeValid = validation.every(function (v) {
        return !v || v.mimeValid;
      });
      var isNotValid = !extensionValid || !mimeValid;

      if (isNotValid) {
        var _props$fileMimeTypes2 = props.fileMimeTypes,
            fileMimeTypes = _props$fileMimeTypes2 === void 0 ? [] : _props$fileMimeTypes2,
            _props$fileExtensionT2 = props.fileExtensionTypes,
            fileExtensionTypes = _props$fileExtensionT2 === void 0 ? [] : _props$fileExtensionT2,
            fileTypesError = props.fileTypesError;
        if (fileTypesError) return [fileTypesError];
        var errors = [];

        if (!extensionValid) {
          errors.push(fileExtensionTypes.length === 1 ? "".concat(field, " must be of type ").concat(fileExtensionTypes[0]) : "".concat(field, " must be one of the following file types: \n      ").concat(fileExtensionTypes.join(", ")));
        }

        if (!mimeValid) {
          errors.push(fileMimeTypes.length === 1 ? "".concat(field, " must be of type ").concat(fileMimeTypes[0]) : "".concat(field, " must be one of the following file types: \n      ").concat(fileMimeTypes.join(", ")));
        }

        return errors;
      }

      return [];
    }
  };
};

var maxLength = function maxLength() {
  return {
    propTypes: {
      maxLength: propTypes.number,
      maxLengthError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.maxLength === "number" && props.maxLength > 0;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" || Array.isArray(value)) {
        var length = value.length;

        if (props.maxLength !== undefined && length > props.maxLength) {
          var subject = typeof value === "string" ? "character" : "item";
          return [props.maxLengthError || "".concat(field, " cannot have more than ").concat(props.maxLength, " ").concat(subject).concat(props.maxLength === 1 ? "" : "s")];
        }
      }

      return [];
    }
  };
};

var maxValue = function maxValue() {
  return {
    propTypes: {
      maxValue: propTypes.number,
      maxValueError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.maxValue === "number";
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "number" || typeof value === "string") {
        if (props.maxValue !== undefined && parseFloat(value.toString()) > props.maxValue) {
          return [props.maxValueError || "".concat(field, " cannot be more than ").concat(props.maxValue)];
        }
      }

      return [];
    }
  };
};

var minLength = function minLength() {
  return {
    propTypes: {
      minLength: propTypes.number,
      minLengthError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.minLength === "number" && props.minLength > 0;
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "string" || Array.isArray(value)) {
        var length = value.length;

        if (props.minLength !== undefined && length < props.minLength) {
          var subject = typeof value === "string" ? "character" : "item";
          return [props.minLengthError || "".concat(field, " must have at least ").concat(props.minLength, " ").concat(subject).concat(props.minLength === 1 ? "" : "s")];
        }
      }

      return [];
    }
  };
};

var minValue = function minValue() {
  return {
    propTypes: {
      minValue: propTypes.number,
      minValueError: propTypes.string
    },
    shouldValidate: function shouldValidate(props) {
      return typeof props.minValue === "number";
    },
    getErrors: function getErrors(field, value, props) {
      if (typeof value === "number" || typeof value === "string") {
        if (props.minValue !== undefined && parseFloat(value.toString()) < props.minValue) {
          return [props.minValueError || "".concat(field, " must be at least ").concat(props.minValue)];
        }
      }

      return [];
    }
  };
}; // source: https://stackoverflow.com/questions/2811031/decimal-or-numeric-values-in-regular-expression-validation


var regex$1 = new RegExp(/^-?(((0|[1-9]\d*)(\.\d+)?)|(\.\d+))$/);

var number = function number(validationDefault) {
  return {
    propTypes: {
      numberValidation: propTypes.bool.isRequired,
      numberError: propTypes.string
    },
    defaultProps: {
      numberValidation: validationDefault
    },
    shouldValidate: function shouldValidate(props) {
      return props.numberValidation === true;
    },
    getErrors: function getErrors(field, value, props) {
      if (value === null || value === undefined || value === "" || typeof value === "number") {
        return [];
      }

      if (typeof value === "string" && !Number.isNaN(value) && regex$1.test(value)) {
        return [];
      }

      return [props.numberError || "".concat(field, " is not a valid number")];
    }
  };
};

var requiredField = function requiredField(defaultValue) {
  var getComparisonValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
    return v;
  };
  return {
    propTypes: {
      required: propTypes.bool.isRequired,
      requiredError: propTypes.string
    },
    defaultProps: {
      required: defaultValue
    },
    shouldValidate: function shouldValidate(props) {
      return props.required === true;
    },
    getErrors: function getErrors(field, value, props) {
      var comparison = getComparisonValue(value);

      if (comparison === null || comparison === undefined || comparison === "" || comparison === false || Array.isArray(comparison) && comparison.length === 0 || typeof comparison === "string" && !/\S/.test(comparison) // String does not contain any characters that are not whitespace
      ) {
          return [props.requiredError || "".concat(field, " is required")];
        }

      return [];
    }
  };
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  confirmField: confirmField,
  emailAddress: emailAddress,
  fileTypes: fileTypes,
  maxLength: maxLength,
  maxValue: maxValue,
  minLength: minLength,
  minValue: minValue,
  number: number,
  requiredField: requiredField
});

var ArrayItemProvider = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ArrayItemProvider, _React$Component);

  var _super = _createSuper$1(ArrayItemProvider);

  function ArrayItemProvider() {
    var _this;

    _classCallCheck$1(this, ArrayItemProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "getArrayContext", memoizeOne(function (arrayIndex, value, parentValue, formValue, onChange, errors, onError, onRemove, showErrors, allErrors, animateErrors, disabled, readOnly) {
      return {
        arrayIndex: arrayIndex,
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        onRemove: onRemove,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly
      };
    }));

    _defineProperty$1(_assertThisInitialized$1(_this), "onChange", function (field, data, applyChanges) {
      _this.props.onChange(_this.props.value, field, data, applyChanges);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onRemove", function () {
      if (_this.props.index === undefined) return;

      _this.props.onRemove(_this.props.index);
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onError", function (field, errors, applyErrors) {
      _this.props.onError(_this.props.value, field, errors, applyErrors);
    });

    return _this;
  }

  _createClass$1(ArrayItemProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps, this.props.propagateUpdates);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          children = _this$props.children;
      var arrayContext = this.getArrayContext(index, value, parentValue, formValue, this.onChange, errors, this.onError, this.onRemove, showErrors, allErrors, animateErrors, disabled, readOnly);
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: arrayContext
      }, typeof children === "function" ? children(fieldFormState(arrayContext)) : children);
    }
  }]);

  return ArrayItemProvider;
}(React.Component);

_defineProperty$1(ArrayItemProvider, "propTypes", {
  index: propTypes.number,
  value: propTypes.any.isRequired,
  parentValue: propTypes.any.isRequired,
  formValue: propTypes.any.isRequired,
  onChange: propTypes.func.isRequired,
  errors: propTypes.any.isRequired,
  onError: propTypes.func.isRequired,
  showErrors: propTypes.bool.isRequired,
  allErrors: propTypes.bool.isRequired,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]).isRequired,
  disabled: propTypes.bool.isRequired,
  readOnly: propTypes.bool.isRequired,
  propagateUpdates: propTypes.oneOfType([propTypes.any, propTypes.bool]),
  onRemove: propTypes.func.isRequired
});

var validators = [minLength(), maxLength()];
var validatorPropTypes = validators.reduce(function (acc, v) {
  return v.propTypes ? _objectSpread2$1(_objectSpread2$1({}, acc), v.propTypes) : acc;
}, {});

var getDefaultOptions$2 = function getDefaultOptions() {
  return {
    defaultProps: {},
    displayName: function displayName(props) {
      return props.field;
    }
  };
};
/**
 * Higher-order function to create a form-connected array higher-order component
 * @param {Object} `options` Array options
 * @returns Array HOC
 */


var withFormArray = function withFormArray() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$2();
  return function (FormArrayComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$2();
    var arrayDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits$1(ArrayWrapper, _React$Component2);

      var _super2 = _createSuper$1(ArrayWrapper);

      function ArrayWrapper() {
        var _this2;

        _classCallCheck$1(this, ArrayWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty$1(_assertThisInitialized$1(_this2), "_prevContext", void 0);

        _defineProperty$1(_assertThisInitialized$1(_this2), "_hasInnerObjectError", false);

        _defineProperty$1(_assertThisInitialized$1(_this2), "_validateOnUpdate", false);

        _defineProperty$1(_assertThisInitialized$1(_this2), "validate", function (props, context) {
          var comparePreviousErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var field = props.field,
              arrayKey = props.arrayKey;
          var contextValue = context.value || {};
          var contextErrors = context.errors || {};
          var fieldValue = contextValue[field] || [];
          var fieldErrors = contextErrors[field] || [];
          var fieldName = options.displayName ? options.displayName(props) : defaultOptions.displayName ? defaultOptions.displayName(props) : ""; // remove previous 'array' errors

          var itemErrors = fieldErrors.filter(function (e) {
            return fieldValue.some(function (v) {
              return v[arrayKey] === e[arrayKey];
            });
          });
          var arrayErrors = validators.reduce(function (acc, v) {
            if (!v.getErrors) return acc;
            if (v.shouldValidate && !v.shouldValidate(props, context)) return acc;
            return [].concat(_toConsumableArray$1(acc), _toConsumableArray$1(v.getErrors(fieldName, fieldValue, props, context)));
          }, []);
          var newErrors = [].concat(_toConsumableArray$1(arrayErrors), _toConsumableArray$1(itemErrors));

          if (comparePreviousErrors) {
            // stop if errors unchanged
            if (shallowCompareArrays(fieldErrors, newErrors)) return;
          }

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, field, newErrors));
          };

          if (_this2.context.onError) {
            _this2.context.onError(field, newErrors, applyErrors);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "objectOnChange", function (object, field, data, applyChanges) {
          var _ref;

          var _this2$props = _this2.props,
              arrayField = _this2$props.field,
              arrayKey = _this2$props.arrayKey,
              autoRemove = _this2$props.autoRemove;
          var arrayData = [(_ref = {}, _defineProperty$1(_ref, arrayKey, object[arrayKey]), _defineProperty$1(_ref, "field", field), _defineProperty$1(_ref, "data", data), _ref)];

          var arrayApplyChanges = function arrayApplyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray$1(prevArrayValue);

            var objectIndex = newArray.findIndex(function (v) {
              return v[arrayKey] === object[arrayKey];
            });

            if (objectIndex >= 0) {
              var updatedObject = applyChanges(newArray[objectIndex]);
              newArray[objectIndex] = updatedObject;

              if (autoRemove) {
                updatedObject[arrayKey];

                var otherObjectValues = _objectWithoutProperties$1(updatedObject, [arrayKey].map(_toPropertyKey$1));

                if (Object.values(otherObjectValues).every(function (v) {
                  return !isValueSet(v);
                })) {
                  newArray.splice(objectIndex, 1);
                }
              }
            } else {
              newArray.push(applyChanges(object)); // at the point of adding an auto item apply any errors

              if (_this2._nextAutoItem && Object.keys(_this2._nextAutoItemErrors).length > 0) {
                // ignore errors for the field(s) just changed, as the change will trigger re-validation
                var fieldArray = Array.isArray(field) ? field : [field];
                var autoItemErrors = fieldArray.reduce(function (acc, f) {
                  acc[f];

                  var remaining = _objectWithoutProperties$1(acc, [f].map(_toPropertyKey$1));

                  return remaining;
                }, _objectSpread2$1({}, _this2._nextAutoItemErrors));
                var arrayErrors = [_objectSpread2$1(_defineProperty$1({}, arrayKey, object[arrayKey]), autoItemErrors)];

                var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
                  var prevArrayErrors = prevErrors[arrayField] || [];
                  return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, arrayField, [].concat(_toConsumableArray$1(prevArrayErrors), arrayErrors)));
                };

                if (_this2.context.onError) {
                  _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
                }
              }

              _this2._nextAutoItem = null;
              _this2._nextAutoItemErrors = {};
            }

            return _objectSpread2$1(_objectSpread2$1({}, prevValue), {}, _defineProperty$1({}, arrayField, newArray));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(arrayField, arrayData, arrayApplyChanges);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "objectOnRemove", function (index) {
          var arrayField = _this2.props.field;

          var applyChanges = function applyChanges(prevValue) {
            var prevArrayValue = prevValue[arrayField] || [];

            var newArray = _toConsumableArray$1(prevArrayValue);

            newArray.splice(index, 1);
            return _objectSpread2$1(_objectSpread2$1({}, prevValue), {}, _defineProperty$1({}, arrayField, newArray));
          };

          if (_this2.context.onChange) {
            var contextValue = _this2.context.value || {};

            _this2.context.onChange(arrayField, applyChanges(contextValue)[arrayField], applyChanges);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "objectOnError", function (object, field, errors, applyErrors) {
          var _ref2;

          var _this2$props2 = _this2.props,
              arrayField = _this2$props2.field,
              arrayKey = _this2$props2.arrayKey;
          _this2._hasInnerObjectError = true; // hold back auto item errors until item is actually added

          if (_this2._nextAutoItem && object[arrayKey] === _this2._nextAutoItem[arrayKey]) {
            _this2._nextAutoItemErrors = applyErrors(_this2._nextAutoItemErrors);
            return;
          }

          var arrayErrors = [(_ref2 = {}, _defineProperty$1(_ref2, arrayKey, object[arrayKey]), _defineProperty$1(_ref2, "field", field), _defineProperty$1(_ref2, "errors", errors), _ref2)];

          var arrayApplyErrors = function arrayApplyErrors(prevErrors) {
            var prevArrayErrors = prevErrors[arrayField] || [];

            var newArray = _toConsumableArray$1(prevArrayErrors);

            var objectIndex = newArray.findIndex(function (v) {
              return _typeof$1(v) === "object" && v[arrayKey] === object[arrayKey];
            });

            if (objectIndex >= 0) {
              var foundItem = newArray[objectIndex];
              newArray[objectIndex] = applyErrors(foundItem);
            } else {
              var newItem = _defineProperty$1({}, arrayKey, object[arrayKey]);

              newArray.push(applyErrors(newItem));
            }

            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, arrayField, newArray));
          };

          if (_this2.context.onError) {
            _this2.context.onError(arrayField, arrayErrors, arrayApplyErrors);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "getObjectErrorsByKey", memoizeOne(function (errors, arrayKey) {
          var objectErrors = errors.filter(function (e) {
            return _typeof$1(e) === "object";
          });
          return objectErrors.reduce(function (acc, e) {
            acc[e[arrayKey]] = e;
            return acc;
          }, {});
        }));

        _defineProperty$1(_assertThisInitialized$1(_this2), "_nextAutoItem", null);

        _defineProperty$1(_assertThisInitialized$1(_this2), "_nextAutoItemErrors", {});

        _defineProperty$1(_assertThisInitialized$1(_this2), "_defaultItemErrors", {});

        return _this2;
      }

      _createClass$1(ArrayWrapper, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (this._hasInnerObjectError) this._validateOnUpdate = true;else this.validate(this.props, this.context);
          this._prevContext = this.context;
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          // clear validation errors so unmounted components don't invalidate forms
          var field = this.props.field;
          var errors = [];

          var applyErrors = function applyErrors(prevErrors) {
            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, field, errors));
          };

          if (this.context.onError) {
            this.context.onError(field, errors, applyErrors);
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$_prevContext,
              _this3 = this;

          var currentContextValue = this.context.value || {};
          var prevContextValue = ((_this$_prevContext = this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
          var validate = currentContextValue[this.props.field] !== prevContextValue[prevProps.field] || this._validateOnUpdate;

          if (!validate) {
            // run validators if any validator props have changed
            var validatorPropKeys = Object.keys(validatorPropTypes);
            validate = validatorPropKeys.some(function (k) {
              return _this3.props[k] !== prevProps[k];
            });
          }

          if (validate) {
            this.validate(this.props, this.context, true);
          }

          this._prevContext = this.context;
          this._validateOnUpdate = false;
        }
      }, {
        key: "render",
        value: function render() {
          var _this4 = this;

          var _ref3 = this.props,
              field = _ref3.field,
              arrayKey = _ref3.arrayKey,
              showErrors = _ref3.showErrors,
              allErrors = _ref3.allErrors,
              animateErrors = _ref3.animateErrors,
              disabled = _ref3.disabled,
              readOnly = _ref3.readOnly,
              autoAdd = _ref3.autoAdd,
              autoAddPopulate = _ref3.autoAddPopulate,
              propagateUpdates = _ref3.propagateUpdates,
              children = _ref3.children;
          var contextValue = this.context.value || {};
          var contextErrors = this.context.errors || {};
          var values = contextValue[field] || [];
          var errors = contextErrors[field] || [];
          var arrayErrors = errors.filter(function (e) {
            return typeof e === "string";
          });
          var objectErrors = this.getObjectErrorsByKey(errors, arrayKey);

          if (autoAdd) {
            if (!this._nextAutoItem) {
              this._nextAutoItem = autoAddPopulate(arrayKey);
            }

            values = [].concat(_toConsumableArray$1(values), [this._nextAutoItem]);
          }

          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly
          };
          var passThruProps = omitProps(this.props, Object.keys(ArrayWrapper.propTypes));
          return /*#__PURE__*/React.createElement(FormArrayComponent, _extends$1({}, this.props, contextProps, {
            value: values,
            errors: arrayErrors,
            passThruChildren: children,
            passThruProps: passThruProps
          }), values.map(function (v, i) {
            var _objectErrors$v$array;

            if (v[arrayKey] === undefined) {
              throw new Error("ArrayField object missing ".concat(arrayKey, " property for ").concat(field, "[").concat(i, "]"));
            }

            return /*#__PURE__*/React.createElement(ArrayItemProvider, _extends$1({}, contextProps, {
              key: v[arrayKey],
              index: _this4._nextAutoItem && v[arrayKey] === _this4._nextAutoItem[arrayKey] ? undefined : i,
              value: v,
              parentValue: contextValue,
              formValue: _this4.context.formValue || contextValue,
              onChange: _this4.objectOnChange,
              onRemove: _this4.objectOnRemove,
              errors: (_objectErrors$v$array = objectErrors[v[arrayKey]]) !== null && _objectErrors$v$array !== void 0 ? _objectErrors$v$array : _this4._defaultItemErrors,
              onError: _this4.objectOnError,
              propagateUpdates: propagateUpdates
            }), children);
          }));
        }
      }]);

      return ArrayWrapper;
    }(React.Component), _defineProperty$1(_class, "propTypes", {}), _defineProperty$1(_class, "defaultProps", _objectSpread2$1({
      arrayKey: "key",
      autoAdd: false,
      autoAddPopulate: function autoAddPopulate(arrayKey) {
        return _defineProperty$1({}, arrayKey, Date.now());
      },
      autoRemove: false
    }, arrayDefaultProps)), _defineProperty$1(_class, "contextType", FormContext), _defineProperty$1(_class, "displayName", "withFormArray(".concat(FormArrayComponent.displayName || FormArrayComponent.name, ")")), _temp;
  };
};

var ObjectDataProvider = /*#__PURE__*/function (_React$Component) {
  _inherits$1(ObjectDataProvider, _React$Component);

  var _super = _createSuper$1(ObjectDataProvider);

  function ObjectDataProvider() {
    var _this;

    _classCallCheck$1(this, ObjectDataProvider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "getObjectContext", memoizeOne(function (value, parentValue, formValue, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly) {
      return {
        value: value,
        parentValue: parentValue,
        formValue: formValue,
        onChange: onChange,
        errors: errors,
        onError: onError,
        showErrors: showErrors,
        allErrors: allErrors,
        animateErrors: animateErrors,
        disabled: disabled,
        readOnly: readOnly
      };
    }));

    return _this;
  }

  _createClass$1(ObjectDataProvider, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return shouldFieldUpdate(this.props, nextProps, this.props.propagateUpdates);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          parentValue = _this$props.parentValue,
          formValue = _this$props.formValue,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          onError = _this$props.onError,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          children = _this$props.children;
      var objectContext = this.getObjectContext(value, parentValue, formValue, onChange, errors, onError, showErrors, allErrors, animateErrors, disabled, readOnly);
      return /*#__PURE__*/React.createElement(FormContext.Provider, {
        value: objectContext
      }, typeof children === "function" ? children(fieldFormState(objectContext)) : children);
    }
  }]);

  return ObjectDataProvider;
}(React.Component);

_defineProperty$1(ObjectDataProvider, "propTypes", {
  value: propTypes.any.isRequired,
  parentValue: propTypes.any.isRequired,
  formValue: propTypes.any.isRequired,
  onChange: propTypes.any.isRequired,
  errors: propTypes.any.isRequired,
  onError: propTypes.any.isRequired,
  showErrors: propTypes.bool.isRequired,
  allErrors: propTypes.bool.isRequired,
  animateErrors: propTypes.oneOfType([propTypes.number, propTypes.bool]).isRequired,
  disabled: propTypes.bool.isRequired,
  readOnly: propTypes.bool.isRequired,
  propagateUpdates: propTypes.oneOfType([propTypes.any, propTypes.bool])
});

var getDefaultOptions$3 = function getDefaultOptions() {
  return {
    defaultProps: {}
  };
};
/**
 * Higher-order function to create a form-connected object higher-order component
 * @param {Object} `options` Object options
 * @returns Object HOC
 */


var withFormObject = function withFormObject() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultOptions$3();
  return function (FormObjectComponent) {
    var _class, _temp;

    var defaultOptions = getDefaultOptions$3();
    var objectDefaultProps = options.defaultProps || defaultOptions.defaultProps;
    return _temp = _class = /*#__PURE__*/function (_React$Component2) {
      _inherits$1(ObjectWrapper, _React$Component2);

      var _super2 = _createSuper$1(ObjectWrapper);

      function ObjectWrapper() {
        var _this2;

        _classCallCheck$1(this, ObjectWrapper);

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this2 = _super2.call.apply(_super2, [this].concat(args));

        _defineProperty$1(_assertThisInitialized$1(_this2), "_defaultChildValue", {});

        _defineProperty$1(_assertThisInitialized$1(_this2), "_defaultChildErrors", {});

        _defineProperty$1(_assertThisInitialized$1(_this2), "getChildValue", function () {
          var contextValue = _this2.context.value || {};
          return contextValue[_this2.props.field] || _this2._defaultChildValue;
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "onChildChange", function (field, data, applyChanges) {
          var objectField = _this2.props.field;
          var objectData = {
            field: field,
            data: data
          };

          var objectApplyChanges = function objectApplyChanges(prevValue) {
            return _objectSpread2$1(_objectSpread2$1({}, prevValue), {}, _defineProperty$1({}, objectField, applyChanges(prevValue[objectField] || {})));
          };

          if (_this2.context.onChange) {
            _this2.context.onChange(objectField, objectData, objectApplyChanges);
          }
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "getChildErrors", function () {
          var contentErrors = _this2.context.errors || {};
          return contentErrors[_this2.props.field] || _this2._defaultChildErrors;
        });

        _defineProperty$1(_assertThisInitialized$1(_this2), "onChildError", function (field, errors, applyErrors) {
          var objectField = _this2.props.field;
          var objectErrors = {
            field: field,
            errors: errors
          };

          var objectApplyErrors = function objectApplyErrors(prevErrors) {
            return _objectSpread2$1(_objectSpread2$1({}, prevErrors), {}, _defineProperty$1({}, objectField, applyErrors(prevErrors[objectField] || {})));
          };

          if (_this2.context.onError) {
            _this2.context.onError(objectField, objectErrors, objectApplyErrors);
          }
        });

        return _this2;
      }

      _createClass$1(ObjectWrapper, [{
        key: "render",
        value: function render() {
          var _ref = this.props,
              children = _ref.children,
              showErrors = _ref.showErrors,
              allErrors = _ref.allErrors,
              animateErrors = _ref.animateErrors,
              disabled = _ref.disabled,
              readOnly = _ref.readOnly,
              propagateUpdates = _ref.propagateUpdates;
          var contextValue = this.context.value || {};
          var contextProps = {
            showErrors: showErrors !== undefined ? showErrors : this.context.showErrors,
            allErrors: allErrors !== undefined ? allErrors : this.context.allErrors,
            animateErrors: animateErrors !== undefined ? animateErrors : this.context.animateErrors,
            disabled: disabled !== undefined ? disabled : this.context.disabled,
            readOnly: readOnly !== undefined ? readOnly : this.context.readOnly
          };
          return /*#__PURE__*/React.createElement(FormObjectComponent, _extends$1({}, this.props, contextProps), /*#__PURE__*/React.createElement(ObjectDataProvider, _extends$1({}, contextProps, {
            value: this.getChildValue(),
            parentValue: contextValue,
            formValue: this.context.formValue || contextValue,
            onChange: this.onChildChange,
            errors: this.getChildErrors(),
            onError: this.onChildError,
            propagateUpdates: propagateUpdates
          }), children));
        }
      }]);

      return ObjectWrapper;
    }(React.Component), _defineProperty$1(_class, "propTypes", {}), _defineProperty$1(_class, "defaultProps", _objectSpread2$1({}, objectDefaultProps)), _defineProperty$1(_class, "contextType", FormContext), _defineProperty$1(_class, "displayName", "withFormObject(".concat(FormObjectComponent.displayName || FormObjectComponent.name, ")")), _temp;
  };
};
/**
 * A form hook to trigger actions upon field events
 */


var FieldTrigger = /*#__PURE__*/function (_React$Component) {
  _inherits$1(FieldTrigger, _React$Component);

  var _super = _createSuper$1(FieldTrigger);

  function FieldTrigger() {
    var _this;

    _classCallCheck$1(this, FieldTrigger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "_prevContext", void 0);

    _defineProperty$1(_assertThisInitialized$1(_this), "_matchWarning", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_targetWarning", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "_valueWarning", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "validateProps", function () {
      var _this$props = _this.props,
          event = _this$props.event,
          match = _this$props.match,
          action = _this$props.action,
          target = _this$props.target,
          value = _this$props.value;

      if (!match && !_this._matchWarning && event === TriggerEvent.OnMatch) {
        console.warn("Trigger match prop is required for ".concat(event, " events"));
        _this._matchWarning = true;
      }

      if (!target && !_this._targetWarning && (action === TriggerAction.Change || action === TriggerAction.Clear || action === TriggerAction.Set)) {
        console.warn("Trigger target prop is required for ".concat(action, " actions"));
        _this._targetWarning = true;
      }

      if (!value && !_this._valueWarning && (action === TriggerAction.Change || action === TriggerAction.Set)) {
        console.warn("Trigger value prop is required for ".concat(action, " actions"));
        _this._valueWarning = true;
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      var _this$_prevContext;

      var currentContextValue = _this.context.value || {};
      var prevContextValue = ((_this$_prevContext = _this._prevContext) === null || _this$_prevContext === void 0 ? void 0 : _this$_prevContext.value) || {};
      _this._prevContext = _this.context;
      var currentValue = currentContextValue[_this.props.field];
      var prevValue = prevContextValue[prevProps.field];

      _this.validateProps();

      switch (_this.props.event) {
        // field value has changed
        case TriggerEvent.OnChange:
          if (currentValue !== prevValue) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value was set but has now been cleared

        case TriggerEvent.OnClear:
          if (currentValue !== prevValue && !isValueSet(currentValue)) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value was not set but is now

        case TriggerEvent.OnSet:
          if (currentValue !== prevValue && !isValueSet(prevValue)) {
            _this.handleEvent(_this.props, _this.context);
          }

          break;
        // field value changed and equals match prop

        case TriggerEvent.OnMatch:
          if (currentValue !== prevValue) {
            var hasMatch = typeof _this.props.match === "function" ? _this.props.match(fieldFormState(_this.context)) : currentValue === _this.props.match;
            if (hasMatch) _this.handleEvent(_this.props, _this.context);
          }

          break;
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "handleEvent", function (props, context) {
      switch (props.action) {
        // updating the target field
        case TriggerAction.Change:
        case TriggerAction.Set:
          {
            if (props.target === undefined) break; // for set action, ensure not previously set

            if (props.action === TriggerAction.Set) {
              var targetValue = context.value[props.target];
              if (isValueSet(targetValue)) break;
            }

            var newValue = typeof props.value === "function" ? props.value(fieldFormState(context)) : props.value;

            var applyChanges = function applyChanges(prevValue) {
              return _objectSpread2$1(_objectSpread2$1({}, prevValue), {}, _defineProperty$1({}, props.target, newValue));
            };

            context.onChange(props.target, newValue, applyChanges);
            break;
          }
        // clear the target field

        case TriggerAction.Clear:
          {
            if (props.target === undefined) break;
            var _targetValue = context.value[props.target];
            if (_targetValue === undefined) break;

            var _applyChanges = function _applyChanges(prevValue) {
              var _ref = props.target;
              prevValue[_ref];

              var otherValues = _objectWithoutProperties$1(prevValue, [_ref].map(_toPropertyKey$1));

              return otherValues;
            };

            context.onChange(props.target, undefined, _applyChanges);
            break;
          }
        // perform a custom function

        default:
          if (typeof props.action === "function") {
            var _formState = fieldFormState(context);

            props.action(_formState);
          }

      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass$1(FieldTrigger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._prevContext = this.context;
      this.validateProps();
    }
  }]);

  return FieldTrigger;
}(React.Component);

_defineProperty$1(FieldTrigger, "propTypes", {
  field: propTypes.string.isRequired,
  event: propTypes.string,
  match: propTypes.any,
  action: propTypes.oneOfType([propTypes.any, propTypes.func]).isRequired,
  target: propTypes.string,
  value: propTypes.any
});

_defineProperty$1(FieldTrigger, "defaultProps", {
  event: TriggerEvent.OnChange
});

_defineProperty$1(FieldTrigger, "contextType", FormContext);
/**
 * A hook to run an effect when form fields change
 * @param {function} `effect` Effect function, can optionally return a 'clean-up' function
 * @param {string[]} `triggerFields` Array of field names to trigger the effect on, or an empty array to fire on form initialisation, or omit to trigger on any field change
 */


var useFormEffect = function useFormEffect(effect, triggerFields) {
  var context = useContext(FormContext);
  var prevContext = useRef();
  var cleanup = useRef();
  useEffect(function () {
    var triggered = !triggerFields || triggerFields.some(function (f) {
      var _prevContext$current;

      return prevContext.current && context.value[f] !== ((_prevContext$current = prevContext.current) === null || _prevContext$current === void 0 ? void 0 : _prevContext$current.value[f]);
    });

    if (triggered) {
      if (cleanup.current) {
        var _prevContext$current2;

        cleanup.current(fieldFormState((_prevContext$current2 = prevContext.current) !== null && _prevContext$current2 !== void 0 ? _prevContext$current2 : context));
      }

      cleanup.current = effect(fieldFormState(context));
    }

    prevContext.current = context;
  }, [context.value]);
  useEffect(function () {
    if ((triggerFields === null || triggerFields === void 0 ? void 0 : triggerFields.length) === 0) {
      cleanup.current = effect(fieldFormState(context));
    }

    return function () {
      if (cleanup.current) {
        var _prevContext$current3;

        cleanup.current(fieldFormState((_prevContext$current3 = prevContext.current) !== null && _prevContext$current3 !== void 0 ? _prevContext$current3 : context));
      }
    };
  }, []);
};
/**
 * A hook to get or set a single field value
 * @param {string} `field` The name of the field
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current field value
 * @returns {function} `setValue` A function to update the field value, takes a single parameter for the new field value
 */


var useFormField = function useFormField(field) {
  var context = useContext(FormContext);
  return [context.value[field], function (value) {
    return context.onChange(field, value, function (state) {
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, field, value));
    });
  }];
};
/**
 * A hook to return form state data
 * @returns {object} The current state of the form relative to this hook
 * @returns {object} `fields` Form field data, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `errors` Form field errors, either for the entire form or the current level when Object/Array fields are used
 * @returns {object} `parentFields` Form field data for the parent level when Object/Array fields are used
 * @returns {object} `formFields` Form field data for the entire form when Object/Array fields are used
 * @returns {number} `arrayIndex` Index of the current row when used inside an Array field
 *
 */


var useFormState = function useFormState() {
  var context = useContext(FormContext);
  return fieldFormState(context);
};

var lookupName = function lookupName(lookup) {
  return typeof lookup === "string" ? lookup : lookup.name;
};

var utils$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  lookupName: lookupName
});
var LOOKUP_REQUEST = "LOOKUPS/REQUEST";
var LOOKUP_RESET = "LOOKUPS/RESET";
var LOOKUP_SET = "LOOKUPS/SET";
var SAVE_LOOKUP_STATE = "LOOKUPS/SAVE";
/**
 * Action creator for requesting lookup data
 * @param {string|object} `lookup` A previously registered lookup or its name
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 */

var lookupRequest = function lookupRequest(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = options.key,
      otherOptions = _objectWithoutProperties$1(options, ["key"]);

  return {
    type: LOOKUP_REQUEST,
    name: lookupName(lookup),
    params: params,
    key: key !== undefined ? key : getParamsKey(params),
    options: otherOptions || {}
  };
};
/**
 * Action creator for clearing cached lookup data
 * @param {string|object} `lookup` Optional, the lookup to reset or its name. If not specified then all lookups will be reset
 * @param {*} `params` Optional, parameters that were used for the lookup request to reset. If omitted (and no key is specified) then all cached data for the lookup will be cleared
 * @param {object} `options` Additional options for the reset
 * @param {number} `options.key` Optional, unique key for the lookup to reset. If omitted will be automatically generated from params, otherwise all cached data for the lookup will be cleared
 */


var lookupReset = function lookupReset(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    type: LOOKUP_RESET,
    name: lookup !== undefined ? lookupName(lookup) : undefined,
    params: params,
    key: options.key !== undefined ? options.key : params !== undefined && params !== null ? getParamsKey(params) : undefined
  };
};
/**
 * Action creator for manually updating cached lookup data
 * @param {string|object} `lookup` A previously registered lookup or its name
 * @param {*} `data` Data to be stored in the lookup cache
 * @param {*} `params` Optional, parameters that were used for the lookup request to update
 * @param {object} `options` Additional options for the update
 * @param {number} `options.key` Optional, unique key for the lookup to update. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 */


var lookupSet = function lookupSet(lookup, data, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var state = {
    loading: false,
    slowLoading: false,
    params: params,
    date: Date.now(),
    response: data,
    error: undefined
  };
  return {
    type: LOOKUP_SET,
    name: lookupName(lookup),
    key: options.key !== undefined ? options.key : getParamsKey(params),
    limit: undefined,
    state: state
  };
}; // internal action creators


var saveLookupState = function saveLookupState(name, key, limit) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    type: SAVE_LOOKUP_STATE,
    name: name,
    key: key,
    limit: limit,
    state: state
  };
};

var defaultOptions$5 = {
  cache: true,
  transform: function transform(data) {
    return data;
  }
};
var lookups = {};

var getLookupAction = function getLookupAction(name) {
  return lookups[name].config.action;
};

var getLookupOptions = function getLookupOptions(name) {
  return lookups[name].config.options;
};
/**
 * Determines whether a lookup has been registered
 * @param {string} `name` The name of a lookup to check
 * @returns {boolean} True if the lookup has been registered, otherwise false
 */


var lookupExists = function lookupExists(name) {
  return lookups.hasOwnProperty(name);
};
/**
 * Finds a previously registered lookup if it exists
 * @param {string} `name` The name of a lookup to check
 * @returns {object|null} The registered lookup, or null if it does not exist
 */


var findLookup = function findLookup(name) {
  if (lookupExists(name)) {
    return lookups[name];
  }

  return null;
};
/**
 * Registers a new lookup
 * @param {string} `name` Name of the lookup to register
 * @param {function} `action` API action creator for requesting lookup data, receives lookup parameters
 * @param {object} `options` Default options for requesting lookup data
 * @param {boolean} `options.cache` Whether lookup requests should save and retrieve their data from cached state, default true
 * @param {number} `options.cacheExpiry` Time in milliseconds that cached data should be kept before being invalidated, or null for indefinite, default null
 * @param {number} `options.cacheLimit` Number of copies of cached data for different request parameters that should be kept, or null for unlimited, default null
 * @param {function} `options.transform` Transform function to apply when lookup data is retrieved successfully, receives the original data and lookup parameters, and returns the transformed data
 * @returns {object} The registered lookup
 * @returns {string} `name` The registered name of the lookup
 * @returns {number} `registeredAt` Timestamp when the lookup was registered
 * @returns {object} `config` The configuration of the lookup when it was registered
 * @returns {function} `unregister` A function to unregister this lookup
 * @returns {number} `unregisteredAt` If unregistered, the timestamp when this occurred
 */


var registerLookup = function registerLookup(name, action) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (lookupExists(name)) {
    console.warn("Lookup has already been registered: ".concat(name));
  }

  var config = {
    action: action,
    options: _objectSpread2$1(_objectSpread2$1({}, defaultOptions$5), options)
  };
  var lookup = {
    name: name,
    registeredAt: Date.now(),
    config: config,
    unregister: function unregister() {
      return unregisterLookup(name);
    }
  };
  lookups[name] = lookup;
  return lookup;
};
/**
 * Unregisters an existing lookup
 * @param {string|object} `lookup` A previously registered lookup or its name
 */


var unregisterLookup = function unregisterLookup(lookup) {
  var name = lookupName(lookup);
  var found = findLookup(name);

  if (found) {
    found.unregistedAt = Date.now();
    delete lookups[name];
  }
};

var getLookupState = function getLookupState(state) {
  return state.lookups;
};

var getLookupCache = function getLookupCache(state, lookup) {
  var name = lookupName(lookup);
  var lookupState = getLookupState(state);
  return lookupState[name] || {};
};
/**
 * Selects Redux state data for a single lookup
 * @param {object} `state` Redux state
 * @param {string|object} `lookup`  A previously registered lookup or its name
 * @param {*} `params` Optional, parameters that were used for the lookup request to find
 * @param {object} `options` Additional options for the selector
 * @param {number} `options.key` Optional, unique key for the lookup request to find. If omitted will be automatically generated from params
 */


var getLookupData = function getLookupData(state, lookup, params) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cacheState = getLookupCache(state, lookup);
  var key = options.key !== undefined ? options.key : getParamsKey(params);
  return cacheState[key] || {};
};

var defaultOptions$6 = {
  required: true,
  autoNamePrefix: "withLookup/"
};

var withLookup = function withLookup() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (LookupComponent) {
    var _options = _objectSpread2$1(_objectSpread2$1({}, defaultOptions$6), options);

    var LookupWrapper = /*#__PURE__*/function (_React$Component) {
      _inherits$1(LookupWrapper, _React$Component);

      var _super = _createSuper$1(LookupWrapper);

      function LookupWrapper() {
        var _this;

        _classCallCheck$1(this, LookupWrapper);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));

        _defineProperty$1(_assertThisInitialized$1(_this), "_autoLookup", void 0);

        _defineProperty$1(_assertThisInitialized$1(_this), "_lookupWarning", false);

        _defineProperty$1(_assertThisInitialized$1(_this), "getLookup", function () {
          var _this$props = _this.props,
              lookup = _this$props.lookup,
              lookupAction = _this$props.lookupAction,
              lookupOptions = _this$props.lookupOptions;
          if (_this._autoLookup) return _this._autoLookup;

          if (lookupAction) {
            var name = createAutoName(_options.autoNamePrefix);
            _this._autoLookup = registerLookup(name, lookupAction, lookupOptions);
            return _this._autoLookup;
          }

          if (lookup) return lookup;

          if (!_this._lookupWarning && _options.required) {
            console.warn("".concat(LookupWrapper.displayName, " props lookup/lookupAction have not been defined"));
            _this._lookupWarning = true;
          }

          return null;
        });

        return _this;
      }

      _createClass$1(LookupWrapper, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          if (this._autoLookup) {
            this.props.lookupReset(this._autoLookup);
            unregisterLookup(this._autoLookup);
            this._autoLookup = undefined;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props2 = this.props;
          _this$props2.lookupReset;

          var otherProps = _objectWithoutProperties$1(_this$props2, ["lookupReset"]);

          var lookup = this.getLookup();
          return /*#__PURE__*/React.createElement(LookupComponent, _extends$1({}, otherProps, {
            lookup: lookup
          }));
        }
      }]);

      return LookupWrapper;
    }(React.Component);

    _defineProperty$1(LookupWrapper, "propTypes", {
      lookupReset: propTypes.any.isRequired
    });

    _defineProperty$1(LookupWrapper, "displayName", "withLookup(".concat(LookupComponent.displayName || LookupComponent.name, ")"));

    return connect$1(null, {
      lookupReset: lookupReset
    })(LookupWrapper);
  };
};

var LookupBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(LookupBase, _React$Component);

  var _super = _createSuper$1(LookupBase);

  function LookupBase() {
    var _this;

    _classCallCheck$1(this, LookupBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty$1(_assertThisInitialized$1(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          lookupRequest = _this$props.lookupRequest,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          lookupOptions = _this$props.lookupOptions,
          lookupData = _this$props.lookupData,
          onLoad = _this$props.onLoad; // re-request if lookup was reset or params changed

      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams))) {
        if (onLoad) onLoad();
        lookupRequest(lookup, lookupParams, lookupOptions).then(_this.onRequestCompleted);
      }
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "reset", function () {
      var _this$props2 = _this.props,
          lookupReset = _this$props2.lookupReset,
          lookup = _this$props2.lookup,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions,
          onReset = _this$props2.onReset;
      if (!lookup) return;
      lookupReset(lookup, lookupParams, lookupOptions);
      if (onReset) onReset(); // re-requesting handled in componentDidUpdate
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "onRequestCompleted", function () {
      if (!_this._isMounted) return;
      var _this$props3 = _this.props,
          onLoaded = _this$props3.onLoaded,
          lookupData = _this$props3.lookupData;
      if (onLoaded) onLoaded(lookupData);
    });

    return _this;
  }

  _createClass$1(LookupBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          lookupRequest = _this$props4.lookupRequest,
          lookupReset = _this$props4.lookupReset,
          lookup = _this$props4.lookup,
          lookupParams = _this$props4.lookupParams,
          lookupOptions = _this$props4.lookupOptions,
          resetOnMount = _this$props4.resetOnMount,
          onLoad = _this$props4.onLoad,
          onReset = _this$props4.onReset;
      this._isMounted = true;
      if (!lookup) return;

      if (resetOnMount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }

      if (onLoad) onLoad();
      lookupRequest(lookup, lookupParams, lookupOptions).then(this.onRequestCompleted);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props5 = this.props,
          lookupReset = _this$props5.lookupReset,
          lookup = _this$props5.lookup,
          lookupParams = _this$props5.lookupParams,
          lookupOptions = _this$props5.lookupOptions,
          resetOnUnmount = _this$props5.resetOnUnmount,
          onReset = _this$props5.onReset;
      this._isMounted = false;

      if (lookup && resetOnUnmount) {
        lookupReset(lookup, lookupParams, lookupOptions);
        if (onReset) onReset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          render = _this$props6.render,
          children = _this$props6.children,
          lookupData = _this$props6.lookupData;
      var resetLookup = this.reset;

      if (render) {
        return render(lookupData, resetLookup) || null;
      }

      if (children) {
        return children(lookupData, resetLookup) || null;
      }

      return null;
    }
  }]);

  return LookupBase;
}(React.Component);

_defineProperty$1(LookupBase, "propTypes", {
  render: propTypes.func,
  resetOnMount: propTypes.bool,
  resetOnUnmount: propTypes.bool,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  onReset: propTypes.func,
  children: propTypes.func,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any,
  lookupData: propTypes.any.isRequired,
  lookupRequest: propTypes.func.isRequired,
  lookupReset: propTypes.any.isRequired
});

_defineProperty$1(LookupBase, "defaultProps", {
  resetOnMount: false,
  resetOnUnmount: false
});

var mapStateToProps$1 = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: getLookupData(state, lookup, lookupParams, lookupOptions)
  };
};

var actions$1 = {
  lookupRequest: lookupRequest,
  lookupReset: lookupReset
};

var connectBase$6 = function connectBase() {
  return connect$1(mapStateToProps$1, actions$1);
};

var LookupBaseComponent = compose(withLookup({
  autoNamePrefix: "Lookup/"
}), connectBase$6())(LookupBase);
/**
 * A helper to load and display lookup data
 */

var Lookup = function Lookup(props) {
  return /*#__PURE__*/React.createElement(LookupBaseComponent, props);
};

Lookup.propTypes = {
  render: propTypes.func,
  resetOnMount: propTypes.bool,
  resetOnUnmount: propTypes.bool,
  onLoad: propTypes.func,
  onLoaded: propTypes.func,
  onReset: propTypes.func,
  children: propTypes.func,
  lookup: propTypes.any,
  lookupAction: propTypes.func,
  lookupParams: propTypes.any,
  lookupOptions: propTypes.any
};
/**
 * A hook to return lookup data for a previously registered lookup
 * @param {string|object} `lookup` A lookup that has already been registered
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 * @param {boolean} `options.resetOnMount` Optional, whether lookup data should be reset when the component is mounted
 * @param {boolean} `options.resetOnUnmount` Optional, whether lookup data should be reset when the component is unmounted
 * @returns {[]} An array in the format: [lookupData, resetLookup]
 * @returns {object} `lookupData` The current data for the lookup: { loading, slowLoading, params, date, response, error }
 * @returns {function} `resetLookup` A function to reset the lookup and re-request new data
 */

var useLookup = function useLookup(lookup, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lookupData = useSelector(function (state) {
    return getLookupData(state, lookup, params, options);
  });
  var dispatch = useDispatch();
  useEffect(function () {
    if (options.resetOnMount) {
      dispatch(lookupReset(lookup, params, options));
    }

    dispatch(lookupRequest(lookup, params, options));
    return function () {
      if (options.resetOnUnmount) {
        dispatch(lookupReset(lookup, params, options));
      }
    };
  }, []);
  var date = lookupData.date;
  var prevDate = useRef(date);
  var prevParams = useRef(params);
  useEffect(function () {
    // re-request if lookup was reset or params changed
    if (!date && prevDate || !compareParams(params, prevParams.current)) {
      dispatch(lookupRequest(lookup, params, options));
    }

    prevDate.current = date;
    prevParams.current = params;
  }, [date, params]);

  var resetLookup = function resetLookup() {
    dispatch(lookupReset(lookup, params, options));
    dispatch(lookupRequest(lookup, params, options));
  };

  return [lookupData, resetLookup];
};
/**
 * A hook to register a temporary lookup for an API action and return its data.
 * Useful shortcut for single instances of components where caching is not important.
 * For multiple instances or shared components, and to gain the benefits of caching, prefer useLookup instead.
 * @param {function} `action` API action creator for requesting lookup data, receives lookup parameters
 * @param {*} `params` Optional, parameters that will be passed to the lookup action
 * @param {object} `options` Additional options for the request
 * @param {number} `options.key` Optional, unique key for the request. If omitted will be automatically generated from params, otherwise the default key of '0' will be used
 * @param {boolean} `options.cache` Optional, override the lookup cache setting
 * @param {number} `options.cacheExpiry` Optional, override the lookup cacheExpiry setting
 * @param {number} `options.cacheLimit` Optional, override the lookup cacheLimit setting
 * @param {function} `options.transform` Optional, override the lookup transform setting
 * @returns {[]} An array in the format: [lookupData, resetLookup]
 * @returns {object} `lookupData` The current data for the lookup: { loading, slowLoading, params, date, response, error }
 * @returns {function} `resetLookup` A function to reset the lookup and re-request new data
 */


var useLookupAction = function useLookupAction(action, params) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lookup = useRef();

  if (!lookup.current) {
    var name = createAutoName("useLookupAction/");
    lookup.current = registerLookup(name, action, options);
  }

  var dispatch = useDispatch();
  useEffect(function () {
    return function () {
      if (!lookup.current) return;
      dispatch(lookupReset(lookup.current));
      lookup.current.unregister();
    };
  }, []);
  return useLookup(lookup.current, params, options);
};

var PreferenceLoaderBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(PreferenceLoaderBase, _React$Component);

  var _super = _createSuper$1(PreferenceLoaderBase);

  function PreferenceLoaderBase() {
    var _this;

    _classCallCheck$1(this, PreferenceLoaderBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$1(_assertThisInitialized$1(_this), "onLoadPreferences", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, loadPreferences, savePreferences, onLoaded, preferences;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, loadPreferences = _this$props.loadPreferences, savePreferences = _this$props.savePreferences, onLoaded = _this$props.onLoaded, preferences = _this$props.preferences;
              _context.next = 3;
              return loadPreferences();

            case 3:
              if (onLoaded) onLoaded(preferences, savePreferences);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty$1(_assertThisInitialized$1(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty$1(_assertThisInitialized$1(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass$1(PreferenceLoaderBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoadPreferences();
    }
  }]);

  return PreferenceLoaderBase;
}(React.Component);

_defineProperty$1(PreferenceLoaderBase, "propTypes", {
  onLoaded: propTypes.func,
  preferences: propTypes.any.isRequired,
  loadPreferences: propTypes.any.isRequired,
  savePreferences: propTypes.any.isRequired
});

var mapStateToProps$2 = function mapStateToProps(state) {
  return {
    preferences: getPreferenceState(state)
  };
};

var actions$2 = {
  loadPreferences: loadPreferences,
  savePreferences: savePreferences
};
var connect = createTypedConnect();
var ConnectedPreferenceLoader = connect(mapStateToProps$2, actions$2)(PreferenceLoaderBase);
/**
 * A helper to load app preferences
 * (loading occurs when the component is mounted)
 */

var PreferenceLoader = function PreferenceLoader(props) {
  return /*#__PURE__*/React.createElement(ConnectedPreferenceLoader, props);
};

PreferenceLoader.propTypes = {
  onLoaded: propTypes.func
};

var PreferenceSaverBase = /*#__PURE__*/function (_React$Component) {
  _inherits$1(PreferenceSaverBase, _React$Component);

  var _super = _createSuper$1(PreferenceSaverBase);

  function PreferenceSaverBase(props) {
    var _this;

    _classCallCheck$1(this, PreferenceSaverBase);

    _this = _super.call(this, props);

    _defineProperty$1(_assertThisInitialized$1(_this), "debouncedSavePreferences", void 0);

    _defineProperty$1(_assertThisInitialized$1(_this), "onSavePreferences", /*#__PURE__*/_asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, savePreferences, onSaved;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, savePreferences = _this$props.savePreferences, onSaved = _this$props.onSaved;
              _context.next = 3;
              return savePreferences();

            case 3:
              if (onSaved) onSaved();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _this.debouncedSavePreferences = debounce(_this.onSavePreferences, props.debounce);
    return _this;
  }

  _createClass$1(PreferenceSaverBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var saveOnMount = this.props.saveOnMount;
      if (saveOnMount) this.onSavePreferences();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var saveOnUnmount = this.props.saveOnUnmount;
      if (saveOnUnmount) this.onSavePreferences();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return typeof children === "function" ? children(this.debouncedSavePreferences) : children;
    }
  }]);

  return PreferenceSaverBase;
}(React.Component);

_defineProperty$1(PreferenceSaverBase, "propTypes", {
  saveOnMount: propTypes.bool.isRequired,
  saveOnUnmount: propTypes.bool.isRequired,
  debounce: propTypes.number.isRequired,
  onSaved: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]).isRequired,
  savePreferences: propTypes.any.isRequired
});

var actions$3 = {
  savePreferences: savePreferences
};
var ConnectedPreferenceSaver = createTypedConnect()(undefined, actions$3)(PreferenceSaverBase);
/**
 * A helper to save app preferences
 */

var PreferenceSaver = function PreferenceSaver(props) {
  return /*#__PURE__*/React.createElement(ConnectedPreferenceSaver, props);
};

PreferenceSaver.propTypes = {
  saveOnMount: propTypes.bool,
  saveOnUnmount: propTypes.bool,
  debounce: propTypes.number,
  onSaved: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]).isRequired
};
PreferenceSaver.defaultProps = {
  saveOnMount: false,
  saveOnUnmount: false,
  debounce: 1000
};
/**
 * A hook to retrieve and manage preferences
 * @returns {object} An object with the following properties:
 * @returns {object} `preferences` Current preference values
 * @returns {function} `updatePreference` A function to update a single preference value, takes 2 arguments for the name and value to set
 * @returns {function} `resetPreferences` A function to reset all preferences to default values
 * @returns {function} `loadPreferences` A function to load preferences from previously saved data (if configured)
 * @returns {function} `savePreferences` A function to save preferences for re-loading later (if configured)
 */

var usePreferences = function usePreferences() {
  var dispatch = useDispatch();
  var preferences = useSelector(getPreferenceState);
  return {
    preferences: preferences,
    updatePreference: function updatePreference$1(key, value) {
      return dispatch(updatePreference(key, value));
    },
    resetPreferences: function resetPreferences$1() {
      return dispatch(resetPreferences());
    },
    loadPreferences: function loadPreferences$1() {
      return dispatch(loadPreferences());
    },
    savePreferences: function savePreferences$1() {
      return dispatch(savePreferences());
    }
  };
};
/**
 * A hook to retrieve or update a single preference value
 * @param {string} `key` Preference key to find
 * @returns {[]} An array in the format: [value, setValue]
 * @returns {*} `value` The current preference value, or undefined if the key does not exist
 * @returns {function} `setValue` A function to update the preference value, takes a single argument for the new value to set
 */


var usePreferenceValue = function usePreferenceValue(key) {
  var dispatch = useDispatch();
  var value = useSelector(function (state) {
    return getPreferenceValue(state, key);
  });

  var setValue = function setValue(newValue) {
    dispatch(updatePreference(key, newValue));
  };

  return [value, setValue];
};

var ScreenSize;

(function (ScreenSize) {
  ScreenSize["Small"] = "small";
  ScreenSize["Medium"] = "medium";
  ScreenSize["Large"] = "large";
})(ScreenSize || (ScreenSize = {}));

var _screenSizes;

var defaultOptions$7 = {
  screenSizes: (_screenSizes = {}, _defineProperty$1(_screenSizes, ScreenSize.Small, {
    max: 767
  }), _defineProperty$1(_screenSizes, ScreenSize.Medium, {
    min: 768,
    max: 1199
  }), _defineProperty$1(_screenSizes, ScreenSize.Large, {
    min: 1200
  }), _screenSizes)
};
var config$2 = new ModuleConfig(defaultOptions$7);

var getResponsiveOptions = function getResponsiveOptions() {
  return config$2.getAll();
};
/**
 * Configures options for the responsive module
 * @param {Object} `options` Options to set
 * @param {Object} `options.screenSizes` Defined screen breakpoints for the app, in the form of a key-object collection, where each key is the screen name, and the object the screen configuration. For example: { "small": { min:400, max:700 } }
 */


var setResponsiveOptions = function setResponsiveOptions(options) {
  return config$2.setAll(options);
}; // internal module helpers


var getScreenSizes = function getScreenSizes() {
  return config$2.get("screenSizes");
};
/**
 * Selects Redux state for responsive data
 * @param {object} `state` Redux state
 */


var getResponsiveState = function getResponsiveState(state) {
  return state.responsive;
};
/**
 * Returns state/config for the current screen size
 * @param {object|null} `state` Redux state, or null if the screen size has not been determined
 */


var getResponsiveScreen = function getResponsiveScreen(state) {
  var _getResponsiveState = getResponsiveState(state),
      screenSize = _getResponsiveState.screenSize;

  if (!screenSize) return null;
  var screenSizes = getScreenSizes();
  return {
    screenSize: screenSize,
    screenConfig: screenSizes[screenSize]
  };
};

var RESPONSIVE_RESIZE = "RESPONSIVE/RESIZE";

var updateScreenSize = function updateScreenSize(size) {
  return function (dispatch, getState) {
    var _getResponsiveState = getResponsiveState(getState()),
        screenSize = _getResponsiveState.screenSize;

    var screenSizes = getScreenSizes();
    var newScreenSize = Object.keys(screenSizes).find(function (key) {
      var _screenSizes$key = screenSizes[key],
          min = _screenSizes$key.min,
          max = _screenSizes$key.max;
      return (min === undefined || size >= min) && (max === undefined || size <= max);
    });

    if (newScreenSize && newScreenSize !== screenSize) {
      dispatch({
        type: RESPONSIVE_RESIZE,
        screenSize: newScreenSize
      });
    }
  };
};
/**
 * A hook to make components responsive
 * @returns {object|null} Current screen state/config, or null if the screen size has not been determined
 * @returns {string} `screenSize` The current screen size
 * @returns {object} `screenConfig` The current screen configuration
 */


var useResponsive = function useResponsive() {
  return useSelector(getResponsiveScreen);
};

var defaultOptions$8 = {
  reducers: {},
  middleware: [],
  reduxDevTools: false
};
var store = undefined;
var reducers = {}; // manipulation function to prevent build minification obscuring
// raw config value when using deployment string substitution

var useReduxDevTools = function useReduxDevTools(value) {
  if (typeof value === "string") {
    return value.toUpperCase() === "TRUE";
  }

  return !!value;
};
/**
 * Creates a new Redux store for state management
 * @param {Object} `options` Configuration options for the store
 * @param {Object} `options.reducers` Object containing the initial reducers for the store
 * @param {Array} `options.middleware` Redux middleware to apply to the store
 * @param {boolean|string} `options.reduxDevTools` Whether the Redux developer tools browser extension should be enabled, default false
 * @returns {Store} The newly created Store object
 */


var createReduxStore = function createReduxStore() {
  var _storeOptions$middlew;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var storeOptions = _objectSpread2$1(_objectSpread2$1({}, defaultOptions$8), options);

  reducers = _objectSpread2$1({}, storeOptions.reducers);
  var composeEnhancer = compose;

  if (storeOptions.reduxDevTools && useReduxDevTools(storeOptions.reduxDevTools) && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }

  var storeEnhancer = composeEnhancer(applyMiddleware.apply(void 0, _toConsumableArray$1((_storeOptions$middlew = storeOptions.middleware) !== null && _storeOptions$middlew !== void 0 ? _storeOptions$middlew : [])));
  var newStore = createStore(combineReducers(reducers), storeEnhancer);
  store = newStore;
  return newStore;
};
/**
 * Updates the Redux store with new reducers.
 * Existing reducers with the same name will be replaced
 * @param {Object} `newReducers` Object containing the new reducers to apply
 */


var updateReducers = function updateReducers(newReducers) {
  if (!store) return;
  reducers = _objectSpread2$1(_objectSpread2$1({}, reducers), newReducers);
  store.replaceReducer(combineReducers(reducers));
};

function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

var getInitialState = function getInitialState() {
  return {
    loggedIn: false
  };
};

var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AUTHENTICATE:
      return _objectSpread2$1(_objectSpread2$1({}, state), onMapAuthenticatedState$1(action.result));

    case DEAUTHENTICATE:
      return _objectSpread2$1(_objectSpread2$1({}, state), onMapDeauthenticatedState$1(action.result));

    default:
      return state;
  }
};

var initialState = {};

var builders = function builders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case RESET_LIST:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.id, {
        filters: _objectSpread2$1({}, action.filters),
        pagination: _objectSpread2$1({}, action.pagination),
        selection: _objectSpread2$1({}, action.selection)
      }));

    case CHANGE_FILTERS:
      var newListState = _objectSpread2$1(_objectSpread2$1({}, state[action.id]), {}, {
        filters: action.filters
      });

      if (action.resetPage) {
        newListState.pagination = _objectSpread2$1(_objectSpread2$1({}, newListState.pagination), {}, {
          pageNumber: 1
        });
      }

      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.id, newListState));

    case CHANGE_PAGINATION:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.id, _objectSpread2$1(_objectSpread2$1({}, state[action.id]), {}, {
        pagination: action.pagination
      })));

    case CHANGE_SELECTION:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.id, _objectSpread2$1(_objectSpread2$1({}, state[action.id]), {}, {
        selection: action.selection
      })));

    case CLEAR_STATE:
      var _action$id = action.id;
      state[_action$id];

      var remainingState = _objectWithoutProperties$1(state, [_action$id].map(_toPropertyKey$1));

      return _objectSpread2$1({}, remainingState);

    default:
      return state;
  }
};

var initialState$1 = {};

var lookups$1 = function lookups$1() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SAVE_LOOKUP_STATE:
    case LOOKUP_SET:
      {
        var oldLookupState = state[action.name] || {};
        var oldKeyState = oldLookupState.keys || [];
        var newLookupState = oldKeyState.reduce(function (acc, key) {
          if (key !== action.key && (!action.limit || acc.keys.length < action.limit)) {
            acc.keys = [].concat(_toConsumableArray$1(acc.keys), [key]);
            acc[key] = oldLookupState[key];
          }

          return acc;
        }, _defineProperty$1({
          keys: [action.key]
        }, action.key, _objectSpread2$1(_objectSpread2$1({}, oldLookupState[action.key]), action.state)));
        return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.name, newLookupState));
      }

    case LOOKUP_RESET:
      {
        if (!action.name) {
          // reset all lookups
          return {};
        }

        if (action.key === undefined) {
          // reset all data for a lookup
          var _action$name = action.name;
          state[_action$name];

          var otherLookups = _objectWithoutProperties$1(state, [_action$name].map(_toPropertyKey$1));

          return otherLookups;
        } // reset specified key for a lookup


        var _oldLookupState = state[action.name] || {};

        var _action$key = action.key;
        _oldLookupState[_action$key];

        var _oldLookupState$keys = _oldLookupState.keys,
            keys = _oldLookupState$keys === void 0 ? [] : _oldLookupState$keys,
            otherKeys = _objectWithoutProperties$1(_oldLookupState, [_action$key, "keys"].map(_toPropertyKey$1));

        return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.name, _objectSpread2$1(_objectSpread2$1({}, otherKeys), {}, {
          keys: keys.filter(function (k) {
            return k !== action.key;
          })
        })));
      }

    default:
      return state;
  }
};

var initialState$2 = {
  events: []
};

var notifications = function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ADD:
      var newEvent = {
        id: Math.floor(Math.random() * 100000000),
        title: action.title,
        type: action.eventType,
        message: action.message,
        customData: action.customData,
        expiry: action.expiry,
        creation: Date.now()
      };

      if (action.method === AddMethod.AddOrReplaceTop) {
        // check for duplicate event on top of the stack
        var _state$events = _toArray$1(state.events),
            lastEvent = _state$events[0],
            otherEvents = _state$events.slice(1);

        if (lastEvent && lastEvent.type === newEvent.type && lastEvent.message === newEvent.message) {
          return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
            events: [_objectSpread2$1(_objectSpread2$1({}, lastEvent), {}, {
              expiry: newEvent.expiry,
              creation: newEvent.creation
            })].concat(_toConsumableArray$1(otherEvents))
          });
        }
      }

      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        events: [newEvent].concat(_toConsumableArray$1(state.events))
      });

    case REMOVE:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        events: state.events.filter(function (e) {
          return e.id !== action.id;
        })
      });

    case REMOVE_ALL:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        events: []
      });

    default:
      return state;
  }
};

var preferences = function preferences() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getPreferenceDefaults();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case UPDATE_PREFERENCE:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, _defineProperty$1({}, action.key, action.value));

    case RESET_PREFERENCES:
      return getPreferenceDefaults();

    case LOAD_PREFERENCES:
      return _objectSpread2$1(_objectSpread2$1({}, state), action.values);

    default:
      return state;
  }
};

var initialState$3 = {
  screenSize: null
};

var responsive = function responsive() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case RESPONSIVE_RESIZE:
      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        screenSize: action.screenSize
      });

    default:
      return state;
  }
};

var abortMiddleware = function abortMiddleware() {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === "function" || action.type !== ABORTABLE_PROVIDER) {
          return next(action);
        }

        var abort = action.abort,
            abortAction = action.action;

        if (typeof abortAction === "function") {
          // thunks can't be handled automatically
          // the abort implementation will however be available as a 3rd param
          return abortAction(dispatch, getState, abort);
        }

        var abortableAction = _objectSpread2$1(_objectSpread2$1({}, abortAction), {}, {
          abort: abort
        });

        return dispatch(abortableAction);
      };
    };
  };
};

var apiRequest$1 = function apiRequest(method, url) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options$headers = options.headers,
      headers = _options$headers === void 0 ? {} : _options$headers,
      body = options.body,
      contentType = options.contentType,
      auth = options.auth,
      abort = options.abort,
      other = _objectWithoutProperties$1(options, ["headers", "body", "contentType", "auth", "abort"]);

  return new Promise(function (resolve, reject) {
    var object = _objectSpread2$1(_objectSpread2$1({}, other), {}, {
      method: method.toUpperCase(),
      headers: _objectSpread2$1({}, headers),
      body: undefined,
      signal: abort === null || abort === void 0 ? void 0 : abort.signal
    });

    if (contentType !== null && contentType !== undefined) {
      object.headers["Content-Type"] = contentType;
    }

    if (auth !== null && auth !== undefined) {
      object.headers["Authorization"] = auth;
    }

    if (body !== null && body !== undefined) {
      if (contentType && contentType.includes("application/json")) {
        object.body = JSON.stringify(body);
      } else {
        object.body = body;
      }
    }

    var rejected = false;

    if (abort !== undefined) {
      if (abort.aborted) {
        // aborted before request started
        reject(abort.reason);
        return;
      }

      if (!abort.signal) {
        // manually handle aborts where AbortSignal not supported
        var onAbort = function onAbort(reason) {
          rejected = true;
          abort.removeListener(onAbort);
          reject(reason);
        };

        abort.addListener(onAbort);
      }
    }

    fetch(url, object).then(function (response) {
      if (rejected) return;

      if (!response.ok) {
        var onErrorResponse = getOnErrorResponse();
        onErrorResponse(response).then(function (error) {
          return reject(error);
        });
        return;
      }

      var handleResponse = function handleResponse(r) {
        resolve(r);
      };

      var responseType = response.headers.get("Content-Type");

      if (!responseType || options.preventResponseHandling) {
        handleResponse(response);
      } else if (responseType.includes("application/json")) {
        // json response (silently catch errors caused by no data being returned by server)
        response.json().then(function (data) {
          return handleResponse(data);
        }).catch(function (error) {
          return handleResponse(null);
        });
      } else if (responseType.includes("application/zip") || responseType.includes("application/pdf") || responseType.includes("application/octet-stream") || responseType.includes("image/")) {
        // blob file types
        response.blob().then(function (data) {
          return handleResponse(data);
        });
      } else if (responseType.includes("text/")) {
        // text file types
        response.text().then(function (data) {
          return handleResponse(data);
        });
      } else {
        // unsupported type
        handleResponse(response);
      }
    }).catch(function (e) {
      if (rejected) return;
      var error = e;

      if (error.name === "AbortError" || abort !== null && abort !== void 0 && abort.aborted) {
        reject(abort === null || abort === void 0 ? void 0 : abort.reason);
      } else {
        var failureError = getFetchFailureError();
        reject(new ApiError(failureError || error.message, HttpStatus.ServiceUnavailable));
      }
    });
  });
};

var apiRequestHandler = function apiRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: action.method,
      url: action.url,
      contentType: action.contentType,
      body: action.body,
      auth: action.auth
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var requestOptions,
          response,
          error,
          onErrorNotification,
          reason,
          _args = arguments;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestOptions = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              response = undefined;
              _context.prev = 2;
              _context.next = 5;
              return apiRequest$1(action.method, action.url, _objectSpread2$1(_objectSpread2$1({}, requestOptions), {}, {
                headers: _objectSpread2$1(_objectSpread2$1({}, requestOptions.headers), action.headers),
                contentType: action.contentType,
                body: action.body,
                preventResponseHandling: getPreventResponseHandling() || action.preventResponseHandling,
                abort: action.abort
              }));

            case 5:
              response = _context.sent;
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);

              if (_context.t0 instanceof ApiError) {
                error = _context.t0;
                onErrorNotification = getOnErrorNotification();
                store.dispatch(req.error(error));

                if (!getPreventErrorNotification() && !action.preventErrorNotification && onErrorNotification) {
                  store.dispatch(onErrorNotification(error.message));
                }

                resolve({
                  success: false,
                  error: error
                });
              } else {
                reason = typeof _context.t0 === "string" ? _context.t0 : undefined;
                store.dispatch(req.abort(reason));
                resolve({
                  success: false,
                  reason: reason
                });
              }

              return _context.abrupt("return");

            case 12:
              store.dispatch(req.success(response));
              resolve({
                success: true,
                response: response
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 8]]);
    }));

    return function dispatchRequest() {
      return _ref.apply(this, arguments);
    };
  }(); // process the api request


  beforeRequest();
  onApiRequest$1(store, action).then(function (requestOptions) {
    dispatchRequest(requestOptions);
  }).catch(function (error) {
    store.dispatch(req.error(error));
    resolve({
      success: false,
      error: error
    });
  });
};

var mockRequestHandler = function mockRequestHandler(store, action, options, resolve) {
  var actionData = {};

  if (action.actionCustomData) {
    actionData.customData = action.actionCustomData;
  }

  var req = ajaxActionsFor(action.requestType, actionData); // function to perform any pre-request actions

  var beforeRequest = function beforeRequest() {
    store.dispatch(req.start({
      method: "MOCK",
      success: action.success,
      response: action.response,
      error: action.error,
      delay: action.delay
    }));

    if (action.actionSlowDelay) {
      store.dispatch(req.slow(action.actionSlowDelay));
    }
  }; // function to perform the request and subsequent actions


  var dispatchRequest = function dispatchRequest() {
    if (action.success) {
      store.dispatch(req.success(action.response));
      resolve({
        success: true,
        response: action.response
      });
    } else if (action.error != undefined) {
      var errorResponse = new ApiError(action.error);
      var onErrorNotification = getOnErrorNotification();
      store.dispatch(req.error(errorResponse));

      if (!getPreventErrorNotification() && !action.preventErrorNotification && onErrorNotification) {
        store.dispatch(onErrorNotification(errorResponse.message));
      }

      resolve({
        success: false,
        error: errorResponse
      });
    }
  }; // process the api request


  beforeRequest();
  var rejected = false;

  if (action.abort !== undefined) {
    var onAbort = function onAbort(reason) {
      var _action$abort;

      rejected = true;
      (_action$abort = action.abort) === null || _action$abort === void 0 ? void 0 : _action$abort.removeListener(onAbort);
      store.dispatch(req.abort(reason));
      resolve({
        success: false,
        reason: reason
      });
    };

    action.abort.addListener(onAbort);
  }

  if (action.delay) {
    setTimeout(function () {
      if (rejected) return;
      dispatchRequest();
    }, action.delay);
  } else {
    if (rejected) return;
    dispatchRequest();
  }
}; // Redux middleware


var defaultOptions$9 = {};
var debounceMap = new DebounceMap();

var apiMiddleware = function apiMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions$9;
  return function (store) {
    return function (next) {
      return function (action) {
        var requestHandler = action.type === API_REQUEST ? apiRequestHandler : action.type === MOCK_REQUEST ? mockRequestHandler : null;

        if (requestHandler) {
          return new Promise(function (resolve) {
            var processRequest = function processRequest() {
              return requestHandler(store, action, options, resolve);
            };

            if (action.debounce && action.requestType) {
              debounceMap.debounce(action.requestType, processRequest, Math.abs(action.debounce), {
                immediate: action.debounce < 0
              });
            } else {
              processRequest();
            }
          });
        }

        return next(action);
      };
    };
  };
};

var middlewareMap = {};

var loggingMiddleware = function loggingMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        // check middlewares setup
        processLoggers(function (logger) {
          if (!middlewareMap[logger.type] && logger.getMiddleware) {
            var mw = logger.getMiddleware();

            if (mw) {
              middlewareMap[logger.type] = mw(store);
            }
          }
        }); // intercept and process each middleware

        var middlewares = Object.values(middlewareMap);
        var theNext = middlewares.reduce(function (acc, mw) {
          return mw(acc);
        }, next);
        return theNext(action);
      };
    };
  };
};

var lookupPromises = new ConcurrentPromiseMap();

var lookupMiddleware = function lookupMiddleware() {
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === LOOKUP_REQUEST) {
          // ensure the lookup is registered
          if (!lookupExists(action.name)) {
            var error = "Lookup \"".concat(action.name, "\" has not been registered");
            console.error(error);
            return Promise.resolve({
              success: false,
              error: error
            });
          } // get required lookup info


          var lookupAction = getLookupAction(action.name);

          var lookupOptions = _objectSpread2$1(_objectSpread2$1({}, getLookupOptions(action.name)), action.options);

          var lookupState = getLookupState(store.getState());
          var promiseKey = "".concat(action.name, "/").concat(action.key); // re-use state data if caching

          if (lookupOptions.cache && lookupState[action.name] && lookupState[action.name][action.key] && lookupState[action.name][action.key].response) {
            var useCache = true;
            var dataState = lookupState[action.name][action.key];
            var cacheDate = dataState.date; // check cache hasn't expired

            if (cacheDate && lookupOptions.cacheExpiry) {
              var expiryDate = cacheDate + lookupOptions.cacheExpiry;
              if (expiryDate < Date.now()) useCache = false;
            }

            if (useCache) {
              return Promise.resolve({
                success: true,
                response: dataState.response
              });
            }
          } // the process of requesting a lookup is promise-able so if
          // multiple simultaneous requests we only perform the lookup once


          var requestLookup = function requestLookup() {
            return new Promise(function (resolve) {
              var saveFailure = false;

              var saveLookup = function saveLookup(newState) {
                // ensure the lookup is still registered
                if (!lookupExists(action.name)) {
                  if (!saveFailure) {
                    console.warn("Lookup \"".concat(action.name, "\" unregistered before request finished"));
                  }

                  saveFailure = true;
                  return;
                }

                var limit = lookupOptions.cache ? lookupOptions.cacheLimit === undefined || isNaN(lookupOptions.cacheLimit) ? undefined : lookupOptions.cacheLimit : 1;
                store.dispatch(saveLookupState(action.name, action.key, limit, newState));
              };

              saveLookup({
                loading: true,
                slowLoading: false,
                params: action.params
              });
              var slowTimeout = setTimeout(function () {
                saveLookup({
                  loading: true,
                  slowLoading: true
                });
              }, 200);
              store.dispatch(typeof lookupAction === "function" ? lookupAction(action.params) : lookupAction).then(function (_ref) {
                var success = _ref.success,
                    rawResponse = _ref.response,
                    error = _ref.error;
                clearTimeout(slowTimeout);
                var response = success && rawResponse && lookupOptions.transform ? lookupOptions.transform(rawResponse, action.params) : rawResponse;
                saveLookup({
                  loading: false,
                  slowLoading: false,
                  date: Date.now(),
                  response: response,
                  error: error
                });
                resolve({
                  success: success,
                  response: response,
                  error: error
                });
              });
            });
          };

          return lookupPromises.resolve(promiseKey, requestLookup);
        }

        return next(action);
      };
    };
  };
};

var getDefaultReducers = function getDefaultReducers() {
  return {
    auth: auth,
    builders: builders,
    lookups: lookups$1,
    notifications: notifications,
    preferences: preferences,
    responsive: responsive
  };
};

var getDefaultMiddleware = function getDefaultMiddleware() {
  return [apiMiddleware(), lookupMiddleware(), loggingMiddleware(), thunk, abortMiddleware() // must run before thunk
  ];
};

var createDefaultReduxStore = function createDefaultReduxStore() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var reducers = _objectSpread2$1(_objectSpread2$1({}, options.reducers || {}), getDefaultReducers());

  var middleware = [].concat(_toConsumableArray$1(options.middleware || []), _toConsumableArray$1(getDefaultMiddleware()));
  return createReduxStore(_objectSpread2$1(_objectSpread2$1({}, options), {}, {
    reducers: reducers,
    middleware: middleware
  }));
};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var reactIs_production_min$1 = createCommonjsModule$1(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118;function x(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case t:case r:case d:return u}}}function y(a){return x(a)===m}exports.typeOf=x;exports.AsyncMode=l;
exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w)};exports.isAsyncMode=function(a){return y(a)||x(a)===l};exports.isConcurrentMode=y;exports.isContextConsumer=function(a){return x(a)===k};exports.isContextProvider=function(a){return x(a)===h};
exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return x(a)===n};exports.isFragment=function(a){return x(a)===e};exports.isLazy=function(a){return x(a)===t};exports.isMemo=function(a){return x(a)===r};exports.isPortal=function(a){return x(a)===d};exports.isProfiler=function(a){return x(a)===g};exports.isStrictMode=function(a){return x(a)===f};exports.isSuspense=function(a){return x(a)===p};
});

unwrapExports$1(reactIs_production_min$1);
reactIs_production_min$1.typeOf;
reactIs_production_min$1.AsyncMode;
reactIs_production_min$1.ConcurrentMode;
reactIs_production_min$1.ContextConsumer;
reactIs_production_min$1.ContextProvider;
reactIs_production_min$1.Element;
reactIs_production_min$1.ForwardRef;
reactIs_production_min$1.Fragment;
reactIs_production_min$1.Lazy;
reactIs_production_min$1.Memo;
reactIs_production_min$1.Portal;
reactIs_production_min$1.Profiler;
reactIs_production_min$1.StrictMode;
reactIs_production_min$1.Suspense;
reactIs_production_min$1.isValidElementType;
reactIs_production_min$1.isAsyncMode;
reactIs_production_min$1.isConcurrentMode;
reactIs_production_min$1.isContextConsumer;
reactIs_production_min$1.isContextProvider;
reactIs_production_min$1.isElement;
reactIs_production_min$1.isForwardRef;
reactIs_production_min$1.isFragment;
reactIs_production_min$1.isLazy;
reactIs_production_min$1.isMemo;
reactIs_production_min$1.isPortal;
reactIs_production_min$1.isProfiler;
reactIs_production_min$1.isStrictMode;
reactIs_production_min$1.isSuspense;

var reactIs_development$1 = createCommonjsModule$1(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
// TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports$1(reactIs_development$1);
reactIs_development$1.typeOf;
reactIs_development$1.AsyncMode;
reactIs_development$1.ConcurrentMode;
reactIs_development$1.ContextConsumer;
reactIs_development$1.ContextProvider;
reactIs_development$1.Element;
reactIs_development$1.ForwardRef;
reactIs_development$1.Fragment;
reactIs_development$1.Lazy;
reactIs_development$1.Memo;
reactIs_development$1.Portal;
reactIs_development$1.Profiler;
reactIs_development$1.StrictMode;
reactIs_development$1.Suspense;
reactIs_development$1.isValidElementType;
reactIs_development$1.isAsyncMode;
reactIs_development$1.isConcurrentMode;
reactIs_development$1.isContextConsumer;
reactIs_development$1.isContextProvider;
reactIs_development$1.isElement;
reactIs_development$1.isForwardRef;
reactIs_development$1.isFragment;
reactIs_development$1.isLazy;
reactIs_development$1.isMemo;
reactIs_development$1.isPortal;
reactIs_development$1.isProfiler;
reactIs_development$1.isStrictMode;
reactIs_development$1.isSuspense;

var reactIs$1 = createCommonjsModule$1(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;

function toObject$1(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative$1() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign$1 = shouldUseNative$1() ? Object.assign : function (target, source) {
	var from;
	var to = toObject$1(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols$1) {
			symbols = getOwnPropertySymbols$1(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable$1.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$1;
  var loggedTypeFailures$1 = {};
  var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$2(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$3);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures$1)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures$1[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures$1 = {};
  }
};

var checkPropTypes_1$1 = checkPropTypes$1;

var has$3 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$3 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$3 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull$1() {
  return null;
}

var factoryWithTypeCheckers$1 = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$3(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull$1);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$3(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$3('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull$1;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$3(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$3('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull$1;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$3(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull$1;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign$1({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1$1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1$1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction$1() {}
function emptyFunctionWithReset$1() {}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$1;

var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$1
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes$1 = createCommonjsModule$1(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims$1();
}
});
propTypes$1.bool;
propTypes$1.number;
propTypes$1.string;
propTypes$1.shape;
propTypes$1.func;
propTypes$1.any;
propTypes$1.node;

var classnames = createCommonjsModule$1(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var _templateObject;
var sizes = {
  mobile: {
    minWidth: 320,
    maxWidth: 767
  },
  tablet: {
    minWidth: 768,
    maxWidth: 991
  },
  computer: {
    minWidth: 992
  },
  largeScreen: {
    minWidth: 1200,
    maxWidth: 1919
  },
  widescreen: {
    minWidth: 1920
  }
};
Object.keys(sizes).reduce(function (acc, label) {
  var minWidth = sizes[label].minWidth ? "(min-width: ".concat(sizes[label].minWidth, "px)") : "";
  var maxWidth = sizes[label].maxWidth ? "(max-width: ".concat(sizes[label].maxWidth, "px)") : "";
  var mediaProps = "".concat(minWidth, " ").concat(maxWidth);

  acc[label] = function (first) {
    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    @media ", " {\n      ", ";\n    }\n  "])), mediaProps, css.apply(void 0, [first].concat(interpolations)));
  };

  return acc;
}, {});
var getCssPixelWidth = function getCssPixelWidth(width) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100%";

  if (typeof width === "number") {
    return "".concat(width, "px");
  } else if (typeof width === "string") {
    return width;
  }

  return defaultValue;
}; // this is very much an approximation for default Cinnamon styling
// and may have to be tweaked!

var CHARACTERS_TO_EMS = 0.75;
var getCssCharacterWidth = function getCssCharacterWidth(width) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100%";

  if (typeof width === "number") {
    return "".concat(width * CHARACTERS_TO_EMS, "em");
  } else if (typeof width === "string") {
    return width;
  }

  return defaultValue;
};

/**
 * A single item for a `dt` & `dd` element pair
 */

var DataListItem = function DataListItem(_ref) {
  var children = _ref.children,
      width = _ref.width,
      title = _ref.title,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin data-list-item", className),
    style: {
      width: getCssPixelWidth(width, "100%")
    }
  }, /*#__PURE__*/React.createElement("dt", null, title), /*#__PURE__*/React.createElement("dd", null, children));
};

DataListItem.propTypes = {
  /**
   * Optional, Restricts the width to each item to the specified amount / percentage
   */
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * The value of dt (data title)
   */
  title: propTypes$1.string.isRequired,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * Creates a styled `dl` element that displays a list of data
 */

var DataList = function DataList(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("dl", {
    className: classnames("cin data-list", className)
  }, children);
};

DataList.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
DataList.Item = DataListItem;

/**
 * Component for rendering an API error message
 */

var ErrorMessage = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorMessage, _React$Component);

  var _super = _createSuper(ErrorMessage);

  function ErrorMessage() {
    var _this;

    _classCallCheck(this, ErrorMessage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "isApiError", function (error) {
      return _typeof(error) === "object" && error instanceof ApiError;
    });

    _defineProperty(_assertThisInitialized(_this), "mapApiErrors", function (error) {
      var _this$props = _this.props,
          omitCodes = _this$props.omitCodes,
          overrideMessages = _this$props.overrideMessages;
      return error.format(omitCodes, overrideMessages);
    });

    _defineProperty(_assertThisInitialized(_this), "isGenericError", function (error) {
      return _typeof(error) === "object" && error.hasOwnProperty("message") && typeof error.message === "string";
    });

    _defineProperty(_assertThisInitialized(_this), "mapGenericErrors", function (error) {
      if (!error.message) return [];
      return [error.message];
    });

    return _this;
  }

  _createClass(ErrorMessage, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          header = _this$props2.header,
          error = _this$props2.error;
      if (!error) return null;
      var errors = [];

      if (typeof error === "string" && error.length > 0) {
        errors = [error];
      } else if (this.isApiError(error)) {
        errors = this.mapApiErrors(error);
      } else if (this.isGenericError(error)) {
        errors = this.mapGenericErrors(error);
      }

      var errorProps = {};

      if (!errors || errors.length === 0) {
        errorProps.content = "An unexpected error has occurred";
      } else if (errors.length === 1) {
        errorProps.content = errors[0];
      } else {
        errorProps.list = errors;
      }

      return /*#__PURE__*/React.createElement(Message, _extends({
        error: true,
        visible: true,
        header: header
      }, errorProps));
    }
  }]);

  return ErrorMessage;
}(React.Component);

_defineProperty(ErrorMessage, "propTypes", {
  /**
   * Title for the error message
   */
  header: propTypes$1.string,

  /**
   * The error that occurred, if null then no error will be displayed
   */
  error: propTypes$1.oneOfType([propTypes$1.instanceOf(ApiError), propTypes$1.object, propTypes$1.string]),

  /**
   * Whether error codes should be hidden
   */
  omitCodes: propTypes$1.bool,

  /**
   * Object containing replacement message content to customise API errors.
   * Each key should map to a numeric API error code, with a replacement message string or component as the value.
   * Alternatively, keys may also be the original error string to exactly match on.
   * Where both types of key exist, the original error string key/replacement pair will take precedence
   * Replacement messages can also be a function which will receive the original error, and return a string or component
   * @property {string|ReactNode|function} `[code]` Message to display for a given error code
   * @property {string|ReactNode|function} `[message]` Message to display for a given error message
   */
  overrideMessages: propTypes$1.object
});

_defineProperty(ErrorMessage, "defaultProps", {
  header: "Something went wrong",
  omitCodes: false
});

var Reveal = /*#__PURE__*/function (_React$Component) {
  _inherits(Reveal, _React$Component);

  var _super = _createSuper(Reveal);

  function Reveal(props) {
    var _this;

    _classCallCheck(this, Reveal);

    _this = _super.call(this, props);
    _this.state = {
      wrapperStyle: {
        height: 0,
        opacity: 0
      }
    };
    _this.content = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(Reveal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible) {
        this.show();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.visible && !prevProps.visible) {
        this.show();
      } else if (!this.props.visible && prevProps.visible) {
        this.hide();
      }
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight() {
      var el = this.content.current;
      if (!el) return 0;
      return el.offsetHeight + parseInt(window.getComputedStyle(el, null).getPropertyValue("margin-top"), 10) + parseInt(window.getComputedStyle(el, null).getPropertyValue("margin-bottom"), 10);
    }
  }, {
    key: "show",
    value: function show() {
      var duration = this.props.duration;
      var height = this.getContentHeight();
      this.setState({
        wrapperStyle: {
          height: height,
          opacity: 1,
          transition: "height ".concat(duration * 0.5, "ms ease 0ms, opacity ").concat(duration, "ms ease ").concat(duration * 0.1, "ms")
        }
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var duration = this.props.duration;
      this.setState({
        wrapperStyle: {
          height: 0,
          opacity: 0,
          transition: "height ".concat(duration, "ms ease ").concat(duration * 0.4, "ms, opacity ").concat(duration, "ms ease 0ms")
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var wrapperStyle = this.state.wrapperStyle;
      return /*#__PURE__*/React.createElement("div", {
        style: wrapperStyle
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.content
      }, children));
    }
  }]);

  return Reveal;
}(React.Component);

_defineProperty(Reveal, "propTypes", {
  visible: propTypes$1.bool,
  duration: propTypes$1.number.isRequired
});

_defineProperty(Reveal, "defaultProps", {
  visible: true,
  duration: 400
});

/**
 * A component for indicating the state of data being loaded
 */

var Loadable = /*#__PURE__*/function (_React$Component) {
  _inherits(Loadable, _React$Component);

  var _super = _createSuper(Loadable);

  function Loadable() {
    var _this;

    _classCallCheck(this, Loadable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeError: _this.props.error
    });

    _defineProperty(_assertThisInitialized(_this), "renderLoader", function (loading, slowLoading, animateLoader) {
      if (!loading || !(slowLoading || slowLoading === undefined)) return null;
      var loaderContent = /*#__PURE__*/React.createElement(Loader, {
        inline: true,
        active: loading,
        size: "large"
      });

      if (typeof animateLoader === "number" && animateLoader > 0) {
        return /*#__PURE__*/React.createElement(Transition, {
          animation: "fade",
          duration: animateLoader,
          visible: loading,
          transitionOnMount: true
        }, loaderContent);
      }

      return loaderContent;
    });

    _defineProperty(_assertThisInitialized(_this), "renderError", function (error, animateError) {
      var activeError = _this.state.activeError;
      if (!activeError) return null;
      var errorContent = /*#__PURE__*/React.createElement(ErrorMessage, {
        error: activeError
      });

      if (typeof animateError === "number" && animateError > 0) {
        return /*#__PURE__*/React.createElement(Reveal, {
          visible: !!error,
          duration: animateError
        }, errorContent);
      }

      return errorContent;
    });

    return _this;
  }

  _createClass(Loadable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          loading = _this$props.loading,
          slowLoading = _this$props.slowLoading,
          error = _this$props.error,
          animateLoader = _this$props.animateLoader,
          animateError = _this$props.animateError,
          fitLoader = _this$props.fitLoader,
          children = _this$props.children,
          fluid = _this$props.fluid;
      return /*#__PURE__*/React.createElement(Dimmer.Dimmable, {
        dimmed: loading,
        className: classnames("cin loadable", {
          loading: loading,
          "fit-loader": fitLoader,
          fluid: fluid
        }, className)
      }, /*#__PURE__*/React.createElement(Dimmer, {
        active: loading,
        inverted: true
      }, this.renderLoader(loading, slowLoading, animateLoader)), children, this.renderError(error, animateError));
    }
  }]);

  return Loadable;
}(React.Component);

_defineProperty(Loadable, "getDerivedStateFromProps", function (nextProps, prevState) {
  if (nextProps.error && nextProps.error !== prevState.error) {
    return {
      activeError: nextProps.error
    };
  }

  return null;
});

Loadable.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Whether data is currently being loaded
   */
  loading: propTypes$1.bool,

  /**
   * Optional, indicates loading is taking longer than expected
   * If a value is passed, the loading spinner will only appear when set to true
   */
  slowLoading: propTypes$1.bool,

  /**
   * Error message to display when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Time in milliseconds for the loader animation transition, or false to disable
   */
  animateLoader: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),

  /**
   * Time in milliseconds for the error animation transition, or false to disable
   */
  animateError: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),

  /**
   * Whether the loading region should automatically expand to fit the loading indicator
   * When false, the loading indicator may be cut-off if the content is not tall enough
   */
  fitLoader: propTypes$1.bool,

  /**
   * Whether the Loadable should expand to fill its container and center the loading
   * indicator
   */
  fluid: propTypes$1.bool
};
Loadable.defaultProps = {
  animateLoader: 300,
  animateError: 400,
  fitLoader: true
};

var TreeNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TreeNode, _React$Component);

  var _super = _createSuper(TreeNode);

  function TreeNode() {
    var _this;

    _classCallCheck(this, TreeNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: _this.props.fixed || _this.props.defaultExpanded || _this.props.node.defaultExpanded || _this.props.node.root || false,
      // used to ensure previously expanded children are rendered so they persist their expanded state
      previouslyExpanded: false
    });

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "getNodeKey", function (node) {
      var nodeKey = _this.props.nodeKey;
      var key = node[nodeKey];

      if (!key && !_this._keyWarning) {
        node.children;
            var nodeWithoutChildren = _objectWithoutProperties(node, ["children"]);

        console.warn("TreeView nodeKey is invalid for node: " + JSON.stringify(nodeWithoutChildren));
        _this._keyWarning = true;
      }

      return key;
    });

    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      return _this.setState({
        expanded: false,
        previouslyExpanded: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "expand", function () {
      return _this.setState({
        expanded: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderNode", function (node, state, events) {
      return node.text;
    });

    return _this;
  }

  _createClass(TreeNode, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          visible = _this$props.visible,
          node = _this$props.node,
          nodeKey = _this$props.nodeKey,
          indent = _this$props.indent,
          fixed = _this$props.fixed,
          collapsedIcon = _this$props.collapsedIcon,
          expandedIcon = _this$props.expandedIcon,
          defaultExpanded = _this$props.defaultExpanded,
          renderNode = _this$props.renderNode,
          animate = _this$props.animate;
      var _this$state = this.state,
          expanded = _this$state.expanded,
          previouslyExpanded = _this$state.previouslyExpanded;
      var hasChildren = node.children && node.children.length > 0;
      var renderArgs = [node, {
        expanded: expanded
      }, {
        onCollapse: this.collapse,
        onExpand: this.expand
      }];
      var expanderIndent = fixed ? 0 : 25;
      var isAnimating = typeof animate === "number" && animate > 0;
      var AnimateWrapper = isAnimating ? Transition : React.Fragment;
      var animateProps = isAnimating ? {
        visible: visible && expanded,
        animation: "fade down",
        duration: animate
      } : {};
      return /*#__PURE__*/React.createElement("div", {
        className: classnames("cin tree-node", {
          visible: !!visible
        }, node.className)
      }, visible && !node.root && /*#__PURE__*/React.createElement(React.Fragment, null, !fixed && /*#__PURE__*/React.createElement(Button, {
        basic: true,
        compact: true,
        icon: expanded ? expandedIcon : collapsedIcon,
        onClick: expanded ? this.collapse : this.expand,
        style: {
          marginLeft: -expanderIndent,
          opacity: hasChildren ? 100 : 0,
          cursor: hasChildren ? "pointer" : "default"
        }
      }), /*#__PURE__*/React.createElement("div", null, renderNode && renderNode.apply(void 0, renderArgs) || this.defaultRenderNode.apply(this, renderArgs))), (isAnimating || expanded || previouslyExpanded) && hasChildren && /*#__PURE__*/React.createElement(AnimateWrapper, animateProps, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: node.root ? expanderIndent : indent
        }
      }, node.children.map(function (child, index) {
        return /*#__PURE__*/React.createElement(TreeNode, {
          key: _this2.getNodeKey(child) || index,
          visible: isAnimating || visible && expanded,
          node: child,
          nodeKey: nodeKey,
          indent: indent,
          fixed: fixed,
          collapsedIcon: collapsedIcon,
          expandedIcon: expandedIcon,
          defaultExpanded: defaultExpanded,
          renderNode: renderNode,
          animate: animate
        });
      }))));
    }
  }]);

  return TreeNode;
}(React.Component);

_defineProperty(TreeNode, "propTypes", {
  visible: propTypes$1.bool,
  node: propTypes$1.shape({
    root: propTypes$1.bool,
    defaultExpanded: propTypes$1.bool,
    text: propTypes$1.string,
    children: propTypes$1.arrayOf(propTypes$1.object),
    className: propTypes$1.string
  }).isRequired,
  nodeKey: propTypes$1.string,
  indent: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fixed: propTypes$1.bool,
  collapsedIcon: propTypes$1.node,
  expandedIcon: propTypes$1.node,
  defaultExpanded: propTypes$1.bool,
  renderNode: propTypes$1.func,
  animate: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool])
});

_defineProperty(TreeNode, "defaultProps", {
  visible: true
});

/**
 * Displays data in a nested tree structure
 */

var TreeView = function TreeView(_ref) {
  var nodes = _ref.nodes,
      nodeKey = _ref.nodeKey,
      indent = _ref.indent,
      fixed = _ref.fixed,
      collapsedIcon = _ref.collapsedIcon,
      expandedIcon = _ref.expandedIcon,
      defaultExpanded = _ref.defaultExpanded,
      renderNode = _ref.renderNode,
      animateNodes = _ref.animateNodes,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin tree-view", className)
  }, /*#__PURE__*/React.createElement(TreeNode, {
    node: {
      root: true,
      children: nodes
    },
    nodeKey: nodeKey,
    indent: indent,
    fixed: fixed,
    collapsedIcon: collapsedIcon,
    expandedIcon: expandedIcon,
    defaultExpanded: defaultExpanded,
    renderNode: renderNode,
    animate: animateNodes
  }));
};

TreeView.propTypes = {
  /**
   * Array of tree nodes objects in format [{ value: "", text: "", children: [] }]
   * @property {any} `value` Unique key for the node (can use a different property name by overriding the nodeKey prop)
   * @property {string} `text` Text to display for the node (optional if using the custom renderNode prop)
   * @property {Array} `children` Optional child node objects for nesting data in the tree
   * @property {boolean} `defaultExpanded` Whether the node should be expanded when initially mounted
   * @property {string} `className` Optional classes for styling
   */
  nodes: propTypes$1.arrayOf(propTypes$1.object).isRequired,

  /**
   * Property name for unique key in each node object
   */
  nodeKey: propTypes$1.string,

  /**
   * Indent width for each sub-level of nodes
   */
  indent: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * Whether the tree should be fixed and not expandable/collapsable
   */
  fixed: propTypes$1.bool,

  /**
   * Icon to display when a node is collapsed
   */
  collapsedIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Icon to display when a node is expanded
   */
  expandedIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Whether the tree should be fully expanded when initially mounted
   */
  defaultExpanded: propTypes$1.bool,

  /**
   * Custom render function for each node in the tree
   * @param {Object} `node` The current node being rendered
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.expanded` Whether the node is currently expanded
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onCollapse` Collapses the node
   * @param {function} `events.onExpand` Expands the node
   */
  renderNode: propTypes$1.func,

  /**
   * Time in milliseconds for node animation transitions, or false to disable
   */
  animateNodes: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
TreeView.defaultProps = {
  nodeKey: "value",
  indent: 20,
  fixed: false,
  collapsedIcon: /*#__PURE__*/React.createElement(Icon, {
    name: "triangle right",
    size: "large"
  }),
  expandedIcon: /*#__PURE__*/React.createElement(Icon, {
    name: "triangle down",
    size: "large"
  }),
  defaultExpanded: false,
  animateNodes: 400
};

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */

var parse_1 = parse;
var serialize_1 = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode$1 = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode$1;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
    // JSDOM does not support changing cookies, disable it for tests
    if (isJsDom()) {
        return false;
    }
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function isJsDom() {
    if (typeof navigator !== 'object' ||
        typeof navigator.userAgent !== 'string') {
        return false;
    }
    return (navigator.userAgent.indexOf('Node.js') >= 0 ||
        navigator.userAgent.indexOf('jsdom') >= 0);
}
function parseCookies(cookies) {
    if (typeof cookies === 'string') {
        return parse_1(cookies);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}

// We can't please Rollup and TypeScript at the same time
// Only way to make both of them work
var objectAssign$2 = require('object-assign');
var Cookies = /** @class */ (function () {
    function Cookies(cookies) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = parseCookies(cookies);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function () {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = parse_1(document.cookie);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        return readCookie(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues();
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = readCookie(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = objectAssign$2({}, this.cookies, (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = serialize_1(name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = objectAssign$2({}, options, {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        }));
        this.cookies = objectAssign$2({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = serialize_1(name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());

var TokenStorageMethod;

(function (TokenStorageMethod) {
  TokenStorageMethod["None"] = "none";
  TokenStorageMethod["Cookies"] = "cookies";
  TokenStorageMethod["LocalStorage"] = "localStorage";
})(TokenStorageMethod || (TokenStorageMethod = {}));

var DefaultTokenStorageMethod = TokenStorageMethod.Cookies;
var tokenStorageMethod = DefaultTokenStorageMethod;
var getTokenStorageMethod = function getTokenStorageMethod() {
  return tokenStorageMethod;
};
var setTokenStorageMethod = function setTokenStorageMethod(method) {
  tokenStorageMethod = method;
};

var cookies = new Cookies();

var storeToken$1 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, token) {
    var tokenStorage;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenStorage = getTokenStorageMethod();
            _context.t0 = tokenStorage;
            _context.next = _context.t0 === TokenStorageMethod.LocalStorage ? 4 : _context.t0 === TokenStorageMethod.Cookies ? 6 : 8;
            break;

          case 4:
            localStorage.setItem(key, token);
            return _context.abrupt("break", 9);

          case 6:
            cookies.set(key, token, {
              path: "/"
            });
            return _context.abrupt("break", 9);

          case 8:
            console.warn("Unknown TokenStorageMethod provided ".concat(tokenStorage));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function storeToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getToken$1 = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
    var token;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = localStorage.getItem(key);

            if (token == null) {
              token = cookies.get(key);
            }

            return _context2.abrupt("return", token);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var clearToken$1 = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            localStorage.removeItem(key);
            cookies.remove(key, {
              path: "/"
            });

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function clearToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var WebTokenStoreProvider = {
  getToken: getToken$1,
  storeToken: storeToken$1,
  clearToken: clearToken$1
};

/**
 * React Router compatible <Route/> that only matches when a user is currently authenticated
 */

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      render = _ref.render,
      redirect = _ref.redirect,
      loggedIn = _ref.loggedIn,
      rest = _objectWithoutProperties(_ref, ["component", "render", "redirect", "loggedIn"]);

  if (!loggedIn && !redirect) return null;

  var renderRoute = function renderRoute(props) {
    if (!loggedIn) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: redirect,
          state: {
            nextPath: props.location
          }
        }
      });
    }

    if (Component) return /*#__PURE__*/React.createElement(Component, props);
    if (render) return render(props);
    return null;
  };

  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: renderRoute
  }));
};

PrivateRoute.propTypes = {
  /**
   * Component to be rendered by route
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function to render the route
   * @param {Object} `props` react-router Route render props
   */
  render: propTypes$1.func,

  /**
   * Optional path to automatically redirect to if not authenticated, if not specified then the route will not match
   */
  redirect: propTypes$1.string
};

var mapStateToProps$3 = function mapStateToProps(state) {
  return {
    loggedIn: getAuthState(state).loggedIn
  };
};

var PrivateRoute$1 = connect$1(mapStateToProps$3)(PrivateRoute);

/**
 * React Router compatible <Route/> that only matches when a user is not authenticated
 */

var PublicRoute = function PublicRoute(_ref) {
  var Component = _ref.component,
      render = _ref.render,
      redirect = _ref.redirect,
      loggedIn = _ref.loggedIn,
      rest = _objectWithoutProperties(_ref, ["component", "render", "redirect", "loggedIn"]);

  if (loggedIn && !redirect) return null;

  var renderRoute = function renderRoute(props) {
    if (loggedIn) {
      return /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: redirect,
          state: {
            nextPath: props.location
          }
        }
      });
    }

    if (Component) return /*#__PURE__*/React.createElement(Component, props);
    if (render) return render(props);
    return null;
  };

  return /*#__PURE__*/React.createElement(Route, _extends({}, rest, {
    render: renderRoute
  }));
};

PublicRoute.propTypes = {
  /**
   * Component to be rendered by route
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function to render the route
   * @param {Object} `props` react-router Route render props
   */
  render: propTypes$1.func,

  /**
   * Optional path to automatically redirect to if currently authenticated, if not specified then the route will not match
   */
  redirect: propTypes$1.string
};

var mapStateToProps$4 = function mapStateToProps(state) {
  return {
    loggedIn: getAuthState(state).loggedIn
  };
};

var PublicRoute$1 = connect$1(mapStateToProps$4)(PublicRoute);

/**
 * React Router compatible <Switch/> that also matches on <PrivateRoute/> and <PublicRoute/> components
 */

var AuthenticatedSwitch = function AuthenticatedSwitch(_ref) {
  var loggedIn = _ref.loggedIn,
      children = _ref.children,
      switchProps = _objectWithoutProperties(_ref, ["loggedIn", "children"]);

  var filteredChildren = React.Children.map(children, function (element) {
    if (element.type) {
      if (!loggedIn && element.type === PrivateRoute$1 || loggedIn && element.type === PublicRoute$1) {
        var _element$props = element.props,
            redirect = _element$props.redirect;
            _element$props.component;
            var routeProps = _objectWithoutProperties(_element$props, ["redirect", "component"]);

        if (redirect) {
          return /*#__PURE__*/React.createElement(Route, _extends({}, routeProps, {
            render: function render(props) {
              return /*#__PURE__*/React.createElement(Redirect, {
                to: {
                  pathname: redirect,
                  state: {
                    nextPath: props.location
                  }
                }
              });
            }
          }));
        }

        return null;
      }
    }

    return element;
  }).filter(function (x) {
    return x !== null;
  });
  return /*#__PURE__*/React.createElement(Switch, switchProps, filteredChildren);
};

var mapStateToProps$5 = function mapStateToProps(state) {
  return {
    loggedIn: getAuthState(state).loggedIn
  };
};

var AuthenticatedSwitch$1 = connect$1(mapStateToProps$5)(AuthenticatedSwitch);

var ActionTypes = {
  Home: "home",
  Add: "add",
  Edit: "edit",
  Delete: "delete",
  Upload: "upload",
  Download: "download",
  Up: "up",
  Down: "down",
  Left: "left",
  Right: "right",
  Save: "save",
  Cancel: "cancel"
};

/**
 * A minimal button that indicates a specific action to perform
 */

var ActionButton = function ActionButton(_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, ["type"]);

  var icon = undefined;
  var color = undefined;

  switch (type) {
    case ActionTypes.Home:
      icon = "home";
      color = "black";
      break;

    case ActionTypes.Add:
      icon = "plus";
      color = "green";
      break;

    case ActionTypes.Edit:
      icon = "pencil";
      color = "blue";
      break;

    case ActionTypes.Delete:
      icon = "trash";
      color = "grey";
      break;

    case ActionTypes.Upload:
      icon = "upload";
      color = "blue";
      break;

    case ActionTypes.Download:
      icon = "download";
      color = "blue";
      break;

    case ActionTypes.Up:
      icon = "chevron up";
      color = "grey";
      break;

    case ActionTypes.Down:
      icon = "chevron down";
      color = "grey";
      break;

    case ActionTypes.Left:
      icon = "chevron left";
      color = "grey";
      break;

    case ActionTypes.Right:
      icon = "chevron right";
      color = "grey";
      break;

    case ActionTypes.Save:
      icon = "check";
      color = "green";
      break;

    case ActionTypes.Cancel:
      icon = "close";
      color = "grey";
      break;
  }

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    compact: true,
    circular: true,
    icon: icon,
    color: color
  }));
};

ActionButton.propTypes = {
  /**
   * The style of button to display
   * @typedef ActionTypes
   * @property {string} `home`
   * @property {string} `add`
   * @property {string} `edit`
   * @property {string} `delete`
   * @property {string} `upload`
   * @property {string} `download`
   * @property {string} `up`
   * @property {string} `down`
   * @property {string} `left`
   * @property {string} `right`
   * @property {string} `save`
   * @property {string} `cancel`
   */
  type: propTypes$1.oneOf(Object.values(ActionTypes)),

  /**
   * Event handler for when the button is clicked
   */
  onClick: propTypes$1.func,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
ActionButton.defaultProps = {
  type: "home"
};

var momentTimezone = createCommonjsModule$1(function (module) {
//! moment-timezone.js
//! version : 0.5.32
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {

	/*global define*/
	if (module.exports) {
		module.exports = factory(moment); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(commonjsGlobal$1, function (moment) {

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.32",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));
});

var version = "2020d";
var zones = [
	"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
	"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
	"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
	"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
	"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
	"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
	"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
	"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
	"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
	"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
	"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
	"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
	"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|",
	"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
	"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
	"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
	"Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
	"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
	"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
	"Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
	"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
	"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
	"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
	"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
	"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
	"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
	"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
	"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
	"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
	"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
	"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
	"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
	"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
	"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
	"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
	"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
	"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
	"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
	"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
	"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
	"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
	"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
	"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
	"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
	"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
	"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
	"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
	"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
	"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
	"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
	"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
	"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
	"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
	"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
	"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
	"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
	"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
	"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
	"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
	"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
	"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
	"America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2",
	"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
	"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
	"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
	"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
	"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
	"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
	"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
	"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
	"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
	"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
	"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
	"America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
	"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
	"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
	"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
	"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
	"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
	"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
	"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
	"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
	"America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
	"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
	"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
	"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
	"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
	"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
	"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
	"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
	"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
	"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
	"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
	"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
	"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
	"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
	"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
	"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
	"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
	"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
	"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
	"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
	"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
	"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
	"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
	"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
	"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
	"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
	"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
	"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
	"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
	"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
	"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
	"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
	"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
	"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
	"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
	"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
	"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
	"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
	"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
	"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
	"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
	"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
	"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
	"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
	"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
	"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
	"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
	"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
	"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
	"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
	"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
	"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3",
	"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
	"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
	"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
	"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10",
	"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
	"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
	"Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1",
	"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
	"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
	"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
	"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
	"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
	"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
	"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
	"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
	"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
	"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
	"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
	"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
	"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
	"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
	"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
	"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
	"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
	"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
	"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
	"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
	"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
	"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
	"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
	"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
	"Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
	"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
	"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
	"Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
	"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
	"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
	"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
	"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
	"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
	"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
	"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
	"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
	"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
	"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
	"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
	"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
	"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
	"Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
	"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
	"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
	"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
	"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
	"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
	"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
	"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
	"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
	"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
	"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
	"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
	"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
	"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
	"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
	"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
	"Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
	"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
	"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
	"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
	"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
	"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
	"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
	"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
	"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
	"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
	"Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
	"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
	"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
	"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
	"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
	"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
	"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
	"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
	"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
	"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
	"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
	"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
	"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
	"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
	"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
	"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
	"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
	"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
	"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
	"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
	"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
	"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
	"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
	"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
	"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
	"Atlantic/South_Georgia|-02|20|0||30",
	"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
	"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
	"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
	"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
	"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
	"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
	"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
	"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
	"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
	"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
	"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
	"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
	"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
	"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
	"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
	"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
	"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
	"EST|EST|50|0||",
	"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"Etc/GMT-0|GMT|0|0||",
	"Etc/GMT-1|+01|-10|0||",
	"Pacific/Port_Moresby|+10|-a0|0||25e4",
	"Etc/GMT-11|+11|-b0|0||",
	"Pacific/Tarawa|+12|-c0|0||29e3",
	"Etc/GMT-13|+13|-d0|0||",
	"Etc/GMT-14|+14|-e0|0||",
	"Etc/GMT-2|+02|-20|0||",
	"Etc/GMT-3|+03|-30|0||",
	"Etc/GMT-4|+04|-40|0||",
	"Etc/GMT-5|+05|-50|0||",
	"Etc/GMT-6|+06|-60|0||",
	"Indian/Christmas|+07|-70|0||21e2",
	"Etc/GMT-8|+08|-80|0||",
	"Pacific/Palau|+09|-90|0||21e3",
	"Etc/GMT+1|-01|10|0||",
	"Etc/GMT+10|-10|a0|0||",
	"Etc/GMT+11|-11|b0|0||",
	"Etc/GMT+12|-12|c0|0||",
	"Etc/GMT+3|-03|30|0||",
	"Etc/GMT+4|-04|40|0||",
	"Etc/GMT+5|-05|50|0||",
	"Etc/GMT+6|-06|60|0||",
	"Etc/GMT+7|-07|70|0||",
	"Etc/GMT+8|-08|80|0||",
	"Etc/GMT+9|-09|90|0||",
	"Etc/UTC|UTC|0|0||",
	"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
	"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
	"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
	"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
	"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
	"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
	"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
	"Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
	"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
	"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
	"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
	"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
	"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
	"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
	"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
	"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
	"Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
	"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
	"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
	"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
	"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
	"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
	"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
	"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
	"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
	"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
	"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
	"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
	"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
	"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
	"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
	"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
	"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
	"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
	"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
	"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
	"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
	"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
	"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
	"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
	"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
	"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
	"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
	"HST|HST|a0|0||",
	"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
	"Indian/Cocos|+0630|-6u|0||596",
	"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
	"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
	"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
	"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
	"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
	"Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
	"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
	"MST|MST|70|0||",
	"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
	"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
	"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
	"Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
	"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
	"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
	"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
	"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
	"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
	"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
	"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
	"Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
	"Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
	"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
	"Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
	"Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
	"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
	"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
	"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
	"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
	"Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
	"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
	"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
	"Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
	"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
	"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
	"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
	"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
	"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
];
var links = [
	"Africa/Abidjan|Africa/Bamako",
	"Africa/Abidjan|Africa/Banjul",
	"Africa/Abidjan|Africa/Conakry",
	"Africa/Abidjan|Africa/Dakar",
	"Africa/Abidjan|Africa/Freetown",
	"Africa/Abidjan|Africa/Lome",
	"Africa/Abidjan|Africa/Nouakchott",
	"Africa/Abidjan|Africa/Ouagadougou",
	"Africa/Abidjan|Africa/Timbuktu",
	"Africa/Abidjan|Atlantic/St_Helena",
	"Africa/Cairo|Egypt",
	"Africa/Johannesburg|Africa/Maseru",
	"Africa/Johannesburg|Africa/Mbabane",
	"Africa/Lagos|Africa/Bangui",
	"Africa/Lagos|Africa/Brazzaville",
	"Africa/Lagos|Africa/Douala",
	"Africa/Lagos|Africa/Kinshasa",
	"Africa/Lagos|Africa/Libreville",
	"Africa/Lagos|Africa/Luanda",
	"Africa/Lagos|Africa/Malabo",
	"Africa/Lagos|Africa/Niamey",
	"Africa/Lagos|Africa/Porto-Novo",
	"Africa/Maputo|Africa/Blantyre",
	"Africa/Maputo|Africa/Bujumbura",
	"Africa/Maputo|Africa/Gaborone",
	"Africa/Maputo|Africa/Harare",
	"Africa/Maputo|Africa/Kigali",
	"Africa/Maputo|Africa/Lubumbashi",
	"Africa/Maputo|Africa/Lusaka",
	"Africa/Nairobi|Africa/Addis_Ababa",
	"Africa/Nairobi|Africa/Asmara",
	"Africa/Nairobi|Africa/Asmera",
	"Africa/Nairobi|Africa/Dar_es_Salaam",
	"Africa/Nairobi|Africa/Djibouti",
	"Africa/Nairobi|Africa/Kampala",
	"Africa/Nairobi|Africa/Mogadishu",
	"Africa/Nairobi|Indian/Antananarivo",
	"Africa/Nairobi|Indian/Comoro",
	"Africa/Nairobi|Indian/Mayotte",
	"Africa/Tripoli|Libya",
	"America/Adak|America/Atka",
	"America/Adak|US/Aleutian",
	"America/Anchorage|US/Alaska",
	"America/Argentina/Buenos_Aires|America/Buenos_Aires",
	"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
	"America/Argentina/Catamarca|America/Catamarca",
	"America/Argentina/Cordoba|America/Cordoba",
	"America/Argentina/Cordoba|America/Rosario",
	"America/Argentina/Jujuy|America/Jujuy",
	"America/Argentina/Mendoza|America/Mendoza",
	"America/Atikokan|America/Coral_Harbour",
	"America/Chicago|US/Central",
	"America/Curacao|America/Aruba",
	"America/Curacao|America/Kralendijk",
	"America/Curacao|America/Lower_Princes",
	"America/Denver|America/Shiprock",
	"America/Denver|Navajo",
	"America/Denver|US/Mountain",
	"America/Detroit|US/Michigan",
	"America/Edmonton|Canada/Mountain",
	"America/Fort_Wayne|America/Indiana/Indianapolis",
	"America/Fort_Wayne|America/Indianapolis",
	"America/Fort_Wayne|US/East-Indiana",
	"America/Godthab|America/Nuuk",
	"America/Halifax|Canada/Atlantic",
	"America/Havana|Cuba",
	"America/Indiana/Knox|America/Knox_IN",
	"America/Indiana/Knox|US/Indiana-Starke",
	"America/Jamaica|Jamaica",
	"America/Kentucky/Louisville|America/Louisville",
	"America/Los_Angeles|US/Pacific",
	"America/Manaus|Brazil/West",
	"America/Mazatlan|Mexico/BajaSur",
	"America/Mexico_City|Mexico/General",
	"America/New_York|US/Eastern",
	"America/Noronha|Brazil/DeNoronha",
	"America/Panama|America/Cayman",
	"America/Phoenix|US/Arizona",
	"America/Port_of_Spain|America/Anguilla",
	"America/Port_of_Spain|America/Antigua",
	"America/Port_of_Spain|America/Dominica",
	"America/Port_of_Spain|America/Grenada",
	"America/Port_of_Spain|America/Guadeloupe",
	"America/Port_of_Spain|America/Marigot",
	"America/Port_of_Spain|America/Montserrat",
	"America/Port_of_Spain|America/St_Barthelemy",
	"America/Port_of_Spain|America/St_Kitts",
	"America/Port_of_Spain|America/St_Lucia",
	"America/Port_of_Spain|America/St_Thomas",
	"America/Port_of_Spain|America/St_Vincent",
	"America/Port_of_Spain|America/Tortola",
	"America/Port_of_Spain|America/Virgin",
	"America/Regina|Canada/Saskatchewan",
	"America/Rio_Branco|America/Porto_Acre",
	"America/Rio_Branco|Brazil/Acre",
	"America/Santiago|Chile/Continental",
	"America/Sao_Paulo|Brazil/East",
	"America/St_Johns|Canada/Newfoundland",
	"America/Tijuana|America/Ensenada",
	"America/Tijuana|America/Santa_Isabel",
	"America/Tijuana|Mexico/BajaNorte",
	"America/Toronto|America/Montreal",
	"America/Toronto|Canada/Eastern",
	"America/Vancouver|Canada/Pacific",
	"America/Whitehorse|Canada/Yukon",
	"America/Winnipeg|Canada/Central",
	"Asia/Ashgabat|Asia/Ashkhabad",
	"Asia/Bangkok|Asia/Phnom_Penh",
	"Asia/Bangkok|Asia/Vientiane",
	"Asia/Dhaka|Asia/Dacca",
	"Asia/Dubai|Asia/Muscat",
	"Asia/Ho_Chi_Minh|Asia/Saigon",
	"Asia/Hong_Kong|Hongkong",
	"Asia/Jerusalem|Asia/Tel_Aviv",
	"Asia/Jerusalem|Israel",
	"Asia/Kathmandu|Asia/Katmandu",
	"Asia/Kolkata|Asia/Calcutta",
	"Asia/Kuala_Lumpur|Asia/Singapore",
	"Asia/Kuala_Lumpur|Singapore",
	"Asia/Macau|Asia/Macao",
	"Asia/Makassar|Asia/Ujung_Pandang",
	"Asia/Nicosia|Europe/Nicosia",
	"Asia/Qatar|Asia/Bahrain",
	"Asia/Rangoon|Asia/Yangon",
	"Asia/Riyadh|Asia/Aden",
	"Asia/Riyadh|Asia/Kuwait",
	"Asia/Seoul|ROK",
	"Asia/Shanghai|Asia/Chongqing",
	"Asia/Shanghai|Asia/Chungking",
	"Asia/Shanghai|Asia/Harbin",
	"Asia/Shanghai|PRC",
	"Asia/Taipei|ROC",
	"Asia/Tehran|Iran",
	"Asia/Thimphu|Asia/Thimbu",
	"Asia/Tokyo|Japan",
	"Asia/Ulaanbaatar|Asia/Ulan_Bator",
	"Asia/Urumqi|Asia/Kashgar",
	"Atlantic/Faroe|Atlantic/Faeroe",
	"Atlantic/Reykjavik|Iceland",
	"Atlantic/South_Georgia|Etc/GMT+2",
	"Australia/Adelaide|Australia/South",
	"Australia/Brisbane|Australia/Queensland",
	"Australia/Broken_Hill|Australia/Yancowinna",
	"Australia/Darwin|Australia/North",
	"Australia/Hobart|Australia/Tasmania",
	"Australia/Lord_Howe|Australia/LHI",
	"Australia/Melbourne|Australia/Victoria",
	"Australia/Perth|Australia/West",
	"Australia/Sydney|Australia/ACT",
	"Australia/Sydney|Australia/Canberra",
	"Australia/Sydney|Australia/NSW",
	"Etc/GMT-0|Etc/GMT",
	"Etc/GMT-0|Etc/GMT+0",
	"Etc/GMT-0|Etc/GMT0",
	"Etc/GMT-0|Etc/Greenwich",
	"Etc/GMT-0|GMT",
	"Etc/GMT-0|GMT+0",
	"Etc/GMT-0|GMT-0",
	"Etc/GMT-0|GMT0",
	"Etc/GMT-0|Greenwich",
	"Etc/UTC|Etc/UCT",
	"Etc/UTC|Etc/Universal",
	"Etc/UTC|Etc/Zulu",
	"Etc/UTC|UCT",
	"Etc/UTC|UTC",
	"Etc/UTC|Universal",
	"Etc/UTC|Zulu",
	"Europe/Belgrade|Europe/Ljubljana",
	"Europe/Belgrade|Europe/Podgorica",
	"Europe/Belgrade|Europe/Sarajevo",
	"Europe/Belgrade|Europe/Skopje",
	"Europe/Belgrade|Europe/Zagreb",
	"Europe/Chisinau|Europe/Tiraspol",
	"Europe/Dublin|Eire",
	"Europe/Helsinki|Europe/Mariehamn",
	"Europe/Istanbul|Asia/Istanbul",
	"Europe/Istanbul|Turkey",
	"Europe/Lisbon|Portugal",
	"Europe/London|Europe/Belfast",
	"Europe/London|Europe/Guernsey",
	"Europe/London|Europe/Isle_of_Man",
	"Europe/London|Europe/Jersey",
	"Europe/London|GB",
	"Europe/London|GB-Eire",
	"Europe/Moscow|W-SU",
	"Europe/Oslo|Arctic/Longyearbyen",
	"Europe/Oslo|Atlantic/Jan_Mayen",
	"Europe/Prague|Europe/Bratislava",
	"Europe/Rome|Europe/San_Marino",
	"Europe/Rome|Europe/Vatican",
	"Europe/Warsaw|Poland",
	"Europe/Zurich|Europe/Busingen",
	"Europe/Zurich|Europe/Vaduz",
	"Indian/Christmas|Etc/GMT-7",
	"Pacific/Auckland|Antarctica/McMurdo",
	"Pacific/Auckland|Antarctica/South_Pole",
	"Pacific/Auckland|NZ",
	"Pacific/Chatham|NZ-CHAT",
	"Pacific/Chuuk|Pacific/Truk",
	"Pacific/Chuuk|Pacific/Yap",
	"Pacific/Easter|Chile/EasterIsland",
	"Pacific/Guam|Pacific/Saipan",
	"Pacific/Honolulu|Pacific/Johnston",
	"Pacific/Honolulu|US/Hawaii",
	"Pacific/Kwajalein|Kwajalein",
	"Pacific/Pago_Pago|Pacific/Midway",
	"Pacific/Pago_Pago|Pacific/Samoa",
	"Pacific/Pago_Pago|US/Samoa",
	"Pacific/Palau|Etc/GMT-9",
	"Pacific/Pohnpei|Pacific/Ponape",
	"Pacific/Port_Moresby|Etc/GMT-10",
	"Pacific/Tarawa|Etc/GMT-12",
	"Pacific/Tarawa|Pacific/Funafuti",
	"Pacific/Tarawa|Pacific/Wake",
	"Pacific/Tarawa|Pacific/Wallis"
];
var countries = [
	"AD|Europe/Andorra",
	"AE|Asia/Dubai",
	"AF|Asia/Kabul",
	"AG|America/Port_of_Spain America/Antigua",
	"AI|America/Port_of_Spain America/Anguilla",
	"AL|Europe/Tirane",
	"AM|Asia/Yerevan",
	"AO|Africa/Lagos Africa/Luanda",
	"AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
	"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
	"AS|Pacific/Pago_Pago",
	"AT|Europe/Vienna",
	"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
	"AW|America/Curacao America/Aruba",
	"AX|Europe/Helsinki Europe/Mariehamn",
	"AZ|Asia/Baku",
	"BA|Europe/Belgrade Europe/Sarajevo",
	"BB|America/Barbados",
	"BD|Asia/Dhaka",
	"BE|Europe/Brussels",
	"BF|Africa/Abidjan Africa/Ouagadougou",
	"BG|Europe/Sofia",
	"BH|Asia/Qatar Asia/Bahrain",
	"BI|Africa/Maputo Africa/Bujumbura",
	"BJ|Africa/Lagos Africa/Porto-Novo",
	"BL|America/Port_of_Spain America/St_Barthelemy",
	"BM|Atlantic/Bermuda",
	"BN|Asia/Brunei",
	"BO|America/La_Paz",
	"BQ|America/Curacao America/Kralendijk",
	"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
	"BS|America/Nassau",
	"BT|Asia/Thimphu",
	"BW|Africa/Maputo Africa/Gaborone",
	"BY|Europe/Minsk",
	"BZ|America/Belize",
	"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson",
	"CC|Indian/Cocos",
	"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
	"CF|Africa/Lagos Africa/Bangui",
	"CG|Africa/Lagos Africa/Brazzaville",
	"CH|Europe/Zurich",
	"CI|Africa/Abidjan",
	"CK|Pacific/Rarotonga",
	"CL|America/Santiago America/Punta_Arenas Pacific/Easter",
	"CM|Africa/Lagos Africa/Douala",
	"CN|Asia/Shanghai Asia/Urumqi",
	"CO|America/Bogota",
	"CR|America/Costa_Rica",
	"CU|America/Havana",
	"CV|Atlantic/Cape_Verde",
	"CW|America/Curacao",
	"CX|Indian/Christmas",
	"CY|Asia/Nicosia Asia/Famagusta",
	"CZ|Europe/Prague",
	"DE|Europe/Zurich Europe/Berlin Europe/Busingen",
	"DJ|Africa/Nairobi Africa/Djibouti",
	"DK|Europe/Copenhagen",
	"DM|America/Port_of_Spain America/Dominica",
	"DO|America/Santo_Domingo",
	"DZ|Africa/Algiers",
	"EC|America/Guayaquil Pacific/Galapagos",
	"EE|Europe/Tallinn",
	"EG|Africa/Cairo",
	"EH|Africa/El_Aaiun",
	"ER|Africa/Nairobi Africa/Asmara",
	"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
	"ET|Africa/Nairobi Africa/Addis_Ababa",
	"FI|Europe/Helsinki",
	"FJ|Pacific/Fiji",
	"FK|Atlantic/Stanley",
	"FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
	"FO|Atlantic/Faroe",
	"FR|Europe/Paris",
	"GA|Africa/Lagos Africa/Libreville",
	"GB|Europe/London",
	"GD|America/Port_of_Spain America/Grenada",
	"GE|Asia/Tbilisi",
	"GF|America/Cayenne",
	"GG|Europe/London Europe/Guernsey",
	"GH|Africa/Accra",
	"GI|Europe/Gibraltar",
	"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
	"GM|Africa/Abidjan Africa/Banjul",
	"GN|Africa/Abidjan Africa/Conakry",
	"GP|America/Port_of_Spain America/Guadeloupe",
	"GQ|Africa/Lagos Africa/Malabo",
	"GR|Europe/Athens",
	"GS|Atlantic/South_Georgia",
	"GT|America/Guatemala",
	"GU|Pacific/Guam",
	"GW|Africa/Bissau",
	"GY|America/Guyana",
	"HK|Asia/Hong_Kong",
	"HN|America/Tegucigalpa",
	"HR|Europe/Belgrade Europe/Zagreb",
	"HT|America/Port-au-Prince",
	"HU|Europe/Budapest",
	"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
	"IE|Europe/Dublin",
	"IL|Asia/Jerusalem",
	"IM|Europe/London Europe/Isle_of_Man",
	"IN|Asia/Kolkata",
	"IO|Indian/Chagos",
	"IQ|Asia/Baghdad",
	"IR|Asia/Tehran",
	"IS|Atlantic/Reykjavik",
	"IT|Europe/Rome",
	"JE|Europe/London Europe/Jersey",
	"JM|America/Jamaica",
	"JO|Asia/Amman",
	"JP|Asia/Tokyo",
	"KE|Africa/Nairobi",
	"KG|Asia/Bishkek",
	"KH|Asia/Bangkok Asia/Phnom_Penh",
	"KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
	"KM|Africa/Nairobi Indian/Comoro",
	"KN|America/Port_of_Spain America/St_Kitts",
	"KP|Asia/Pyongyang",
	"KR|Asia/Seoul",
	"KW|Asia/Riyadh Asia/Kuwait",
	"KY|America/Panama America/Cayman",
	"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
	"LA|Asia/Bangkok Asia/Vientiane",
	"LB|Asia/Beirut",
	"LC|America/Port_of_Spain America/St_Lucia",
	"LI|Europe/Zurich Europe/Vaduz",
	"LK|Asia/Colombo",
	"LR|Africa/Monrovia",
	"LS|Africa/Johannesburg Africa/Maseru",
	"LT|Europe/Vilnius",
	"LU|Europe/Luxembourg",
	"LV|Europe/Riga",
	"LY|Africa/Tripoli",
	"MA|Africa/Casablanca",
	"MC|Europe/Monaco",
	"MD|Europe/Chisinau",
	"ME|Europe/Belgrade Europe/Podgorica",
	"MF|America/Port_of_Spain America/Marigot",
	"MG|Africa/Nairobi Indian/Antananarivo",
	"MH|Pacific/Majuro Pacific/Kwajalein",
	"MK|Europe/Belgrade Europe/Skopje",
	"ML|Africa/Abidjan Africa/Bamako",
	"MM|Asia/Yangon",
	"MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
	"MO|Asia/Macau",
	"MP|Pacific/Guam Pacific/Saipan",
	"MQ|America/Martinique",
	"MR|Africa/Abidjan Africa/Nouakchott",
	"MS|America/Port_of_Spain America/Montserrat",
	"MT|Europe/Malta",
	"MU|Indian/Mauritius",
	"MV|Indian/Maldives",
	"MW|Africa/Maputo Africa/Blantyre",
	"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
	"MY|Asia/Kuala_Lumpur Asia/Kuching",
	"MZ|Africa/Maputo",
	"NA|Africa/Windhoek",
	"NC|Pacific/Noumea",
	"NE|Africa/Lagos Africa/Niamey",
	"NF|Pacific/Norfolk",
	"NG|Africa/Lagos",
	"NI|America/Managua",
	"NL|Europe/Amsterdam",
	"NO|Europe/Oslo",
	"NP|Asia/Kathmandu",
	"NR|Pacific/Nauru",
	"NU|Pacific/Niue",
	"NZ|Pacific/Auckland Pacific/Chatham",
	"OM|Asia/Dubai Asia/Muscat",
	"PA|America/Panama",
	"PE|America/Lima",
	"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
	"PG|Pacific/Port_Moresby Pacific/Bougainville",
	"PH|Asia/Manila",
	"PK|Asia/Karachi",
	"PL|Europe/Warsaw",
	"PM|America/Miquelon",
	"PN|Pacific/Pitcairn",
	"PR|America/Puerto_Rico",
	"PS|Asia/Gaza Asia/Hebron",
	"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
	"PW|Pacific/Palau",
	"PY|America/Asuncion",
	"QA|Asia/Qatar",
	"RE|Indian/Reunion",
	"RO|Europe/Bucharest",
	"RS|Europe/Belgrade",
	"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
	"RW|Africa/Maputo Africa/Kigali",
	"SA|Asia/Riyadh",
	"SB|Pacific/Guadalcanal",
	"SC|Indian/Mahe",
	"SD|Africa/Khartoum",
	"SE|Europe/Stockholm",
	"SG|Asia/Singapore",
	"SH|Africa/Abidjan Atlantic/St_Helena",
	"SI|Europe/Belgrade Europe/Ljubljana",
	"SJ|Europe/Oslo Arctic/Longyearbyen",
	"SK|Europe/Prague Europe/Bratislava",
	"SL|Africa/Abidjan Africa/Freetown",
	"SM|Europe/Rome Europe/San_Marino",
	"SN|Africa/Abidjan Africa/Dakar",
	"SO|Africa/Nairobi Africa/Mogadishu",
	"SR|America/Paramaribo",
	"SS|Africa/Juba",
	"ST|Africa/Sao_Tome",
	"SV|America/El_Salvador",
	"SX|America/Curacao America/Lower_Princes",
	"SY|Asia/Damascus",
	"SZ|Africa/Johannesburg Africa/Mbabane",
	"TC|America/Grand_Turk",
	"TD|Africa/Ndjamena",
	"TF|Indian/Reunion Indian/Kerguelen",
	"TG|Africa/Abidjan Africa/Lome",
	"TH|Asia/Bangkok",
	"TJ|Asia/Dushanbe",
	"TK|Pacific/Fakaofo",
	"TL|Asia/Dili",
	"TM|Asia/Ashgabat",
	"TN|Africa/Tunis",
	"TO|Pacific/Tongatapu",
	"TR|Europe/Istanbul",
	"TT|America/Port_of_Spain",
	"TV|Pacific/Funafuti",
	"TW|Asia/Taipei",
	"TZ|Africa/Nairobi Africa/Dar_es_Salaam",
	"UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
	"UG|Africa/Nairobi Africa/Kampala",
	"UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
	"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
	"UY|America/Montevideo",
	"UZ|Asia/Samarkand Asia/Tashkent",
	"VA|Europe/Rome Europe/Vatican",
	"VC|America/Port_of_Spain America/St_Vincent",
	"VE|America/Caracas",
	"VG|America/Port_of_Spain America/Tortola",
	"VI|America/Port_of_Spain America/St_Thomas",
	"VN|Asia/Bangkok Asia/Ho_Chi_Minh",
	"VU|Pacific/Efate",
	"WF|Pacific/Wallis",
	"WS|Pacific/Apia",
	"YE|Asia/Riyadh Asia/Aden",
	"YT|Africa/Nairobi Indian/Mayotte",
	"ZA|Africa/Johannesburg",
	"ZM|Africa/Maputo Africa/Lusaka",
	"ZW|Africa/Maputo Africa/Harare"
];
var latest = {
	version: version,
	zones: zones,
	links: links,
	countries: countries
};

var latest$1 = /*#__PURE__*/Object.freeze({
__proto__: null,
version: version,
zones: zones,
links: links,
countries: countries,
'default': latest
});

var require$$1 = getCjsExportFromNamespace(latest$1);

var momentTimezone$1 = createCommonjsModule$1(function (module) {
var moment = module.exports = momentTimezone;
moment.tz.load(require$$1);
});

var DateInput = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInput, _React$Component);

  var _super = _createSuper(DateInput);

  function DateInput(props) {
    var _this;

    _classCallCheck(this, DateInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "setup", function (value) {
      if (!value) {
        return {
          value: null,
          year: _this.state.year || "",
          month: _this.state.month || "",
          day: _this.state.day || ""
        };
      }

      var m = moment(value, "YYYY-MM-DD");
      return {
        value: m,
        year: m.format("YYYY"),
        month: m.format("MM"),
        day: m.format("DD"),
        valid: m.isValid(),
        invalidAt: m.invalidAt()
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onDayChange", function (e, _ref) {
      var value = _ref.value;
      _this.state.orig;
      var changes = {
        day: value
      };

      _this.setState(changes);
    });

    _defineProperty(_assertThisInitialized(_this), "onMonthChange", function (e, _ref2) {
      var value = _ref2.value;
      _this.state.orig;
      var changes = {
        month: value
      };

      _this.setState(changes);
    });

    _defineProperty(_assertThisInitialized(_this), "onYearChange", function (e, _ref3) {
      var value = _ref3.value;
      _this.state.orig;
      var changes = {
        year: value
      };

      _this.setState(changes);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      var values = _objectSpread2({}, _this.state);

      if (!values.year || !values.month || !values.day) {
        _this.props.onChange(undefined);

        return;
      }

      var m = moment("".concat(values.year, "-").concat(values.month, "-").concat(values.day), "YYYY-MM-DD");

      _this.setState({
        valid: m.isValid(),
        invalidAt: m.invalidAt()
      });

      _this.props.onChange(m.isValid() ? m.format("YYYY-MM-DD") : undefined);
    });

    _this.state = _this.setup(props.value);
    return _this;
  }

  _createClass(DateInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value === prevProps.value) return;
      this.setState(this.setup(this.props.value));
    }
  }, {
    key: "render",
    value: function render() {
      var inputStyles = {
        width: "50px",
        minWidth: "50px",
        marginRight: "10px"
      };
      var _this$state = this.state,
          day = _this$state.day,
          month = _this$state.month,
          year = _this$state.year,
          valid = _this$state.valid;
          _this$state.invalidAt;
      var showErrors = this.props.showErrors;
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Day"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input$1, {
        value: day,
        onChange: this.onDayChange,
        onBlur: this.onBlur,
        style: inputStyles,
        placeholder: "25",
        maxLength: 2
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Month"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input$1, {
        value: month,
        onChange: this.onMonthChange,
        onBlur: this.onBlur,
        style: inputStyles,
        placeholder: "12",
        maxLength: 2
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Year"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input$1, {
        value: year,
        onChange: this.onYearChange,
        onBlur: this.onBlur,
        style: _objectSpread2(_objectSpread2({}, inputStyles), {}, {
          width: "80px"
        }),
        placeholder: "2015",
        maxLength: 4
      })), showErrors && /*#__PURE__*/React.createElement("div", null, valid === false && /*#__PURE__*/React.createElement(Label, {
        color: "red"
      }, "Invalid")));
    }
  }]);

  return DateInput;
}(React.Component);

_defineProperty(DateInput, "propTypes", {
  value: propTypes$1.string,
  onChange: propTypes$1.func,
  showErrors: propTypes$1.bool
});

_defineProperty(DateInput, "defaultProps", {
  showErrors: true
});

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props;
          _props.excludeScrollbar;
          var props = _objectWithoutProperties$2(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose$2;

var _extends_1 = createCommonjsModule$1(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized = _assertThisInitialized$2;

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose$1;

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty$2;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$1 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$2({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$2({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$2({}, attributes, data.attributes);
  data.styles = _extends$2({}, styles, data.styles);
  data.arrowStyles = _extends$2({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$1(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$1(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$2({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$1({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$1({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$2({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$1({}, side, reference[side]),
      end: defineProperty$1({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$2({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$1(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$2({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$2({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$2({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$2({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var key = '__global_unique_id__';

var gud = function() {
  return commonjsGlobal$1[key] = (commonjsGlobal$1[key] || 0) + 1;
};

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning$4 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning$4.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var implementation = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



_interopRequireDefault(React);



var _propTypes2 = _interopRequireDefault(propTypes$1);



var _gud2 = _interopRequireDefault(gud);



var _warning2 = _interopRequireDefault(warning_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (process.env.NODE_ENV !== 'production') {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(React.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(React.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];
});

unwrapExports$1(implementation);

var lib = createCommonjsModule$1(function (module, exports) {

exports.__esModule = true;



var _react2 = _interopRequireDefault(React);



var _implementation2 = _interopRequireDefault(implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];
});

var createContext = unwrapExports$1(lib);

var ManagerContext = createContext({
  setReferenceNode: undefined,
  referenceNode: undefined
});

var Manager =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(Manager, _React$Component);

  function Manager() {
    var _this;

    _this = _React$Component.call(this) || this;

    defineProperty(assertThisInitialized(_this), "setReferenceNode", function (referenceNode) {
      if (!referenceNode || _this.state.context.referenceNode === referenceNode) {
        return;
      }

      _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: _extends_1({}, context, {
            referenceNode: referenceNode
          })
        };
      });
    });

    _this.state = {
      context: {
        setReferenceNode: _this.setReferenceNode,
        referenceNode: undefined
      }
    };
    return _this;
  }

  var _proto = Manager.prototype;

  _proto.render = function render() {
    return createElement(ManagerContext.Provider, {
      value: this.state.context
    }, this.props.children);
  };

  return Manager;
}(Component);

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};

var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty(assertThisInitialized(_this), "state", {
      data: undefined,
      placement: undefined
    });

    defineProperty(assertThisInitialized(_this), "popperInstance", void 0);

    defineProperty(assertThisInitialized(_this), "popperNode", null);

    defineProperty(assertThisInitialized(_this), "arrowNode", null);

    defineProperty(assertThisInitialized(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      safeInvoke(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    defineProperty(assertThisInitialized(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    defineProperty(assertThisInitialized(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    defineProperty(assertThisInitialized(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: _extends_1({}, _this.props.modifiers, {
          arrow: _extends_1({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    defineProperty(assertThisInitialized(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : _extends_1({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    defineProperty(assertThisInitialized(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    defineProperty(assertThisInitialized(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    defineProperty(assertThisInitialized(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    defineProperty(assertThisInitialized(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    defineProperty(assertThisInitialized(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = assertThisInitialized(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new Popper(referenceElement, popperNode, _this.getOptions());
    });

    defineProperty(assertThisInitialized(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    safeInvoke(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return unwrapArray(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(Component);

defineProperty(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});
function Popper$1(_ref) {
  var referenceElement = _ref.referenceElement,
      props = objectWithoutPropertiesLoose(_ref, ["referenceElement"]);

  return createElement(ManagerContext.Consumer, null, function (_ref2) {
    var referenceNode = _ref2.referenceNode;
    return createElement(InnerPopper, _extends_1({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  inheritsLoose(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    defineProperty(assertThisInitialized(_this), "refHandler", function (node) {
      safeInvoke(_this.props.innerRef, node);
      safeInvoke(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    safeInvoke(this.props.innerRef, null);
  };

  _proto.render = function render() {
    warning_1(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return unwrapArray(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(Component);

function Reference(props) {
  return createElement(ManagerContext.Consumer, null, function (_ref) {
    var setReferenceNode = _ref.setReferenceNode;
    return createElement(InnerReference, _extends_1({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

var _typeof$2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};









var classCallCheck$1 = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    classCallCheck$1(this, YearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return React.createElement(
          "div",
          {
            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year)
          },
          selectedYear === year ? React.createElement(
            "span",
            { className: "react-datepicker__year-option--selected" },
            "\u2713"
          ) : "",
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(React.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "upcoming",
            key: "upcoming",
            onClick: _this.incrementYears
          },
          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(React.createElement(
          "div",
          {
            className: "react-datepicker__year-option",
            ref: "previous",
            key: "previous",
            onClick: _this.decrementYears
          },
          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  YearDropdownOptions.prototype.render = function render() {
    var dropdownClass = classnames({
      "react-datepicker__year-dropdown": true,
      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
    });

    return React.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return YearDropdownOptions;
}(React.Component);

YearDropdownOptions.propTypes = {
  minDate: propTypes$1.object,
  maxDate: propTypes$1.object,
  onCancel: propTypes$1.func.isRequired,
  onChange: propTypes$1.func.isRequired,
  scrollableYearDropdown: propTypes$1.bool,
  year: propTypes$1.number.isRequired,
  yearDropdownItemNumber: propTypes$1.number
};

var dayOfWeekCodes = {
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
  7: "sun"
};

// These functions are not exported so
// that we avoid magic strings like 'days'
function set$1(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get$1(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

// ** Date Constructors **

function newDate(point) {
  return moment(point);
}

function newDateWithOffset(utcOffset) {
  return moment().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = moment(value, dateFormat, locale || moment.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return moment.isMoment(date);
}

function isDate(date) {
  return moment.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set$1(date, "month", month);
}

function setYear(date, year) {
  return set$1(date, "year", year);
}



// ** Date Getters **

function getSecond(date) {
  return get$1(date, "second");
}

function getMinute(date) {
  return get$1(date, "minute");
}

function getHour(date) {
  return get$1(date, "hour");
}

// Returns day of week
function getDay(date) {
  return get$1(date, "day");
}

function getWeek(date) {
  return get$1(date, "week");
}

function getMonth(date) {
  return get$1(date, "month");
}

function getYear(date) {
  return get$1(date, "year");
}

// Returns day of month
function getDate(date) {
  return get$1(date, "date");
}



function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, "day");
}

function getStartOfWeek(date) {
  return getStartOf(date, "week");
}
function getStartOfMonth(date) {
  return getStartOf(date, "month");
}

function getStartOfDate(date) {
  return getStartOf(date, "date");
}

// *** End of ***





// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, "minutes");
}

function addHours(date, amount) {
  return add(date, amount, "hours");
}

function addDays(date, amount) {
  return add(date, amount, "days");
}

function addWeeks(date, amount) {
  return add(date, amount, "weeks");
}

function addMonths(date, amount) {
  return add(date, amount, "months");
}

function addYears(date, amount) {
  return add(date, amount, "years");
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, "days");
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, "weeks");
}

function subtractMonths(date, amount) {
  return subtract(date, amount, "months");
}

function subtractYears(date, amount) {
  return subtract(date, amount, "years");
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameYear(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "year");
  } else {
    return !date1 && !date2;
  }
}

function isSameMonth(date1, date2) {
  if (date1 && date2) {
    return date1.isSame(date2, "month");
  } else {
    return !date1 && !date2;
  }
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, "day");
  } else {
    return !moment1 && !moment2;
  }
}



function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf("day").subtract(1, "seconds");
  var after = endDate.clone().startOf("day").add(1, "seconds");
  return day.clone().startOf("day").isBetween(before, after);
}

// *** Diffing ***



// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || moment.locale());
}







function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return moment.localeData(locale);
}

function getFormattedWeekdayInLocale(locale, date, formatFunc) {
  return formatFunc(locale.weekdays(date));
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

function getMonthShortInLocale(locale, date) {
  return locale.monthsShort(date);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isOutOfBounds(day) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref5.minDate,
      maxDate = _ref5.maxDate;

  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref6) {
  var minTime = _ref6.minTime,
      maxTime = _ref6.maxTime;

  if (!minTime || !maxTime) {
    throw new Error("Both minTime and maxTime props required");
  }

  var base = moment().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref7.minDate,
      includeDates = _ref7.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref8.maxDate,
      includeDates = _ref8.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref9) {
  var minDate = _ref9.minDate,
      includeDates = _ref9.includeDates;

  if (includeDates && minDate) {
    return moment.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, "day");
    }));
  } else if (includeDates) {
    return moment.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref10) {
  var maxDate = _ref10.maxDate,
      includeDates = _ref10.includeDates;

  if (includeDates && maxDate) {
    return moment.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, "day");
    }));
  } else if (includeDates) {
    return moment.max(includeDates);
  } else {
    return maxDate;
  }
}

function getHightLightDaysMap() {
  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";

  var dateClasses = new Map();
  for (var i = 0, len = highlightDates.length; i < len; i++) {
    var obj = highlightDates[i];
    if (isMoment(obj)) {
      var key = obj.format("MM.DD.YYYY");
      var classNamesArr = dateClasses.get(key) || [];
      if (!classNamesArr.includes(defaultClassName)) {
        classNamesArr.push(defaultClassName);
        dateClasses.set(key, classNamesArr);
      }
    } else if ((typeof obj === "undefined" ? "undefined" : _typeof$2(obj)) === "object") {
      var keys = Object.keys(obj);
      var className = keys[0];
      var arrOfMoments = obj[keys[0]];
      if (typeof className === "string" && arrOfMoments.constructor === Array) {
        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
          var _key = arrOfMoments[k].format("MM.DD.YYYY");
          var _classNamesArr = dateClasses.get(_key) || [];
          if (!_classNamesArr.includes(className)) {
            _classNamesArr.push(className);
            dateClasses.set(_key, _classNamesArr);
          }
        }
      }
    }
  }

  return dateClasses;
}

function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
  var l = injectedTimes.length;
  var times = [];
  for (var i = 0; i < l; i++) {
    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);

    if (injectedTime.isBetween(currentTime, nextTime)) {
      times.push(injectedTimes[i]);
    }
  }

  return times;
}

var WrappedYearDropdownOptions = onClickOutsideHOC(YearDropdownOptions);

var YearDropdown = function (_React$Component) {
  inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _temp, _this, _ret;

    classCallCheck$1(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(React.createElement(
          "option",
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return React.createElement(
        "select",
        {
          value: _this.props.year,
          className: "react-datepicker__year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return React.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
        React.createElement(
          "span",
          { className: "react-datepicker__year-read-view--selected-year" },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return React.createElement(WrappedYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function (event) {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      }, function () {
        if (_this.props.adjustDateOnChange) {
          _this.handleYearChange(_this.props.date, event);
        }
      });
    }, _this.handleYearChange = function (date, event) {
      _this.onSelect(date, event);
      _this.setOpen();
    }, _this.onSelect = function (date, event) {
      if (_this.props.onSelect) {
        _this.props.onSelect(date, event);
      }
    }, _this.setOpen = function () {
      if (_this.props.setOpen) {
        _this.props.setOpen(true);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  YearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return React.createElement(
      "div",
      {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return YearDropdown;
}(React.Component);

YearDropdown.propTypes = {
  adjustDateOnChange: propTypes$1.bool,
  dropdownMode: propTypes$1.oneOf(["scroll", "select"]).isRequired,
  maxDate: propTypes$1.object,
  minDate: propTypes$1.object,
  onChange: propTypes$1.func.isRequired,
  scrollableYearDropdown: propTypes$1.bool,
  year: propTypes$1.number.isRequired,
  yearDropdownItemNumber: propTypes$1.number,
  date: propTypes$1.object,
  onSelect: propTypes$1.func,
  setOpen: propTypes$1.func
};

var MonthDropdownOptions = function (_React$Component) {
  inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _temp, _this, _ret;

    classCallCheck$1(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return React.createElement(
          "div",
          {
            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i)
          },
          _this.props.month === i ? React.createElement(
            "span",
            { className: "react-datepicker__month-option--selected" },
            "\u2713"
          ) : "",
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdownOptions.prototype.render = function render() {
    return React.createElement(
      "div",
      { className: "react-datepicker__month-dropdown" },
      this.renderOptions()
    );
  };

  return MonthDropdownOptions;
}(React.Component);

MonthDropdownOptions.propTypes = {
  onCancel: propTypes$1.func.isRequired,
  onChange: propTypes$1.func.isRequired,
  month: propTypes$1.number.isRequired,
  monthNames: propTypes$1.arrayOf(propTypes$1.string.isRequired).isRequired
};

var WrappedMonthDropdownOptions = onClickOutsideHOC(MonthDropdownOptions);

var MonthDropdown = function (_React$Component) {
  inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _temp, _this, _ret;

    classCallCheck$1(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return React.createElement(
          "option",
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return React.createElement(
        "select",
        {
          value: _this.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          }
        },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return React.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-read-view",
          onClick: _this.toggleDropdown
        },
        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
        React.createElement(
          "span",
          { className: "react-datepicker__month-read-view--selected-month" },
          monthNames[_this.props.month]
        )
      );
    }, _this.renderDropdown = function (monthNames) {
      return React.createElement(WrappedMonthDropdownOptions, {
        key: "dropdown",
        ref: "options",
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown
      });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthDropdown.prototype.render = function render() {
    var _this2 = this;

    var localeData = getLocaleDataForLocale(this.props.locale);
    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
      return getMonthShortInLocale(localeData, newDate({ M: M }));
    } : function (M) {
      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
    });

    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode(monthNames);
        break;
      case "select":
        renderedDropdown = this.renderSelectMode(monthNames);
        break;
    }

    return React.createElement(
      "div",
      {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthDropdown;
}(React.Component);

MonthDropdown.propTypes = {
  dropdownMode: propTypes$1.oneOf(["scroll", "select"]).isRequired,
  locale: propTypes$1.string,
  dateFormat: propTypes$1.string.isRequired,
  month: propTypes$1.number.isRequired,
  onChange: propTypes$1.func.isRequired,
  useShortMonthInDropdown: propTypes$1.bool
};

function generateMonthYears(minDate, maxDate) {
  var list = [];

  var currDate = getStartOfMonth(cloneDate(minDate));
  var lastDate = getStartOfMonth(cloneDate(maxDate));

  while (!isAfter(currDate, lastDate)) {
    list.push(cloneDate(currDate));

    addMonths(currDate, 1);
  }

  return list;
}

var MonthYearDropdownOptions = function (_React$Component) {
  inherits(MonthYearDropdownOptions, _React$Component);

  function MonthYearDropdownOptions(props) {
    classCallCheck$1(this, MonthYearDropdownOptions);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.renderOptions = function () {
      return _this.state.monthYearsList.map(function (monthYear) {
        var monthYearPoint = monthYear.valueOf();

        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);

        return React.createElement(
          "div",
          {
            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: monthYearPoint,
            ref: monthYearPoint,
            onClick: _this.onChange.bind(_this, monthYearPoint)
          },
          isSameMonthYear ? React.createElement(
            "span",
            { className: "react-datepicker__month-year-option--selected" },
            "\u2713"
          ) : "",
          formatDate(monthYear, _this.props.dateFormat)
        );
      });
    };

    _this.onChange = function (monthYear) {
      return _this.props.onChange(monthYear);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.state = {
      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  MonthYearDropdownOptions.prototype.render = function render() {
    var dropdownClass = classnames({
      "react-datepicker__month-year-dropdown": true,
      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
    });

    return React.createElement(
      "div",
      { className: dropdownClass },
      this.renderOptions()
    );
  };

  return MonthYearDropdownOptions;
}(React.Component);

MonthYearDropdownOptions.propTypes = {
  minDate: propTypes$1.object.isRequired,
  maxDate: propTypes$1.object.isRequired,
  onCancel: propTypes$1.func.isRequired,
  onChange: propTypes$1.func.isRequired,
  scrollableMonthYearDropdown: propTypes$1.bool,
  date: propTypes$1.object.isRequired,
  dateFormat: propTypes$1.string.isRequired
};

var WrappedMonthYearDropdownOptions = onClickOutsideHOC(MonthYearDropdownOptions);

var MonthYearDropdown = function (_React$Component) {
  inherits(MonthYearDropdown, _React$Component);

  function MonthYearDropdown() {
    var _temp, _this, _ret;

    classCallCheck$1(this, MonthYearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));

      var options = [];

      while (!isAfter(currDate, lastDate)) {
        var timepoint = currDate.valueOf();
        options.push(React.createElement(
          "option",
          { key: timepoint, value: timepoint },
          formatDate(currDate, _this.props.dateFormat)
        ));

        addMonths(currDate, 1);
      }

      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return React.createElement(
        "select",
        {
          value: getStartOfMonth(_this.props.date).valueOf(),
          className: "react-datepicker__month-year-select",
          onChange: _this.onSelectChange
        },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);

      return React.createElement(
        "div",
        {
          key: "read",
          style: { visibility: visible ? "visible" : "hidden" },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(event) {
            return _this.toggleDropdown(event);
          }
        },
        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
        React.createElement(
          "span",
          { className: "react-datepicker__month-year-read-view--selected-month-year" },
          yearMonth
        )
      );
    }, _this.renderDropdown = function () {
      return React.createElement(WrappedMonthYearDropdownOptions, {
        key: "dropdown",
        ref: "options",
        date: _this.props.date,
        dateFormat: _this.props.dateFormat,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: localizeDate(_this.props.minDate, _this.props.locale),
        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (monthYearPoint) {
      _this.toggleDropdown();

      var changedDate = newDate(parseInt(monthYearPoint));

      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
        return;
      }

      _this.props.onChange(changedDate);
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  MonthYearDropdown.prototype.render = function render() {
    var renderedDropdown = void 0;
    switch (this.props.dropdownMode) {
      case "scroll":
        renderedDropdown = this.renderScrollMode();
        break;
      case "select":
        renderedDropdown = this.renderSelectMode();
        break;
    }

    return React.createElement(
      "div",
      {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
      },
      renderedDropdown
    );
  };

  return MonthYearDropdown;
}(React.Component);

MonthYearDropdown.propTypes = {
  dropdownMode: propTypes$1.oneOf(["scroll", "select"]).isRequired,
  dateFormat: propTypes$1.string.isRequired,
  locale: propTypes$1.string,
  maxDate: propTypes$1.object.isRequired,
  minDate: propTypes$1.object.isRequired,
  date: propTypes$1.object.isRequired,
  onChange: propTypes$1.func.isRequired,
  scrollableMonthYearDropdown: propTypes$1.bool
};

var Day = function (_React$Component) {
  inherits(Day, _React$Component);

  function Day() {
    var _temp, _this, _ret;

    classCallCheck$1(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return isSameDay(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return isDayDisabled(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return false;
      }

      // Looking for className in the Map of {'day string, 'className'}
      var dayStr = day.format("MM.DD.YYYY");
      return highlightDates.get(dayStr);
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isDayInRange(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return isDayInRange(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return isDayInRange(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return isSameDay(day, selectingDate);
      } else {
        return isSameDay(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return isSameDay(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = getDay(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
        "react-datepicker__day--disabled": _this.isDisabled(),
        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
        "react-datepicker__day--range-start": _this.isRangeStart(),
        "react-datepicker__day--range-end": _this.isRangeEnd(),
        "react-datepicker__day--in-range": _this.isInRange(),
        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
        "react-datepicker__day--weekend": _this.isWeekend(),
        "react-datepicker__day--outside-month": _this.isOutsideMonth()
      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Day.prototype.render = function render() {
    return React.createElement(
      "div",
      {
        className: this.getClassNames(this.props.day),
        onClick: this.handleClick,
        onMouseEnter: this.handleMouseEnter,
        "aria-label": "day-" + getDate(this.props.day),
        role: "option"
      },
      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
    );
  };

  return Day;
}(React.Component);

Day.propTypes = {
  disabledKeyboardNavigation: propTypes$1.bool,
  day: propTypes$1.object.isRequired,
  dayClassName: propTypes$1.func,
  endDate: propTypes$1.object,
  highlightDates: propTypes$1.instanceOf(Map),
  inline: propTypes$1.bool,
  month: propTypes$1.number,
  onClick: propTypes$1.func,
  onMouseEnter: propTypes$1.func,
  preSelection: propTypes$1.object,
  selected: propTypes$1.object,
  selectingDate: propTypes$1.object,
  selectsEnd: propTypes$1.bool,
  selectsStart: propTypes$1.bool,
  startDate: propTypes$1.object,
  utcOffset: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  renderDayContents: propTypes$1.func
};

var WeekNumber = function (_React$Component) {
  inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _temp, _this, _ret;

    classCallCheck$1(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  WeekNumber.prototype.render = function render() {
    var weekNumberClasses = {
      "react-datepicker__week-number": true,
      "react-datepicker__week-number--clickable": !!this.props.onClick
    };
    return React.createElement(
      "div",
      {
        className: classnames(weekNumberClasses),
        "aria-label": "week-" + this.props.weekNumber,
        onClick: this.handleClick
      },
      this.props.weekNumber
    );
  };

  return WeekNumber;
}(React.Component);

WeekNumber.propTypes = {
  weekNumber: propTypes$1.number.isRequired,
  onClick: propTypes$1.func
};

var Week = function (_React$Component) {
  inherits(Week, _React$Component);

  function Week() {
    var _temp, _this, _ret;

    classCallCheck$1(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === "function") {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        return React.createElement(Day, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          renderDayContents: _this.props.renderDayContents,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
        });
      }));
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Week.prototype.render = function render() {
    return React.createElement(
      "div",
      { className: "react-datepicker__week" },
      this.renderDays()
    );
  };

  return Week;
}(React.Component);

Week.propTypes = {
  disabledKeyboardNavigation: propTypes$1.bool,
  day: propTypes$1.object.isRequired,
  dayClassName: propTypes$1.func,
  endDate: propTypes$1.object,
  excludeDates: propTypes$1.array,
  filterDate: propTypes$1.func,
  formatWeekNumber: propTypes$1.func,
  highlightDates: propTypes$1.instanceOf(Map),
  includeDates: propTypes$1.array,
  inline: propTypes$1.bool,
  maxDate: propTypes$1.object,
  minDate: propTypes$1.object,
  month: propTypes$1.number,
  onDayClick: propTypes$1.func,
  onDayMouseEnter: propTypes$1.func,
  onWeekSelect: propTypes$1.func,
  preSelection: propTypes$1.object,
  selected: propTypes$1.object,
  selectingDate: propTypes$1.object,
  selectsEnd: propTypes$1.bool,
  selectsStart: propTypes$1.bool,
  showWeekNumber: propTypes$1.bool,
  startDate: propTypes$1.object,
  utcOffset: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  renderDayContents: propTypes$1.func
};

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  inherits(Month, _React$Component);

  function Month() {
    var _temp, _this, _ret;

    classCallCheck$1(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(React.createElement(Week, {
          key: i,
          day: currentWeekStart,
          month: getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderDayContents: _this.props.renderDayContents
        }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return classnames("react-datepicker__month", {
        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Month.prototype.render = function render() {
    return React.createElement(
      "div",
      {
        className: this.getClassNames(),
        onMouseLeave: this.handleMouseLeave,
        role: "listbox",
        "aria-label": "month-" + this.props.day.format("YYYY-MM")
      },
      this.renderWeeks()
    );
  };

  return Month;
}(React.Component);

Month.propTypes = {
  disabledKeyboardNavigation: propTypes$1.bool,
  day: propTypes$1.object.isRequired,
  dayClassName: propTypes$1.func,
  endDate: propTypes$1.object,
  excludeDates: propTypes$1.array,
  filterDate: propTypes$1.func,
  fixedHeight: propTypes$1.bool,
  formatWeekNumber: propTypes$1.func,
  highlightDates: propTypes$1.instanceOf(Map),
  includeDates: propTypes$1.array,
  inline: propTypes$1.bool,
  maxDate: propTypes$1.object,
  minDate: propTypes$1.object,
  onDayClick: propTypes$1.func,
  onDayMouseEnter: propTypes$1.func,
  onMouseLeave: propTypes$1.func,
  onWeekSelect: propTypes$1.func,
  peekNextMonth: propTypes$1.bool,
  preSelection: propTypes$1.object,
  selected: propTypes$1.object,
  selectingDate: propTypes$1.object,
  selectsEnd: propTypes$1.bool,
  selectsStart: propTypes$1.bool,
  showWeekNumbers: propTypes$1.bool,
  startDate: propTypes$1.object,
  utcOffset: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  renderDayContents: propTypes$1.func
};

var Time = function (_React$Component) {
  inherits(Time, _React$Component);

  function Time() {
    var _temp, _this, _ret;

    classCallCheck$1(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ["react-datepicker__time-list-item"];

      if (currH === getHour(time) && currM === getMinute(time)) {
        classes.push("react-datepicker__time-list-item--selected");
      }
      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
        classes.push("react-datepicker__time-list-item--disabled");
      }
      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
        classes.push("react-datepicker__time-list-item--injected");
      }

      return classes.join(" ");
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : "hh:mm A";
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : newDate();
      var currH = getHour(activeTime);
      var currM = getMinute(activeTime);
      var base = getStartOfDay(newDate());
      var multiplier = 1440 / intervals;
      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
        return a - b;
      });
      for (var i = 0; i < multiplier; i++) {
        var currentTime = addMinutes(cloneDate(base), i * intervals);
        times.push(currentTime);

        if (sortedInjectTimes) {
          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
          times = times.concat(timesToInject);
        }
      }

      return times.map(function (time, i) {
        return React.createElement(
          "li",
          {
            key: i,
            onClick: _this.handleClick.bind(_this, time),
            className: _this.liClasses(time, currH, currM),
            ref: function ref(li) {
              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
                _this.centerLi = li;
              }
            }
          },
          formatDate(time, format)
        );
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Time.prototype.componentDidMount = function componentDidMount() {
    // code to ensure selected time will always be in focus within time window when it first appears
    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
  };

  Time.prototype.render = function render() {
    var _this2 = this;

    var height = null;
    if (this.props.monthRef && this.header) {
      height = this.props.monthRef.clientHeight - this.header.clientHeight;
    }

    return React.createElement(
      "div",
      {
        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      },
      React.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--time",
          ref: function ref(header) {
            _this2.header = header;
          }
        },
        React.createElement(
          "div",
          { className: "react-datepicker-time__header" },
          this.props.timeCaption
        )
      ),
      React.createElement(
        "div",
        { className: "react-datepicker__time" },
        React.createElement(
          "div",
          { className: "react-datepicker__time-box" },
          React.createElement(
            "ul",
            {
              className: "react-datepicker__time-list",
              ref: function ref(list) {
                _this2.list = list;
              },
              style: height ? { height: height } : {}
            },
            this.renderTimes.bind(this)()
          )
        )
      )
    );
  };

  createClass$1(Time, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
  return Time;
}(React.Component);

Time.propTypes = {
  format: propTypes$1.string,
  includeTimes: propTypes$1.array,
  intervals: propTypes$1.number,
  selected: propTypes$1.object,
  onChange: propTypes$1.func,
  todayButton: propTypes$1.node,
  minTime: propTypes$1.object,
  maxTime: propTypes$1.object,
  excludeTimes: propTypes$1.array,
  monthRef: propTypes$1.object,
  timeCaption: propTypes$1.string,
  injectTimes: propTypes$1.array
};

Time.calcCenterPosition = function (listHeight, centerLiRef) {
  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
};

function CalendarContainer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$arrowProps = _ref.arrowProps,
      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;

  return React.createElement(
    "div",
    { className: className },
    React.createElement("div", _extends$3({ className: "react-datepicker__triangle" }, arrowProps)),
    children
  );
}

CalendarContainer.propTypes = {
  className: propTypes$1.string,
  children: propTypes$1.node,
  arrowProps: propTypes$1.object // react-popper arrow props
};

var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || "").split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  inherits(Calendar, _React$Component);
  createClass$1(Calendar, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month"
      };
    }
  }]);

  function Calendar(props) {
    classCallCheck$1(this, Calendar);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var current = now(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && isBefore(current, minDate)) {
          return minDate;
        } else if (maxDate && isAfter(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return localizeDate(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: addMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: subtractMonths(cloneDate(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleYearChange = function (date) {
      if (_this.props.onYearChange) {
        _this.props.onYearChange(date);
      }
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
      if (_this.props.adjustDateOnChange) {
        if (_this.props.onSelect) {
          _this.props.onSelect(date);
        }
        if (_this.props.setOpen) {
          _this.props.setOpen(true);
        }
      }
    };

    _this.handleMonthYearChange = function (date) {
      _this.handleYearChange(date);
      _this.handleMonthChange(date);
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: setYear(cloneDate(_this.state.date), year)
      }, function () {
        return _this.handleYearChange(_this.state.date);
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: setMonth(cloneDate(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.changeMonthYear = function (monthYear) {
      _this.setState({
        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
      }, function () {
        return _this.handleMonthYearChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = getStartOfWeek(cloneDate(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(React.createElement(
          "div",
          { key: "W", className: "react-datepicker__day-name" },
          _this.props.weekLabel || "#"
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = addDays(cloneDate(startOfWeek), offset);
        var localeData = getLocaleData(day);
        var weekDayName = _this.formatWeekday(localeData, day);

        return React.createElement(
          "div",
          { key: offset, className: "react-datepicker__day-name" },
          weekDayName
        );
      }));
    };

    _this.formatWeekday = function (localeData, day) {
      if (_this.props.formatWeekDay) {
        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
      }
      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
    };

    _this.renderPreviousMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];

      var clickHandler = _this.decreaseMonth;

      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--previous--disabled");
        clickHandler = null;
      }

      return React.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.previousMonthButtonLabel
      );
    };

    _this.renderNextMonthButton = function () {
      if (_this.props.renderCustomHeader) {
        return;
      }

      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
        return;
      }

      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
      if (_this.props.showTimeSelect) {
        classes.push("react-datepicker__navigation--next--with-time");
      }
      if (_this.props.todayButton) {
        classes.push("react-datepicker__navigation--next--with-today-button");
      }

      var clickHandler = _this.increaseMonth;

      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
        classes.push("react-datepicker__navigation--next--disabled");
        clickHandler = null;
      }

      return React.createElement(
        "button",
        {
          type: "button",
          className: classes.join(" "),
          onClick: clickHandler
        },
        _this.props.nextMonthButtonLabel
      );
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ["react-datepicker__current-month"];

      if (_this.props.showYearDropdown) {
        classes.push("react-datepicker__current-month--hasYearDropdown");
      }
      if (_this.props.showMonthDropdown) {
        classes.push("react-datepicker__current-month--hasMonthDropdown");
      }
      if (_this.props.showMonthYearDropdown) {
        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
      }
      return React.createElement(
        "div",
        { className: classes.join(" ") },
        formatDate(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return React.createElement(YearDropdown, {
        adjustDateOnChange: _this.props.adjustDateOnChange,
        date: _this.state.date,
        onSelect: _this.props.onSelect,
        setOpen: _this.props.setOpen,
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: getYear(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
      });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown || overrideHide) {
        return;
      }
      return React.createElement(MonthDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: getMonth(_this.state.date),
        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
      });
    };

    _this.renderMonthYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthYearDropdown || overrideHide) {
        return;
      }
      return React.createElement(MonthYearDropdown, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonthYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        date: _this.state.date,
        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
      });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
        return;
      }
      return React.createElement(
        "div",
        {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
          }
        },
        _this.props.todayButton
      );
    };

    _this.renderDefaultHeader = function (_ref) {
      var monthDate = _ref.monthDate,
          i = _ref.i;
      return React.createElement(
        "div",
        { className: "react-datepicker__header" },
        _this.renderCurrentMonth(monthDate),
        React.createElement(
          "div",
          {
            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
            onFocus: _this.handleDropdownFocus
          },
          _this.renderMonthDropdown(i !== 0),
          _this.renderMonthYearDropdown(i !== 0),
          _this.renderYearDropdown(i !== 0)
        ),
        React.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderCustomHeader = function (_ref2) {
      var monthDate = _ref2.monthDate,
          i = _ref2.i;

      if (i !== 0) {
        return null;
      }

      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);

      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);

      return React.createElement(
        "div",
        {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: _this.props.onDropdownFocus
        },
        _this.props.renderCustomHeader(_extends$3({}, _this.state, {
          changeMonth: _this.changeMonth,
          changeYear: _this.changeYear,
          decreaseMonth: _this.decreaseMonth,
          increaseMonth: _this.increaseMonth,
          prevMonthButtonDisabled: prevMonthButtonDisabled,
          nextMonthButtonDisabled: nextMonthButtonDisabled
        })),
        React.createElement(
          "div",
          { className: "react-datepicker__day-names" },
          _this.header(monthDate)
        )
      );
    };

    _this.renderMonths = function () {
      if (_this.props.showTimeSelectOnly) {
        return;
      }

      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = addMonths(cloneDate(_this.state.date), i);
        var monthKey = "month-" + i;
        monthList.push(React.createElement(
          "div",
          {
            key: monthKey,
            ref: function ref(div) {
              _this.monthContainer = div;
            },
            className: "react-datepicker__month-container"
          },
          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
          React.createElement(Month, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset,
            renderDayContents: _this.props.renderDayContents,
            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
          })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
        return React.createElement(Time, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          includeTimes: _this.props.includeTimes,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer,
          injectTimes: _this.props.injectTimes
        });
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: null
    };
    return _this;
  }

  Calendar.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    // monthContainer height is needed in time component
    // to determine the height for the ul in the time component
    // setState here so height is given after final component
    // layout is rendered
    if (this.props.showTimeSelect) {
      this.assignMonthContainer = function () {
        _this2.setState({ monthContainer: _this2.monthContainer });
      }();
    }
  };

  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
      this.setState({
        date: this.localizeDate(this.props.preSelection)
      });
    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
      this.setState({
        date: this.localizeDate(this.props.openToDate)
      });
    }
  };

  Calendar.prototype.render = function render() {
    var Container = this.props.container || CalendarContainer;

    return React.createElement(
      Container,
      {
        className: classnames("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        })
      },
      this.renderPreviousMonthButton(),
      this.renderNextMonthButton(),
      this.renderMonths(),
      this.renderTodayButton(),
      this.renderTimeSection(),
      this.props.children
    );
  };

  return Calendar;
}(React.Component);

Calendar.propTypes = {
  adjustDateOnChange: propTypes$1.bool,
  className: propTypes$1.string,
  children: propTypes$1.node,
  container: propTypes$1.func,
  dateFormat: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.array]).isRequired,
  dayClassName: propTypes$1.func,
  disabledKeyboardNavigation: propTypes$1.bool,
  dropdownMode: propTypes$1.oneOf(["scroll", "select"]),
  endDate: propTypes$1.object,
  excludeDates: propTypes$1.array,
  filterDate: propTypes$1.func,
  fixedHeight: propTypes$1.bool,
  formatWeekNumber: propTypes$1.func,
  highlightDates: propTypes$1.instanceOf(Map),
  includeDates: propTypes$1.array,
  includeTimes: propTypes$1.array,
  injectTimes: propTypes$1.array,
  inline: propTypes$1.bool,
  locale: propTypes$1.string,
  maxDate: propTypes$1.object,
  minDate: propTypes$1.object,
  monthsShown: propTypes$1.number,
  onClickOutside: propTypes$1.func.isRequired,
  onMonthChange: propTypes$1.func,
  onYearChange: propTypes$1.func,
  forceShowMonthNavigation: propTypes$1.bool,
  onDropdownFocus: propTypes$1.func,
  onSelect: propTypes$1.func.isRequired,
  onWeekSelect: propTypes$1.func,
  showTimeSelect: propTypes$1.bool,
  showTimeSelectOnly: propTypes$1.bool,
  timeFormat: propTypes$1.string,
  timeIntervals: propTypes$1.number,
  onTimeChange: propTypes$1.func,
  minTime: propTypes$1.object,
  maxTime: propTypes$1.object,
  excludeTimes: propTypes$1.array,
  timeCaption: propTypes$1.string,
  openToDate: propTypes$1.object,
  peekNextMonth: propTypes$1.bool,
  scrollableYearDropdown: propTypes$1.bool,
  scrollableMonthYearDropdown: propTypes$1.bool,
  preSelection: propTypes$1.object,
  selected: propTypes$1.object,
  selectsEnd: propTypes$1.bool,
  selectsStart: propTypes$1.bool,
  showMonthDropdown: propTypes$1.bool,
  showMonthYearDropdown: propTypes$1.bool,
  showWeekNumbers: propTypes$1.bool,
  showYearDropdown: propTypes$1.bool,
  startDate: propTypes$1.object,
  todayButton: propTypes$1.node,
  useWeekdaysShort: propTypes$1.bool,
  formatWeekDay: propTypes$1.func,
  withPortal: propTypes$1.bool,
  utcOffset: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  weekLabel: propTypes$1.string,
  yearDropdownItemNumber: propTypes$1.number,
  setOpen: propTypes$1.func,
  useShortMonthInDropdown: propTypes$1.bool,
  showDisabledMonthNavigation: propTypes$1.bool,
  previousMonthButtonLabel: propTypes$1.string,
  nextMonthButtonLabel: propTypes$1.string,
  renderCustomHeader: propTypes$1.func,
  renderDayContents: propTypes$1.func
};

var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];

var PopperComponent = function (_React$Component) {
  inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    classCallCheck$1(this, PopperComponent);
    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  PopperComponent.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        hidePopper = _props.hidePopper,
        popperComponent = _props.popperComponent,
        popperModifiers = _props.popperModifiers,
        popperPlacement = _props.popperPlacement,
        popperProps = _props.popperProps,
        targetComponent = _props.targetComponent;


    var popper = void 0;

    if (!hidePopper) {
      var classes = classnames("react-datepicker-popper", className);
      popper = React.createElement(
        Popper$1,
        _extends$3({
          modifiers: popperModifiers,
          placement: popperPlacement
        }, popperProps),
        function (_ref) {
          var ref = _ref.ref,
              style = _ref.style,
              placement = _ref.placement,
              arrowProps = _ref.arrowProps;
          return React.createElement(
            "div",
            _extends$3({ ref: ref, style: style }, {
              className: classes,
              "data-placement": placement
            }),
            React.cloneElement(popperComponent, { arrowProps: arrowProps })
          );
        }
      );
    }

    if (this.props.popperContainer) {
      popper = React.createElement(this.props.popperContainer, {}, popper);
    }

    return React.createElement(
      Manager,
      null,
      React.createElement(
        Reference,
        null,
        function (_ref2) {
          var ref = _ref2.ref;
          return React.createElement(
            "div",
            { ref: ref, className: "react-datepicker-wrapper" },
            targetComponent
          );
        }
      ),
      popper
    );
  };

  createClass$1(PopperComponent, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: "viewport"
          }
        },
        popperProps: {},
        popperPlacement: "bottom-start"
      };
    }
  }]);
  return PopperComponent;
}(React.Component);

PopperComponent.propTypes = {
  className: propTypes$1.string,
  hidePopper: propTypes$1.bool,
  popperComponent: propTypes$1.element,
  popperModifiers: propTypes$1.object, // <datepicker/> props
  popperPlacement: propTypes$1.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: propTypes$1.func,
  popperProps: propTypes$1.object,
  targetComponent: propTypes$1.element
};

var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var WrappedCalendar = onClickOutsideHOC(Calendar);

// Compares dates year+month combinations
function hasPreSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
  }

  return date1 !== date2;
}

function hasSelectionChanged(date1, date2) {
  if (date1 && date2) {
    return !equals(date1, date2);
  }

  return false;
}

/**
 * General datepicker component.
 */
var INPUT_ERR_1 = "Date input not valid.";

var DatePicker = function (_React$Component) {
  inherits(DatePicker, _React$Component);
  createClass$1(DatePicker, null, [{
    key: "defaultProps",
    get: function get$$1() {
      return {
        allowSameDay: false,
        dateFormat: "L",
        dateFormatCalendar: "MMMM YYYY",
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: "scroll",
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onInputClick: function onInputClick() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside$$1() {},
        onMonthChange: function onMonthChange() {},

        preventOpenOnFocus: false,
        onYearChange: function onYearChange() {},
        onInputError: function onInputError() {},

        monthsShown: 1,
        readOnly: false,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next month",
        renderDayContents: function renderDayContents(date) {
          return date;
        }
      };
    }
  }]);

  function DatePicker(props) {
    classCallCheck$1(this, DatePicker);

    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = getEffectiveMinDate(_this.props);
      var maxDate = getEffectiveMaxDate(_this.props);
      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
        focused: false
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      if (_this.input && _this.input.focus) {
        _this.input.focus();
      }
    };

    _this.setBlur = function () {
      if (_this.input && _this.input.blur) {
        _this.input.blur();
      }

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }

      _this.cancelFocusInput();
    };

    _this.setOpen = function (open) {
      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
      }, function () {
        if (!open) {
          _this.setState(function (prev) {
            return {
              focused: skipSetBlur ? prev.focused : false
            };
          }, function () {
            !skipSetBlur && _this.setBlur();

            _this.setState({ inputValue: null });
          });
        }
      });
    };

    _this.inputOk = function () {
      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
    };

    _this.isCalendarOpen = function () {
      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
          _this.setOpen(true);
        }
      }
      _this.setState({ focused: true });
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open && !_this.props.withPortal) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
      _this.setState({ focused: false });
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function () {
      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
        allArgs[_key] = arguments[_key];
      }

      var event = allArgs[0];
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw.apply(_this, allArgs);
        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({
        inputValue: event.target.value,
        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
      });
      var date = parseDate(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
        if (isOutOfBounds(changedDate, _this.props)) {
          _this.props.onChange(date, event);
          _this.props.onSelect(changedDate, event);
        }

        return;
      }

      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            var selected = _this.props.selected;
            if (keepInput) selected = newDate(changedDate);
            changedDate = setTime(newDate(changedDate), {
              hour: getHour(selected),
              minute: getMinute(selected),
              second: getSecond(selected)
            });
          }
          if (!_this.props.inline) {
            _this.setState({
              preSelection: changedDate
            });
          }
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = setTime(cloneDate(selected), {
        hour: getHour(time),
        minute: getMinute(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
      if (_this.props.shouldCloseOnSelect) {
        _this.setOpen(false);
      }
      _this.setState({ inputValue: null });
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled && !_this.props.readOnly) {
        _this.setOpen(true);
      }

      _this.props.onInputClick();
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
          _this.onInputClick();
        }
        return;
      }
      var copy = newDate(_this.state.preSelection);
      if (eventKey === "Enter") {
        event.preventDefault();
        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === "Escape") {
        event.preventDefault();

        _this.setOpen(false);
        if (!_this.inputOk()) {
          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
        }
      } else if (eventKey === "Tab") {
        _this.setOpen(false, true);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case "ArrowLeft":
            newSelection = subtractDays(copy, 1);
            break;
          case "ArrowRight":
            newSelection = addDays(copy, 1);
            break;
          case "ArrowUp":
            newSelection = subtractWeeks(copy, 1);
            break;
          case "ArrowDown":
            newSelection = addWeeks(copy, 1);
            break;
          case "PageUp":
            newSelection = subtractMonths(copy, 1);
            break;
          case "PageDown":
            newSelection = addMonths(copy, 1);
            break;
          case "Home":
            newSelection = subtractYears(copy, 1);
            break;
          case "End":
            newSelection = addYears(copy, 1);
            break;
        }
        if (!newSelection) {
          if (_this.props.onInputError) {
            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
          }
          return; // Let the input component handle this keydown
        }
        event.preventDefault();
        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
        if (_this.props.adjustDateOnChange) {
          _this.setSelected(newSelection);
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      if (event) {
        if (event.preventDefault) {
          event.preventDefault();
        }
      }
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.clear = function () {
      _this.onClearClick();
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && !_this.isCalendarOpen()) {
        return null;
      }
      return React.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          adjustDateOnChange: _this.props.adjustDateOnChange,
          setOpen: _this.setOpen,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          formatWeekDay: _this.props.formatWeekDay,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.state.highlightDates,
          includeDates: _this.props.includeDates,
          includeTimes: _this.props.includeTimes,
          injectTimes: _this.props.injectTimes,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
          showMonthYearDropdown: _this.props.showMonthYearDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          onYearChange: _this.props.onYearChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          showTimeSelectOnly: _this.props.showTimeSelectOnly,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          timeCaption: _this.props.timeCaption,
          className: _this.props.calendarClassName,
          container: _this.props.calendarContainer,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
          renderCustomHeader: _this.props.renderCustomHeader,
          popperProps: _this.props.popperProps,
          renderDayContents: _this.props.renderDayContents
        },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var _classnames, _React$cloneElement;

      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));

      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
      var customInputRef = _this.props.customInputRef || "ref";
      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);

      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
        _this.input = input;
      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return React.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          onClick: _this.onClearClick,
          title: _this.props.clearButtonTitle,
          tabIndex: -1
        });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setPreSelection(this.props.selected);
    }
    if (prevProps.highlightDates !== this.props.highlightDates) {
      this.setState({
        highlightDates: getHightLightDaysMap(this.props.highlightDates)
      });
    }
    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
      this.setState({ inputValue: null });
    }
  };

  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearPreventFocusTimeout();
  };

  DatePicker.prototype.render = function render() {
    var calendar = this.renderCalendar();

    if (this.props.inline && !this.props.withPortal) {
      return calendar;
    }

    if (this.props.withPortal) {
      return React.createElement(
        "div",
        null,
        !this.props.inline ? React.createElement(
          "div",
          { className: "react-datepicker__input-container" },
          this.renderDateInput(),
          this.renderClearButton()
        ) : null,
        this.state.open || this.props.inline ? React.createElement(
          "div",
          { className: "react-datepicker__portal" },
          calendar
        ) : null
      );
    }

    return React.createElement(PopperComponent, {
      className: this.props.popperClassName,
      hidePopper: !this.isCalendarOpen(),
      popperModifiers: this.props.popperModifiers,
      targetComponent: React.createElement(
        "div",
        { className: "react-datepicker__input-container" },
        this.renderDateInput(),
        this.renderClearButton()
      ),
      popperContainer: this.props.popperContainer,
      popperComponent: calendar,
      popperPlacement: this.props.popperPlacement,
      popperProps: this.props.popperProps
    });
  };

  return DatePicker;
}(React.Component);

DatePicker.propTypes = {
  adjustDateOnChange: propTypes$1.bool,
  allowSameDay: propTypes$1.bool,
  autoComplete: propTypes$1.string,
  autoFocus: propTypes$1.bool,
  calendarClassName: propTypes$1.string,
  calendarContainer: propTypes$1.func,
  children: propTypes$1.node,
  className: propTypes$1.string,
  customInput: propTypes$1.element,
  customInputRef: propTypes$1.string,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFormat: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.array]),
  dateFormatCalendar: propTypes$1.string,
  dayClassName: propTypes$1.func,
  disabled: propTypes$1.bool,
  disabledKeyboardNavigation: propTypes$1.bool,
  dropdownMode: propTypes$1.oneOf(["scroll", "select"]).isRequired,
  endDate: propTypes$1.object,
  excludeDates: propTypes$1.array,
  filterDate: propTypes$1.func,
  fixedHeight: propTypes$1.bool,
  formatWeekNumber: propTypes$1.func,
  highlightDates: propTypes$1.array,
  id: propTypes$1.string,
  includeDates: propTypes$1.array,
  includeTimes: propTypes$1.array,
  injectTimes: propTypes$1.array,
  inline: propTypes$1.bool,
  isClearable: propTypes$1.bool,
  locale: propTypes$1.string,
  maxDate: propTypes$1.object,
  minDate: propTypes$1.object,
  monthsShown: propTypes$1.number,
  name: propTypes$1.string,
  onBlur: propTypes$1.func,
  onChange: propTypes$1.func.isRequired,
  onSelect: propTypes$1.func,
  onWeekSelect: propTypes$1.func,
  onClickOutside: propTypes$1.func,
  onChangeRaw: propTypes$1.func,
  onFocus: propTypes$1.func,
  onInputClick: propTypes$1.func,
  onKeyDown: propTypes$1.func,
  onMonthChange: propTypes$1.func,
  onYearChange: propTypes$1.func,
  onInputError: propTypes$1.func,
  open: propTypes$1.bool,
  openToDate: propTypes$1.object,
  peekNextMonth: propTypes$1.bool,
  placeholderText: propTypes$1.string,
  popperContainer: propTypes$1.func,
  popperClassName: propTypes$1.string, // <PopperComponent/> props
  popperModifiers: propTypes$1.object, // <PopperComponent/> props
  popperPlacement: propTypes$1.oneOf(popperPlacementPositions), // <PopperComponent/> props
  popperProps: propTypes$1.object,
  preventOpenOnFocus: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  required: propTypes$1.bool,
  scrollableYearDropdown: propTypes$1.bool,
  scrollableMonthYearDropdown: propTypes$1.bool,
  selected: propTypes$1.object,
  selectsEnd: propTypes$1.bool,
  selectsStart: propTypes$1.bool,
  showMonthDropdown: propTypes$1.bool,
  showMonthYearDropdown: propTypes$1.bool,
  showWeekNumbers: propTypes$1.bool,
  showYearDropdown: propTypes$1.bool,
  forceShowMonthNavigation: propTypes$1.bool,
  showDisabledMonthNavigation: propTypes$1.bool,
  startDate: propTypes$1.object,
  startOpen: propTypes$1.bool,
  tabIndex: propTypes$1.number,
  timeCaption: propTypes$1.string,
  title: propTypes$1.string,
  todayButton: propTypes$1.node,
  useWeekdaysShort: propTypes$1.bool,
  formatWeekDay: propTypes$1.func,
  utcOffset: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  value: propTypes$1.string,
  weekLabel: propTypes$1.string,
  withPortal: propTypes$1.bool,
  yearDropdownItemNumber: propTypes$1.number,
  shouldCloseOnSelect: propTypes$1.bool,
  showTimeSelect: propTypes$1.bool,
  showTimeSelectOnly: propTypes$1.bool,
  timeFormat: propTypes$1.string,
  timeIntervals: propTypes$1.number,
  minTime: propTypes$1.object,
  maxTime: propTypes$1.object,
  excludeTimes: propTypes$1.array,
  useShortMonthInDropdown: propTypes$1.bool,
  clearButtonTitle: propTypes$1.string,
  previousMonthButtonLabel: propTypes$1.string,
  nextMonthButtonLabel: propTypes$1.string,
  renderCustomHeader: propTypes$1.func,
  renderDayContents: propTypes$1.func
};
var PRESELECT_CHANGE_VIA_INPUT = "input";
var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";

var BasePicker = function BasePicker(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin base-picker", {
      "time-select": props.showTimeSelect
    })
  }, /*#__PURE__*/React.createElement(DatePicker, props));
};

var BaseInput = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseInput, _React$Component);

  var _super = _createSuper(BaseInput);

  function BaseInput() {
    var _this;

    _classCallCheck(this, BaseInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasFocus: false,
      value: _this.props.value
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (e, d) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onValueChange = _this$props.onValueChange;
      onChange(e, d);

      _this.setState({
        value: d.value
      });

      if (onValueChange) onValueChange(d.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputFocus", function (e) {
      _this.props.onFocus(e);

      _this.setState({
        hasFocus: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onInputBlur", function () {
      _this.setState({
        hasFocus: false
      });
    });

    return _this;
  }

  _createClass(BaseInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClick = _this$props2.onClick,
          onKeyDown = _this$props2.onKeyDown,
          tabIndex = _this$props2.tabIndex,
          placeholdText = _this$props2.placeholdText,
          dateValid = _this$props2.dateValid,
          disabled = _this$props2.disabled;
      var value = this.state.value;
      var error = !(dateValid || !value);
      return /*#__PURE__*/React.createElement(Input$1, {
        onClick: onClick,
        onKeyDown: onKeyDown,
        tabIndex: tabIndex,
        value: value,
        onChange: this.onInputChange,
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        placeholder: placeholdText,
        error: error,
        disabled: disabled
      });
    }
  }]);

  return BaseInput;
}(React.Component);

_defineProperty(BaseInput, "getDerivedStateFromProps", function (nextProps, prevState) {
  if (prevState.hasFocus && nextProps.dateValid) {
    return {
      value: nextProps.value
    };
  }

  if (!prevState.hasFocus) {
    return {
      value: nextProps.dateValid ? nextProps.value : ""
    };
  }

  return null;
});

var to2Figures = function to2Figures(value) {
  if (value.length === 2) return value;
  return ("0" + value).slice(-2);
};

var to4Figures = function to4Figures(value, futureCenturyThreshold) {
  if (value.length === 4) return value;

  if (value.length == 2) {
    var currentYear = moment();
    var currentYearPrefix = parseInt(currentYear.format("YYYY").substring(0, 2));
    var currentYear2dp = parseInt(currentYear.format("YYYY").slice(-2));
    var cutOffYear2dp = moment().add("years", futureCenturyThreshold).format("YYYY").slice(-2);
    var valueInt = parseInt(value);
    var yearPrefix = valueInt > currentYear2dp && valueInt > cutOffYear2dp ? currentYearPrefix - 1 : valueInt < currentYear2dp && valueInt < cutOffYear2dp && currentYear2dp > cutOffYear2dp ? currentYearPrefix + 1 : currentYearPrefix;
    return yearPrefix + value;
  }

  return value;
};

var getCorrectDateFormat = function getCorrectDateFormat(value, dateFormat, futureCenturyThreshold) {
  if (dateFormat && value && value.length !== 10 && (dateFormat.toUpperCase() === "DD/MM/YYYY" || dateFormat.toUpperCase() === "MM/DD/YYYY")) {
    var parts = value.split("/");

    if (parts.length === 3) {
      return "".concat(to2Figures(parts[0]), "/").concat(to2Figures(parts[1]), "/").concat(to4Figures(parts[2], futureCenturyThreshold));
    }
  }

  return value;
};

var getCorrectTimeFormat = function getCorrectTimeFormat(value) {
  var parts = value.split(":");
  if (parts.length !== 2) return value;
  return "".concat(to2Figures(parts[0]), ":").concat(to2Figures(parts[1]));
};

var getCorrectDateTimeFormat = function getCorrectDateTimeFormat(value, dateTimeFormat, futureCenturyThreshold) {
  var parts = value.split(" ");
  if (parts.length !== 2) return value;

  if (dateTimeFormat === "DD/MM/YYYY HH:mm" || dateTimeFormat === "MM/DD/YYYY HH:mm") {
    var date = getCorrectDateFormat(parts[0], dateTimeFormat.substring(0, 10), futureCenturyThreshold);
    var time = getCorrectTimeFormat(parts[1]);
    return "".concat(date, " ").concat(time);
  }

  return value;
};

var DatePicker$1 = /*#__PURE__*/function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onInputValueChange", function (value) {
      if (typeof value === "string") {
        value = getCorrectDateFormat(value, _this.props.dateFormat, _this.props.futureCenturyThreshold);
        value = moment(value, _this.props.dateFormat, true);
      }

      _this.props.onChange(moment.isMoment(value) && value.isValid() ? value : undefined);
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder,
          other = _objectWithoutProperties(_this$props, ["value", "onChange", "placeholder"]);

      return /*#__PURE__*/React.createElement(BasePicker, _extends({}, other, {
        customInput: /*#__PURE__*/React.createElement(BaseInput, {
          placeholdText: placeholder,
          onValueChange: this.onInputValueChange,
          dateValid: !!value
        }),
        selected: value,
        onChange: onChange
      }));
    }
  }]);

  return DatePicker;
}(React.Component);

_defineProperty(DatePicker$1, "propTypes", {
  value: propTypes$1.instanceOf(moment),
  onChange: propTypes$1.func.isRequired,
  placeholder: propTypes$1.string,
  dateFormat: propTypes$1.string,
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DatePicker$1, "defaultProps", {
  placeholder: "Pick a date",
  // react-datepicker default overrides
  dateFormat: "DD/MM/YYYY",
  futureCenturyThreshold: 30
});

var DateTimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimePicker, _React$Component);

  var _super = _createSuper(DateTimePicker);

  function DateTimePicker() {
    var _this;

    _classCallCheck(this, DateTimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onInputValueChange", function (value) {
      if (typeof value === "string") {
        value = getCorrectDateTimeFormat(value, _this.props.dateFormat, _this.props.futureCenturyThreshold);
        value = moment(value, _this.props.dateFormat, true);
      }

      _this.props.onChange(moment.isMoment(value) && value.isValid() ? value : undefined);
    });

    return _this;
  }

  _createClass(DateTimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder,
          other = _objectWithoutProperties(_this$props, ["value", "onChange", "placeholder"]);

      return /*#__PURE__*/React.createElement(BasePicker, _extends({}, other, {
        customInput: /*#__PURE__*/React.createElement(BaseInput, {
          placeholdText: placeholder,
          onValueChange: this.onInputValueChange,
          dateValid: !!value
        }),
        selected: value,
        onChange: onChange,
        showTimeSelect: true
      }));
    }
  }]);

  return DateTimePicker;
}(React.Component);

_defineProperty(DateTimePicker, "propTypes", {
  value: propTypes$1.instanceOf(moment),
  onChange: propTypes$1.func.isRequired,
  placeholder: propTypes$1.string,
  dateFormat: propTypes$1.string,
  timeFormat: propTypes$1.string,
  timeIntervals: propTypes$1.number,
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DateTimePicker, "defaultProps", {
  placeholder: "Pick a date and time",
  // react-datepicker default overrides
  dateFormat: "DD/MM/YYYY HH:mm",
  timeFormat: "HH:mm",
  timeIntervals: 5,
  futureCenturyThreshold: 30
});

var inputStyles = {
  width: "50px",
  minWidth: "50px",
  marginRight: "10px"
};
var resetStyles = {
  width: "25px",
  position: "relative",
  marginTop: "16px"
};

var TimeInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeInput, _React$Component);

  var _super = _createSuper(TimeInput);

  function TimeInput(props) {
    var _this;

    _classCallCheck(this, TimeInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "setup", function (value) {
      if (!value) {
        return {
          hour: _this.state.hour || "",
          minute: _this.state.minute || ""
        };
      }

      var time = moment(value, "HH:mm");
      var hour = time.format("HH");
      var minute = time.format("mm");
      return {
        hour: hour,
        minute: minute
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onHourChange", function (e, data) {
      var changes = {
        hour: data.value
      };

      _this.setState(changes);
    });

    _defineProperty(_assertThisInitialized(_this), "onMinuteChange", function (e, data) {
      var changes = {
        minute: data.value
      };

      _this.setState(changes);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      var values = _objectSpread2({}, _this.state);

      var hour = parseInt(values.hour);
      var minute = parseInt(values.minute);

      if (isNaN(hour) || isNaN(minute)) {
        _this.setState({
          hour: isNaN(hour) ? "" : values.hour,
          minute: isNaN(minute) ? "" : values.minute
        }, function () {
          return _this.props.onChange(undefined);
        });

        return;
      }

      if (hour > 23) {
        hour = "00";
      }

      if (minute > 59) {
        minute = "00";
      }

      var m = moment("".concat(hour, ":").concat(minute), "HH:mm");

      _this.setState({
        hour: m.format("HH"),
        minute: m.format("mm")
      });

      _this.props.onChange(m.format("HH:mm"));
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function (e) {
      e.preventDefault();

      _this.setState({
        hour: "",
        minute: ""
      }, function () {
        _this.props.onChange(undefined);
      });
    });

    _this.state = _this.setup(props.value);
    return _this;
  }

  _createClass(TimeInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.value === prevProps.value) return;
      this.setState(this.setup(this.props.value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          hour = _this$state.hour,
          minute = _this$state.minute;
      var _this$props = this.props,
          isClearable = _this$props.isClearable,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled;
      var placeholderParts = placeholder.split(":");
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Hour"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input$1, {
        value: hour,
        onChange: this.onHourChange,
        onBlur: this.onBlur,
        style: inputStyles,
        placeholder: placeholderParts.length >= 1 ? placeholderParts[0] : undefined,
        maxLength: 2,
        disabled: disabled
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, "Minute"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Input$1, {
        value: minute,
        onChange: this.onMinuteChange,
        onBlur: this.onBlur,
        style: inputStyles,
        placeholder: placeholderParts.length >= 2 ? placeholderParts[1] : undefined,
        maxLength: 2,
        disabled: disabled
      })), (hour || minute) && isClearable && /*#__PURE__*/React.createElement("div", {
        style: resetStyles
      }, /*#__PURE__*/React.createElement("a", {
        className: "react-datepicker__close-icon",
        href: "#",
        onClick: this.reset
      })));
    }
  }]);

  return TimeInput;
}(React.Component);

_defineProperty(TimeInput, "propTypes", {
  value: propTypes$1.string,
  onChange: propTypes$1.func,
  isClearable: propTypes$1.bool,
  placeholder: propTypes$1.string
});

_defineProperty(TimeInput, "defaultProps", {
  placeholder: "13:15"
});

var TimePicker = /*#__PURE__*/function (_React$Component) {
  _inherits(TimePicker, _React$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker() {
    var _this;

    _classCallCheck(this, TimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onInputValueChange", function (value) {
      if (typeof value === "string") {
        value = moment(value, _this.props.timeFormat, true);
      }

      _this.props.onChange(moment.isMoment(value) && value.isValid() ? value : undefined);
    });

    return _this;
  }

  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          placeholder = _this$props.placeholder,
          otherProps = _objectWithoutProperties(_this$props, ["value", "onChange", "placeholder"]);

      return /*#__PURE__*/React.createElement(BasePicker, _extends({}, otherProps, {
        customInput: /*#__PURE__*/React.createElement(BaseInput, {
          placeholdText: placeholder,
          onValueChange: this.onInputValueChange,
          dateValid: !!value
        }),
        selected: value,
        onChange: onChange,
        showTimeSelect: true,
        showTimeSelectOnly: true
      }));
    }
  }]);

  return TimePicker;
}(React.Component);

_defineProperty(TimePicker, "propTypes", {
  value: propTypes$1.instanceOf(moment),
  onChange: propTypes$1.func.isRequired,
  placeholder: propTypes$1.string,
  dateFormat: propTypes$1.string,
  timeFormat: propTypes$1.string,
  timeIntervals: propTypes$1.number
});

_defineProperty(TimePicker, "defaultProps", {
  placeholder: "Pick a time",
  // react-datepicker default overrides
  dateFormat: "HH:mm",
  timeFormat: "HH:mm",
  timeIntervals: 5
});

var dateTest = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(.+)?[zZ]?$/;
/**
 * Date and time field for instant dates (point in time that can be globally agreed)
 */

var DateTimeInstant = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimeInstant, _React$Component);

  var _super = _createSuper(DateTimeInstant);

  function DateTimeInstant() {
    var _this;

    _classCallCheck(this, DateTimeInstant);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var timezone = _this.props.timezone;

      if (!momentTimezone$1.isMoment(value)) {
        return _this.props.onChange(undefined);
      }

      var update = momentTimezone$1.tz(value.format("YYYY-MM-DD HH:mm"), "YYYY-MM-DD HH:mm", timezone);
      return _this.props.onChange(update.toISOString());
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (value) {});

    _defineProperty(_assertThisInitialized(_this), "onTimeChange", function (value) {});

    _defineProperty(_assertThisInitialized(_this), "parse", function () {
      var value = _this.props.value;
      return value ? momentTimezone$1(value, momentTimezone$1.ISO_8601) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "parsePicker", function () {
      var timezone = _this.props.timezone;

      var parsed = _this.parse();

      if (!parsed) return undefined;
      return momentTimezone$1(parsed.tz(timezone).format("YYYY-MM-DD HH:mm"), "YYYY-MM-DD HH:mm");
    });

    return _this;
  }

  _createClass(DateTimeInstant, [{
    key: "render",
    value: // parseDay = () => {
    //   const { value } = this.props;
    //   return value ? moment(value).format("YYYY-MM-DD") : undefined;
    // };
    //
    // parseTime = () => {
    //   const { value } = this.props;
    //   return value ? moment(value).format("HH:mm") : undefined;
    // };
    function render() {
      var _this$props = this.props,
          picker = _this$props.picker;
          _this$props.value;
          _this$props.onChange;
          _this$props.timezone;
          var otherProps = _objectWithoutProperties(_this$props, ["picker", "value", "onChange", "timezone"]);

      if (!picker) {
        console.error("picker={false} is not setup yet on <DateTimeInstant />");
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(DateInput, _extends({
          value: this.parseDay(),
          onChange: this.onDateChange
        }, otherProps)), /*#__PURE__*/React.createElement(TimeInput, _extends({
          value: this.parseTime(),
          onChange: this.onTimeChange
        }, otherProps)));
      }

      return /*#__PURE__*/React.createElement(DateTimePicker, _extends({
        value: this.parsePicker(),
        onChange: this.onChange
      }, otherProps));
    }
  }]);

  return DateTimeInstant;
}(React.Component);

_defineProperty(DateTimeInstant, "propTypes", {
  /**
   * Current value of the field
   * Must be a string in format: YYYY-MM-DDTHH:mm:ssZ
   */
  value: function value(_ref) {
    var _value = _ref.value;

    if (_value && !dateTest.test(_value)) {
      return new Error("DateTimeInstant only accepts UTC ISO 8601 string value `YYYY-MM-DDTHH:mm:ssZ");
    }
  },

  /**
   * Callback when the field has changed
   * @param {string} `value` New date/time value
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * Whether the field should display a picker control for choosing the value
   */
  picker: propTypes$1.bool,

  /**
   * Timezone to apply, if available the current value in app preferences is used by default, otherwise the timezone is determined by the client browser
   */
  timezone: propTypes$1.string,

  /**
   * The number of years from now at which point a 2-digit year will be considered a year from the previous or current century
   */
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DateTimeInstant, "defaultProps", {
  picker: true,
  timezone: momentTimezone$1.tz.guess()
});

var mapStateToProps$6 = function mapStateToProps(state, ownProps) {
  return {
    timezone: ownProps.timezone || getPreferenceState(state).timezone
  };
};

var DateTimeInstant$1 = connect$1(mapStateToProps$6)(DateTimeInstant);

var dateTest$1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(.+)?[zZ]?$/;
/**
 * Date field for instant dates (point in time that can be globally agreed)
 */

var DateInstant = /*#__PURE__*/function (_React$Component) {
  _inherits(DateInstant, _React$Component);

  var _super = _createSuper(DateInstant);

  function DateInstant() {
    var _this;

    _classCallCheck(this, DateInstant);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "parse", function () {
      var value = _this.props.value;
      return value ? momentTimezone$1(value, momentTimezone$1.ISO_8601) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "parsePicker", function () {
      var timezone = _this.props.timezone;

      var p = _this.parse();

      if (!p) return undefined; // parse datepicker a UTC'd moment object.

      return momentTimezone$1.utc(p.tz(timezone).format("YYYY-MM-DD"), "YYYY-MM-DD");
    });

    _defineProperty(_assertThisInitialized(_this), "parseInput", function () {
      var timezone = _this.props.timezone;

      var p = _this.parse();

      return p ? p.tz(timezone).format("YYYY-MM-DD") : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "onPickerChange", function (value) {
      var timezone = _this.props.timezone;

      if (!momentTimezone$1.isMoment(value)) {
        return _this.props.onChange(undefined);
      }

      var update = momentTimezone$1.tz(value.format("YYYY-MM-DD"), "YYYY-MM-DD", timezone).startOf("day");
      return _this.props.onChange(update.toISOString());
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      var timezone = _this.props.timezone;
      var update = value ? momentTimezone$1(value, "YYYY-MM-DD").tz(timezone).startOf("day").toISOString() : undefined;

      _this.props.onChange(update);
    });

    return _this;
  }

  _createClass(DateInstant, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          picker = _this$props.picker;
          _this$props.value;
          _this$props.onChange;
          _this$props.timezone;
          var otherProps = _objectWithoutProperties(_this$props, ["picker", "value", "onChange", "timezone"]);

      if (!picker) {
        return /*#__PURE__*/React.createElement(DateInput, _extends({
          value: this.parseInput(),
          onChange: this.onInputChange
        }, otherProps));
      }

      return /*#__PURE__*/React.createElement(DatePicker$1, _extends({
        value: this.parsePicker(),
        onChange: this.onPickerChange
      }, otherProps));
    }
  }]);

  return DateInstant;
}(React.Component);

_defineProperty(DateInstant, "propTypes", {
  /**
   * Current value of the field
   * Must be a string in format: YYYY-MM-DDTHH:mm:ssZ
   */
  value: function value(_ref) {
    var _value = _ref.value;

    if (_value && !dateTest$1.test(_value)) {
      return new Error("DateInstant only accepts UTC ISO 8601 string value `YYYY-MM-DDTHH:mm:ssZ`");
    }
  },

  /**
   * Callback when the field has changed
   * @param {string} `value` New date value
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * Whether the field should display a picker control for choosing the value
   */
  picker: propTypes$1.bool,

  /**
   * Timezone to apply, if available the current value in app preferences is used by default, otherwise the timezone is determined by the client browser
   */
  timezone: propTypes$1.string,

  /**
   * The number of years from now at which point a 2-digit year will be considered a year from the previous or current century
   */
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DateInstant, "defaultProps", {
  picker: true,
  timezone: momentTimezone$1.tz.guess()
});

var mapStateToProps$7 = function mapStateToProps(state, ownProps) {
  return {
    timezone: ownProps.timezone || getPreferenceState(state).timezone
  };
};

var DateInstant$1 = connect$1(mapStateToProps$7)(DateInstant);

var dateTest$2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
/**
 * Date and time field for local dates (local time to the user)
 */

var DateTimeLocal = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimeLocal, _React$Component);

  var _super = _createSuper(DateTimeLocal);

  function DateTimeLocal() {
    var _this;

    _classCallCheck(this, DateTimeLocal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      return _this.props.onChange(moment.isMoment(value) ? value.format("YYYY-MM-DD[T]HH:mm") : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (value) {});

    _defineProperty(_assertThisInitialized(_this), "onTimeChange", function (value) {});

    _defineProperty(_assertThisInitialized(_this), "parse", function () {
      var value = _this.props.value;
      return value ? moment(value) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "parseDay", function () {
      var value = _this.props.value;
      return value ? moment(value).format("YYYY-MM-DD") : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "parseTime", function () {
      var value = _this.props.value;
      return value ? moment(value).format("HH:mm") : undefined;
    });

    return _this;
  }

  _createClass(DateTimeLocal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          picker = _this$props.picker;
          _this$props.value;
          _this$props.onChange;
          var otherProps = _objectWithoutProperties(_this$props, ["picker", "value", "onChange"]);

      if (!picker) {
        console.error("picker={false} is not setup yet on <DateTimeLocal />");
        return /*#__PURE__*/React.createElement("div", {
          style: {
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(DateInput, _extends({
          value: this.parseDay(),
          onChange: this.onDateChange
        }, otherProps)), /*#__PURE__*/React.createElement(TimeInput, _extends({
          value: this.parseTime(),
          onChange: this.onTimeChange
        }, otherProps)));
      }

      return /*#__PURE__*/React.createElement(DateTimePicker, _extends({
        value: this.parse(),
        onChange: this.onChange
      }, otherProps));
    }
  }]);

  return DateTimeLocal;
}(React.Component);

_defineProperty(DateTimeLocal, "propTypes", {
  /**
   * Current value of the field
   * Must be a string in format: YYYY-MM-DDTHH:mm
   */
  value: function value(_ref) {
    var _value = _ref.value;

    if (_value && !dateTest$2.test(_value)) {
      return new Error("DateTimeLocal only accepts string value `YYYY-MM-DDTHH:mm`");
    }
  },

  /**
   * Callback when the field has changed
   * @param {string} `value` New date/time value
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * Whether the field should display a picker control for choosing the value
   */
  picker: propTypes$1.bool,

  /**
   * The number of years from now at which point a 2-digit year will be considered a year from the previous or current century
   */
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DateTimeLocal, "defaultProps", {
  picker: true
});

var dateTest$3 = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Date field for local dates (local time to the user)
 */

var DateLocal = /*#__PURE__*/function (_React$Component) {
  _inherits(DateLocal, _React$Component);

  var _super = _createSuper(DateLocal);

  function DateLocal() {
    var _this;

    _classCallCheck(this, DateLocal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "parsePicker", function () {
      var value = _this.props.value;
      return value ? moment(value) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "parseInput", function () {
      var value = _this.props.value;
      return value ? moment(value).format("YYYY-MM-DD") : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "onPickerChange", function (value) {
      return _this.props.onChange(moment.isMoment(value) ? value.format("YYYY-MM-DD") : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      return _this.props.onChange(value);
    });

    return _this;
  }

  _createClass(DateLocal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          picker = _this$props.picker;
          _this$props.value;
          _this$props.onChange;
          var otherProps = _objectWithoutProperties(_this$props, ["picker", "value", "onChange"]);

      if (!picker) {
        return /*#__PURE__*/React.createElement(DateInput, _extends({
          value: this.parseInput(),
          onChange: this.onInputChange
        }, otherProps));
      }

      return /*#__PURE__*/React.createElement(DatePicker$1, _extends({
        value: this.parsePicker(),
        onChange: this.onPickerChange
      }, otherProps));
    }
  }]);

  return DateLocal;
}(React.Component);

_defineProperty(DateLocal, "propTypes", {
  /**
   * Current value of the field
   * Must be a string in format: YYYY-MM-DD
   */
  value: function value(_ref) {
    var _value = _ref.value;

    if (_value && !dateTest$3.test(_value)) {
      return new Error("DateLocal only accepts string value `YYYY-MM-DD`");
    }
  },

  /**
   * Callback when the field has changed
   * @param {string} `value` New date value
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * Whether the field should display a picker control for choosing the value
   */
  picker: propTypes$1.bool,

  /**
   * The number of years from now at which point a 2-digit year will be considered a year from the previous or current century
   */
  futureCenturyThreshold: propTypes$1.number
});

_defineProperty(DateLocal, "defaultProps", {
  picker: true
});

var timeTests = [{
  format: "HH:mm",
  regex: /^\d{2}:\d{2}$/
}, {
  format: "HH:mm:ss",
  regex: /^\d{2}:\d{2}:\d{2}$/
}];

var findTimeTest = function findTimeTest(value) {
  if (!value) return undefined;
  return timeTests.find(function (t) {
    return t.regex.test(value);
  });
};
/**
 * Time field for local times (to the user)
 */


var TimeLocal = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeLocal, _React$Component);

  var _super = _createSuper(TimeLocal);

  function TimeLocal() {
    var _this;

    _classCallCheck(this, TimeLocal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "parsePicker", function () {
      var value = _this.props.value;
      var timeTest = findTimeTest(value);
      if (!timeTest) return undefined;
      return moment(value, timeTest.format);
    });

    _defineProperty(_assertThisInitialized(_this), "onPickerChange", function (value) {
      return _this.props.onChange(moment.isMoment(value) ? value.format("HH:mm") : undefined);
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      return _this.props.onChange(value || undefined);
    });

    return _this;
  }

  _createClass(TimeLocal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          picker = _this$props.picker,
          value = _this$props.value,
          otherProps = _objectWithoutProperties(_this$props, ["picker", "value"]);

      if (!picker) {
        return /*#__PURE__*/React.createElement(TimeInput, _extends({}, otherProps, {
          value: value,
          onChange: this.onInputChange
        }));
      }

      return /*#__PURE__*/React.createElement(TimePicker, _extends({}, otherProps, {
        value: this.parsePicker(),
        onChange: this.onPickerChange
      }));
    }
  }]);

  return TimeLocal;
}(React.Component);

_defineProperty(TimeLocal, "propTypes", {
  /**
   * Current value of the field
   * Must be a string in format: HH:mm or HH:mm:ss
   */
  value: function value(_ref) {
    var _value = _ref.value;

    if (_value && !findTimeTest(_value)) {
      var validFormats = timeTests.map(function (t) {
        return t.format;
      });
      return new Error("TimeLocal only accepts string value '".concat(validFormats.join("' or '"), "'"));
    }
  },

  /**
   * Callback when the field has changed
   * @param {string} `value` New time value
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * Whether the field should display a picker control for choosing the value
   */
  picker: propTypes$1.bool
});

_defineProperty(TimeLocal, "defaultProps", {
  picker: true
});

var BaseDateTimeFormatter = function BaseDateTimeFormatter(_ref) {
  var value = _ref.value,
      timezone = _ref.timezone,
      format = _ref.format,
      tooltip = _ref.tooltip,
      tooltipTimezone = _ref.tooltipTimezone,
      tooltipFormat = _ref.tooltipFormat,
      className = _ref.className;
  if (!value) return null;
  var m = momentTimezone$1.utc(value);
  var mLocal = m.tz(timezone || momentTimezone$1.tz.guess());
  var displayFormat = format;

  if (typeof format === "function") {
    var today = momentTimezone$1().tz(timezone || momentTimezone$1.tz.guess()).startOf("day");
    var mToday = momentTimezone$1(mLocal).startOf("day");
    var isToday = mToday.isSame(today);
    var isYesterday = mToday.isSame(today.subtract(1, "days"));
    var isTomorrow = mToday.isSame(today.add(2, "days")); // add/subtract mutates date, compensate for isYesterday

    displayFormat = format({
      isYesterday: isYesterday,
      isToday: isToday,
      isTomorrow: isTomorrow
    });
  }

  var output = /*#__PURE__*/React.createElement("span", {
    className: className
  }, mLocal.format(displayFormat));
  if (!tooltip) return output;
  var tooltipText = m.tz(tooltipTimezone || momentTimezone$1.tz.guess()).format(tooltipFormat);
  return /*#__PURE__*/React.createElement(Popup, {
    trigger: output,
    content: tooltipText,
    flowing: true,
    size: "tiny",
    position: "bottom left"
  });
};

BaseDateTimeFormatter.propTypes = {
  value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.instanceOf(Date), propTypes$1.instanceOf(momentTimezone$1)]),
  timezone: propTypes$1.string,
  format: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]).isRequired,
  tooltip: propTypes$1.bool,
  tooltipTimezone: propTypes$1.string,
  tooltipFormat: propTypes$1.string,
  className: propTypes$1.string
};

var mapStateToProps$8 = function mapStateToProps(state, ownProps) {
  var preferenceTimezone = getPreferenceState(state).timezone;
  return {
    timezone: ownProps.timezone || preferenceTimezone,
    tooltipTimezone: ownProps.tooltipTimezone || preferenceTimezone
  };
};

var BaseDateTimeFormatter$1 = connect$1(mapStateToProps$8)(BaseDateTimeFormatter);

var formatMap = {
  default: "Do MMM YY",
  short: "DD/MM/YYYY",
  medium: "Do MMMM YYYY",
  long: "dddd, MMMM DD, YYYY",
  monthYear: "MMM YYYY"
};
/**
 * Formats a value as a date
 */

var DateFormatter = function DateFormatter(_ref) {
  var format = _ref.format,
      tooltipFormat = _ref.tooltipFormat,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["format", "tooltipFormat", "className"]);

  return /*#__PURE__*/React.createElement(BaseDateTimeFormatter$1, _extends({}, props, {
    format: formatMap[format] || format,
    tooltipFormat: formatMap[tooltipFormat] || tooltipFormat,
    className: classnames("cin date-formatter", className)
  }));
};

DateFormatter.propTypes = {
  /**
   * Value to format (UTC where applicable)
   */
  value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.instanceOf(Date), propTypes$1.instanceOf(moment)]),

  /**
   * Optional moment timezone for interpreting the date value
   */
  timezone: propTypes$1.string,

  /**
   * Display format to render the reformatted value. Can be a preset value, a custom (moment.js) format string, or a custom function
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `short`
   * @property {string} `medium`
   * @property {string} `long`
   * @property {string} `monthYear`
   * @property {string} `[custom]`
   *
   * @param {object} `state` The current state of the date being formatted
   * @param {boolean} `state.isYesterday` Whether the date occurred yesterday
   * @param {boolean} `state.isToday` Whether the date is on the same day as the user's current time
   * @param {boolean} `state.isTomorrow` Whether the date occurs tomorrow
   * @returns {string} Custom (moment.js) date format
   */
  format: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap)), propTypes$1.string, propTypes$1.func]),

  /**
   * Whether to display a tooltip that displays the value in another timezone/format
   */
  tooltip: propTypes$1.bool,

  /**
   * Optional moment timezone for interpreting the date value, for the tooltip
   */
  tooltipTimezone: propTypes$1.string,

  /**
   * Display format to render the reformatted tooltip. Can be a preset value or a custom (moment.js) format string
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `short`
   * @property {string} `medium`
   * @property {string} `long`
   * @property {string} `monthYear`
   * @property {string} `[custom]`
   */
  tooltipFormat: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap)), propTypes$1.string]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
DateFormatter.defaultProps = {
  format: "default",
  tooltipFormat: "long",
  tooltip: false
};

var formatMap$1 = {
  default: "Do MMM YY h:mm a",
  short: "DD/MM/YYYY HH:mm",
  medium: "Do MMMM YYYY [at] HH:mm",
  long: "dddd, MMMM DD, YYYY [at] HH:mm"
};
/**
 * Formats a value as a date and time
 */

var DateTimeFormatter = function DateTimeFormatter(_ref) {
  var format = _ref.format,
      tooltipFormat = _ref.tooltipFormat,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["format", "tooltipFormat", "className"]);

  return /*#__PURE__*/React.createElement(BaseDateTimeFormatter$1, _extends({}, props, {
    format: formatMap$1[format] || format,
    tooltipFormat: formatMap$1[tooltipFormat] || tooltipFormat,
    className: classnames("cin date-time-formatter", className)
  }));
};

DateTimeFormatter.propTypes = {
  /**
   * Value to format (UTC where applicable)
   */
  value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.instanceOf(Date), propTypes$1.instanceOf(moment)]),

  /**
   * Optional moment timezone for interpreting the date/time value
   */
  timezone: propTypes$1.string,

  /**
   * Display format to render the reformatted value. Can be a preset value, a custom (moment.js) format string, or a custom function
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `short`
   * @property {string} `medium`
   * @property {string} `long`
   * @property {string} `[custom]`
   *
   * @param {object} `state` The current state of the date being formatted
   * @param {boolean} `state.isYesterday` Whether the date occurred yesterday
   * @param {boolean} `state.isToday` Whether the date is on the same day as the user's current time
   * @param {boolean} `state.isTomorrow` Whether the date occurs tomorrow
   * @returns {string} Custom (moment.js) date format
   */
  format: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap$1)), propTypes$1.string, propTypes$1.func]),

  /**
   * Whether to display a tooltip that displays the value in another timezone/format
   */
  tooltip: propTypes$1.bool,

  /**
   * Optional moment timezone for interpreting the date/time value, for the tooltip
   */
  tooltipTimezone: propTypes$1.string,

  /**
   * Display format to render the reformatted tooltip. Can be a preset value or a custom (moment.js) format string
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `short`
   * @property {string} `medium`
   * @property {string} `long`
   * @property {string} `[custom]`
   */
  tooltipFormat: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap$1)), propTypes$1.string]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
DateTimeFormatter.defaultProps = {
  format: "default",
  tooltipFormat: "long",
  tooltip: false
};

var formatMap$2 = {
  default: "h:mm a",
  "12hour": "hh:mm a",
  "24hour": "HH:mm"
};
/**
 * Formats a value as a time
 */

var TimeFormatter = function TimeFormatter(_ref) {
  var format = _ref.format,
      tooltipFormat = _ref.tooltipFormat,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["format", "tooltipFormat", "className"]);

  return /*#__PURE__*/React.createElement(BaseDateTimeFormatter$1, _extends({}, props, {
    format: formatMap$2[format] || format,
    tooltipFormat: formatMap$2[tooltipFormat] || tooltipFormat,
    className: classnames("cin time-formatter", className)
  }));
};

TimeFormatter.propTypes = {
  /**
   * Value to format (UTC where applicable)
   */
  value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.instanceOf(Date), propTypes$1.instanceOf(moment)]),

  /**
   * Optional moment timezone for interpreting the time value
   */
  timezone: propTypes$1.string,

  /**
   * Display format to render the reformatted value. Can be a preset value or a custom (moment.js) format string
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `12hour`
   * @property {string} `24hour`
   * @property {string} `[custom]`
   */
  format: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap$2)), propTypes$1.string]),

  /**
   * Whether to display a tooltip that displays the value in another timezone/format
   */
  tooltip: propTypes$1.bool,

  /**
   * Optional moment timezone for interpreting the time value, for the tooltip
   */
  tooltipTimezone: propTypes$1.string,

  /**
   * Display format to render the reformatted tooltip. Can be a preset value or a custom (moment.js) format string
   * @typedef formatMap
   * @property {string} `default`
   * @property {string} `12hour`
   * @property {string} `24hour`
   * @property {string} `[custom]`
   */
  tooltipFormat: propTypes$1.oneOfType([propTypes$1.oneOf(Object.keys(formatMap$2)), propTypes$1.string]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
TimeFormatter.defaultProps = {
  format: "default",
  tooltipFormat: "24hour",
  tooltip: false
};

var formatMap$3 = {
  default: {
    thousandSeparator: true
  },
  GBP: {
    decimalPlaces: 2,
    thousandSeparator: true,
    prefix: "£"
  },
  USD: {
    decimalPlaces: 2,
    thousandSeparator: true,
    prefix: "$"
  },
  EUR: {
    decimalPlaces: 2,
    thousandSeparator: true,
    prefix: "€"
  },
  percentage: {
    decimalPlaces: 1,
    suffix: "%"
  },
  kg: {
    thousandSeparator: true,
    suffix: "kg"
  }
};
/**
 * Formats a value as a number
 */

var NumberFormatter = function NumberFormatter(_ref) {
  var value = _ref.value,
      format = _ref.format,
      decimalPlaces = _ref.decimalPlaces,
      thousandSeparator = _ref.thousandSeparator,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      spaced = _ref.spaced,
      className = _ref.className,
      language = _ref.language;
  if (value === undefined || value === null) return null;
  var num = Number(value);
  if (Number.isNaN(num)) return null;
  var formatProps = formatMap$3[format];
  var decimalPlacesVal = decimalPlaces !== undefined ? decimalPlaces : formatProps.decimalPlaces;
  var thousandSeparatorVal = thousandSeparator !== undefined ? thousandSeparator : formatProps.thousandSeparator;
  var prefixVal = prefix !== undefined ? prefix : formatProps.prefix;
  var suffixVal = suffix !== undefined ? suffix : formatProps.suffix;
  var fixedDecimalPlaces = typeof decimalPlacesVal == "number" ? decimalPlacesVal : (decimalPlacesVal || {}).fixed;
  var valueString = decimalPlacesVal !== undefined && decimalPlacesVal !== null ? fixedDecimalPlaces !== undefined && fixedDecimalPlaces !== null ? num.toFixed(fixedDecimalPlaces) : num.toLocaleString(language, {
    minimumFractionDigits: (decimalPlacesVal || {}).min,
    maximumFractionDigits: (decimalPlacesVal || {}).max
  }) : num.toString();

  if (thousandSeparatorVal) {
    var parts = valueString.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    valueString = parts.join(".");
  }

  return /*#__PURE__*/React.createElement("span", {
    className: classnames("cin number-formatter", className)
  }, prefixVal, prefixVal && spaced && " ", valueString, suffixVal && spaced && " ", suffixVal);
};

NumberFormatter.propTypes = {
  /**
   * Value to format
   */
  value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),

  /**
   * Display format to render the reformatted value
   * @typedef formatMap
   * @property {string} `default` Number format with a thousand separator, no rounding
   * @property {string} `GBP` Currency format in British pounds sterling
   * @property {string} `USD` Currency format in US Dollars
   * @property {string} `EUR` Currency format in Euros
   * @property {string} `percentage` Percentage format rounded to 1 decimal place
   * @property {string} `kg` Weight format with a thousand separator
   */
  format: propTypes$1.oneOf(Object.keys(formatMap$3)),

  /**
   * Override the number of decimal places being displayed
   */
  decimalPlaces: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.object]),

  /**
   * Override whether the number is being shown with thousand separators
   */
  thousandSeparator: propTypes$1.bool,

  /**
   * Override the string being prepended to the reformatted value
   */
  prefix: propTypes$1.string,

  /**
   * Override the string being appended to the reformatted value
   */
  suffix: propTypes$1.string,

  /**
   * Optional, when true spaces any prefix/suffix from the value shown
   */
  spaced: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
     * Language to apply to formatting, if available the current value in app preferences is used by default, otherwise the language is determined by the client browser
     */
  language: propTypes$1.string
};
NumberFormatter.defaultProps = {
  format: "default",
  spaced: false
};

var mapStateToProps$9 = function mapStateToProps(state, ownProps) {
  return {
    language: ownProps.language || getPreferenceState(state).language
  };
};

var NumberFormatter$1 = connect$1(mapStateToProps$9)(NumberFormatter);

var Format = function Format(_ref) {
  var as = _ref.as,
      props = _objectWithoutProperties(_ref, ["as"]);

  var As = as;
  return /*#__PURE__*/React.createElement(As, props);
};

Format.Date = DateFormatter;
Format.DateTime = DateTimeFormatter;
Format.Time = TimeFormatter;
Format.Number = NumberFormatter$1;

var getActiveErrors = function getActiveErrors(errors, showAll) {
  var errorArray = errors || [];
  return !showAll && errorArray.length > 0 ? [errorArray[0]] : errorArray;
};

var FieldError = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldError, _React$Component);

  var _super = _createSuper(FieldError);

  function FieldError() {
    var _this;

    _classCallCheck(this, FieldError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      allErrors: [],
      activeErrors: getActiveErrors(_this.props.errors, _this.props.showAll)
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_fadeIn", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true; // only fade errors in after initial render + validation

      setTimeout(function () {
        if (_this._isMounted) _this._fadeIn = true;
      }, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    return _this;
  }

  _createClass(FieldError, [{
    key: "render",
    value: function render() {
      var animate = this.props.animate;
      var _this$state = this.state,
          allErrors = _this$state.allErrors,
          activeErrors = _this$state.activeErrors;
      var duration = this._fadeIn ? typeof animate === "number" ? animate : 500 : 0;
      return /*#__PURE__*/React.createElement(React.Fragment, null, allErrors.map(function (e, i) {
        if (!e) return null;
        var showError = activeErrors.includes(e);

        if (animate !== undefined && !!animate) {
          return /*#__PURE__*/React.createElement(Reveal, {
            visible: showError,
            duration: duration,
            key: i
          }, /*#__PURE__*/React.createElement("p", {
            className: "cin form-error"
          }, e));
        }

        return showError && /*#__PURE__*/React.createElement("p", {
          className: "cin form-error",
          key: e
        }, e);
      }));
    }
  }]);

  return FieldError;
}(React.Component);

_defineProperty(FieldError, "propTypes", {
  errors: propTypes$1.arrayOf(propTypes$1.string),
  showAll: propTypes$1.bool,
  animate: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.number])
});

_defineProperty(FieldError, "defaultProps", {
  showAll: true
});

_defineProperty(FieldError, "getDerivedStateFromProps", function (nextProps, prevState) {
  // manage error state for fluid animations
  var activeErrors = getActiveErrors(nextProps.errors, nextProps.showAll);
  var totalErrorsChanged = activeErrors.length !== prevState.activeErrors.length;
  var errorsChanged = totalErrorsChanged || activeErrors.some(function (e, i) {
    return e !== prevState.activeErrors[i];
  });
  if (!errorsChanged) return null; // same number of errors but at least one is different - swap out differences to avoid animation

  if (errorsChanged && !totalErrorsChanged) {
    return {
      allErrors: prevState.allErrors.map(function (e) {
        var activeIndex = prevState.activeErrors.findIndex(function (x) {
          return x === e;
        });
        return activeIndex >= 0 ? activeErrors[activeIndex] : null;
      }),
      activeErrors: activeErrors
    };
  }

  return {
    allErrors: [].concat(_toConsumableArray(prevState.allErrors), _toConsumableArray(activeErrors.filter(function (e) {
      return !prevState.allErrors.includes(e);
    }))),
    activeErrors: activeErrors
  };
});

var _templateObject$1, _templateObject2;
var Field = styled(function (props) {
  var renderReadOnly = props.renderReadOnly;
      props.width;
      props.fluid;
      var label = props.label,
      actions = props.actions,
      errors = props.errors,
      animateErrors = props.animateErrors,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["renderReadOnly", "width", "fluid", "label", "actions", "errors", "animateErrors", "children"]);

  return /*#__PURE__*/React.createElement(Form$1.Field, _extends({
    error: errors && errors.length > 0
  }, otherProps), label && (typeof label === "string" ? /*#__PURE__*/React.createElement("label", null, label) : label), typeof renderReadOnly === "function" ? /*#__PURE__*/React.createElement("div", {
    className: "read-only"
  }, renderReadOnly()) : children, actions && /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, actions), /*#__PURE__*/React.createElement(FieldError, {
    errors: errors,
    animate: animateErrors
  }));
})(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return props.width !== "initial" && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      .ui.input,\n      .ui.dropdown,\n      & > textarea,\n      .react-datepicker-wrapper,\n      .dropzone {\n        width: ", " !important;\n      }\n\n      & > .read-only {\n        max-width: ", " !important;\n      }\n\n      .react-datepicker-wrapper .react-datepicker__input-container,\n      .react-datepicker-wrapper .ui.input {\n        width: 100% !important;\n      }\n    "])), function (props) {
    return props.fluid || props.width === "fluid" ? "100%" : getCssCharacterWidth(props.width, "100%");
  }, function (props) {
    return props.fluid || props.width === "fluid" ? "100%" : getCssCharacterWidth(props.width, "100%");
  });
});
Field.defaultProps = {
  width: 30
};

var ClearButton = function ClearButton(props) {
  var onClick = props.onClick,
      className = props.className,
      disabled = props.disabled;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin form-clearer", className)
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    disabled: disabled,
    icon: "close",
    size: "tiny",
    circular: true,
    basic: true,
    type: "button"
  }));
};

/**
 * A form button to clear fields when clicked
 */
var FieldClearer = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldClearer, _React$Component);

  var _super = _createSuper(FieldClearer);

  function FieldClearer() {
    var _this;

    _classCallCheck(this, FieldClearer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getFields", function () {
      var _this$context$value = _this.context.value,
          value = _this$context$value === void 0 ? {} : _this$context$value;
      var field = _this.props.field;
      if (!field) return Object.keys(value);
      return Array.isArray(field) ? field : [field];
    });

    _defineProperty(_assertThisInitialized(_this), "canClear", function () {
      var _this$context$value2 = _this.context.value,
          value = _this$context$value2 === void 0 ? {} : _this$context$value2;

      var fields = _this.getFields();

      return fields.some(function (f) {
        return utils.isValueSet(value[f]);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var onChange = _this.context.onChange;

      var fields = _this.getFields();

      var applyChanges = function applyChanges(prevValue) {
        return fields.reduce(function (acc, f) {
          acc[f];
              var nextAcc = _objectWithoutProperties(acc, [f].map(_toPropertyKey));

          return nextAcc;
        }, prevValue);
      };

      if (onChange) {
        onChange(fields.length === 1 ? fields[0] : fields, undefined, applyChanges);
      }
    });

    return _this;
  }

  _createClass(FieldClearer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.field;
          var autoHide = _this$props.autoHide,
          disabled = _this$props.disabled,
          as = _this$props.as,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["field", "autoHide", "disabled", "as", "className"]);

      var canClear = this.canClear();
      if (autoHide && !canClear) return null;
      var Component = as || ClearButton;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClear,
        disabled: disabled || !canClear,
        className: className
      }));
    }
  }]);

  return FieldClearer;
}(React.Component);

_defineProperty(FieldClearer, "propTypes", {
  field: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.arrayOf(propTypes$1.string)]),
  autoHide: propTypes$1.bool,
  disabled: propTypes$1.bool,
  as: propTypes$1.elementType,
  className: propTypes$1.string
});

_defineProperty(FieldClearer, "defaultProps", {
  autoHide: true
});

_defineProperty(FieldClearer, "contextType", FormContext);

/**
 * Groups form fields together
 */
var FieldGroup = function FieldGroup(props) {
  var compact = props.compact,
      label = props.label,
      className = props.className,
      children = props.children,
      otherProps = _objectWithoutProperties(props, ["compact", "label", "className", "children"]);

  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Form$1.Field, null, /*#__PURE__*/React.createElement("label", null, label)), /*#__PURE__*/React.createElement(Form$1.Group, _extends({
    className: classnames({
      compact: compact
    }, className)
  }, otherProps), children));
};

FieldGroup.propTypes = {
  compact: propTypes$1.bool,
  label: propTypes$1.string,
  className: propTypes$1.string
};

var CheckboxBase = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxBase, _React$Component);

  var _super = _createSuper(CheckboxBase);

  function CheckboxBase() {
    var _this;

    _classCallCheck(this, CheckboxBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      return _this.props.onChange(!_this.props.value);
    });

    return _this;
  }

  _createClass(CheckboxBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(CheckboxBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        errors: errors !== undefined ? utils.fieldErrors(errors, showErrors, allErrors) : undefined,
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Checkbox$1, _extends({}, semanticProps, {
        checked: value,
        onChange: this.onChange,
        label: label,
        disabled: disabled
      })));
    }
  }]);

  return CheckboxBase;
}(React.Component);

_defineProperty(CheckboxBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  label: propTypes$1.node.isRequired
});

_defineProperty(CheckboxBase, "defaultProps", {
  value: false,
  onChange: function onChange() {}
});

var ConnectedCheckbox = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(CheckboxBase);
/**
 * Field for a single checkbox
 */

var Checkbox = function Checkbox(props) {
  return /*#__PURE__*/React.createElement(ConnectedCheckbox, props);
};

Checkbox.propTypes = {
  label: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Checkbox.defaultProps = {
  label: ""
};

var CheckboxGroupBase = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxGroupBase, _React$Component);

  var _super = _createSuper(CheckboxGroupBase);

  function CheckboxGroupBase() {
    var _this;

    _classCallCheck(this, CheckboxGroupBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      if (d.value === undefined) return;
      var currentValues = Array.isArray(_this.props.value) ? _this.props.value : [];
      var currentIndex = currentValues.indexOf(d.value);

      if (d.checked && currentIndex < 0) {
        _this.props.onChange([].concat(_toConsumableArray(currentValues), [d.value]));
      } else if (!d.checked && currentIndex >= 0) {
        _this.props.onChange(currentValues.filter(function (v) {
          return v !== d.value;
        }));
      }
    });

    return _this;
  }

  _createClass(CheckboxGroupBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          options = _this$props.options,
          inline = _this$props.inline;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(CheckboxGroupBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, options.map(function (o) {
        var isChecked = Array.isArray(value) && value.indexOf(o.value) >= 0;
        return /*#__PURE__*/React.createElement(Checkbox$1, _extends({}, semanticProps, {
          key: o.key || o.value,
          checked: isChecked,
          onChange: _this2.onChange,
          label: o.text,
          value: o.value,
          disabled: disabled
        }));
      }));
    }
  }]);

  return CheckboxGroupBase;
}(React.Component);

_defineProperty(CheckboxGroupBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  inline: propTypes$1.bool.isRequired,
  options: propTypes$1.arrayOf(propTypes$1.shape({
    key: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
    text: propTypes$1.node
  })).isRequired,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  label: propTypes$1.node.isRequired
});

_defineProperty(CheckboxGroupBase, "defaultProps", {
  value: [],
  onChange: function onChange() {}
});

var ConnectedCheckboxGroup = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(CheckboxGroupBase);
/**
 * Field for a group of checkboxes
 */

var CheckboxGroup = function CheckboxGroup(props) {
  return /*#__PURE__*/React.createElement(ConnectedCheckboxGroup, props);
};

CheckboxGroup.propTypes = {
  label: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  options: propTypes$1.arrayOf(propTypes$1.shape({
    key: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
    text: propTypes$1.node
  })).isRequired,
  inline: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
CheckboxGroup.defaultProps = {
  label: "",
  inline: false
};

var CheckboxTreeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(CheckboxTreeBase, _React$Component);

  var _super = _createSuper(CheckboxTreeBase);

  function CheckboxTreeBase() {
    var _this;

    _classCallCheck(this, CheckboxTreeBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "hasChildren", function (node) {
      return !!node.children && node.children.length > 0;
    });

    _defineProperty(_assertThisInitialized(_this), "getLeafValuesRecursive", function (node) {
      var includeDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!_this.hasChildren(node)) {
        return includeDisabled || !node.disabled ? [node.value] : [];
      }

      return node.children.reduce(function (acc, c) {
        if (_this.hasChildren(c)) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(_this.getLeafValuesRecursive(c, includeDisabled)));
        } else {
          return includeDisabled || !c.disabled ? [].concat(_toConsumableArray(acc), [c.value]) : acc;
        }
      }, []);
    });

    _defineProperty(_assertThisInitialized(_this), "getIndeterminateState", function (node) {
      // an indeterminate node is one where it's children are partially selected
      var value = _this.props.value;
      var currentValues = Array.isArray(value) ? value : [];

      var leafValues = _this.getLeafValuesRecursive(node);

      var selectedLeafValues = leafValues.filter(function (v) {
        return currentValues.includes(v);
      });
      if (selectedLeafValues.length === 0) return 0; // none

      if (selectedLeafValues.length < leafValues.length) return 1; // partial

      return 2; // all
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (node, checked) {
      var value = _this.props.value;
      var currentValues = Array.isArray(value) ? value : [];

      var leafValues = _this.getLeafValuesRecursive(node);

      if (checked) {
        var missingValues = leafValues.filter(function (v) {
          return !currentValues.includes(v);
        });

        _this.props.onChange([].concat(_toConsumableArray(currentValues), _toConsumableArray(missingValues)));
      } else {
        var newValues = currentValues.filter(function (v) {
          return !leafValues.includes(v);
        });

        _this.props.onChange(newValues);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderNode", function (node) {
      var disabled = _this.props.disabled;

      var indeterminateState = _this.getIndeterminateState(node);

      return /*#__PURE__*/React.createElement(Checkbox$1, {
        indeterminate: indeterminateState === 1,
        checked: indeterminateState === 2,
        onChange: function onChange(e, d) {
          return _this.onChange(node, d.checked);
        },
        label: node.text,
        value: node.value,
        disabled: disabled || node.disabled
      });
    });

    return _this;
  }

  _createClass(CheckboxTreeBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          nodes = _this$props.nodes;
      var otherProps = utils.omitProps(passThruProps, Object.keys(CheckboxTreeBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(TreeView, _extends({}, otherProps, {
        nodes: nodes,
        nodeKey: "value",
        renderNode: this.renderNode
      })));
    }
  }]);

  return CheckboxTreeBase;
}(React.Component);

_defineProperty(CheckboxTreeBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  nodes: propTypes$1.arrayOf(propTypes$1.shape({
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
    text: propTypes$1.node,
    children: propTypes$1.arrayOf(propTypes$1.shape({
      value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
      text: propTypes$1.node,
      children: propTypes$1.arrayOf(propTypes$1.shape({
        value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
        text: propTypes$1.node,
        children: propTypes$1.arrayOf(propTypes$1.object),
        defaultExpanded: propTypes$1.bool,
        className: propTypes$1.string,
        disabled: propTypes$1.bool
      })),
      defaultExpanded: propTypes$1.bool,
      className: propTypes$1.string,
      disabled: propTypes$1.bool
    })),
    defaultExpanded: propTypes$1.bool,
    className: propTypes$1.string,
    disabled: propTypes$1.bool
  })).isRequired,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  label: propTypes$1.node.isRequired
});

_defineProperty(CheckboxTreeBase, "defaultProps", {
  value: [],
  onChange: function onChange() {}
});

var ConnectedCheckboxTree = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(CheckboxTreeBase);
/**
 * Field for a tree-view of checkboxes
 */

var CheckboxTree = function CheckboxTree(props) {
  return /*#__PURE__*/React.createElement(ConnectedCheckboxTree, props);
};

CheckboxTree.propTypes = {
  label: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  nodes: propTypes$1.arrayOf(propTypes$1.shape({
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
    text: propTypes$1.node,
    children: propTypes$1.arrayOf(propTypes$1.shape({
      value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
      text: propTypes$1.node,
      children: propTypes$1.arrayOf(propTypes$1.shape({
        value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]).isRequired,
        text: propTypes$1.node,
        children: propTypes$1.arrayOf(propTypes$1.object),
        defaultExpanded: propTypes$1.bool,
        className: propTypes$1.string,
        disabled: propTypes$1.bool
      })),
      defaultExpanded: propTypes$1.bool,
      className: propTypes$1.string,
      disabled: propTypes$1.bool
    })),
    defaultExpanded: propTypes$1.bool,
    className: propTypes$1.string,
    disabled: propTypes$1.bool
  })).isRequired,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
CheckboxTree.defaultProps = {
  label: ""
};

var DateFieldBase = /*#__PURE__*/function (_React$Component) {
  _inherits(DateFieldBase, _React$Component);

  var _super = _createSuper(DateFieldBase);

  function DateFieldBase() {
    _classCallCheck(this, DateFieldBase);

    return _super.apply(this, arguments);
  }

  _createClass(DateFieldBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          instant = _this$props.instant,
          local = _this$props.local;
      var otherProps = utils.omitProps(passThruProps, Object.keys(DateFieldBase.propTypes));
      var DateComponent = instant ? DateInstant$1 : local ? DateLocal : null;

      if (!DateComponent) {
        console.error("Form Date field must have instant or local prop specified");
        return null;
      }

      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(DateComponent, _extends({}, otherProps, {
        value: value,
        onChange: onChange,
        disabled: disabled
      })));
    }
  }]);

  return DateFieldBase;
}(React.Component);

_defineProperty(DateFieldBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  local: propTypes$1.bool,
  instant: propTypes$1.bool,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  label: propTypes$1.node.isRequired
});

_defineProperty(DateFieldBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedDateField = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(DateFieldBase);
/**
 * Field for choosing a date
 */

var DateField = function DateField(props) {
  return /*#__PURE__*/React.createElement(ConnectedDateField, props);
};

DateField.propTypes = {
  label: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  instant: propTypes$1.bool,
  local: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
DateField.defaultProps = {
  label: "",
  inline: false
};

var DateTimeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(DateTimeBase, _React$Component);

  var _super = _createSuper(DateTimeBase);

  function DateTimeBase() {
    _classCallCheck(this, DateTimeBase);

    return _super.apply(this, arguments);
  }

  _createClass(DateTimeBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          instant = _this$props.instant,
          local = _this$props.local;
      var otherProps = utils.omitProps(passThruProps, Object.keys(DateTimeBase.propTypes));
      var DateTimeComponent = instant ? DateTimeInstant$1 : local ? DateTimeLocal : null;

      if (!DateTimeComponent) {
        console.error("Form Date field must have instant or local prop specified");
        return null;
      }

      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(DateTimeComponent, _extends({}, otherProps, {
        value: value,
        onChange: onChange,
        disabled: disabled
      })));
    }
  }]);

  return DateTimeBase;
}(React.Component);

_defineProperty(DateTimeBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  local: propTypes$1.bool,
  instant: propTypes$1.bool,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  label: propTypes$1.node.isRequired
});

_defineProperty(DateTimeBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedDateTime = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(DateTimeBase);
/**
 * Field for choosing a date and time
 */

var DateTime = function DateTime(props) {
  return /*#__PURE__*/React.createElement(ConnectedDateTime, props);
};

DateTime.propTypes = {
  label: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  instant: propTypes$1.bool,
  local: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
DateTime.defaultProps = {
  label: "",
  inline: false
};

var validOptionKeys = ["as", "active", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"];
var filterDropdownItemProps = function filterDropdownItemProps(item) {
  return validOptionKeys.reduce(function (acc, k) {
    if (item.hasOwnProperty(k)) acc[k] = item[k];
    return acc;
  }, {});
};

var HiddenOption = function HiddenOption() {
  return /*#__PURE__*/React.createElement("div", null);
};
/**
 * Wrapper around Semantic UI Dropdown providing lookup data connectivity
 * in the form of a list of selectable options
 */


var LookupDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(LookupDropdown, _React$Component);

  var _super = _createSuper(LookupDropdown);

  function LookupDropdown() {
    var _this;

    _classCallCheck(this, LookupDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedOptions: []
    });

    _defineProperty(_assertThisInitialized(_this), "isValidValue", function (value) {
      return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== "";
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          value = _this$props.value,
          lookupRequest = _this$props.lookupRequest,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          lookupOptions = _this$props.lookupOptions,
          lookupData = _this$props.lookupData;

      var hasValue = _this.isValidValue(value);

      if (!hasValue && _this.state.selectedOptions.length > 0) {
        // if value cleared remove selection
        _this.setState({
          selectedOptions: []
        });
      } // re-request if lookup was reset or params changed


      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams))) {
        lookupRequest(lookup, lookupParams, lookupOptions);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      var onChange = _this.props.onChange;
      var value = d.value,
          options = d.options;

      var hasValue = _this.isValidValue(value);

      if (hasValue && options) {
        // selected options may not be in the options list if re-requested,
        // so store and re-add when rendered
        var selectedValues = Array.isArray(value) ? value : [value];
        var selectedOptions = options.filter(function (o) {
          return selectedValues.includes(o.value);
        });

        _this.setState({
          selectedOptions: selectedOptions
        });
      }

      if (onChange) onChange(e, d);
    });

    return _this;
  }

  _createClass(LookupDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          lookupRequest = _this$props2.lookupRequest,
          lookup = _this$props2.lookup,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions;
      if (!lookup) return;
      lookupRequest(lookup, lookupParams, lookupOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props;
          _this$props3.lookup;
          _this$props3.lookupAction;
          _this$props3.lookupParams;
          _this$props3.lookupOptions;
          var lookupData = _this$props3.lookupData;
          _this$props3.lookupRequest;
          var unknownValueText = _this$props3.unknownValueText,
          unknownValueOptions = _this$props3.unknownValueOptions,
          otherProps = _objectWithoutProperties(_this$props3, ["lookup", "lookupAction", "lookupParams", "lookupOptions", "lookupData", "lookupRequest", "unknownValueText", "unknownValueOptions"]);

      var selectedOptions = this.state.selectedOptions;
      var options = lookupData.response || [];
      var text = undefined;
      var unknownValue = otherProps.value && (!options || options.length === 0 || !options.find(function (o) {
        return o.value === otherProps.value;
      }));

      if (unknownValue) {
        if (unknownValueOptions) {
          var unknownOptions = typeof unknownValueOptions === "function" ? unknownValueOptions(otherProps.value, options) : unknownValueOptions;
          options = [].concat(_toConsumableArray(options), _toConsumableArray(unknownOptions.filter(function (x) {
            return x.value && x.text;
          }).map(function (x) {
            return _objectSpread2(_objectSpread2({}, x), {}, {
              as: HiddenOption
            });
          })));
        }

        if (unknownValueText) {
          text = typeof unknownValueText === "function" ? unknownValueText(otherProps.value, options) : unknownValueText;
        }
      } // combine previously selected options + distinct


      options = [].concat(_toConsumableArray(options), _toConsumableArray(selectedOptions)).filter(function (o, idx, arr) {
        return arr.findIndex(function (x) {
          return x.value === o.value;
        }) === idx;
      });
      var validOptions = options.map(function (o) {
        return filterDropdownItemProps(o);
      });
      return /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, otherProps, {
        loading: lookupData.loading && lookupData.slowLoading,
        options: validOptions,
        text: text,
        onChange: function onChange(e, d) {
          return _this2.onChange(e, _objectSpread2(_objectSpread2({}, d), {}, {
            options: options
          }));
        }
      }));
    }
  }]);

  return LookupDropdown;
}(React.Component);

_defineProperty(LookupDropdown, "propTypes", {
  /**
   * Optional additional options to use when the current value if not one of the options from the lookup
   * These will enable unknown values to be displayed, but will remain hidden unless they are a valid lookup option
   * (a typical case for this is when the initial value was not in the lookup response)
   */
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.array, propTypes$1.func]),

  /**
   * Optional text to display when the current value is not one of the options from the lookup
   * unknownValueOptions should be preferred, especially for multiple typeaheads
   * (a typical case for this is when the initial value was not in the lookup response)
   */
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  // -------------------
  // withLookup props
  // -------------------

  /**
   * A lookup that has already been registered, not required when using the lookupAction prop
   */
  lookup: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.object]),

  /**
   * Optional API action creator to get lookup data, if specified a temporary lookup will be automatically registered instead of the one supplied to the lookup prop.
   * Useful shortcut for single instances of components where caching is not important.
   * For multiple instances or shared components, and to gain the benefits of caching, prefer the lookup prop instead.
   */
  lookupAction: propTypes$1.func,

  /**
   * Optional additional parameters to supply to the lookup's action
   */
  lookupParams: propTypes$1.any,

  /**
   * Optional additional configuration options for requesting or resetting the lookup data
   */
  lookupOptions: propTypes$1.object
});

var mapStateToProps$a = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: getLookupData(state, lookup, lookupParams, lookupOptions)
  };
};

var actions$4 = {
  lookupRequest: lookupRequest
};
var LookupDropdown$1 = compose(withLookup({
  autoNamePrefix: "LookupDropdown/"
}), connect$1(mapStateToProps$a, actions$4))(LookupDropdown);

var HiddenOption$1 = function HiddenOption() {
  return /*#__PURE__*/React.createElement("div", null);
};
/**
 * Wrapper around Semantic UI Dropdown providing lookup data connectivity
 * in the form of a searchable list of options
 */


var LookupTypeAhead = /*#__PURE__*/function (_React$Component) {
  _inherits(LookupTypeAhead, _React$Component);

  var _super = _createSuper(LookupTypeAhead);

  function LookupTypeAhead(props) {
    var _this;

    _classCallCheck(this, LookupTypeAhead);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      lookupKey: null,
      previousKey: null,
      previousSearch: null,
      selectedOptions: [],
      additionalOptions: []
    });

    _defineProperty(_assertThisInitialized(_this), "updateDropdownDirection", function () {
      if (!_this.dropdownRef) return;
      var current = _this.dropdownRef.current;
      if (!current) return;
      if (current.setOpenDirection) current.setOpenDirection();
      if (current.scrollSelectedItemIntoView) current.scrollSelectedItemIntoView();
    });

    _defineProperty(_assertThisInitialized(_this), "updateSearchSuggestions", function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var searchSuggestions = _this.props.searchSuggestions;

      if (searchSuggestions || searchSuggestions === "") {
        _this.onSearchChange(null, {
          forceSuggestions: force
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isValidValue", function (value) {
      return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== "";
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$state = _this.state,
          lookupKey = _this$state.lookupKey,
          previousSearch = _this$state.previousSearch,
          selectedOptions = _this$state.selectedOptions;
      var prevData = prevProps.lookupCache[lookupKey] || {};
      var currentData = _this.props.lookupCache[lookupKey] || {};

      if (!currentData.loading && prevData.loading) {
        _this.updateDropdownDirection();
      }

      var hasValue = _this.isValidValue(_this.props.value);

      if (!hasValue && selectedOptions.length > 0) {
        // if value cleared remove selection
        _this.setState({
          selectedOptions: []
        });

        if (previousSearch) {
          _this.updateSearchSuggestions(true);
        }
      } // re-request if lookup was reset or params changed


      if (previousSearch !== null && (!currentData.date && prevData.date || !compareParams(_this.props.lookupParams, prevProps.lookupParams))) {
        _this.onSearchChange(null, {
          searchQuery: previousSearch,
          forceSuggestions: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (options) {
      var additionalOptions = _this.state.additionalOptions;
      var additionalValues = additionalOptions.map(function (o) {
        return o.value;
      });
      return options.filter(function (o) {
        return !additionalValues.includes(o.value);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchChange", function (e, _ref) {
      var searchQuery = _ref.searchQuery,
          forceSuggestions = _ref.forceSuggestions;
      var lookupKey = null;
      var search = searchQuery;
      var validRequest = !!search;

      if (!validRequest) {
        var _this$props = _this.props,
            searchSuggestions = _this$props.searchSuggestions,
            value = _this$props.value;

        var hasValue = _this.isValidValue(value);

        if ((!hasValue || forceSuggestions) && (searchSuggestions || searchSuggestions === "")) {
          search = typeof searchSuggestions === "string" ? searchSuggestions : "";
          validRequest = true;
        }
      }

      if (validRequest) {
        var _this$props2 = _this.props,
            _lookupRequest = _this$props2.lookupRequest,
            lookup = _this$props2.lookup,
            lookupParams = _this$props2.lookupParams,
            lookupOptions = _this$props2.lookupOptions;
        if (!lookup) return;

        var params = _objectSpread2(_objectSpread2({}, lookupParams), {}, {
          search: search
        });

        lookupKey = getParamsKey(params);

        var options = _objectSpread2(_objectSpread2({}, lookupOptions), {}, {
          key: lookupKey
        });

        _lookupRequest(lookup, params, options);

        _this.setState({
          previousSearch: search
        });
      }

      _this.setState({
        lookupKey: lookupKey,
        previousKey: _this.state.lookupKey
      });

      _this.updateDropdownDirection();
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      var onChange = _this.props.onChange;
      var value = d.value,
          options = d.options;

      var hasValue = _this.isValidValue(value);

      if (hasValue && options) {
        // selected options may not be in the options list on the next search,
        // so store and re-add when rendered
        var selectedValues = Array.isArray(value) ? value : [value];
        var selectedOptions = options.filter(function (o) {
          return selectedValues.includes(o.value);
        });

        _this.setState({
          selectedOptions: selectedOptions
        });
      }

      var additionalOptions = _this.state.additionalOptions;

      if (additionalOptions.every(function (o) {
        return o.value !== value;
      })) {
        // clear additional options from the options list if no longer needed
        _this.setState({
          additionalOptions: []
        });
      }

      if (onChange) onChange(e, d);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e, d) {
      // when leaving the field repopulate suggestions
      if (_this.state.previousSearch) {
        _this.updateSearchSuggestions(_this.props.alwaysShowSuggestionsOnBlur);
      }

      var onBlur = _this.props.onBlur;
      if (onBlur) onBlur(e, d);
    });

    _defineProperty(_assertThisInitialized(_this), "onAddItem", function (e, _ref2) {
      var value = _ref2.value;

      _this.setState({
        additionalOptions: [{
          value: value,
          text: value
        }]
      });
    });

    _this.debouncedSearchChange = debounce(_this.onSearchChange, props.debounce);
    _this.dropdownRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(LookupTypeAhead, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSearchSuggestions(this.props.alwaysShowSuggestionsOnMount);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props;
          _this$props3.lookup;
          _this$props3.lookupAction;
          _this$props3.lookupParams;
          _this$props3.lookupOptions;
          var lookupCache = _this$props3.lookupCache;
          _this$props3.lookupRequest;
          var unknownValueText = _this$props3.unknownValueText,
          unknownValueOptions = _this$props3.unknownValueOptions;
          _this$props3.searchSuggestions;
          _this$props3.alwaysShowSuggestionsOnBlur;
          _this$props3.alwaysShowSuggestionsOnMount;
          var otherProps = _objectWithoutProperties(_this$props3, ["lookup", "lookupAction", "lookupParams", "lookupOptions", "lookupCache", "lookupRequest", "unknownValueText", "unknownValueOptions", "searchSuggestions", "alwaysShowSuggestionsOnBlur", "alwaysShowSuggestionsOnMount"]);

      var _this$state2 = this.state,
          lookupKey = _this$state2.lookupKey,
          previousKey = _this$state2.previousKey,
          selectedOptions = _this$state2.selectedOptions,
          additionalOptions = _this$state2.additionalOptions;
      var lookupData = lookupCache[lookupKey] || {};
      var previousData = lookupCache[previousKey] || {};
      var options = lookupData.loading ? previousData.response || [] : lookupData.response || [];
      var text = undefined;
      var unknownValue = otherProps.value && (!options || options.length === 0 || !options.find(function (o) {
        return o.value === otherProps.value;
      }));

      if (unknownValue) {
        if (unknownValueOptions) {
          var unknownOptions = typeof unknownValueOptions === "function" ? unknownValueOptions(otherProps.value, options) : unknownValueOptions;
          options = [].concat(_toConsumableArray(options), _toConsumableArray(unknownOptions.filter(function (x) {
            return x.value && x.text;
          }).map(function (x) {
            return _objectSpread2(_objectSpread2({}, x), {}, {
              as: HiddenOption$1
            });
          })));
        }

        if (unknownValueText) {
          text = typeof unknownValueText === "function" ? unknownValueText(otherProps.value, options) : unknownValueText;
        }
      } // combine previously selected options + distinct


      options = [].concat(_toConsumableArray(options), _toConsumableArray(selectedOptions), _toConsumableArray(additionalOptions)).filter(function (o, idx, arr) {
        return arr.findIndex(function (x) {
          return x.value === o.value;
        }) === idx;
      });
      var validOptions = options.map(function (o) {
        return filterDropdownItemProps(o);
      });
      return /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, otherProps, {
        ref: this.dropdownRef,
        loading: lookupData.loading && lookupData.slowLoading,
        options: validOptions,
        text: text,
        search: this.onSearch,
        onSearchChange: this.debouncedSearchChange,
        onChange: function onChange(e, d) {
          return _this2.onChange(e, _objectSpread2(_objectSpread2({}, d), {}, {
            options: options
          }));
        },
        onBlur: this.onBlur,
        onAddItem: this.onAddItem,
        noResultsMessage: lookupKey ? "No results found" : "Search..."
      }));
    }
  }]);

  return LookupTypeAhead;
}(React.Component);

_defineProperty(LookupTypeAhead, "propTypes", {
  /**
   * Optional time in milliseconds to debounce the lookup request, default 200ms
   */
  debounce: propTypes$1.number,

  /**
   * Optional additional options to use when the current value if not one of the options from the lookup
   * These will enable unknown values to be displayed, but will remain hidden unless they are a valid lookup option
   * (a typical case for this is when a value exists but no search has been made)
   */
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.array, propTypes$1.func]),

  /**
   * Optional text to display when the current value is not one of the options from the lookup search
   * unknownValueOptions should be preferred, especially for multiple typeaheads
   * (a typical case for this is when a value exists but no search has been made)
   */
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),

  /**
   * Whether the typeahead should be pre-populated with suggested options when no search has been made
   * Can be a boolean value, or a string to search on
   * Note that if the typeahead already has a value when initialized, no search will take place.
   */
  searchSuggestions: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.string]),

  /**
   * Optional flag to always show search suggestions after focus is lost
   */
  alwaysShowSuggestionsOnBlur: propTypes$1.bool,

  /**
   * Optional flag to always show search suggestions after component is first loaded
   */
  alwaysShowSuggestionsOnMount: propTypes$1.bool,
  // -------------------
  // withLookup props
  // -------------------

  /**
   * A lookup that has already been registered, not required when using the lookupAction prop
   */
  lookup: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.object]),

  /**
   * Optional API action creator to get lookup data, if specified a temporary lookup will be automatically registered instead of the one supplied to the lookup prop.
   * Useful shortcut for single instances of components where caching is not important.
   * For multiple instances or shared components, and to gain the benefits of caching, prefer the lookup prop instead.
   */
  lookupAction: propTypes$1.func,

  /**
   * Optional additional parameters to supply to the lookup's action
   */
  lookupParams: propTypes$1.object,

  /**
   * Optional additional configuration options for requesting or resetting the lookup data
   */
  lookupOptions: propTypes$1.object
});

_defineProperty(LookupTypeAhead, "defaultProps", {
  lookupOptions: {
    cache: true,
    cacheLimit: 5
  },
  debounce: 200,
  alwaysShowSuggestionsOnBlur: false,
  alwaysShowSuggestionsOnMount: true
});

var mapStateToProps$b = function mapStateToProps(state, _ref3) {
  var lookup = _ref3.lookup;
  return {
    lookupCache: getLookupCache(state, lookup)
  };
};

var actions$5 = {
  lookupRequest: lookupRequest
};
var LookupTypeAhead$1 = compose(withLookup({
  autoNamePrefix: "LookupTypeAhead/"
}), connect$1(mapStateToProps$b, actions$5))(LookupTypeAhead);

var DropdownBase = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownBase, _React$Component);

  var _super = _createSuper(DropdownBase);

  function DropdownBase() {
    var _this;

    _classCallCheck(this, DropdownBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      var _this$props = _this.props,
          textField = _this$props.textField,
          optionField = _this$props.optionField,
          multiple = _this$props.multiple;
      var value = d.value,
          options = d.options;
      var additionalFormData = {}; // if textField specified store the selected text

      if (textField) {
        if (value && options) {
          var selectedValues = Array.isArray(value) ? value : [value];
          var selectedText = selectedValues.map(function (v) {
            var _options$find$text, _options$find;

            return (_options$find$text = (_options$find = options.find(function (o) {
              return o.value === v;
            })) === null || _options$find === void 0 ? void 0 : _options$find.text) !== null && _options$find$text !== void 0 ? _options$find$text : v;
          });
          additionalFormData[textField] = !multiple && selectedText.length === 1 ? selectedText[0] : selectedText;
        } else {
          additionalFormData[textField] = multiple ? [] : "";
        }
      } // if optionField specified store the entire value object


      if (optionField) {
        if (value && options) {
          var _selectedValues = Array.isArray(value) ? value : [value];

          var selectedOptions = _selectedValues.map(function (v) {
            var _options$find2;

            return (_options$find2 = options.find(function (o) {
              return o.value === v;
            })) !== null && _options$find2 !== void 0 ? _options$find2 : null;
          });

          additionalFormData[optionField] = !multiple && selectedOptions.length === 1 ? selectedOptions[0] : selectedOptions;
        } else {
          additionalFormData[optionField] = multiple ? [] : {};
        }
      }

      _this.props.onChange(value, additionalFormData);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value,
          textField = _ref.textField,
          formState = _ref.formState,
          options = _ref.options;
      var valueArray = Array.isArray(value) ? value : [value];

      if (textField && formState.fields[textField]) {
        var text = formState.fields[textField];
        var textArray = Array.isArray(text) ? text : [text];

        if (valueArray.length === textArray.length) {
          valueArray = textArray;
        }
      } else if (Array.isArray(options)) {
        valueArray = valueArray.map(function (v) {
          var _o$value;

          var o = options.find(function (x) {
            return x.value === v;
          });
          return typeof (o === null || o === void 0 ? void 0 : o.text) === "string" || typeof (o === null || o === void 0 ? void 0 : o.text) === "number" || typeof (o === null || o === void 0 ? void 0 : o.text) === "boolean" ? o.text : (_o$value = o === null || o === void 0 ? void 0 : o.value) !== null && _o$value !== void 0 ? _o$value : v;
        });
      }

      return /*#__PURE__*/React.createElement("p", null, valueArray.filter(function (v) {
        return v !== null && v !== undefined && v !== "";
      }).join(", "));
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    return _this;
  }

  _createClass(DropdownBase, [{
    key: "render",
    value: function render() {
      var multiple = this.props.multiple;
      var _this$props2 = this.props,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? multiple ? [] : "" : _this$props2$value;
          _this$props2.onChange;
          var errors = _this$props2.errors,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          label = _this$props2.label,
          actions = _this$props2.actions,
          inline = _this$props2.inline,
          width = _this$props2.width,
          fluid = _this$props2.fluid,
          required = _this$props2.required,
          passThruProps = _this$props2.passThruProps,
          formState = _this$props2.formState,
          selectOnBlur = _this$props2.selectOnBlur,
          selection = _this$props2.selection,
          lookup = _this$props2.lookup,
          lookupAction = _this$props2.lookupAction,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions,
          unknownValueOptions = _this$props2.unknownValueOptions,
          unknownValueText = _this$props2.unknownValueText,
          textField = _this$props2.textField;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(DropdownBase.propTypes));
      var safeValue = value !== null ? value : multiple ? [] : ""; // auto-infer unknown value options when textField specified

      var inferredValueOptions = undefined;

      if (textField && value && formState.fields[textField]) {
        var text = formState.fields[textField];
        var textArray = Array.isArray(text) ? text : [text];
        var valueArray = Array.isArray(value) ? value : [value];

        if (valueArray.length === textArray.length) {
          inferredValueOptions = valueArray.map(function (v, i) {
            return {
              value: v,
              text: textArray[i]
            };
          });
        }
      }

      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, lookup || lookupAction ? /*#__PURE__*/React.createElement(LookupDropdown$1, _extends({}, semanticProps, {
        value: safeValue,
        onChange: this.onChange,
        selectOnBlur: selectOnBlur,
        selection: selection,
        lookup: lookup,
        lookupAction: lookupAction,
        lookupParams: typeof lookupParams === "function" ? lookupParams(formState) : lookupParams,
        lookupOptions: typeof lookupOptions === "function" ? lookupOptions(formState) : lookupOptions,
        unknownValueOptions: typeof unknownValueOptions === "function" ? unknownValueOptions(formState) : unknownValueOptions || inferredValueOptions,
        unknownValueText: typeof unknownValueText === "function" ? unknownValueText(formState) : unknownValueText,
        disabled: disabled
      })) : /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, semanticProps, {
        value: safeValue,
        onChange: this.onChange,
        selectOnBlur: selectOnBlur,
        selection: selection,
        disabled: disabled
      })));
    }
  }]);

  return DropdownBase;
}(React.Component);

_defineProperty(DropdownBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  optionField: propTypes$1.string,
  textField: propTypes$1.string,
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.arrayOf(propTypes$1.any), propTypes$1.func]),
  lookupOptions: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupParams: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupAction: propTypes$1.func,
  lookup: propTypes$1.any,
  selection: propTypes$1.bool.isRequired,
  selectOnBlur: propTypes$1.bool.isRequired,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(DropdownBase, "defaultProps", {
  onChange: function onChange() {}
});

var ConnectedDropdown = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(DropdownBase);
/**
 * Field for a dropdown menu
 */

var Dropdown = function Dropdown(props) {
  return /*#__PURE__*/React.createElement(ConnectedDropdown, props);
};

Dropdown.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  selectOnBlur: propTypes$1.bool,
  selection: propTypes$1.bool,
  lookup: propTypes$1.any,
  lookupAction: propTypes$1.func,
  lookupParams: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupOptions: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.arrayOf(propTypes$1.any), propTypes$1.func]),
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  textField: propTypes$1.string,
  optionField: propTypes$1.string,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Dropdown.defaultProps = {
  label: "",
  inline: false,
  selectOnBlur: false,
  selection: true
};

var EmailBase = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailBase, _React$Component);

  var _super = _createSuper(EmailBase);

  function EmailBase() {
    var _this;

    _classCallCheck(this, EmailBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      return _this.props.onChange(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value,
          errors = _ref.errors;

      if (!errors || !errors.length) {
        return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
          href: "mailto:".concat(value)
        }, value));
      }

      return /*#__PURE__*/React.createElement("p", null, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    return _this;
  }

  _createClass(EmailBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value;
          _this$props.onChange;
          var errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          label = _this$props.label,
          actions = _this$props.actions,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(EmailBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Input$1, _extends({}, semanticProps, {
        value: value !== null ? value : "",
        onChange: this.onChange,
        disabled: disabled
      })));
    }
  }]);

  return EmailBase;
}(React.Component);

_defineProperty(EmailBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  emailError: propTypes$1.string,
  emailValidation: propTypes$1.bool.isRequired,
  confirmFieldError: propTypes$1.string,
  confirmField: propTypes$1.string,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(EmailBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedEmail = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.minLength(), index$1.maxLength(), index$1.confirmField(), index$1.emailAddress(true)]
})(EmailBase);
/**
 * Field for an email address
 */

var Email = function Email(props) {
  return /*#__PURE__*/React.createElement(ConnectedEmail, props);
};

Email.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  confirmField: propTypes$1.string,
  confirmFieldError: propTypes$1.string,
  emailValidation: propTypes$1.bool,
  emailError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Email.defaultProps = {
  label: "",
  inline: false,
  emailValidation: true
};

var InputBase = /*#__PURE__*/function (_React$Component) {
  _inherits(InputBase, _React$Component);

  var _super = _createSuper(InputBase);

  function InputBase(props) {
    var _this;

    _classCallCheck(this, InputBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "applyChangeDebounced", function (_) {});

    _defineProperty(_assertThisInitialized(_this), "applyChange", function (value) {
      if (_this.props.value === value) return;

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.setState({
        val: e.target.value
      }, function () {
        _this.applyChangeDebounced(_this.state.val);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      _this.applyChange(_this.state.val);

      if (_this.props.onBlur) _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value,
          subLabel = _ref.subLabel,
          subLabelPosition = _ref.subLabelPosition;

      if (subLabel) {
        var right = subLabelPosition === "right" || subLabelPosition === "right corner";
        return /*#__PURE__*/React.createElement("p", null, !right && subLabel + " ", value, right && " " + subLabel);
      }

      return /*#__PURE__*/React.createElement("p", null, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    _this.state = {
      val: props.value,
      prev: props.value
    };
    _this.applyChangeDebounced = props.debounce !== undefined ? debounce(_this.applyChange, props.debounce) : _this.applyChange;
    return _this;
  }

  _createClass(InputBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.value;
          _this$props.onChange;
          var errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          label = _this$props.label,
          actions = _this$props.actions,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          subLabel = _this$props.subLabel,
          subLabelPosition = _this$props.subLabelPosition,
          passThruProps = _this$props.passThruProps;
      var val = this.state.val;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(InputBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: errors !== undefined ? utils.fieldErrors(errors, showErrors, allErrors) : undefined,
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Input$1, _extends({}, semanticProps, {
        label: subLabel,
        labelPosition: subLabelPosition,
        value: val !== null ? val : "",
        onChange: this.onChange,
        onBlur: this.onBlur,
        disabled: disabled
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // apply external value changes
      if (props.value !== state.prev && props.value !== state.val) {
        return {
          val: props.value,
          prev: props.value
        };
      }

      return {
        prev: props.value
      };
    }
  }]);

  return InputBase;
}(React.Component);

_defineProperty(InputBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  confirmFieldError: propTypes$1.string,
  confirmField: propTypes$1.string,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  debounce: propTypes$1.number,
  renderReadOnly: propTypes$1.func,
  subLabelPosition: propTypes$1.oneOf(["left", "right", "left corner", "right corner"]),
  subLabel: propTypes$1.node,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(InputBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedInput = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.minLength(), index$1.maxLength(), index$1.confirmField()]
})(InputBase);
/**
 * Field for a single line of text
 */

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(ConnectedInput, props);
};

Input.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  subLabel: propTypes$1.node,
  subLabelPosition: propTypes$1.oneOf(["left", "right", "left corner", "right corner"]),
  renderReadOnly: propTypes$1.func,
  debounce: propTypes$1.number,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  confirmField: propTypes$1.string,
  confirmFieldError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Input.defaultProps = {
  label: "",
  inline: false
};

var NumericBase = /*#__PURE__*/function (_React$Component) {
  _inherits(NumericBase, _React$Component);

  var _super = _createSuper(NumericBase);

  function NumericBase(props) {
    var _this;

    _classCallCheck(this, NumericBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "applyChangeDebounced", function (_) {});

    _defineProperty(_assertThisInitialized(_this), "strip", function (incoming) {
      var decimalPlaces = _this.props.decimalPlaces;
      var value = incoming.replace(/[^-\.\d]/g, ""); // only allow single .

      value = value.replace(/\./g, "|").replace("|", ".").replace(/\|/g, ""); // only allow single -

      value = value.replace(/-/g, "|").replace("|", "-").replace(/\|/g, ""); // limit decimal places

      if (decimalPlaces === 0) {
        return value.replace(".", "");
      }

      if (decimalPlaces !== undefined && decimalPlaces > 0) {
        var pattern = "(\\.\\d{".concat(decimalPlaces, "})\\d*");
        var regex = new RegExp(pattern);
        return value.replace(regex, "$1");
      }

      return value;
    });

    _defineProperty(_assertThisInitialized(_this), "applyChange", function (value) {
      if (_this.props.value === value) return;

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.setState({
        formatted: _this.strip(e.target.value)
      }, function () {
        _this.applyChangeDebounced(_this.state.formatted);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      var blur = function blur() {
        if (_this.props.debounce !== undefined) {
          // 'void' any previously triggered change with 'unformatted' value
          _this.applyChangeDebounced(_this.state.formatted);
        }

        _this.applyChange(_this.state.formatted);

        if (_this.props.onBlur) _this.props.onBlur(e);
      };

      if (_this.props.formatValue) {
        _this.setState({
          formatted: NumericBase.formatValue(e.target.value, _this.props)
        }, blur);
      } else {
        blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref, _ref2) {
      var subLabel = _ref.subLabel,
          subLabelPosition = _ref.subLabelPosition;
      var formatted = _ref2.formatted;

      if (subLabel) {
        var right = subLabelPosition === "right" || subLabelPosition === "right corner";
        return /*#__PURE__*/React.createElement("p", null, !right && subLabel + " ", formatted, right && " " + subLabel);
      }

      return /*#__PURE__*/React.createElement("p", null, formatted);
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props, _this.state);
    });

    _this.state = {
      formatted: NumericBase.formatValue(props.value, props),
      prev: props.value
    };
    _this.applyChangeDebounced = props.debounce !== undefined ? debounce(_this.applyChange, props.debounce) : _this.applyChange;
    return _this;
  }

  _createClass(NumericBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          label = _this$props.label,
          actions = _this$props.actions,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          subLabel = _this$props.subLabel,
          subLabelPosition = _this$props.subLabelPosition,
          passThruProps = _this$props.passThruProps;
      var formatted = this.state.formatted;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(NumericBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Input$1, _extends({}, semanticProps, {
        label: subLabel,
        labelPosition: subLabelPosition,
        value: formatted !== null ? formatted : "",
        onChange: this.onChange,
        onBlur: this.onBlur,
        disabled: disabled
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // apply external value changes
      if (props.value !== state.prev && props.value !== state.formatted) {
        return {
          formatted: NumericBase.formatValue(props.value, props),
          prev: props.value
        };
      }

      return {
        prev: props.value
      };
    }
  }, {
    key: "formatValue",
    value: function formatValue(value, props) {
      var decimalPlaces = props.decimalPlaces,
          formatValue = props.formatValue,
          minValue = props.minValue,
          maxValue = props.maxValue;
      var num = Number(value);

      if (value === null) {
        return "";
      }

      if (Number.isNaN(num) || value === "") {
        return value.toString();
      }

      if (formatValue) {
        if (typeof minValue === "number") {
          num = Math.max(num, minValue);
        }

        if (typeof maxValue === "number") {
          num = Math.min(num, maxValue);
        }

        return decimalPlaces !== undefined && decimalPlaces >= 0 ? num.toFixed(decimalPlaces) : num.toString();
      }

      return value.toString();
    }
  }]);

  return NumericBase;
}(React.Component);

_defineProperty(NumericBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  maxValueError: propTypes$1.string,
  maxValue: propTypes$1.number,
  minValueError: propTypes$1.string,
  minValue: propTypes$1.number,
  numberError: propTypes$1.string,
  numberValidation: propTypes$1.bool.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  formatValue: propTypes$1.bool.isRequired,
  decimalPlaces: propTypes$1.number,
  subLabelPosition: propTypes$1.oneOf(["left", "right", "left corner", "right corner"]),
  subLabel: propTypes$1.node,
  debounce: propTypes$1.number,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(NumericBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedNumeric = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.number(true), index$1.minValue(), index$1.maxValue()]
})(NumericBase);
/**
 * Field for a numeric value
 */

var Numeric = function Numeric(props) {
  return /*#__PURE__*/React.createElement(ConnectedNumeric, props);
};

Numeric.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  debounce: propTypes$1.number,
  subLabel: propTypes$1.node,
  subLabelPosition: propTypes$1.oneOf(["left", "right", "left corner", "right corner"]),
  decimalPlaces: propTypes$1.number,
  formatValue: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  numberValidation: propTypes$1.bool,
  numberError: propTypes$1.string,
  minValue: propTypes$1.number,
  minValueError: propTypes$1.string,
  maxValue: propTypes$1.number,
  maxValueError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Numeric.defaultProps = {
  label: "",
  inline: false,
  formatValue: false,
  numberValidation: true
};

var PasswordBase = /*#__PURE__*/function (_React$Component) {
  _inherits(PasswordBase, _React$Component);

  var _super = _createSuper(PasswordBase);

  function PasswordBase() {
    var _this;

    _classCallCheck(this, PasswordBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isToggled: false
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      return _this.props.onChange(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleVisibility", function () {
      _this.setState(function (prevState) {
        return {
          isToggled: !prevState.isToggled
        };
      });
    });

    return _this;
  }

  _createClass(PasswordBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value;
          _this$props.onChange;
          var errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          toggleVisibility = _this$props.toggleVisibility,
          icon = _this$props.icon,
          label = _this$props.label,
          inline = _this$props.inline,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps;
      var isToggled = this.state.isToggled;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(PasswordBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Input$1, _extends({}, semanticProps, {
        value: value !== null ? value : "",
        onChange: this.onChange,
        type: isToggled ? "text" : "password",
        icon: toggleVisibility ? {
          name: "eye".concat(isToggled ? " slash" : ""),
          link: true,
          onClick: this.onToggleVisibility
        } : icon,
        disabled: disabled
      })));
    }
  }]);

  return PasswordBase;
}(React.Component);

_defineProperty(PasswordBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  confirmFieldError: propTypes$1.string,
  confirmField: propTypes$1.string,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  label: propTypes$1.node.isRequired,
  toggleVisibility: propTypes$1.bool
});

_defineProperty(PasswordBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedPassword = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.minLength(), index$1.maxLength(), index$1.confirmField()]
})(PasswordBase);
/**
 * Field for a password
 */

var Password = function Password(props) {
  return /*#__PURE__*/React.createElement(ConnectedPassword, props);
};

Password.propTypes = {
  toggleVisibility: propTypes$1.bool,
  label: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  confirmField: propTypes$1.string,
  confirmFieldError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Password.defaultProps = {
  label: "",
  inline: false
};

var RadioGroupBase = /*#__PURE__*/function (_React$Component) {
  _inherits(RadioGroupBase, _React$Component);

  var _super = _createSuper(RadioGroupBase);

  function RadioGroupBase() {
    var _this;

    _classCallCheck(this, RadioGroupBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "serializeValue", function (val) {
      return typeof val === "boolean" ? val.toString() : val;
    });

    _defineProperty(_assertThisInitialized(_this), "deserializeValue", function (val) {
      var options = _this.props.options;

      if (val === true.toString() && options.some(function (o) {
        return o.value === true;
      })) {
        return true;
      }

      if (val === false.toString() && options.some(function (o) {
        return o.value === false;
      })) {
        return false;
      }

      return val;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      if (d.value === undefined) return;

      var value = _this.deserializeValue(d.value);

      _this.props.onChange(value);
    });

    return _this;
  }

  _createClass(RadioGroupBase, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          value = _this$props.value,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          field = _this$props.field,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps,
          options = _this$props.options,
          inline = _this$props.inline,
          name = _this$props.name;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(RadioGroupBase.propTypes));
      var groupName = typeof name === "function" ? name(field) : name;
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, options.map(function (o) {
        var serializedValue = _this2.serializeValue(o.value);

        return /*#__PURE__*/React.createElement(Radio, _extends({}, semanticProps, {
          key: o.key || serializedValue,
          name: groupName,
          checked: value === o.value,
          onChange: _this2.onChange,
          label: o.text,
          value: serializedValue,
          disabled: disabled
        }));
      }));
    }
  }]);

  return RadioGroupBase;
}(React.Component);

_defineProperty(RadioGroupBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  name: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]).isRequired,
  inline: propTypes$1.bool.isRequired,
  options: propTypes$1.arrayOf(propTypes$1.shape({
    key: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number, propTypes$1.bool]).isRequired,
    text: propTypes$1.node
  })).isRequired,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  label: propTypes$1.node.isRequired
});

_defineProperty(RadioGroupBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedRadioGroup = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(RadioGroupBase);
/**
 * Field for a group of radio buttons
 */

var RadioGroup = function RadioGroup(props) {
  return /*#__PURE__*/React.createElement(ConnectedRadioGroup, props);
};

RadioGroup.propTypes = {
  label: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  options: propTypes$1.arrayOf(propTypes$1.shape({
    key: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),
    value: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number, propTypes$1.bool]).isRequired,
    text: propTypes$1.node
  })).isRequired,
  inline: propTypes$1.bool,
  name: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
RadioGroup.defaultProps = {
  label: "",
  inline: false,
  name: function name(field) {
    return "radio_".concat(field);
  }
};

var TextAreaBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TextAreaBase, _React$Component);

  var _super = _createSuper(TextAreaBase);

  function TextAreaBase(props) {
    var _this;

    _classCallCheck(this, TextAreaBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "applyChangeDebounced", function (_) {});

    _defineProperty(_assertThisInitialized(_this), "applyChange", function (value) {
      if (_this.props.value === value) return;

      _this.props.onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      _this.setState({
        val: e.target.value
      }, function () {
        _this.applyChangeDebounced(_this.state.val);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      _this.applyChange(_this.state.val);

      if (_this.props.onBlur) _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value;
      return /*#__PURE__*/React.createElement("p", null, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    _this.state = {
      val: props.value,
      prev: props.value
    };
    _this.applyChangeDebounced = props.debounce !== undefined ? debounce(_this.applyChange, props.debounce) : _this.applyChange;
    return _this;
  }

  _createClass(TextAreaBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.value;
          _this$props.onChange;
          var errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          label = _this$props.label,
          actions = _this$props.actions,
          width = _this$props.width,
          fluid = _this$props.fluid,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps;
      var val = this.state.val;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(TextAreaBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(TextArea$1, _extends({}, semanticProps, {
        value: val !== null ? val : "",
        onChange: this.onChange,
        onBlur: this.onBlur,
        disabled: disabled
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // apply external value changes
      if (props.value !== state.prev && props.value !== state.val) {
        return {
          val: props.value,
          prev: props.value
        };
      }

      return {
        prev: props.value
      };
    }
  }]);

  return TextAreaBase;
}(React.Component);

_defineProperty(TextAreaBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  debounce: propTypes$1.number,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(TextAreaBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedTextArea = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.minLength(), index$1.maxLength()]
})(TextAreaBase);
/**
 * Field for multi-line text
 */

var TextArea = function TextArea(props) {
  return /*#__PURE__*/React.createElement(ConnectedTextArea, props);
};

TextArea.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  debounce: propTypes$1.number,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
TextArea.defaultProps = {
  label: ""
};

var TimeFieldBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeFieldBase, _React$Component);

  var _super = _createSuper(TimeFieldBase);

  function TimeFieldBase() {
    _classCallCheck(this, TimeFieldBase);

    return _super.apply(this, arguments);
  }

  _createClass(TimeFieldBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          errors = _this$props.errors,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          label = _this$props.label,
          inline = _this$props.inline,
          required = _this$props.required,
          passThruProps = _this$props.passThruProps;
      var otherProps = utils.omitProps(passThruProps, Object.keys(TimeFieldBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: "initial",
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(TimeLocal, _extends({}, otherProps, {
        value: value,
        onChange: onChange,
        disabled: disabled
      })));
    }
  }]);

  return TimeFieldBase;
}(React.Component);

_defineProperty(TimeFieldBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  inline: propTypes$1.bool.isRequired,
  label: propTypes$1.node.isRequired
});

_defineProperty(TimeFieldBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedTimeField = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(TimeFieldBase);
/**
 * Field for choosing a time
 */

var TimeField = function TimeField(props) {
  return /*#__PURE__*/React.createElement(ConnectedTimeField, props);
};

TimeField.propTypes = {
  label: propTypes$1.node,
  inline: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
TimeField.defaultProps = {
  label: "",
  inline: false
};

var TypeAheadBase = /*#__PURE__*/function (_React$Component) {
  _inherits(TypeAheadBase, _React$Component);

  var _super = _createSuper(TypeAheadBase);

  function TypeAheadBase() {
    var _this;

    _classCallCheck(this, TypeAheadBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e, d) {
      var _this$props = _this.props,
          textField = _this$props.textField,
          optionField = _this$props.optionField,
          multiple = _this$props.multiple;
      var value = d.value,
          options = d.options;
      var additionalFormData = {}; // if textField specified store the selected text

      if (textField) {
        if (value && options) {
          var selectedValues = Array.isArray(value) ? value : [value];
          var selectedText = selectedValues.map(function (v) {
            var _options$find$text, _options$find;

            return (_options$find$text = (_options$find = options.find(function (o) {
              return o.value === v;
            })) === null || _options$find === void 0 ? void 0 : _options$find.text) !== null && _options$find$text !== void 0 ? _options$find$text : v;
          });
          additionalFormData[textField] = !multiple && selectedText.length === 1 ? selectedText[0] : selectedText;
        } else {
          additionalFormData[textField] = multiple ? [] : "";
        }
      } // if optionField specified store the entire value object


      if (optionField) {
        if (value && options) {
          var _selectedValues = Array.isArray(value) ? value : [value];

          var selectedOptions = _selectedValues.map(function (v) {
            var _options$find2;

            return (_options$find2 = options.find(function (o) {
              return o.value === v;
            })) !== null && _options$find2 !== void 0 ? _options$find2 : null;
          });

          additionalFormData[optionField] = !multiple && selectedOptions.length === 1 ? selectedOptions[0] : selectedOptions;
        } else {
          additionalFormData[optionField] = multiple ? [] : {};
        }
      }

      _this.props.onChange(value, additionalFormData);
    });

    _defineProperty(_assertThisInitialized(_this), "onSearchChange", function (e, d) {
      return _this.props.onSearch(d.searchQuery);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value,
          textField = _ref.textField,
          formState = _ref.formState,
          options = _ref.options;
      var valueArray = Array.isArray(value) ? value : [value];

      if (textField && formState.fields[textField]) {
        var text = formState.fields[textField];
        var textArray = Array.isArray(text) ? text : [text];

        if (valueArray.length === textArray.length) {
          valueArray = textArray;
        }
      } else if (Array.isArray(options)) {
        valueArray = valueArray.map(function (v) {
          var _o$value;

          var o = options.find(function (x) {
            return x.value === v;
          });
          return typeof (o === null || o === void 0 ? void 0 : o.text) === "string" || typeof (o === null || o === void 0 ? void 0 : o.text) === "number" || typeof (o === null || o === void 0 ? void 0 : o.text) === "boolean" ? o.text : (_o$value = o === null || o === void 0 ? void 0 : o.value) !== null && _o$value !== void 0 ? _o$value : v;
        });
      }

      return /*#__PURE__*/React.createElement("p", null, valueArray.filter(function (v) {
        return v !== null && v !== undefined && v !== "";
      }).join(", "));
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    return _this;
  }

  _createClass(TypeAheadBase, [{
    key: "render",
    value: function render() {
      var multiple = this.props.multiple;
      var _this$props2 = this.props,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? multiple ? [] : "" : _this$props2$value;
          _this$props2.onChange;
          var errors = _this$props2.errors,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          label = _this$props2.label,
          actions = _this$props2.actions,
          inline = _this$props2.inline,
          width = _this$props2.width,
          fluid = _this$props2.fluid,
          required = _this$props2.required,
          passThruProps = _this$props2.passThruProps,
          formState = _this$props2.formState,
          selectOnBlur = _this$props2.selectOnBlur,
          selection = _this$props2.selection,
          lookup = _this$props2.lookup,
          lookupAction = _this$props2.lookupAction,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions,
          debounce = _this$props2.debounce,
          unknownValueOptions = _this$props2.unknownValueOptions,
          unknownValueText = _this$props2.unknownValueText,
          textField = _this$props2.textField,
          searchSuggestions = _this$props2.searchSuggestions,
          alwaysShowSuggestionsOnBlur = _this$props2.alwaysShowSuggestionsOnBlur,
          alwaysShowSuggestionsOnMount = _this$props2.alwaysShowSuggestionsOnMount;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(TypeAheadBase.propTypes));
      var safeValue = value !== null ? value : multiple ? [] : ""; // auto-infer unknown value options when textField specified

      var inferredValueOptions = undefined;

      if (textField && value && formState.fields[textField]) {
        var text = formState.fields[textField];
        var textArray = Array.isArray(text) ? text : [text];
        var valueArray = Array.isArray(value) ? value : [value];

        if (valueArray.length === textArray.length) {
          inferredValueOptions = valueArray.map(function (v, i) {
            return {
              value: v,
              text: textArray[i]
            };
          });
        }
      }

      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, lookup || lookupAction ? /*#__PURE__*/React.createElement(LookupTypeAhead$1, _extends({}, semanticProps, {
        value: safeValue,
        onChange: this.onChange,
        selectOnBlur: selectOnBlur,
        selection: selection,
        lookup: lookup,
        lookupAction: lookupAction,
        lookupParams: typeof lookupParams === "function" ? lookupParams(formState) : lookupParams,
        lookupOptions: typeof lookupOptions === "function" ? lookupOptions(formState) : lookupOptions,
        debounce: debounce,
        unknownValueOptions: typeof unknownValueOptions === "function" ? unknownValueOptions(formState) : unknownValueOptions || inferredValueOptions,
        unknownValueText: typeof unknownValueText === "function" ? unknownValueText(formState) : unknownValueText,
        searchSuggestions: searchSuggestions,
        alwaysShowSuggestionsOnBlur: alwaysShowSuggestionsOnBlur,
        alwaysShowSuggestionsOnMount: alwaysShowSuggestionsOnMount,
        disabled: disabled
      })) : /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, semanticProps, {
        value: safeValue,
        onChange: this.onChange,
        search: true,
        onSearchChange: this.onSearchChange,
        selectOnBlur: selectOnBlur,
        selection: selection,
        disabled: disabled
      })));
    }
  }]);

  return TypeAheadBase;
}(React.Component);

_defineProperty(TypeAheadBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  alwaysShowSuggestionsOnMount: propTypes$1.bool.isRequired,
  alwaysShowSuggestionsOnBlur: propTypes$1.bool.isRequired,
  searchSuggestions: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.string]),
  optionField: propTypes$1.string,
  textField: propTypes$1.string,
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.arrayOf(propTypes$1.any), propTypes$1.func]),
  debounce: propTypes$1.number.isRequired,
  onSearch: propTypes$1.func.isRequired,
  lookupOptions: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupParams: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupAction: propTypes$1.func,
  lookup: propTypes$1.any,
  selection: propTypes$1.bool.isRequired,
  selectOnBlur: propTypes$1.bool.isRequired,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(TypeAheadBase, "defaultProps", {
  onChange: function onChange() {}
});

var ConnectedTypeAhead = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false)]
})(TypeAheadBase);
/**
 * Field for a type-ahead search field
 */

var TypeAhead = function TypeAhead(props) {
  return /*#__PURE__*/React.createElement(ConnectedTypeAhead, props);
};

TypeAhead.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  selectOnBlur: propTypes$1.bool,
  selection: propTypes$1.bool,
  lookup: propTypes$1.any,
  lookupAction: propTypes$1.func,
  lookupParams: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  lookupOptions: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.func]),
  onSearch: propTypes$1.func,
  debounce: propTypes$1.number,
  unknownValueOptions: propTypes$1.oneOfType([propTypes$1.arrayOf(propTypes$1.any), propTypes$1.func]),
  unknownValueText: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.func]),
  textField: propTypes$1.string,
  optionField: propTypes$1.string,
  searchSuggestions: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.string]),
  alwaysShowSuggestionsOnBlur: propTypes$1.bool,
  alwaysShowSuggestionsOnMount: propTypes$1.bool,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
TypeAhead.defaultProps = {
  onSearch: function onSearch() {},
  label: "",
  inline: false,
  selectOnBlur: false,
  selection: true,
  lookupOptions: {
    cache: true,
    cacheLimit: 5
  },
  debounce: 200,
  alwaysShowSuggestionsOnBlur: false,
  alwaysShowSuggestionsOnMount: true
};

var UrlBase = /*#__PURE__*/function (_React$Component) {
  _inherits(UrlBase, _React$Component);

  var _super = _createSuper(UrlBase);

  function UrlBase() {
    var _this;

    _classCallCheck(this, UrlBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatValue", function (value, defaultProtocol) {
      var sanitised = value.replace(/\s/g, "");

      if (/^(?:[a-z]+:)?\/\//i.test(sanitised)) {
        return sanitised;
      } else {
        return defaultProtocol + "://" + sanitised;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      return _this.props.onChange(e.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "onBlur", function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          formatValue = _this$props.formatValue,
          defaultProtocol = _this$props.defaultProtocol;

      if (value && formatValue && defaultProtocol) {
        var formatted = _this.formatValue(value, defaultProtocol);

        _this.props.onChange(formatted);
      }

      if (_this.props.onBlur) _this.props.onBlur(e);
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderReadOnly", function (_ref) {
      var value = _ref.value,
          errors = _ref.errors;

      if (!errors || !errors.length) {
        return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("a", {
          href: "".concat(value),
          target: "_blank",
          rel: "noopener"
        }, value));
      }

      return /*#__PURE__*/React.createElement("p", null, value);
    });

    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return (_this.props.renderReadOnly || _this.defaultRenderReadOnly)(_this.props);
    });

    return _this;
  }

  _createClass(UrlBase, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value;
          _this$props2.onChange;
          var errors = _this$props2.errors,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly,
          label = _this$props2.label,
          actions = _this$props2.actions,
          inline = _this$props2.inline,
          width = _this$props2.width,
          fluid = _this$props2.fluid,
          required = _this$props2.required,
          passThruProps = _this$props2.passThruProps;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(UrlBase.propTypes));
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        renderReadOnly: readOnly && this.renderReadOnly,
        width: width,
        fluid: fluid,
        label: label,
        actions: actions,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Input$1, _extends({}, semanticProps, {
        value: value !== null ? value : "",
        onChange: this.onChange,
        onBlur: this.onBlur,
        disabled: disabled
      })));
    }
  }]);

  return UrlBase;
}(React.Component);

_defineProperty(UrlBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  defaultProtocol: propTypes$1.string.isRequired,
  formatValue: propTypes$1.bool.isRequired,
  renderReadOnly: propTypes$1.func,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  inline: propTypes$1.bool.isRequired,
  actions: propTypes$1.node,
  label: propTypes$1.node.isRequired
});

_defineProperty(UrlBase, "defaultProps", {
  value: "",
  onChange: function onChange() {}
});

var ConnectedUrl = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.minLength(), index$1.maxLength()]
})(UrlBase);
/**
 * Field for entering a URL
 */

var Url = function Url(props) {
  return /*#__PURE__*/React.createElement(ConnectedUrl, props);
};

Url.propTypes = {
  label: propTypes$1.node,
  actions: propTypes$1.node,
  inline: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  renderReadOnly: propTypes$1.func,
  formatValue: propTypes$1.bool,
  defaultProtocol: propTypes$1.string,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
Url.defaultProps = {
  label: "",
  inline: false,
  formatValue: false,
  defaultProtocol: "http"
};

var index$2 = /*#__PURE__*/Object.freeze({
__proto__: null,
Checkbox: Checkbox,
CheckboxGroup: CheckboxGroup,
CheckboxTree: CheckboxTree,
DateField: DateField,
DateTime: DateTime,
Dropdown: Dropdown,
Email: Email,
Input: Input,
Numeric: Numeric,
Password: Password,
RadioGroup: RadioGroup,
TextArea: TextArea,
TimeField: TimeField,
TypeAhead: TypeAhead,
Url: Url
});

/**
 * A clickable action that can be performed on a row in an Array field
 */
var ArrayAction = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayAction, _React$Component);

  var _super = _createSuper(ArrayAction);

  function ArrayAction() {
    var _this;

    _classCallCheck(this, ArrayAction);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$context$value = _this.context.value,
          value = _this$context$value === void 0 ? {} : _this$context$value;

      _this.props.onClick(value);
    });

    return _this;
  }

  _createClass(ArrayAction, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as;
          _this$props.onClick;
          var otherProps = _objectWithoutProperties(_this$props, ["as", "onClick"]);

      var Component = as;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return ArrayAction;
}(React.Component);

_defineProperty(ArrayAction, "propTypes", {
  as: propTypes$1.elementType.isRequired,
  onClick: propTypes$1.func.isRequired
});

_defineProperty(ArrayAction, "contextType", FormContext);

/**
 * Button to append a new item into a form array
 */
var ArrayAdder = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayAdder, _React$Component);

  var _super = _createSuper(ArrayAdder);

  function ArrayAdder() {
    var _this;

    _classCallCheck(this, ArrayAdder);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      var _this$props = _this.props,
          field = _this$props.field,
          populate = _this$props.populate,
          arrayKey = _this$props.arrayKey,
          onAdded = _this$props.onAdded;
      var next = populate(arrayKey);

      var applyChanges = function applyChanges(prevValue) {
        var prevArrayValue = prevValue[field] || [];
        return _objectSpread2(_objectSpread2({}, prevValue), {}, _defineProperty({}, field, [].concat(_toConsumableArray(prevArrayValue), [next])));
      };

      if (_this.context.onChange) {
        _this.context.onChange(field, applyChanges(_this.context.value || {})[field], applyChanges);
      }

      if (onAdded) onAdded(next);
    });

    return _this;
  }

  _createClass(ArrayAdder, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          as = _this$props2.as;
          _this$props2.field;
          _this$props2.populate;
          _this$props2.arrayKey;
          _this$props2.onAdded;
          var otherProps = _objectWithoutProperties(_this$props2, ["as", "field", "populate", "arrayKey", "onAdded"]);

      var Component = as;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return ArrayAdder;
}(React.Component);

_defineProperty(ArrayAdder, "propTypes", {
  field: propTypes$1.string.isRequired,
  arrayKey: propTypes$1.string,
  as: propTypes$1.elementType,
  populate: propTypes$1.func,
  onAdded: propTypes$1.func
});

_defineProperty(ArrayAdder, "defaultProps", {
  arrayKey: "key",
  as: Button,
  populate: function populate(arrayKey) {
    return _defineProperty({}, arrayKey, Date.now());
  }
});

_defineProperty(ArrayAdder, "contextType", FormContext);

/**
 * Button to remove the current Array item.
 */
var ArrayRemover = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayRemover, _React$Component);

  var _super = _createSuper(ArrayRemover);

  function ArrayRemover() {
    var _this;

    _classCallCheck(this, ArrayRemover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      if (_this.context.onRemove) {
        _this.context.onRemove();
      }

      var onRemoved = _this.props.onRemoved;
      if (onRemoved) onRemoved();
    });

    return _this;
  }

  _createClass(ArrayRemover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          as = _this$props.as;
          _this$props.onRemoved;
          var otherProps = _objectWithoutProperties(_this$props, ["as", "onRemoved"]);

      var Component = as;
      return /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
        onClick: this.onClick
      }), this.props.children);
    }
  }]);

  return ArrayRemover;
}(React.Component);

_defineProperty(ArrayRemover, "propTypes", {
  as: propTypes$1.elementType,
  onRemoved: propTypes$1.func
});

_defineProperty(ArrayRemover, "defaultProps", {
  as: Button
});

_defineProperty(ArrayRemover, "contextType", FormContext);

/**
 * Nests child form field data within an array of objects
 */
var ArrayFieldContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayFieldContainer, _React$Component);

  var _super = _createSuper(ArrayFieldContainer);

  function ArrayFieldContainer() {
    _classCallCheck(this, ArrayFieldContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ArrayFieldContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          errors = _this$props.errors,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Form$1.Field, {
        disabled: disabled
      }, typeof label === "string" ? /*#__PURE__*/React.createElement("label", null, label) : label), children, /*#__PURE__*/React.createElement(Form$1.Field, {
        className: "array-error"
      }, /*#__PURE__*/React.createElement(FieldError, {
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animate: animateErrors
      })));
    }
  }]);

  return ArrayFieldContainer;
}(React.Component);

_defineProperty(ArrayFieldContainer, "propTypes", {
  label: propTypes$1.node,
  minLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  maxLengthError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  arrayKey: propTypes$1.string,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  autoAdd: propTypes$1.bool,
  autoAddPopulate: propTypes$1.func,
  autoRemove: propTypes$1.bool,
  propagateUpdates: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.bool]),
  children: propTypes$1.oneOfType([propTypes$1.node, propTypes$1.func]).isRequired
});

_defineProperty(ArrayFieldContainer, "defaultProps", {
  arrayKey: "key",
  autoAdd: false,
  autoAddPopulate: function autoAddPopulate(arrayKey) {
    return _defineProperty({}, arrayKey, Date.now());
  },
  autoRemove: false
});

var ArrayField = withFormArray({
  defaultProps: {
    arrayKey: "key",
    autoAdd: false,
    autoAddPopulate: function autoAddPopulate(arrayKey) {
      return _defineProperty({}, arrayKey, Date.now());
    },
    autoRemove: false
  },
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  }
})(ArrayFieldContainer);

/**
 * Nests child form field data within an object
 */
var ObjectFieldContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ObjectFieldContainer, _React$Component);

  var _super = _createSuper(ObjectFieldContainer);

  function ObjectFieldContainer() {
    _classCallCheck(this, ObjectFieldContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ObjectFieldContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          disabled = _this$props.disabled,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Form$1.Field, {
        disabled: disabled
      }, typeof label === "string" ? /*#__PURE__*/React.createElement("label", null, label) : label), children);
    }
  }]);

  return ObjectFieldContainer;
}(React.Component);

_defineProperty(ObjectFieldContainer, "propTypes", {
  label: propTypes$1.node,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  propagateUpdates: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.bool]),
  children: propTypes$1.oneOfType([propTypes$1.node, propTypes$1.func])
});

var ObjectField = withFormObject({
  defaultProps: {}
})(ObjectFieldContainer);

var TableContext = /*#__PURE__*/React.createContext({
  data: []
});
TableContext.displayName = "TableContext";

/**
 * Renders a row for a table data item
 */

var TableRow = /*#__PURE__*/function (_React$Component) {
  _inherits(TableRow, _React$Component);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    _classCallCheck(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onRowClick", function () {
      var _this$props = _this.props,
          item = _this$props.item,
          itemKey = _this$props.itemKey,
          onClick = _this$props.onClick;
      if (onClick) onClick(item, itemKey);
    });

    _defineProperty(_assertThisInitialized(_this), "onRowExpand", function () {
      var _this$props2 = _this.props,
          itemKey = _this$props2.itemKey,
          onExpand = _this$props2.onExpand;
      if (onExpand) onExpand(itemKey);
    });

    _defineProperty(_assertThisInitialized(_this), "onRowCollapse", function () {
      var _this$props3 = _this.props,
          itemKey = _this$props3.itemKey,
          onCollapse = _this$props3.onCollapse;
      if (onCollapse) onCollapse(itemKey);
    });

    return _this;
  }

  _createClass(TableRow, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          dataKey = _this$props4.dataKey,
          item = _this$props4.item,
          itemKey = _this$props4.itemKey,
          itemIndex = _this$props4.itemIndex,
          expanded = _this$props4.expanded,
          onClick = _this$props4.onClick,
          children = _this$props4.children;
      var renderArgs = [item, {
        itemKey: itemKey,
        itemIndex: itemIndex,
        expanded: expanded
      }, {
        onExpand: this.onRowExpand,
        onCollapse: this.onRowCollapse
      }];
      return /*#__PURE__*/React.createElement(Table$1.Row, {
        onClick: this.onRowClick,
        className: classnames(item.className, {
          expanded: expanded
        })
      }, /*#__PURE__*/React.createElement(TableContext.Provider, {
        value: {
          data: data,
          dataKey: dataKey,
          item: item,
          itemKey: itemKey,
          itemIndex: itemIndex,
          expanded: expanded,
          onClick: onClick,
          onExpand: this.onRowExpand,
          onCollapse: this.onRowCollapse
        }
      }, typeof children === "function" ? children.apply(void 0, renderArgs) : children));
    }
  }]);

  return TableRow;
}(React.Component);

_defineProperty(TableRow, "propType", {
  /**
   * Row item data to be rendered
   */
  item: propTypes$1.shape({
    className: propTypes$1.string
  }),

  /**
   * Unique key value for row item
   */
  itemKey: propTypes$1.any,

  /**
   * Row index for the item
   */
  itemIndex: propTypes$1.number,

  /**
   * Array of table data
   */
  data: propTypes$1.array,

  /**
   * Property name for unique key in data
   */
  dataKey: propTypes$1.string,

  /**
   * Callback when the row is clicked
   * @param {Object} `item` The row item that was clicked on
   * @param {*} `itemKey` The row item key
   */
  onClick: propTypes$1.func,

  /**
   * Callback when the row is expanded
   * @param {*} `itemKey` The row item key
   */
  onExpand: propTypes$1.func,

  /**
   * Callback when the row is collapsed
   * @param {*} `itemKey` The row item key
   */
  onCollapse: propTypes$1.func,

  /**
   * Whether the row is currently in an expanded state
   */
  expanded: propTypes$1.bool,

  /**
   * Content that the row should contain, or a render function that will be passed the following parameters:
   * @param {Object} `item` The current item being rendered
   * @param {Object} `state` An object representing the current state
   * @param {*} `state.itemKey` Unique key value for row item
   * @param {number} `state.itemIndex` Row index for the item
   * @param {boolean} `state.expanded` Whether the row is currently expanded
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onExpand` Expands the row
   * @param {function} `events.onCollapse` Collapses the row
   */
  children: propTypes$1.any
});

/**
 * Renders a row for a table header
 */

var HeaderRow = /*#__PURE__*/function (_React$Component) {
  _inherits(HeaderRow, _React$Component);

  var _super = _createSuper(HeaderRow);

  function HeaderRow() {
    _classCallCheck(this, HeaderRow);

    return _super.apply(this, arguments);
  }

  _createClass(HeaderRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          dataKey = _this$props.dataKey,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(Table$1.Row, null, /*#__PURE__*/React.createElement(TableContext.Provider, {
        value: {
          data: data,
          dataKey: dataKey,
          headerRow: true
        }
      }, typeof children === "function" ? children() : children));
    }
  }]);

  return HeaderRow;
}(React.Component);

_defineProperty(HeaderRow, "propType", {
  /**
   * Array of table data
   */
  data: propTypes$1.array,

  /**
   * Property name for unique key in data
   */
  dataKey: propTypes$1.string
});

/**
 * Renders a row for a table footer
 */

var FooterRow = /*#__PURE__*/function (_React$Component) {
  _inherits(FooterRow, _React$Component);

  var _super = _createSuper(FooterRow);

  function FooterRow() {
    _classCallCheck(this, FooterRow);

    return _super.apply(this, arguments);
  }

  _createClass(FooterRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          dataKey = _this$props.dataKey,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement(Table$1.Row, null, /*#__PURE__*/React.createElement(TableContext.Provider, {
        value: {
          data: data,
          dataKey: dataKey,
          footerRow: true
        }
      }, typeof children === "function" ? children() : children));
    }
  }]);

  return FooterRow;
}(React.Component);

_defineProperty(FooterRow, "propType", {
  /**
   * Array of table data
   */
  data: propTypes$1.array,

  /**
   * Property name for unique key in data
   */
  dataKey: propTypes$1.string
});

/**
 * Renders an expanded row for a table data item
 */

var ExpandedRow = /*#__PURE__*/function (_React$Component) {
  _inherits(ExpandedRow, _React$Component);

  var _super = _createSuper(ExpandedRow);

  function ExpandedRow() {
    var _this;

    _classCallCheck(this, ExpandedRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onRowCollapse", function () {
      var _this$props = _this.props,
          itemKey = _this$props.itemKey,
          onCollapse = _this$props.onCollapse;
      if (onCollapse) onCollapse(itemKey);
    });

    return _this;
  }

  _createClass(ExpandedRow, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          itemKey = _this$props2.itemKey,
          itemIndex = _this$props2.itemIndex,
          columnSpan = _this$props2.columnSpan,
          render = _this$props2.render,
          visible = _this$props2.visible,
          animate = _this$props2.animate;
      var renderArgs = [item, {
        itemKey: itemKey,
        itemIndex: itemIndex
      }, {
        onCollapse: this.onRowCollapse
      }];
      var content = visible && /*#__PURE__*/React.createElement(Table$1.Row, {
        className: classnames(item.className, "expanded-row")
      }, /*#__PURE__*/React.createElement(Table$1.Cell, {
        colSpan: columnSpan
      }, render.apply(void 0, renderArgs)));
      return typeof animate === "number" && animate > 0 ? /*#__PURE__*/React.createElement(Transition.Group, {
        as: React.Fragment,
        animation: "fade down",
        duration: animate
      }, content) : content;
    }
  }]);

  return ExpandedRow;
}(React.Component);

_defineProperty(ExpandedRow, "propType", {
  /**
   * Row item data to be rendered
   */
  item: propTypes$1.shape({
    className: propTypes$1.string
  }),

  /**
   * Unique key value for row item
   */
  itemKey: propTypes$1.any,

  /**
   * Row index for the item
   */
  itemIndex: propTypes$1.number,

  /**
   * Custom render function for the expanded row content
   * @param {Object} `item` The current item being rendered
   * @param {Object} `state` An object representing the current state
   * @param {*} `state.itemKey` Unique key value for row item
   * @param {number} `state.itemIndex` Row index for the item
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onCollapse` Collapses the row
   */
  render: propTypes$1.func.isRequired,

  /**
   * Number of columns that this row should span
   */
  columnSpan: propTypes$1.number,

  /**
   * Callback when the row is collapsed
   * @param {*} `itemKey` The row item key
   */
  onCollapse: propTypes$1.func,

  /**
   * Whether the expanded row is currently visible
   */
  visible: propTypes$1.bool,

  /**
   * Time in milliseconds for the expanded row animation transition, or false to disable
   */
  animate: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool])
});

/**
 * Renders a standard column for a table data item
 */

var TableColumn = /*#__PURE__*/function (_React$Component) {
  _inherits(TableColumn, _React$Component);

  var _super = _createSuper(TableColumn);

  function TableColumn() {
    var _this;

    _classCallCheck(this, TableColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderCell", function (value) {
      if (typeof value === "boolean") {
        return value ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-check colour-positive",
          "aria-hidden": "true"
        }) : null;
      }

      return value;
    });

    return _this;
  }

  _createClass(TableColumn, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          field = _this$props.field,
          title = _this$props.title,
          header = _this$props.header,
          footer = _this$props.footer,
          component = _this$props.component,
          render = _this$props.render,
          width = _this$props.width,
          align = _this$props.align,
          span = _this$props.span,
          hoverable = _this$props.hoverable,
          className = _this$props.className;
      var _this$context = this.context,
          item = _this$context.item,
          itemKey = _this$context.itemKey,
          itemIndex = _this$context.itemIndex,
          expanded = _this$context.expanded,
          headerRow = _this$context.headerRow,
          footerRow = _this$context.footerRow,
          onClick = _this$context.onClick,
          onExpand = _this$context.onExpand,
          onCollapse = _this$context.onCollapse;

      if (headerRow) {
        // render header cell
        return /*#__PURE__*/React.createElement(Table$1.HeaderCell, {
          textAlign: align,
          className: className,
          style: {
            width: width
          },
          colSpan: span
        }, header || title);
      }

      if (footerRow) {
        // render footer cell
        return /*#__PURE__*/React.createElement(Table$1.Cell, {
          textAlign: align,
          className: className,
          colSpan: span
        }, footer);
      }

      var Component = component;
      var cellState = {
        itemKey: itemKey,
        itemIndex: itemIndex,
        expanded: expanded
      };
      var cellEvents = {
        onExpand: onExpand,
        onCollapse: onCollapse
      };
      var cellStyle = {
        cursor: onClick ? "pointer" : "initial"
      }; // render data cell

      return /*#__PURE__*/React.createElement(Table$1.Cell, {
        textAlign: align,
        className: classnames({
          hoverable: hoverable
        }, className),
        style: cellStyle,
        colSpan: span
      }, render ? render(item, cellState, cellEvents) : Component ? /*#__PURE__*/React.createElement(Component, _extends({
        item: item
      }, cellState, cellEvents)) : this.renderCell(item[field]));
    }
  }]);

  return TableColumn;
}(React.Component);

_defineProperty(TableColumn, "propTypes", {
  /**
   * Property name for the item field to render
   */
  field: propTypes$1.string,

  /**
   * Content to display for the column header, alias for header prop
   */
  title: propTypes$1.node,

  /**
   * Content to display for the column header
   */
  header: propTypes$1.node,

  /**
   * Content to display for the column footer
   */
  footer: propTypes$1.node,

  /**
   * Optional component to use to render each item cell, receives the following props:
   * @property {Object} `item` The current item being rendered
   * @property {*} `itemKey` Unique key value for row item
   * @property {number} `itemIndex` Row index for the item
   * @property {boolean} `expanded` Whether the row is currently expanded
   * @property {function} `onExpand` Expands the row
   * @property {function} `onCollapse` Collapses the row
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function to use to render each item cell
   * @param {Object} `item` The current item being rendered
   * @param {Object} `state` An object representing the current state
   * @param {*} `state.itemKey` Unique key value for row item
   * @param {number} `state.itemIndex` Row index for the item
   * @param {boolean} `state.expanded` Whether the row is currently expanded
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onExpand` Expands the row
   * @param {function} `events.onCollapse` Collapses the row
   */
  render: propTypes$1.func,

  /**
   * Width of the column
   */
  width: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),

  /**
   * Alignment of the column content
   */
  align: propTypes$1.string,

  /**
   * The number of table cells that this column should span
   */
  span: propTypes$1.number,

  /**
   * Whether the column content should only appear when the table row is hovered over
   */
  hoverable: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(TableColumn, "defaultProps", {
  width: "initial"
});

_defineProperty(TableColumn, "contextType", TableContext);

var SelectableColumnHeaderType = {
  Hide: "hide",
  Page: "page",
  All: "all",
  Prompt: "prompt"
};
var ExpandRowsType = {
  None: "none",
  OnClick: "onClick",
  Always: "always",
  Never: "never"
};

/**
 * Renders a column with checkboxes for selecting items
 */

var SelectableColumn = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectableColumn, _React$Component);

  var _super = _createSuper(SelectableColumn);

  function SelectableColumn() {
    var _this;

    _classCallCheck(this, SelectableColumn);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var dataKey = _this.context.dataKey;
      var key = item[dataKey];

      if (!key && !_this._keyWarning) {
        console.error("Table dataKey is invalid");
        _this._keyWarning = true;
      }

      return key;
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderType", function () {
      var header = _this.props.header;
      var type = _typeof(header) === "object" ? header.type : header;
      return type !== null && type !== void 0 ? type : SelectableColumn.defaultProps.header;
    });

    _defineProperty(_assertThisInitialized(_this), "allItemsForEveryPageSelected", function () {
      var data = _this.context.data;
      if (!data) return false;
      var _this$props = _this.props,
          value = _this$props.value,
          totalItems = _this$props.totalItems;
      var selected = value.selected || [];
      var deselected = value.deselected || [];
      return (// selecting all + no deselected
        value.allSelected && deselected.length === 0 || // not selecting all + everything selected
        !value.allSelected && selected.length === totalItems
      );
    });

    _defineProperty(_assertThisInitialized(_this), "allItemsForCurrentPageSelected", function () {
      var data = _this.context.data;
      if (!data) return false;
      var value = _this.props.value;
      var pageKeys = data.map(function (i) {
        return _this.getItemKey(i);
      });
      var selected = value.selected || [];
      var deselected = value.deselected || [];
      return (// selecting all + nothing on current page in deselected
        value.allSelected && pageKeys.every(function (k) {
          return deselected.indexOf(k) < 0;
        }) || // not selecting all + everything on current page in selected
        !value.allSelected && pageKeys.every(function (k) {
          return selected.indexOf(k) >= 0;
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "someItemsForAnyPageSelected", function () {
      var data = _this.context.data;
      if (!data) return false;
      var _this$props2 = _this.props,
          value = _this$props2.value,
          totalItems = _this$props2.totalItems;
      var selected = value.selected || [];
      var deselected = value.deselected || [];
      return (// selecting all + not everything in deselected
        value.allSelected && deselected.length < totalItems || // not selecting all + something in selected
        !value.allSelected && selected.length > 0
      );
    });

    _defineProperty(_assertThisInitialized(_this), "someItemsForCurrentPageSelected", function () {
      var data = _this.context.data;
      if (!data) return false;
      var value = _this.props.value;
      var pageKeys = data.map(function (i) {
        return _this.getItemKey(i);
      });
      var selected = value.selected || [];
      var deselected = value.deselected || [];
      return (// selecting all + not everything on current page in deselected
        value.allSelected && pageKeys.some(function (k) {
          return deselected.indexOf(k) < 0;
        }) || // not selecting all + something on current page in selected
        !value.allSelected && pageKeys.some(function (k) {
          return selected.indexOf(k) >= 0;
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "getHeaderState", function () {
      var _this$props3 = _this.props;
          _this$props3.value;
          var canSelectAll = _this$props3.canSelectAll;

      var headerType = _this.getHeaderType();

      var allSelected = false;
      var someSelected = false;

      if (headerType === SelectableColumnHeaderType.All) {
        // select all items
        allSelected = _this.allItemsForEveryPageSelected();
        someSelected = _this.someItemsForAnyPageSelected();
      } else if (headerType === SelectableColumnHeaderType.Page) {
        // select current page only
        allSelected = _this.allItemsForCurrentPageSelected();
        someSelected = _this.someItemsForCurrentPageSelected();
      }

      var disabled = !canSelectAll(_this.context.data);
      var result = {
        disabled: disabled,
        checked: false,
        indeterminate: false
      };

      if (allSelected && someSelected) {
        result.checked = true;
      } else if (someSelected) {
        result.indeterminate = true;
      } else {
        result.checked = false;
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderSelect", function (e, d) {
      var _this$props4 = _this.props,
          value = _this$props4.value,
          onChange = _this$props4.onChange,
          canSelect = _this$props4.canSelect;

      var headerType = _this.getHeaderType();

      if (headerType === SelectableColumnHeaderType.All) {
        // select all items
        onChange(_objectSpread2(_objectSpread2({}, value), {}, {
          allSelected: d.checked,
          selected: [],
          deselected: []
        }));
      } else if (headerType === SelectableColumnHeaderType.Page) {
        // select current page only
        var pageKeys = _this.context.data.filter(function (i, idx) {
          return canSelect(i, idx);
        }).map(function (i) {
          return _this.getItemKey(i);
        });

        var selected = value.selected || [];
        var deselected = value.deselected || [];
        var selectedPageKeys = value.allSelected ? // page keys not in deselected
        pageKeys.filter(function (k) {
          return deselected.indexOf(k) < 0;
        }) : // page keys in selected
        pageKeys.filter(function (k) {
          return selected.indexOf(k) >= 0;
        });
        var selectingAll = selectedPageKeys.length < pageKeys.length;
        var togglePageKeys = selectingAll ? // toggle deselected items on current page
        pageKeys.filter(function (k) {
          return selectedPageKeys.indexOf(k) < 0;
        }) : // toggle selected items on current page
        selectedPageKeys;

        var newValue = _this.toggleItems(togglePageKeys, selectingAll);

        onChange(newValue);
      } else if (headerType === SelectableColumnHeaderType.Prompt) {
        // TODO should select page and then prompt to select all via a popup
        console.error("SelectableColumn header \"prompt\" is currently not implemented");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemState", function () {
      var _this$props5 = _this.props,
          value = _this$props5.value,
          canSelect = _this$props5.canSelect;
      var _this$context = _this.context,
          item = _this$context.item,
          itemIndex = _this$context.itemIndex;
      var disabled = !canSelect(item, itemIndex);
      if (disabled) return {
        disabled: disabled,
        checked: false
      };

      var itemKey = _this.getItemKey(item);

      if (value.selected && ~value.selected.indexOf(itemKey)) {
        return {
          checked: true
        };
      }

      return {
        checked: !!value.allSelected && (!value.deselected || !~value.deselected.indexOf(itemKey))
      };
    });

    _defineProperty(_assertThisInitialized(_this), "toggleItems", function (itemKeyArray, check) {
      var _this$props6 = _this.props,
          value = _this$props6.value,
          totalItems = _this$props6.totalItems,
          preserveSelectedKeys = _this$props6.preserveSelectedKeys;

      var sel = _objectSpread2(_objectSpread2({}, value), {}, {
        selected: value.selected ? _toConsumableArray(value.selected) : [],
        deselected: value.deselected ? _toConsumableArray(value.deselected) : []
      });

      itemKeyArray.forEach(function (itemKey) {
        // if item is deselected, remove it.
        // if item is selected, remove it.
        var di = sel.deselected.indexOf(itemKey);
        if (~di) sel.deselected.splice(di, 1);
        var si = sel.selected.indexOf(itemKey);
        if (~si) sel.selected.splice(si, 1);

        if (check === true && !sel.allSelected) {
          sel.selected.push(itemKey);
        }

        if (check === false && sel.allSelected) {
          sel.deselected.push(itemKey);
        }
      });

      if (sel.allSelected && sel.deselected.length == totalItems) {
        sel.allSelected = false;
        sel.deselected = [];
      }

      if (!sel.allSelected && sel.selected.length == totalItems && !preserveSelectedKeys) {
        sel.allSelected = true;
        sel.selected = [];
      }

      return sel;
    });

    _defineProperty(_assertThisInitialized(_this), "onItemSelect", function (e, d) {
      e.stopPropagation();

      var itemKey = _this.getItemKey(_this.context.item);

      var newValue = _this.toggleItems([itemKey], d.checked);

      return _this.props.onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onCellClick", function (e) {
      return e.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "defaultHeaderRender", function (headerState, headerEvents) {
      return /*#__PURE__*/React.createElement(Checkbox$1, _extends({}, headerState, headerEvents));
    });

    _defineProperty(_assertThisInitialized(_this), "defaultItemRender", function (item, itemState, itemEvents) {
      return /*#__PURE__*/React.createElement(Checkbox$1, _extends({}, itemState, itemEvents));
    });

    return _this;
  }

  _createClass(SelectableColumn, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          render = _this$props7.render,
          width = _this$props7.width,
          align = _this$props7.align,
          className = _this$props7.className;
      var _this$context2 = this.context,
          item = _this$context2.item,
          headerRow = _this$context2.headerRow,
          footerRow = _this$context2.footerRow;

      if (headerRow) {
        var _this$props$header$re, _this$props$header;

        // render header cell
        var headerType = this.getHeaderType();
        var headerState = this.getHeaderState();
        var headerEvents = {
          onChange: this.onHeaderSelect
        };
        var headerRender = (_this$props$header$re = (_this$props$header = this.props.header) === null || _this$props$header === void 0 ? void 0 : _this$props$header.render) !== null && _this$props$header$re !== void 0 ? _this$props$header$re : this.defaultHeaderRender;
        return /*#__PURE__*/React.createElement(Table$1.HeaderCell, {
          textAlign: align,
          className: className,
          style: {
            width: width
          }
        }, headerType !== SelectableColumnHeaderType.Hide && headerRender(headerState, headerEvents));
      }

      if (footerRow) {
        // render footer cell - not currently supported
        return /*#__PURE__*/React.createElement(Table$1.Cell, {
          textAlign: align,
          className: className
        });
      }

      var itemState = this.getItemState();
      var itemEvents = {
        onChange: this.onItemSelect
      };
      var itemRender = render !== null && render !== void 0 ? render : this.defaultItemRender; // render data cell

      return /*#__PURE__*/React.createElement(Table$1.Cell, {
        textAlign: align,
        className: className,
        onClick: this.onCellClick
      }, itemRender(item, itemState, itemEvents));
    }
  }]);

  return SelectableColumn;
}(React.Component);

_defineProperty(SelectableColumn, "propTypes", {
  /**
   * Object representing the current table selection state
   */
  value: propTypes$1.object.isRequired,

  /**
   * Callback when the selection state has changed
   * @param {Object} `selection` An object representing the new selection state
   */
  onChange: propTypes$1.func.isRequired,

  /**
   * The total number of items in the table data
   */
  totalItems: propTypes$1.number.isRequired,

  /**
   * Optional function to determine whether a given item can be selected
   * @param {Object} `item` The item attempting to be selected
   * @param {number} `index` The index of the item attempting to be selected
   * @returns {boolean} Whether the item is selectable
   */
  canSelect: propTypes$1.func,

  /**
   * Optional function to determine whether select all can be used
   * @param {Object[]} `data` The table data
   * @returns {boolean} Whether the select all option is available
   */
  canSelectAll: propTypes$1.func,

  /**
   * The behaviour of the column header.
   * If one of the following values (except hide), the default header checkbox will be rendered.
   * Alternatively, can be an object with 'type' and 'render' keys, where type is one of the following values, and render is a function which is passed header checkbox state and events parameters.
   * @typedef SelectableColumnHeaderType
   * @property {string} `hide` Hides the header checkbox
   * @property {string} `page` Toggles selection of the current page only
   * @property {string} `all` Toggles selection of items across all pages
   * @property {string} `prompt` Toggles selection of the current page and prompts the user to select all pages (not yet implemented)
   */
  header: propTypes$1.oneOfType([propTypes$1.oneOf(Object.values(SelectableColumnHeaderType)), propTypes$1.object]),

  /**
   * Optional render function to override the rendering of each item checkbox
   * @param {object} `item` The current item being rendered
   * @param {object} `itemState` Item checkbox state
   * @param {object} `itemEvents` Item checkbox events
   */
  render: propTypes$1.func,

  /**
   * By default, once every item has been selected the array of selected keys in the selection state will be cleared and the allSelected flag will be set.
   * Enable this to preserve the selected keys array and not set allSelected.
   * Note that the 'all' header behaviour will always set allSelected, as selected keys on hidden pages are not known.
   */
  preserveSelectedKeys: propTypes$1.bool,

  /**
   * Width of the column
   */
  width: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.number]),

  /**
   * Alignment of the column content
   */
  align: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(SelectableColumn, "defaultProps", {
  canSelect: function canSelect() {
    return true;
  },
  canSelectAll: function canSelectAll() {
    return true;
  },
  header: "page",
  width: 50
});

_defineProperty(SelectableColumn, "contextType", TableContext);

/**
 * Renders a cell where each child component is side-by-side
 */

var ActionCell = function ActionCell(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(List, {
    horizontal: true
  }, React.Children.map(children, function (child) {
    return /*#__PURE__*/React.createElement(List.Item, null, child);
  }));
};

/**
 * Renders a cell which contains a dropdown menu
 */

var MenuCell = function MenuCell(_ref) {
  var children = _ref.children,
      direction = _ref.direction,
      openOnHover = _ref.openOnHover,
      props = _objectWithoutProperties(_ref, ["children", "direction", "openOnHover"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mouseOver = _useState4[0],
      setMouseOver = _useState4[1];

  var hoverProps = {};

  if (openOnHover) {
    hoverProps = {
      onMouseEnter: function onMouseEnter() {
        setOpen(true);
        setMouseOver(true);
      },
      onMouseLeave: function onMouseLeave() {
        setOpen(false);
        setMouseOver(false);
      }
    };
  }

  return /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, props, hoverProps, {
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      if (mouseOver) return;
      setOpen(false);
    },
    item: true
  }), /*#__PURE__*/React.createElement(Dropdown$1.Menu, {
    direction: direction,
    onClick: function onClick(e) {
      e.stopPropagation();
      setOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    }
  }, children));
};

MenuCell.propTypes = {
  /**
   * Semantic UI icon name to display on the item
   */
  icon: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Optional direction to render menu
   */
  direction: propTypes$1.string,

  /**
   * Whether the dropdown menu should appear when the icon is hovered over
   */
  openOnHover: propTypes$1.bool
};
MenuCell.defaultProps = {
  icon: "ellipsis horizontal",
  direction: "left"
};

/**
 * A single item for a table menu cell
 */

var MenuCellItem = function MenuCellItem(props) {
  return /*#__PURE__*/React.createElement(Dropdown$1.Item, props);
};

/**
 * A table that renders an array of data
 */

var Table = /*#__PURE__*/function (_React$Component) {
  _inherits(Table, _React$Component);

  var _super = _createSuper(Table);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "_columnsWarning", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.data !== _this.props.data || prevProps.dataKey !== _this.props.dataKey) {
        _this._keyWarning = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var dataKey = _this.props.dataKey;
      var key = item[dataKey];

      if (!key && !_this._keyWarning) {
        console.warn("Table dataKey is invalid");
        _this._keyWarning = true;
      }

      return key;
    });

    _defineProperty(_assertThisInitialized(_this), "getTotalColumns", function () {
      var required = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var columns = _this.props.columns;

      if (!columns && !_this._columnsWarning && required) {
        console.warn("Table columns has not been defined");
        _this._columnsWarning = true;
      }

      return columns;
    });

    _defineProperty(_assertThisInitialized(_this), "isRowExpanded", function (itemKey) {
      var expandRows = _this.props.expandRows;
      return expandRows !== ExpandRowsType.Never && (expandRows === ExpandRowsType.Always || _this.state.expandedRows.some(function (x) {
        return x === itemKey;
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onRowClick", function (item, itemKey) {
      var _this$props = _this.props,
          onRowClick = _this$props.onRowClick,
          expandRows = _this$props.expandRows;

      if (expandRows === ExpandRowsType.OnClick) {
        var rowExpanded = _this.isRowExpanded(itemKey);

        if (rowExpanded) {
          _this.onRowCollapse(itemKey);
        } else {
          _this.onRowExpand(itemKey);
        }
      }

      if (onRowClick) onRowClick(item);
    });

    _defineProperty(_assertThisInitialized(_this), "onRowExpand", function (itemKey) {
      var maxExpandedRows = _this.props.maxExpandedRows;

      var expandedRows = _this.state.expandedRows.filter(function (x) {
        return x !== itemKey;
      });

      if (maxExpandedRows && expandedRows.length >= maxExpandedRows) {
        var _expandedRows = _toArray(expandedRows);
            _expandedRows[0];
            var remainingRows = _expandedRows.slice(1);

        _this.setState({
          expandedRows: [].concat(_toConsumableArray(remainingRows), [itemKey])
        });
      } else {
        _this.setState({
          expandedRows: [].concat(_toConsumableArray(expandedRows), [itemKey])
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRowCollapse", function (itemKey) {
      var expandedRows = _this.state.expandedRows;

      _this.setState({
        expandedRows: expandedRows.filter(function (x) {
          return x !== itemKey;
        })
      });
    });

    _this.state = {
      expandedRows: props.initialExpandedRows
    };
    return _this;
  }

  _createClass(Table, [{
    key: "renderHeaderRow",
    value: function renderHeaderRow() {
      var _this$props2 = this.props,
          data = _this$props2.data,
          dataKey = _this$props2.dataKey,
          children = _this$props2.children;
      return /*#__PURE__*/React.createElement(HeaderRow, {
        data: data,
        dataKey: dataKey
      }, children);
    }
  }, {
    key: "renderFooterRow",
    value: function renderFooterRow() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          dataKey = _this$props3.dataKey,
          children = _this$props3.children;
      return /*#__PURE__*/React.createElement(FooterRow, {
        data: data,
        dataKey: dataKey
      }, children);
    }
  }, {
    key: "renderErrorRow",
    value: function renderErrorRow(columnSpan) {
      var error = this.props.error;
      if (!error) return null;
      var errorStyle = {
        padding: 0
      };
      return /*#__PURE__*/React.createElement(Table$1.Row, null, /*#__PURE__*/React.createElement(Table$1.Cell, {
        colSpan: columnSpan,
        style: errorStyle
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      })));
    }
  }, {
    key: "renderBodyRows",
    value: function renderBodyRows() {
      var _this2 = this;

      var _this$props4 = this.props,
          data = _this$props4.data,
          dataKey = _this$props4.dataKey,
          loading = _this$props4.loading,
          slowLoading = _this$props4.slowLoading,
          emptyMessage = _this$props4.emptyMessage,
          onRowClick = _this$props4.onRowClick,
          expandRows = _this$props4.expandRows,
          renderExpandedRow = _this$props4.renderExpandedRow,
          animateExpandedRows = _this$props4.animateExpandedRows,
          children = _this$props4.children,
          rowContent = _this$props4.rowContent;
      var columnSpan = typeof children === "function" ? this.getTotalColumns() : this.getTotalColumns(false) || React.Children.count(children);
      var showLoading = loading && (slowLoading || slowLoading === undefined || !data || data.length === 0);

      if (showLoading) {
        var loadingStyle = {
          minHeight: "80px",
          textAlign: "center"
        };
        return /*#__PURE__*/React.createElement(Table$1.Row, null, /*#__PURE__*/React.createElement(Table$1.Cell, {
          colSpan: columnSpan,
          style: loadingStyle
        }, /*#__PURE__*/React.createElement(Loader, {
          size: "large",
          active: true,
          inline: "centered"
        })));
      }

      if (!data) return this.renderErrorRow(columnSpan);

      if (data.length === 0) {
        var emptyStyle = {
          textAlign: "center"
        };
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Table$1.Row, null, /*#__PURE__*/React.createElement(Table$1.Cell, {
          colSpan: columnSpan,
          style: emptyStyle
        }, emptyMessage)), this.renderErrorRow(columnSpan));
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(function (item, index) {
        var itemKey = _this2.getItemKey(item) || index;

        var expanded = _this2.isRowExpanded(itemKey);

        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: itemKey
        }, /*#__PURE__*/React.createElement(TableRow, {
          data: data,
          dataKey: dataKey,
          item: item,
          itemKey: itemKey,
          itemIndex: index,
          onClick: !!onRowClick || expandRows === ExpandRowsType.OnClick ? _this2.onRowClick : undefined,
          onExpand: _this2.onRowExpand,
          onCollapse: _this2.onRowCollapse,
          expanded: expanded
        }, rowContent ? rowContent[index] : children), renderExpandedRow && /*#__PURE__*/React.createElement(ExpandedRow, {
          item: item,
          itemKey: itemKey,
          itemIndex: index,
          render: renderExpandedRow,
          columnSpan: columnSpan,
          onCollapse: _this2.onRowCollapse,
          visible: expanded,
          animate: // for v0.9.0 compability
          animateExpandedRows === true ? Table.defaultProps.animateExpandedRows : animateExpandedRows
        }));
      }), this.renderErrorRow(columnSpan));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props;
          _this$props5.data;
          _this$props5.dataKey;
          _this$props5.loading;
          _this$props5.slowLoading;
          _this$props5.error;
          _this$props5.emptyMessage;
          var noHeader = _this$props5.noHeader,
          showFooter = _this$props5.showFooter;
          _this$props5.onRowClick;
          _this$props5.expandRows;
          _this$props5.renderExpandedRow;
          _this$props5.maxExpandedRows;
          _this$props5.initialExpandedRows;
          _this$props5.animateExpandedRows;
          _this$props5.columns;
          _this$props5.children;
          _this$props5.rowContent;
          var otherProps = _objectWithoutProperties(_this$props5, ["data", "dataKey", "loading", "slowLoading", "error", "emptyMessage", "noHeader", "showFooter", "onRowClick", "expandRows", "renderExpandedRow", "maxExpandedRows", "initialExpandedRows", "animateExpandedRows", "columns", "children", "rowContent"]);

      return /*#__PURE__*/React.createElement(Table$1, otherProps, !noHeader && /*#__PURE__*/React.createElement(Table$1.Header, null, this.renderHeaderRow()), /*#__PURE__*/React.createElement(Table$1.Body, null, this.renderBodyRows()), showFooter && /*#__PURE__*/React.createElement(Table$1.Footer, null, this.renderFooterRow()));
    }
  }]);

  return Table;
}(React.Component); // bundle related sub-components


_defineProperty(Table, "propTypes", {
  /**
   * Array of table row data
   * @property {string} `className` Optional classes for styling individual rows
   */
  data: propTypes$1.arrayOf(propTypes$1.object),

  /**
   * Property name for unique key in data, defaults to "key"
   */
  dataKey: propTypes$1.string,

  /**
   * Indicates the table is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the table is taking a long time to load (a loading indicator will appear)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Error message to display within the table when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Message to display if the data contains no items
   */
  emptyMessage: propTypes$1.string,

  /**
   * Hide the table header row
   */
  noHeader: propTypes$1.bool,

  /**
   * Show the table footer row
   */
  showFooter: propTypes$1.bool,

  /**
   * Callback when a row is clicked
   * @param {Object} `item` The row item that was clicked on
   */
  onRowClick: propTypes$1.func,

  /**
   * Default behaviour for expanding rows. Can be one of the following options:
   * @typedef ExpandRowsType
   * @property {string} `none` Rows are initially collapsed, can be toggled using onExpand/onCollapse row callbacks
   * @property {string} `onClick` Rows are initially collapsed, will automatically toggle when a row is clicked
   * @property {string} `always` Rows are permanently expanded and cannot be collapsed
   * @property {string} `never` Rows are permanently collapsed and cannot be expanded
   */
  expandRows: propTypes$1.oneOf(Object.values(ExpandRowsType)),

  /**
   * Render function for displaying an expanded row
   * @param {Object} `item` The current row item being rendered
   * @param {Object} `state` An object representing the current row state
   * @param {*} `state.itemKey` Unique key value for row item
   * @param {number} `state.itemIndex` Row index for the item
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onCollapse` Collapses the row
   */
  renderExpandedRow: propTypes$1.func,

  /**
   * Array of items keys defining the initial set of rows that should be expanded
   */
  initialExpandedRows: propTypes$1.array,

  /**
   * Optional, the maximum number of rows that can be expanded at any one time.
   * If exceeded the oldest expanded row will be automatically collapsed.
   */
  maxExpandedRows: propTypes$1.number,

  /**
   * Time in milliseconds for the expanded row animation transitions, or false to disable
   */
  animateExpandedRows: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),

  /**
   * The total number of columns that the table contains.
   * If children contains Table.Column components this will be calculated automatically.
   * If children is a render function this should be specified manually.
   */
  columns: propTypes$1.number,

  /**
   * Content that each table row should contain, or a render function that will be passed the following parameters:
   * @param {Object} `item` The current item row being rendered
   * @param {Object} `state` An object representing the current row state
   * @param {*} `state.itemKey` Unique key value for row item
   * @param {number} `state.itemIndex` Row index for the item
   * @param {boolean} `state.expanded` Whether the row is currently expanded
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.onExpand` Expands the row
   * @param {function} `events.onCollapse` Collapses the row
   */
  children: propTypes$1.any,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Internal prop for Form.ArrayTable integration.
   * Array of row content for each rendered row of table data.
   * Allows the columns to be rendered differently per-row.
   * @ignore
   */
  rowContent: propTypes$1.arrayOf(propTypes$1.node)
});

_defineProperty(Table, "defaultProps", {
  dataKey: "key",
  emptyMessage: "No Results",
  expandRows: "none",
  initialExpandedRows: [],
  animateExpandedRows: 400,
  noHeader: false,
  showFooter: false
});

Table.Column = TableColumn;
Table.SelectableColumn = SelectableColumn;
Table.Row = TableRow;
Table.HeaderRow = HeaderRow;
Table.FooterRow = FooterRow;
Table.ExpandedRow = ExpandedRow;
Table.Actions = ActionCell;
Table.Menu = MenuCell;
Table.MenuItem = MenuCellItem;

/**
 * Combines a Form.Array and Table component, to enable form array data to be rendered as table rows
 */
var ArrayTableContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ArrayTableContainer, _React$Component);

  var _super = _createSuper(ArrayTableContainer);

  function ArrayTableContainer() {
    _classCallCheck(this, ArrayTableContainer);

    return _super.apply(this, arguments);
  }

  _createClass(ArrayTableContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          showErrors = _this$props.showErrors,
          allErrors = _this$props.allErrors,
          animateErrors = _this$props.animateErrors,
          disabled = _this$props.disabled,
          value = _this$props.value,
          arrayKey = _this$props.arrayKey,
          errors = _this$props.errors,
          children = _this$props.children,
          passThruChildren = _this$props.passThruChildren,
          passThruProps = _this$props.passThruProps;
      var tableProps = utils.omitProps(passThruProps, Object.keys(ArrayTableContainer.propTypes));
      return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Form$1.Field, {
        disabled: disabled
      }, typeof label === "string" ? /*#__PURE__*/React.createElement("label", null, label) : label), /*#__PURE__*/React.createElement(Table, _extends({}, tableProps, {
        data: value,
        dataKey: arrayKey,
        rowContent: children
      }), passThruChildren), /*#__PURE__*/React.createElement(Form$1.Field, {
        className: "array-error"
      }, /*#__PURE__*/React.createElement(FieldError, {
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animate: animateErrors
      })));
    }
  }]);

  return ArrayTableContainer;
}(React.Component);

_defineProperty(ArrayTableContainer, "propTypes", {
  children: propTypes$1.oneOfType([propTypes$1.node, propTypes$1.func]).isRequired,
  propagateUpdates: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.bool]),
  autoRemove: propTypes$1.bool,
  autoAddPopulate: propTypes$1.func,
  autoAdd: propTypes$1.bool,
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  arrayKey: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  maxLengthError: propTypes$1.string,
  maxLength: propTypes$1.number,
  minLengthError: propTypes$1.string,
  minLength: propTypes$1.number,
  label: propTypes$1.node
});

_defineProperty(ArrayTableContainer, "defaultProps", {
  arrayKey: "key",
  autoAdd: false,
  autoAddPopulate: function autoAddPopulate(arrayKey) {
    return _defineProperty({}, arrayKey, Date.now());
  },
  autoRemove: false
});

var ArrayTable = withFormArray({
  defaultProps: {
    arrayKey: "key",
    autoAdd: false,
    autoAddPopulate: function autoAddPopulate(arrayKey) {
      return _defineProperty({}, arrayKey, Date.now());
    },
    autoRemove: false
  },
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  }
})(ArrayTableContainer);

var index$3 = /*#__PURE__*/Object.freeze({
__proto__: null,
ArrayAction: ArrayAction,
ArrayAdder: ArrayAdder,
ArrayRemover: ArrayRemover,
ArrayField: ArrayField,
ObjectField: ObjectField,
ArrayTable: ArrayTable
});

/**
 * Conditionally render child components using the current form state
 */
var IfCondition = /*#__PURE__*/function (_React$Component) {
  _inherits(IfCondition, _React$Component);

  var _super = _createSuper(IfCondition);

  function IfCondition() {
    _classCallCheck(this, IfCondition);

    return _super.apply(this, arguments);
  }

  _createClass(IfCondition, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          condition = _this$props.condition,
          children = _this$props.children;
      var formState = utils.fieldFormState(this.context);

      if (!condition(formState)) {
        return null;
      } else if (React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children)) {
        return children;
      } else {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children);
      }
    }
  }]);

  return IfCondition;
}(React.Component);

_defineProperty(IfCondition, "propTypes", {
  condition: propTypes$1.func.isRequired
});

_defineProperty(IfCondition, "contextType", FormContext);

var index$4 = /*#__PURE__*/Object.freeze({
__proto__: null,
IfCondition: IfCondition
});

var _presetStart, _presetEnd, _defineProperty2;
var DateRangePreset;

(function (DateRangePreset) {
  DateRangePreset["Custom"] = "custom";
  DateRangePreset["Last7"] = "last7";
  DateRangePreset["Last28"] = "last28";
  DateRangePreset["Next7"] = "next7";
  DateRangePreset["Next28"] = "next28";
})(DateRangePreset || (DateRangePreset = {}));

var presets = [{
  text: "Custom",
  value: DateRangePreset.Custom
}, {
  text: "Last 7 days",
  value: DateRangePreset.Last7
}, {
  text: "Last 28 days",
  value: DateRangePreset.Last28
}, {
  text: "Next 7 days",
  value: DateRangePreset.Next7
}, {
  text: "Next 28 days",
  value: DateRangePreset.Next28
}];
var presetStart = (_presetStart = {}, _defineProperty(_presetStart, DateRangePreset.Last7, function (d) {
  return d.subtract(7, "day");
}), _defineProperty(_presetStart, DateRangePreset.Last28, function (d) {
  return d.subtract(28, "day");
}), _defineProperty(_presetStart, DateRangePreset.Next7, function (d) {
  return d;
}), _defineProperty(_presetStart, DateRangePreset.Next28, function (d) {
  return d;
}), _presetStart);
var presetEnd = (_presetEnd = {}, _defineProperty(_presetEnd, DateRangePreset.Last7, function (d) {
  return d;
}), _defineProperty(_presetEnd, DateRangePreset.Last28, function (d) {
  return d;
}), _defineProperty(_presetEnd, DateRangePreset.Next7, function (d) {
  return d.add(7, "day");
}), _defineProperty(_presetEnd, DateRangePreset.Next28, function (d) {
  return d.add(28, "day");
}), _presetEnd);

var DateRangeBase = /*#__PURE__*/function (_React$Component) {
  _inherits(DateRangeBase, _React$Component);

  var _super = _createSuper(DateRangeBase);

  function DateRangeBase() {
    var _this;

    _classCallCheck(this, DateRangeBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      preset: DateRangePreset.Custom
    });

    _defineProperty(_assertThisInitialized(_this), "onStartChange", function (date) {
      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          allowOverlap = _this$props.allowOverlap;

      var startValue = _this.parseValue(date);

      var startDate = _this.encodeInclusiveStart(startValue);

      var end = value.end;

      if (!allowOverlap) {
        // compare the decoded values to ensure no overlapping range
        var endValue = _this.parseValue(end);

        var endComparison = _this.decodeInclusiveEnd(endValue);

        if (startValue && endComparison && endComparison < startValue) {
          var diff = startValue.diff(endComparison, "days");
          end = _this.formatDate(endValue === null || endValue === void 0 ? void 0 : endValue.add(diff + 1, "day"));
        }
      }

      onChange({
        start: _this.formatDate(startDate),
        end: end
      });

      _this.setState({
        preset: DateRangePreset.Custom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEndChange", function (date) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onChange = _this$props2.onChange,
          allowOverlap = _this$props2.allowOverlap;
      var start = value.start;

      var endValue = _this.parseValue(date);

      var endDate = _this.encodeInclusiveEnd(endValue);

      if (!allowOverlap) {
        // compare the decoded values to ensure no overlapping range
        var startValue = _this.parseValue(start);

        var startComparison = _this.decodeInclusiveStart(startValue);

        if (endValue && startComparison && startComparison >= endValue) {
          var diff = startComparison.diff(endValue, "days");
          start = _this.formatDate(startValue === null || startValue === void 0 ? void 0 : startValue.subtract(diff + 1, "day"));
        }
      }

      onChange({
        start: start,
        end: _this.formatDate(endDate)
      });

      _this.setState({
        preset: DateRangePreset.Custom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPresetChange", function (e, d) {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          onChange = _this$props3.onChange;
      var preset = d.value;

      var startDate = _this.calculatePresetDate(presetStart[preset]);

      var endDate = _this.calculatePresetDate(presetEnd[preset]);

      onChange({
        start: _this.formatDate(startDate) || value.start,
        end: _this.formatDate(endDate) || value.end
      });

      _this.setState({
        preset: preset
      });
    });

    _defineProperty(_assertThisInitialized(_this), "calculatePresetDate", function (transform) {
      if (!transform) return null;
      var _this$props4 = _this.props,
          instant = _this$props4.instant,
          local = _this$props4.local,
          timezone = _this$props4.timezone;

      if (instant) {
        var date = transform(momentTimezone$1());
        return date.tz(timezone).startOf("day");
      } else if (local) {
        return transform(momentTimezone$1());
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "parseValue", function (value) {
      if (!value) return null;
      return _this.props.instant ? momentTimezone$1(value, momentTimezone$1.ISO_8601) : momentTimezone$1(value);
    });

    _defineProperty(_assertThisInitialized(_this), "formatDate", function (date) {
      if (!date) return null;
      return _this.props.instant ? date.toISOString() : date.format("YYYY-MM-DD");
    });

    _defineProperty(_assertThisInitialized(_this), "encodeInclusiveStart", function (date) {
      // take date and make it inclusive/exclusive
      var _this$props5 = _this.props,
          instant = _this$props5.instant,
          inclusiveStart = _this$props5.inclusiveStart;

      if (date && !inclusiveStart) {
        return instant ? date.subtract(1) : date.subtract(1, "day");
      }

      return date;
    });

    _defineProperty(_assertThisInitialized(_this), "decodeInclusiveStart", function (date) {
      // take date and undo inclusive/exclusive
      var _this$props6 = _this.props,
          instant = _this$props6.instant,
          inclusiveStart = _this$props6.inclusiveStart;

      if (date && !inclusiveStart) {
        return instant ? date.add(1) : date.add(1, "day");
      }

      return date;
    });

    _defineProperty(_assertThisInitialized(_this), "encodeInclusiveEnd", function (date) {
      // take date and make it inclusive/exclusive
      var _this$props7 = _this.props,
          instant = _this$props7.instant,
          inclusiveEnd = _this$props7.inclusiveEnd;

      if (date && inclusiveEnd && instant) {
        return date.add(1, "day").subtract(1);
      } else if (date && !inclusiveEnd) {
        return date.add(1, "day");
      }

      return date;
    });

    _defineProperty(_assertThisInitialized(_this), "decodeInclusiveEnd", function (date) {
      // take date and undo inclusive/exclusive
      var _this$props8 = _this.props,
          instant = _this$props8.instant,
          inclusiveEnd = _this$props8.inclusiveEnd;

      if (date && inclusiveEnd && instant) {
        return date.add(1).subtract(1, "day");
      } else if (date && !inclusiveEnd) {
        return date.subtract(1, "day");
      }

      return date;
    });

    return _this;
  }

  _createClass(DateRangeBase, [{
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          value = _this$props9.value;
          _this$props9.onChange;
          var errors = _this$props9.errors,
          showErrors = _this$props9.showErrors,
          allErrors = _this$props9.allErrors,
          animateErrors = _this$props9.animateErrors,
          disabled = _this$props9.disabled,
          label = _this$props9.label,
          inline = _this$props9.inline,
          required = _this$props9.required,
          passThruProps = _this$props9.passThruProps,
          instant = _this$props9.instant,
          local = _this$props9.local,
          startPlaceholder = _this$props9.startPlaceholder,
          endPlaceholder = _this$props9.endPlaceholder,
          showPresets = _this$props9.showPresets,
          className = _this$props9.className;
      var otherProps = utils.omitProps(passThruProps, Object.keys(DateRangeBase.propTypes));
      var DateComponent = instant ? DateInstant$1 : local ? DateLocal : null;

      if (!DateComponent) {
        console.error("Form DateRange field must have instant or local prop specified");
        return null;
      }

      var startValue = this.parseValue(value.start);
      var endValue = this.parseValue(value.end);
      var startDate = this.decodeInclusiveStart(startValue);
      var endDate = this.decodeInclusiveEnd(endValue);
      return /*#__PURE__*/React.createElement(Field, {
        inline: inline,
        required: required,
        disabled: disabled,
        width: "initial",
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames("cin date-range", className)
      }, /*#__PURE__*/React.createElement("div", {
        className: "tight-right"
      }, /*#__PURE__*/React.createElement(DateComponent, _extends({}, otherProps, {
        value: this.formatDate(startDate),
        onChange: this.onStartChange,
        placeholder: startPlaceholder,
        selectsStart: true,
        startDate: startDate,
        endDate: endDate,
        disabled: disabled
      }))), /*#__PURE__*/React.createElement("div", {
        className: classnames("tight-left", {
          "tight-right": showPresets
        })
      }, /*#__PURE__*/React.createElement(DateComponent, _extends({}, otherProps, {
        value: this.formatDate(endDate),
        onChange: this.onEndChange,
        placeholder: endPlaceholder,
        selectsEnd: true,
        startDate: startDate,
        endDate: endDate,
        disabled: disabled
      }))), showPresets && /*#__PURE__*/React.createElement("div", {
        className: "tight-left"
      }, /*#__PURE__*/React.createElement(Dropdown$1, {
        selection: true,
        compact: true,
        value: this.state.preset,
        onChange: this.onPresetChange,
        options: presets,
        disabled: disabled
      }))));
    }
  }]);

  return DateRangeBase;
}(React.Component);

_defineProperty(DateRangeBase, "propTypes", (_defineProperty2 = {
  timezone: propTypes$1.string,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  className: propTypes$1.string
}, _defineProperty(_defineProperty2, "timezone", propTypes$1.string), _defineProperty(_defineProperty2, "inclusiveEnd", propTypes$1.bool.isRequired), _defineProperty(_defineProperty2, "inclusiveStart", propTypes$1.bool.isRequired), _defineProperty(_defineProperty2, "allowOverlap", propTypes$1.bool.isRequired), _defineProperty(_defineProperty2, "showPresets", propTypes$1.bool.isRequired), _defineProperty(_defineProperty2, "endPlaceholder", propTypes$1.string), _defineProperty(_defineProperty2, "startPlaceholder", propTypes$1.string), _defineProperty(_defineProperty2, "local", propTypes$1.bool), _defineProperty(_defineProperty2, "instant", propTypes$1.bool), _defineProperty(_defineProperty2, "inline", propTypes$1.bool.isRequired), _defineProperty(_defineProperty2, "label", propTypes$1.node.isRequired), _defineProperty2));

_defineProperty(DateRangeBase, "defaultProps", {
  value: {},
  onChange: function onChange() {},
  timezone: momentTimezone$1.tz.guess()
});

var mapStateToProps$c = function mapStateToProps(state, ownProps) {
  return {
    timezone: ownProps.timezone || getPreferenceState(state).timezone
  };
};

var ConnectedDateRange = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false, function (value) {
    return value && value.start && value.end;
  })]
})(connect$1(mapStateToProps$c)(DateRangeBase));
/**
 * Field for choosing a range of dates
 */

var DateRange = function DateRange(props) {
  return /*#__PURE__*/React.createElement(ConnectedDateRange, props);
};

DateRange.propTypes = {
  label: propTypes$1.node,
  inline: propTypes$1.bool,
  instant: propTypes$1.bool,
  local: propTypes$1.bool,
  startPlaceholder: propTypes$1.string,
  endPlaceholder: propTypes$1.string,
  showPresets: propTypes$1.bool,
  allowOverlap: propTypes$1.bool,
  inclusiveStart: propTypes$1.bool,
  inclusiveEnd: propTypes$1.bool,
  timezone: propTypes$1.string,
  className: propTypes$1.string,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
DateRange.defaultProps = {
  label: "",
  inline: false,
  startPlaceholder: "Start",
  endPlaceholder: "End",
  showPresets: false,
  allowOverlap: false,
  inclusiveStart: true,
  inclusiveEnd: false
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var dist = createCommonjsModule$1(function (module) {
module.exports=function(e){function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}var t={};return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{configurable:!1,enumerable:!0,get:n});},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,r){return Object.prototype.hasOwnProperty.call(e,r)},r.p="",r(r.s=0)}([function(e,r,t){r.__esModule=!0,r.default=function(e,r){if(e&&r){var t=Array.isArray(r)?r:r.split(","),n=e.name||"",o=e.type||"",u=o.replace(/\/.*$/,"");return t.some(function(e){var r=e.trim();return "."===r.charAt(0)?n.toLowerCase().endsWith(r.toLowerCase()):r.endsWith("/*")?u===r.replace(/\/.*$/,""):o===r})}return !0};}]);
});

var accepts = unwrapExports$1(dist);

// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;else if (isDefined(minSize)) return file.size >= minSize;else if (isDefined(maxSize)) return file.size <= maxSize;
  }

  return true;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple;

  if (!multiple && files.length > 1) {
    return false;
  }

  return files.every(function (file) {
    return fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _nonIterableSpread$2(); }

function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray$2(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$3(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$3(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$3(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$3(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$3(_useDropzone, ["open"]);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return React.createElement(Fragment, null, children(_objectSpread({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: propTypes$1.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.arrayOf(propTypes$1.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypes$1.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypes$1.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypes$1.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypes$1.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypes$1.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypes$1.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypes$1.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypes$1.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypes$1.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypes$1.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypes$1.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypes$1.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypes$1.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypes$1.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypes$1.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState$4 = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState$4),
      _useReducer2 = _slicedToArray$2(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargetsRef.current.indexOf(event.target) === -1) {
      dragTargetsRef.current = [].concat(_toConsumableArray$2(dragTargetsRef.current), [event.target]);
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    });
    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray$2(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties$3(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_defineProperty$3({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties$3(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty$3({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        rejectedFiles: []
      });

    default:
      return state;
  }
}

var FileUploadBase = /*#__PURE__*/function (_React$Component) {
  _inherits(FileUploadBase, _React$Component);

  var _super = _createSuper(FileUploadBase);

  function FileUploadBase() {
    var _this;

    _classCallCheck(this, FileUploadBase);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (acceptedFiles, rejectedFiles, event) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onChange = _this$props.onChange,
          onDrop = _this$props.onDrop;

      if (acceptedFiles) {
        onChange(multiple ? acceptedFiles : acceptedFiles[0]);
      }

      if (onDrop) {
        onDrop(acceptedFiles, rejectedFiles, event);
      }
    });

    return _this;
  }

  _createClass(FileUploadBase, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value;
          _this$props2.onChange;
          var errors = _this$props2.errors,
          showErrors = _this$props2.showErrors,
          allErrors = _this$props2.allErrors,
          animateErrors = _this$props2.animateErrors,
          disabled = _this$props2.disabled,
          label = _this$props2.label,
          width = _this$props2.width,
          fluid = _this$props2.fluid,
          required = _this$props2.required,
          passThruProps = _this$props2.passThruProps,
          uploadText = _this$props2.uploadText,
          uploadIcon = _this$props2.uploadIcon,
          replaceText = _this$props2.replaceText,
          replaceIcon = _this$props2.replaceIcon,
          className = _this$props2.className,
          multiple = _this$props2.multiple;
      var dropzoneProps = utils.omitProps(passThruProps, Object.keys(FileUploadBase.propTypes));
      var hasSelection = multiple ? Array.isArray(value) && value.length > 0 : !!value;
      return /*#__PURE__*/React.createElement(Field, {
        required: required,
        disabled: disabled,
        width: width,
        fluid: fluid,
        label: label,
        errors: utils.fieldErrors(errors, showErrors, allErrors),
        animateErrors: animateErrors
      }, /*#__PURE__*/React.createElement(Dropzone, _extends({}, dropzoneProps, {
        onDrop: this.onDrop,
        multiple: multiple,
        disabled: disabled
      }), function (_ref) {
        var getRootProps = _ref.getRootProps,
            getInputProps = _ref.getInputProps,
            isDragActive = _ref.isDragActive,
            isDragAccept = _ref.isDragAccept,
            isDragReject = _ref.isDragReject;
        return /*#__PURE__*/React.createElement("div", getRootProps({
          className: classnames("dropzone", {
            uploaded: !!value,
            active: isDragActive,
            accept: isDragAccept,
            reject: isDragReject,
            disabled: disabled
          }, className)
        }), /*#__PURE__*/React.createElement("input", getInputProps()), hasSelection ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, typeof replaceIcon === "string" ? /*#__PURE__*/React.createElement(Icon, {
          name: replaceIcon,
          size: "large"
        }) : replaceIcon, " ", /*#__PURE__*/React.createElement("strong", null, Array.isArray(value) ? "".concat(value.length, " file").concat(value.length === 1 ? "" : "s", " selected") : value === null || value === void 0 ? void 0 : value.name)), /*#__PURE__*/React.createElement("p", null, replaceText)) : /*#__PURE__*/React.createElement(React.Fragment, null, typeof uploadIcon === "string" ? /*#__PURE__*/React.createElement(Icon, {
          name: uploadIcon,
          size: "huge"
        }) : uploadIcon, /*#__PURE__*/React.createElement("p", null, uploadText)));
      }));
    }
  }]);

  return FileUploadBase;
}(React.Component);

_defineProperty(FileUploadBase, "propTypes", {
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  field: propTypes$1.string.isRequired,
  fileTypesError: propTypes$1.string,
  fileExtensionTypes: propTypes$1.arrayOf(propTypes$1.string),
  fileMimeTypes: propTypes$1.arrayOf(propTypes$1.string),
  requiredError: propTypes$1.string,
  required: propTypes$1.bool,
  className: propTypes$1.string,
  replaceIcon: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.node]).isRequired,
  replaceText: propTypes$1.string.isRequired,
  uploadIcon: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.node]).isRequired,
  uploadText: propTypes$1.string.isRequired,
  multiple: propTypes$1.bool.isRequired,
  fluid: propTypes$1.bool,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  label: propTypes$1.node.isRequired
});

_defineProperty(FileUploadBase, "defaultProps", {
  onChange: function onChange() {}
});

var ConnectedFileUpload = connectForm({
  displayName: function displayName(props) {
    return props.label && typeof props.label === "string" ? props.label : utils.prettifyField(props.field);
  },
  validators: [index$1.requiredField(false), index$1.fileTypes()]
})(FileUploadBase);
/**
 * Field for uploading a file
 */

var FileUpload = function FileUpload(props) {
  return /*#__PURE__*/React.createElement(ConnectedFileUpload, props);
};

FileUpload.propTypes = {
  label: propTypes$1.node,
  width: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),
  fluid: propTypes$1.bool,
  multiple: propTypes$1.bool,
  uploadText: propTypes$1.string,
  uploadIcon: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.node]),
  replaceText: propTypes$1.string,
  replaceIcon: propTypes$1.oneOfType([propTypes$1.any, propTypes$1.node]),
  className: propTypes$1.string,
  required: propTypes$1.bool,
  requiredError: propTypes$1.string,
  fileMimeTypes: propTypes$1.arrayOf(propTypes$1.string),
  fileExtensionTypes: propTypes$1.arrayOf(propTypes$1.string),
  fileTypesError: propTypes$1.string,
  field: propTypes$1.string.isRequired,
  showErrors: propTypes$1.bool,
  allErrors: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  disabled: propTypes$1.bool,
  customErrors: propTypes$1.arrayOf(propTypes$1.string),
  customValidator: propTypes$1.func,
  notifiedFields: propTypes$1.arrayOf(propTypes$1.string)
};
FileUpload.defaultProps = {
  label: "",
  multiple: false,
  uploadText: "Drag and drop your file here",
  uploadIcon: "upload",
  replaceText: "Drag and drop another file here to replace",
  replaceIcon: "file"
};

var index$5 = /*#__PURE__*/Object.freeze({
__proto__: null,
DateRange: DateRange,
FileUpload: FileUpload
});

/**
 * Wraps a collection of form fields, and manages data and validation state
 */
var FormContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(FormContainer, _React$Component);

  var _super = _createSuper(FormContainer);

  function FormContainer() {
    _classCallCheck(this, FormContainer);

    return _super.apply(this, arguments);
  }

  _createClass(FormContainer, [{
    key: "render",
    value: function render() {
      var _ref = this.props;
          _ref.value;
          _ref.errors;
          var passThruProps = _ref.passThruProps,
          loading = _ref.loading,
          slowLoading = _ref.slowLoading,
          error = _ref.error,
          className = _ref.className,
          children = _ref.children;
      var semanticProps = utils.omitProps(passThruProps, Object.keys(FormContainer.propTypes));
      var showLoading = loading && (slowLoading || slowLoading === undefined);
      return /*#__PURE__*/React.createElement(Form$1, _extends({}, semanticProps, {
        className: className,
        loading: showLoading
      }), children, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      }));
    }
  }]);

  return FormContainer;
}(React.Component);

_defineProperty(FormContainer, "propTypes", {
  children: propTypes$1.oneOfType([propTypes$1.node, propTypes$1.func]),
  readOnly: propTypes$1.bool,
  disabled: propTypes$1.bool,
  animateErrors: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),
  allErrors: propTypes$1.bool,
  showErrors: propTypes$1.bool,
  onValidated: propTypes$1.any,
  onError: propTypes$1.any,
  errors: propTypes$1.any,
  onChange: propTypes$1.any.isRequired,
  value: propTypes$1.any,
  className: propTypes$1.string,
  error: propTypes$1.any,
  slowLoading: propTypes$1.bool,
  loading: propTypes$1.bool
});

_defineProperty(FormContainer, "defaultProps", {
  value: {},
  showErrors: false,
  allErrors: false,
  animateErrors: 400,
  disabled: false,
  readOnly: false
});

var Form = withForm({
  defaultProps: {
    animateErrors: 400
  }
})(FormContainer); // bundle related sub-components

Form.Field = Field;
Form.Clearer = FieldClearer;
Form.Error = FieldError;
Form.Group = FieldGroup;
Form.Trigger = FieldTrigger;
Form.Input = Input;
Form.Numeric = Numeric;
Form.Email = Email;
Form.Password = Password;
Form.Checkbox = Checkbox;
Form.CheckboxGroup = CheckboxGroup;
Form.CheckboxTree = CheckboxTree;
Form.Date = DateField;
Form.DateTime = DateTime;
Form.Dropdown = Dropdown;
Form.RadioGroup = RadioGroup;
Form.TextArea = TextArea;
Form.Time = TimeField;
Form.TypeAhead = TypeAhead;
Form.Url = Url;
Form.ArrayAction = ArrayAction;
Form.Array = ArrayField;
Form.Object = ObjectField;
Form.ArrayAdder = ArrayAdder;
Form.ArrayRemover = ArrayRemover;
Form.ArrayTable = ArrayTable;
Form.If = IfCondition;
Form.DateRange = DateRange;
Form.FileUpload = FileUpload;

var PanelPosition = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right"
};
var HorizontalAlignment = {
  Left: "left",
  Center: "center",
  Right: "right"
};
var VerticalAlignment = {
  Top: "top",
  Middle: "middle",
  Bottom: "bottom"
};

/**
 * A container for a single action
 */

var ActionBarItem = function ActionBarItem(_ref) {
  var align = _ref.align,
      verticalAlign = _ref.verticalAlign,
      fluid = _ref.fluid,
      content = _ref.content,
      className = _ref.className,
      children = _ref.children;
  var Content = content;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin action-bar-item", {
      fluid: fluid
    }, align, verticalAlign, className)
  }, Content ? /*#__PURE__*/React.createElement(Content, null) : children);
};

ActionBarItem.propTypes = {
  /**
   * Direction to align item content
   * @typedef HorizontalAlignment
   * @property {string} `left`
   * @property {string} `center`
   * @property {string} `right`
   */
  align: propTypes$1.oneOf(Object.values(HorizontalAlignment)),

  /**
   * Direction to vertically align item content
   * @typedef VerticalAlignment
   * @property {string} `top`
   * @property {string} `middle`
   * @property {string} `bottom`
   */
  verticalAlign: propTypes$1.oneOf(Object.values(VerticalAlignment)),

  /**
   * Whether the item should stretch to fill available space within a parent <ActionBar/>
   */
  fluid: propTypes$1.bool,

  /**
   * Optional component that will be rendered for the item content
   */
  content: propTypes$1.elementType,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * Spaces items within an <ActionBar/>
 */

var ActionBarSpace = function ActionBarSpace(_ref) {
  var width = _ref.width,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin action-bar-space", className),
    style: {
      width: "".concat(width * 10, "px")
    }
  });
};

ActionBarSpace.propTypes = {
  /**
   * Relative width of the space
   */
  width: propTypes$1.number,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
ActionBarSpace.defaultProps = {
  width: 1
};

/**
 * A container for arranging a horizontal group of actions
 */

var ActionBar = function ActionBar(_ref) {
  var verticalAlign = _ref.verticalAlign,
      wrap = _ref.wrap,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin action-bar", {
      wrap: wrap
    }, verticalAlign, className)
  }, children);
};

ActionBar.propTypes = {
  /**
   * Direction to vertically align items
   * @typedef VerticalAlignment
   * @property {string} `top`
   * @property {string} `middle`
   * @property {string} `bottom`
   */
  verticalAlign: propTypes$1.oneOf(Object.values(VerticalAlignment)),

  /**
   * Whether items should automatically wrap onto additional rows where required
   */
  wrap: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
}; // bundle related sub-components

ActionBar.Item = ActionBarItem;
ActionBar.Space = ActionBarSpace;

var _templateObject$2, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5;
var sizeMap = {
  none: "0",
  smallest: "0.25em",
  smaller: "0.5em",
  small: "0.75em",
  default: "1em",
  medium: "1em",
  large: "2em",
  larger: "3em",
  largest: "4em"
};

var buildDimensions = function buildDimensions(all, top, bottom, left, right) {
  var fallback = sizeMap[all] ? sizeMap[all] : 0;
  var topVal = sizeMap[top] ? sizeMap[top] : fallback;
  var bottomVal = sizeMap[bottom] ? sizeMap[bottom] : fallback;
  var leftVal = sizeMap[left] ? sizeMap[left] : fallback;
  var rightVal = sizeMap[right] ? sizeMap[right] : fallback;
  return "".concat(topVal, " ").concat(rightVal, " ").concat(bottomVal, " ").concat(leftVal);
};

var StyledContent = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  margin: ", ";\n  padding: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return buildDimensions(props.margin, props.marginTop, props.marginBottom, props.marginLeft, props.marginRight);
}, function (props) {
  return buildDimensions(props.padding, props.paddingTop, props.paddingBottom, props.paddingLeft, props.paddingRight);
}, function (props) {
  return sizeMap[props.top] && css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n      top: ", ";\n    "])), sizeMap[props.top]);
}, function (props) {
  return sizeMap[props.bottom] && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      bottom: ", ";\n    "])), sizeMap[props.bottom]);
}, function (props) {
  return sizeMap[props.left] && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      left: ", ";\n    "])), sizeMap[props.left]);
}, function (props) {
  return sizeMap[props.right] && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      right: ", ";\n    "])), sizeMap[props.right]);
});
/**
 * A component for arranging and spacing content
 */

var Content = function Content(_ref) {
  var absolute = _ref.absolute,
      className = _ref.className,
      visible = _ref.visible,
      animateVisible = _ref.animateVisible,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["absolute", "className", "visible", "animateVisible", "children"]);

  var classes = ["cin content", {
    absolute: absolute
  }];

  if (visible !== undefined && typeof animateVisible === "number" && animateVisible > 0) {
    return /*#__PURE__*/React.createElement(StyledContent, _extends({}, props, {
      className: classnames.apply(void 0, classes.concat([className]))
    }), /*#__PURE__*/React.createElement(Reveal, {
      visible: visible,
      duration: animateVisible
    }, children));
  }

  classes.push({
    hidden: visible !== undefined && !visible
  });
  return /*#__PURE__*/React.createElement(StyledContent, _extends({}, props, {
    className: classnames.apply(void 0, classes.concat([className]))
  }), children);
};

Content.propTypes = {
  /**
   * Content margin size for all sides
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  margin: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content margin size for the component top
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  marginTop: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content margin size for the component bottom
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  marginBottom: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content margin size for the component left
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  marginLeft: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content margin size for the component right
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  marginRight: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content padding size for all sides
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  padding: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content padding size for the component top
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  paddingTop: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content padding size for the component bottom
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  paddingBottom: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content padding size for the component left
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  paddingLeft: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content padding size for the component right
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  paddingRight: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Whether the content should be positioned absolutely
   */
  absolute: propTypes$1.bool,

  /**
   * Content top spacing when using absolute positioning
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  top: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content bottom spacing when using absolute positioning
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  bottom: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content left spacing when using absolute positioning
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  left: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Content right spacing when using absolute positioning
   * @typedef sizeMap
   * @property {string} `none`
   * @property {string} `smallest`
   * @property {string} `smaller`
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   * @property {string} `larger`
   * @property {string} `largest`
   */
  right: propTypes$1.oneOf(Object.keys(sizeMap)),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Optional, toggles whether the content is shown (without unmounting)
   */
  visible: propTypes$1.bool,

  /**
   * Time in milliseconds for the visible animation transition, or false to disable
   */
  animateVisible: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool])
};
Content.defaultProps = {
  animateVisible: 400
};

/**
 * Displays a horizontal divider to segregate content
 */

var HorizontalLine = function HorizontalLine(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    className: "cin horizontal-line ui segment inverted ".concat(color || "")
  });
};

HorizontalLine.propTypes = {
  /**
   * Semantic UI color value for the line
   */
  color: propTypes$1.string
};

/**
 * Spaces items within an <MenuBar/>
 */

var MenuBarSpace = function MenuBarSpace(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin menu-bar-space", className)
  });
};

MenuBarSpace.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * A container for arranging a horizontal menu bar
 */

var MenuBar = function MenuBar(_ref) {
  var primary = _ref.primary,
      compact = _ref.compact,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["primary", "compact", "className", "children"]);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classnames("cin menu-bar", {
      primary: primary,
      compact: compact
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, children));
};

MenuBar.propTypes = {
  /**
   * Whether the menu bar should have its padding reduced for a more compact layout
   */
  compact: propTypes$1.bool,

  /**
   * Adjusts the MenuBar styling to represent a top-level menu bar
   */
  primary: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
MenuBar.Space = MenuBarSpace;

var DefaultCloseIcon = function DefaultCloseIcon(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    icon: "close",
    circular: true,
    basic: true,
    type: "button",
    className: "close-sidebar"
  });
};
/**
 * A responsive container for rendering a navigation menu
 */


var NavSidebar = /*#__PURE__*/function (_React$Component) {
  _inherits(NavSidebar, _React$Component);

  var _super = _createSuper(NavSidebar);

  function NavSidebar(props) {
    var _this;

    _classCallCheck(this, NavSidebar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      window.addEventListener("resize", _this.onWindowResize);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      window.removeEventListener("resize", _this.onWindowResize);
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          fullScreen = _this$props.fullScreen,
          autoHide = _this$props.autoHide,
          collapsed = _this$props.collapsed,
          location = _this$props.location;
      var windowWidth = _this.state.windowWidth;
      var isFullScreen = typeof fullScreen !== "boolean" && !Number.isNaN(fullScreen) && fullScreen > 0 ? windowWidth <= fullScreen : fullScreen;

      if ((autoHide || isFullScreen) && location !== prevProps.location) {
        _this.hideMenu();
      } // auto-collapse on mobile


      if (collapsed === "auto" && location !== prevProps.location && windowWidth < _this.props.autoCollapseMobileWidth) {
        _this.onMouseLeave();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      // TODO future optimisation - width change only has an effect if crossing fixed/fullScreen/autoCollapseMobileWidth thresholds
      _this.setState({
        windowWidth: window.innerWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      clearTimeout(_this.leaveTimer);
      _this.enterTimer = setTimeout(function () {
        if (!_this.state.mouseOver && _this._isMounted) {
          _this.setState({
            mouseOver: true,
            animating: true
          }, _this.completeAnimation);
        }
      }, _this.props.collapsed === "auto" ? _this.props.autoCollapseWait : 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      clearTimeout(_this.enterTimer);
      _this.leaveTimer = setTimeout(function () {
        if (_this.state.mouseOver && _this._isMounted) {
          _this.setState({
            mouseOver: false,
            animating: true
          }, _this.completeAnimation);
        }
      }, _this.props.collapsed === "auto" ? _this.props.autoCollapseDelay : 0);
    });

    _defineProperty(_assertThisInitialized(_this), "completeAnimation", function () {
      clearTimeout(_this.animateTimer);
      _this.animateTimer = setTimeout(function () {
        if (!_this._isMounted) return;

        _this.setState({
          animating: false
        });
      }, 500);
    });

    _defineProperty(_assertThisInitialized(_this), "showMenu", function () {
      if (_this.state.visible) return;

      _this.setState({
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideMenu", function () {
      if (!_this.state.visible) return;

      _this.setState({
        visible: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleMenu", function () {
      return _this.setState({
        visible: !_this.state.visible
      });
    });

    _this.state = {
      visible: props.defaultVisible,
      windowWidth: window.innerWidth,
      mouseOver: false,
      animating: false
    };
    return _this;
  }

  _createClass(NavSidebar, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          fixed = _this$props2.fixed,
          fullScreen = _this$props2.fullScreen,
          fullScreenCloseIcon = _this$props2.fullScreenCloseIcon,
          renderMenu = _this$props2.renderMenu,
          children = _this$props2.children,
          dimmable = _this$props2.dimmable,
          autoHide = _this$props2.autoHide,
          fitContent = _this$props2.fitContent,
          collapsed = _this$props2.collapsed,
          autoCollapseMobileWidth = _this$props2.autoCollapseMobileWidth,
          animation = _this$props2.animation,
          className = _this$props2.className;
      var _this$state = this.state,
          windowWidth = _this$state.windowWidth,
          mouseOver = _this$state.mouseOver,
          animating = _this$state.animating;
      var visible = this.props.visible !== undefined ? this.props.visible : this.state.visible;
      var state = {
        visible: visible,
        animating: animating,
        collapsed: collapsed === "auto" && !mouseOver || collapsed === true,
        fixed: typeof fixed !== "boolean" && !Number.isNaN(fixed) && fixed > 0 ? windowWidth >= fixed : fixed,
        fullScreen: typeof fullScreen !== "boolean" && !Number.isNaN(fullScreen) && fullScreen > 0 ? windowWidth <= fullScreen : fullScreen
      };
      var events = {
        showMenu: this.showMenu,
        hideMenu: this.hideMenu,
        toggleMenu: this.toggleMenu
      };
      var FullScreenCloseElement = fullScreenCloseIcon === true ? DefaultCloseIcon : fullScreenCloseIcon;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames("cin nav-sidebar", {
          "fit-content": fitContent || state.fixed,
          "full-screen": state.fullScreen,
          collapsed: state.collapsed,
          animating: state.animating
        }, className)
      }, /*#__PURE__*/React.createElement(Sidebar.Pushable, null, /*#__PURE__*/React.createElement(Sidebar, {
        animation: state.fullScreen ? "overlay" : animation,
        visible: state.fixed || visible,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave
      }, collapsed === "auto" && windowWidth < autoCollapseMobileWidth && /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0)",
          zIndex: (!mouseOver || animating) && collapsed === "auto" && windowWidth < autoCollapseMobileWidth ? 5000 : -1
        },
        onClick: this.onMouseEnter
      }), state.fullScreen && !state.fixed && FullScreenCloseElement && /*#__PURE__*/React.createElement(FullScreenCloseElement, {
        onClick: this.hideMenu
      }), renderMenu(state, events)), /*#__PURE__*/React.createElement(Sidebar.Pusher, {
        dimmed: !state.fixed && visible && dimmable,
        onClick: autoHide ? this.hideMenu : undefined
      }, typeof children === "function" ? children(state, events) : children)));
    }
  }]);

  return NavSidebar;
}(React.Component);

_defineProperty(NavSidebar, "propTypes", {
  /**
   * Determines whether the sidebar is permanently fixed to the side of the screen
   * Can either be a boolean value or a pixel threshold above which the sidebar will become fixed
   */
  fixed: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.number]),

  /**
   * Determines whether the sidebar expands to fill the entire screen
   * Can either be a boolean value or a pixel threshold below which the sidebar occupies the entire screen
   */
  fullScreen: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.number]),

  /**
   * Shows an icon in the corner of the sidebar to allow it to be closed when in full screen mode, or a custom element type to render instead
   */
  fullScreenCloseIcon: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.elementType]),

  /**
   * Render function for displaying the navigation menu
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.visible` Whether the navigation menu is currently visible
   * @param {boolean} `state.animating` Whether the navigation menu is currently animating (collapsed-mode only)
   * @param {boolean} `state.collapsed` Whether the navigation menu is currently in a collapsed state
   * @param {boolean} `state.fixed` Whether the navigation menu is currently fixed to the side of the screen
   * @param {boolean} `state.fullScreen` Whether the navigation menu is currently showing full-screen
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.showMenu` Shows the navigation menu
   * @param {function} `events.hideMenu` Hides the navigation menu
   * @param {function} `events.toggleMenu` Toggles visibility of the navigation menu
   */
  renderMenu: propTypes$1.func.isRequired,

  /**
   * Content that the sidebar should wrap, or a render function that will be passed the following parameters:
   * @param {Object} `state` An object representing the current state
   * @param {boolean} `state.visible` Whether the navigation menu is currently visible
   * @param {boolean} `state.animating` Whether the navigation menu is currently animating (collapsed-mode only)
   * @param {boolean} `state.collapsed` Whether the navigation menu is currently in a collapsed state
   * @param {boolean} `state.fixed` Whether the navigation menu is currently fixed to the side of the screen
   * @param {boolean} `state.fullScreen` Whether the navigation menu is currently showing full-screen
   * @param {Object} `events` An object containing useful callbacks that can be triggered
   * @param {function} `events.showMenu` Shows the navigation menu
   * @param {function} `events.hideMenu` Hides the navigation menu
   * @param {function} `events.toggleMenu` Toggles visibility of the navigation menu
   */
  children: propTypes$1.any,

  /**
   * Whether the content being wrapped by the sidebar should be dimmed whilst the menu is open
   */
  dimmable: propTypes$1.bool,

  /**
   * Whether the menu should automatically hide when clicking outside the menu or navigating to another route
   * When in full screen mode navigation will always hide the menu
   */
  autoHide: propTypes$1.bool,

  /**
   * Whether the menu should be shown when the component is first mounted.
   * By default the sidebar will manage the menu visibility internally
   */
  defaultVisible: propTypes$1.bool,

  /**
   * Overrides whether the menu is currently visible, when specified the menu will act as a 'controlled' component (showMenu/hideMenu/toggleMenu events will have no effect).
   * Can be used to control menu visibility from outside the sidebar component
   */
  visible: propTypes$1.bool,

  /**
   * Whether the content being wrapped by the sidebar should be resized automatically when the sidebar is open.
   * When in fixed mode content will always be fitted
   */
  fitContent: propTypes$1.bool,

  /**
   * Whether to render a collapsed (narrow) version of the menu.
   * Can either be a boolean value or "auto" to automatically expand the menu on mouse-over
   */
  collapsed: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.string]),

  /**
   * Time to wait in milliseconds before the menu opens when in "auto" collapse mode and the mouse is hovered over
   */
  autoCollapseWait: propTypes$1.number,

  /**
   * Time delay in milliseconds before the menu collapses when in "auto" mode and the mouse is moved away
   */
  autoCollapseDelay: propTypes$1.number,

  /**
   * Window width at which a menu in "auto" collapse mode will handle mobile-friendly collapse behaviour
   */
  autoCollapseMobileWidth: propTypes$1.number,

  /**
   * Animation for opening / closing the menu, see Semantic UI Sidebar component for possible values
   * When in full screen mode will always use "overlay"
   */
  animation: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(NavSidebar, "defaultProps", {
  fixed: false,
  fullScreen: false,
  fullScreenCloseIcon: true,
  dimmable: false,
  autoHide: false,
  defaultVisible: false,
  fitContent: false,
  collapsed: false,
  autoCollapseWait: 150,
  autoCollapseDelay: 250,
  autoCollapseMobileWidth: 768,
  animation: "push"
});

var NavSidebar$1 = withRouter(NavSidebar);

/**
 * A container for rendering a column alongside other content
 */

var SideColumn = function SideColumn(_ref) {
  var renderColumn = _ref.renderColumn,
      right = _ref.right,
      border = _ref.border,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["renderColumn", "right", "border", "className", "children"]);

  var column = /*#__PURE__*/React.createElement("div", {
    className: classnames("column", {
      right: right,
      border: border
    })
  }, renderColumn());
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classnames("cin side-column", className)
  }), !right && column, /*#__PURE__*/React.createElement("div", {
    className: classnames("content", {
      right: right
    })
  }, children), right && column);
};

SideColumn.propTypes = {
  /**
   * Render function for displaying the column content
   */
  renderColumn: propTypes$1.func,

  /**
   * Whether the column should appear to the left or right of other content
   */
  right: propTypes$1.bool,

  /**
   * Whether a border should appear between the column and other content
   */
  border: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
SideColumn.defaultProps = {
  right: false,
  border: false
};

var _templateObject$3, _templateObject2$2, _templateObject3$1, _templateObject4$1, _templateObject5$1;
var DEFAULT_POSITION = "right";
var DEFAULT_SIZE = "20em";

var getSize$1 = function getSize(size) {
  return getCssPixelWidth(size, DEFAULT_SIZE);
};

var getTranslateX = function getTranslateX(position, size) {
  switch (position) {
    case PanelPosition.Right:
      return getSize$1(size);

    case PanelPosition.Left:
      return "-" + getSize$1(size);

    default:
      return 0;
  }
};

var getTranslateY = function getTranslateY(position, size) {
  switch (position) {
    case PanelPosition.Top:
      return "-" + getSize$1(size);

    case PanelPosition.Bottom:
      return getSize$1(size);

    default:
      return 0;
  }
};

var StyledPanel = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", "\n"])), function (props) {
  return (props.position === PanelPosition.Top || props.position === PanelPosition.Bottom) && css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n      height: ", ";\n    "])), getSize$1(props.size));
}, function (props) {
  return (props.position === PanelPosition.Left || props.position === PanelPosition.Right) && css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n      width: ", ";\n    "])), getSize$1(props.size));
}, function (props) {
  return props.visible && css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n      transform: translate3d(0, 0, 0);\n    "])));
}, function (props) {
  return !props.visible && css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n      transform: translate3d(\n        ", ",\n        ", ",\n        0\n      );\n    "])), getTranslateX(props.position, props.size), getTranslateY(props.position, props.size));
});

var DefaultCloseIcon$1 = function DefaultCloseIcon(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    icon: "close",
    circular: true,
    basic: true,
    type: "button",
    className: "close-panel"
  });
};
/**
 * A container for rendering content attached to the side of the window
 */


var SidePanel = /*#__PURE__*/function (_React$Component) {
  _inherits(SidePanel, _React$Component);

  var _super = _createSuper(SidePanel);

  function SidePanel() {
    var _this;

    _classCallCheck(this, SidePanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: !!_this.props.defaultOpen || !!_this.props.open,
      isVisible: !!_this.props.defaultOpen || !!_this.props.open
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.open != prevProps.open) {
        if (_this.props.open) {
          _this.onOpen();
        } else {
          _this.onClose();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this._animateTimer);
    });

    _defineProperty(_assertThisInitialized(_this), "onOpen", function () {
      _this.setState({
        isOpen: true
      });

      clearTimeout(_this._animateTimer);
      _this._animateTimer = setTimeout(function () {
        return _this.setState({
          isVisible: true
        });
      }, 10);
      if (_this.props.onOpen) _this.props.onOpen();
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      if (_this.props.onClosing && _this.props.onClosing() === false) {
        return;
      }

      _this.setState({
        isVisible: false
      });

      clearTimeout(_this._animateTimer);
      _this._animateTimer = setTimeout(function () {
        return _this.setState({
          isOpen: false
        });
      }, 500);
      if (_this.props.onClose) _this.props.onClose();
    });

    return _this;
  }

  _createClass(SidePanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.defaultOpen;
          var header = _this$props.header,
          closeIcon = _this$props.closeIcon,
          loading = _this$props.loading,
          slowLoading = _this$props.slowLoading,
          error = _this$props.error,
          dimmer = _this$props.dimmer,
          position = _this$props.position,
          size = _this$props.size,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["defaultOpen", "header", "closeIcon", "loading", "slowLoading", "error", "dimmer", "position", "size", "className", "children"]);

      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          isVisible = _this$state.isVisible;
      var CloseElement = closeIcon === true ? DefaultCloseIcon$1 : closeIcon;
      return /*#__PURE__*/React.createElement(Portal, _extends({}, otherProps, {
        open: isOpen,
        onOpen: this.onOpen,
        onClose: this.onClose
      }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledPanel, {
        visible: isVisible,
        position: position,
        size: size,
        className: classnames("cin side-panel", position, {
          visible: isVisible
        }, className)
      }, /*#__PURE__*/React.createElement(Dimmer.Dimmable, {
        dimmed: loading
      }, /*#__PURE__*/React.createElement(Dimmer, {
        active: loading,
        inverted: true
      }, (slowLoading || slowLoading === undefined) && /*#__PURE__*/React.createElement(Loader, {
        size: "large"
      })), typeof header === "string" ? /*#__PURE__*/React.createElement(Header, null, header) : header, CloseElement && /*#__PURE__*/React.createElement(CloseElement, {
        onClick: this.onClose
      }), children, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      }))), /*#__PURE__*/React.createElement(Dimmer, {
        active: dimmer && isOpen,
        page: true
      })));
    }
  }]);

  return SidePanel;
}(React.Component);

_defineProperty(SidePanel, "propTypes", {
  /**
   * Controls whether the panel is currently visible.
   * Alternatively set the trigger prop to use as an uncontrolled component
   */
  open: propTypes$1.bool,

  /**
   * Whether the panel should be shown when the component is first mounted
   */
  defaultOpen: propTypes$1.bool,

  /**
   * Callback function when the panel is opened
   */
  onOpen: propTypes$1.func,

  /**
   * Callback function when the panel is closed
   */
  onClose: propTypes$1.func,

  /**
   * Callback function when the panel is just about to close.
   * Return false to prevent the panel from closing
   */
  onClosing: propTypes$1.func,

  /**
   * Trigger element to render to open the panel.
   * Alternatively set the open prop to use as a controlled component
   */
  trigger: propTypes$1.node,

  /**
   * Panel title text or component
   */
  header: propTypes$1.node,

  /**
   * Shows an icon in the corner of the panel to allow it to be closed, or a custom element type to render instead
   */
  closeIcon: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.elementType]),

  /**
   * Indicates the panel is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the panel is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Error message to display within the panel when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Whether to display a dimmer over the rest of the page when the panel is open
   */
  dimmer: propTypes$1.bool,

  /**
   * The position on screen where the panel should be displayed
   * @typedef PanelPosition
   * @property {string} `top`
   * @property {string} `bottom`
   * @property {string} `left`
   * @property {string} `right`
   */
  position: propTypes$1.oneOf(Object.values(PanelPosition)),

  /**
   * Width of the panel in pixels, or a valid CSS width
   */
  size: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(SidePanel, "defaultProps", {
  dimmer: false,
  position: DEFAULT_POSITION,
  size: DEFAULT_SIZE
});

/**
 * Automatically triggers navigation log events on route changes
 */
var NavigationLogger = /*#__PURE__*/function (_React$Component) {
  _inherits(NavigationLogger, _React$Component);

  var _super = _createSuper(NavigationLogger);

  function NavigationLogger() {
    var _this;

    _classCallCheck(this, NavigationLogger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass(NavigationLogger, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var location = this.props.location;

      if (prevProps.location !== location) {
        logNavigation(location.pathname, {
          previous: prevProps.location.pathname,
          state: location.state
        });
      }
    }
  }]);

  return NavigationLogger;
}(React.Component);

var NavigationLogger$1 = withRouter(NavigationLogger);

/**
 * Automatically triggers a navigation log event when viewing a page
 */
var PageLogger = /*#__PURE__*/function (_React$Component) {
  _inherits(PageLogger, _React$Component);

  var _super = _createSuper(PageLogger);

  function PageLogger() {
    var _this;

    _classCallCheck(this, PageLogger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return null;
    });

    return _this;
  }

  _createClass(PageLogger, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          title = _this$props.title,
          location = _this$props.location;
      var pathname = location.pathname,
          state = location.state;
      logNavigation(pathname, {
        title: title,
        state: state
      });
    }
  }]);

  return PageLogger;
}(React.Component);

_defineProperty(PageLogger, "propTypes", {
  title: propTypes$1.string
});

var PageLogger$1 = withRouter(PageLogger);

/**
 * Creates a division between action menu items
 */

var ActionMenuDivider = function ActionMenuDivider(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(Dropdown$1.Divider, _extends({}, props, {
    className: classnames("cin action-menu-divider", className)
  }));
};

ActionMenuDivider.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * A heading for action menu items
 */

var ActionMenuHeader = function ActionMenuHeader(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(Dropdown$1.Header, _extends({}, props, {
    className: classnames("cin action-menu-header", className)
  }));
};

ActionMenuHeader.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * A single item on a popup list of actions
 */

var ActionMenuItem = function ActionMenuItem(_ref) {
  var link = _ref.link,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["link", "className"]);

  var linkProps = link ? {
    as: Link,
    to: link
  } : {};
  return /*#__PURE__*/React.createElement(Dropdown$1.Item, _extends({}, props, linkProps, {
    className: classnames("cin action-menu-item", className)
  }));
};

ActionMenuItem.propTypes = {
  /**
   * Optional, turns the item into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

var TabLayout = {
  Inline: "inline",
  Stacked: "stacked"
};
var StackedTabAlignment = {
  Top: "top",
  Bottom: "bottom"
};
var ActionMenuDirection = {
  Left: "left",
  Right: "right"
};

/**
 * A dropdown menu for a list of actions
 */

var ActionMenu = function ActionMenu(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      labelPosition = _ref.labelPosition,
      trigger = _ref.trigger,
      direction = _ref.direction,
      openOnHover = _ref.openOnHover,
      className = _ref.className,
      disabled = _ref.disabled,
      compact = _ref.compact,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["icon", "label", "labelPosition", "trigger", "direction", "openOnHover", "className", "disabled", "compact", "children"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mouseOver = _useState4[0],
      setMouseOver = _useState4[1];

  var hoverProps = {};

  if (openOnHover) {
    hoverProps = {
      onMouseEnter: function onMouseEnter() {
        setOpen(true);
        setMouseOver(true);
      },
      onMouseLeave: function onMouseLeave() {
        setOpen(false);
        setMouseOver(false);
      }
    };
  }

  var triggerProps = {
    disabled: disabled
  };
  var dropdownTrigger = trigger !== undefined ? /*#__PURE__*/React.cloneElement(trigger, triggerProps) : /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
    icon: icon,
    content: label,
    labelPosition: labelPosition
  }));
  return /*#__PURE__*/React.createElement(Dropdown$1, _extends({}, props, hoverProps, {
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      if (mouseOver) return;
      setOpen(false);
    },
    trigger: dropdownTrigger,
    icon: null,
    disabled: disabled,
    compact: compact,
    className: classnames("cin action-menu", className)
  }), /*#__PURE__*/React.createElement(Dropdown$1.Menu, {
    direction: direction,
    onClick: function onClick(e) {
      e.stopPropagation();
      setOpen(false);
    },
    onKeyDown: function onKeyDown(e) {
      return e.stopPropagation();
    },
    className: "ui vertical"
  }, children));
};

ActionMenu.propTypes = {
  /**
   * Semantic UI icon name to display on the menu button
   */
  icon: propTypes$1.string,

  /**
   * Text to display on the menu button
   */
  label: propTypes$1.string,

  /**
   * Position to display the text on the menu button relative to the icon
   */
  labelPosition: propTypes$1.string,

  /**
   * Optional, overrides the default button that opens the dropdown menu
   */
  trigger: propTypes$1.node,

  /**
   * Reduces the width of the menu to only take up the space necessary to fit content
   */
  compact: propTypes$1.bool,

  /**
   * Optional direction to render menu
   * @typedef ActionMenuDirection
   * @property {string} `left` Menu items open towards the left (right-aligned)
   * @property {string} `right` Menu items open towards the right (left-aligned)
   */
  direction: propTypes$1.oneOf(Object.values(ActionMenuDirection)),

  /**
   * Whether the dropdown menu should appear when the icon is hovered over
   */
  openOnHover: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
ActionMenu.defaultProps = {
  icon: "caret down",
  label: "Actions",
  labelPosition: "right",
  direction: "left",
  openOnHover: true
}; // bundle related sub-components

ActionMenu.Divider = ActionMenuDivider;
ActionMenu.Header = ActionMenuHeader;
ActionMenu.Item = ActionMenuItem;

var interopRequireWildcard = createCommonjsModule$1(function (module) {
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

module.exports = _interopRequireWildcard;
});

unwrapExports$1(interopRequireWildcard);

var interopRequireDefault = createCommonjsModule$1(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports$1(interopRequireDefault);

var _extends_1$1 = createCommonjsModule$1(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose$1 = _objectWithoutPropertiesLoose$4;

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties$4;

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck$2 = _classCallCheck$2;

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

var createClass$2 = _createClass$2;

var _typeof_1 = createCommonjsModule$1(function (module) {
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var assertThisInitialized$1 = _assertThisInitialized$3;

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof_1(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized$1(self);
}

var possibleConstructorReturn$1 = _possibleConstructorReturn$2;

var getPrototypeOf = createCommonjsModule$1(function (module) {
function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
});

var setPrototypeOf = createCommonjsModule$1(function (module) {
function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
});

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

var inherits$1 = _inherits$2;

var interopRequireDefault$1 = createCommonjsModule$1(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;
});

unwrapExports$1(interopRequireDefault$1);

var checkIndexBounds_1 = createCommonjsModule$1(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault$1(React);

var _warning = interopRequireDefault$1(warning_1);

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.default.Children.count(children);

  process.env.NODE_ENV !== "production" ? (0, _warning.default)(index >= 0 && index <= childrenCount, "react-swipeable-view: the new index: ".concat(index, " is out of bounds: [0-").concat(childrenCount, "].")) : void 0;
};

var _default = checkIndexBounds;
exports.default = _default;
});

unwrapExports$1(checkIndexBounds_1);

var constant = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports.default = _default;
});

unwrapExports$1(constant);

var computeIndex_1 = createCommonjsModule$1(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = interopRequireDefault$1(React);

var _constant = interopRequireDefault$1(constant);

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;
  var indexMax = _react.default.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}
});

unwrapExports$1(computeIndex_1);

var getDisplaySameSlide_1 = createCommonjsModule$1(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = interopRequireDefault$1(React);

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  var getChildrenKey = function getChildrenKey(child) {
    return child ? child.key : 'empty';
  };

  if (props.children.length && nextProps.children.length) {
    var oldKeys = _react.default.Children.map(props.children, getChildrenKey);

    var oldKey = oldKeys[props.index];

    if (oldKey !== null && oldKey !== undefined) {
      var newKeys = _react.default.Children.map(nextProps.children, getChildrenKey);

      var newKey = newKeys[nextProps.index];

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

var _default = getDisplaySameSlide;
exports.default = _default;
});

unwrapExports$1(getDisplaySameSlide_1);

var mod_1 = createCommonjsModule$1(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

var _default = mod;
exports.default = _default;
});

unwrapExports$1(mod_1);

var lib$1 = createCommonjsModule$1(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkIndexBounds", {
  enumerable: true,
  get: function get() {
    return _checkIndexBounds.default;
  }
});
Object.defineProperty(exports, "computeIndex", {
  enumerable: true,
  get: function get() {
    return _computeIndex.default;
  }
});
Object.defineProperty(exports, "constant", {
  enumerable: true,
  get: function get() {
    return _constant.default;
  }
});
Object.defineProperty(exports, "getDisplaySameSlide", {
  enumerable: true,
  get: function get() {
    return _getDisplaySameSlide.default;
  }
});
Object.defineProperty(exports, "mod", {
  enumerable: true,
  get: function get() {
    return _mod.default;
  }
});

var _checkIndexBounds = interopRequireDefault$1(checkIndexBounds_1);

var _computeIndex = interopRequireDefault$1(computeIndex_1);

var _constant = interopRequireDefault$1(constant);

var _getDisplaySameSlide = interopRequireDefault$1(getDisplaySameSlide_1);

var _mod = interopRequireDefault$1(mod_1);
});

unwrapExports$1(lib$1);

var SwipeableViews_1 = createCommonjsModule$1(function (module, exports) {





Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;
exports.default = exports.SwipeableViewsContext = void 0;

var _extends2 = interopRequireDefault(_extends_1$1);

var _objectWithoutProperties2 = interopRequireDefault(objectWithoutProperties);

var _classCallCheck2 = interopRequireDefault(classCallCheck$2);

var _createClass2 = interopRequireDefault(createClass$2);

var _possibleConstructorReturn2 = interopRequireDefault(possibleConstructorReturn$1);

var _getPrototypeOf2 = interopRequireDefault(getPrototypeOf);

var _inherits2 = interopRequireDefault(inherits$1);

var React$1 = interopRequireWildcard(React);

var _propTypes = interopRequireDefault(propTypes$1);

var _warning = interopRequireDefault(warning_1);



function addEventListener(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return {
    remove: function remove() {
      node.removeEventListener(event, handler, options);
    }
  };
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};
var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return "translate(".concat(-translate, "%, 0)");
    },
    'x-reverse': function xReverse(translate) {
      return "translate(".concat(translate, "%, 0)");
    },
    y: function y(translate) {
      return "translate(0, ".concat(-translate, "%)");
    },
    'y-reverse': function yReverse(translate) {
      return "translate(0, ".concat(translate, "%)");
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;
  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.


function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];
  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{
    pageX: event.pageX,
    pageY: event.pageY
  }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode && element !== document.body) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.


var nodeWhoClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;

    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    } // scrollTop is not always be an integer.
    // https://github.com/jquery/api.jquery.com/issues/608


    var scrollPosition = Math.round(shape[axisProperties.scrollPosition[axis]]);
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeWhoClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViewsContext = React$1.createContext();
exports.SwipeableViewsContext = SwipeableViewsContext;

if (process.env.NODE_ENV !== 'production') {
  SwipeableViewsContext.displayName = 'SwipeableViewsContext';
}

var SwipeableViews =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableViews, _React$Component);

  function SwipeableViews(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwipeableViews);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwipeableViews).call(this, props));
    _this.rootNode = null;
    _this.containerNode = null;
    _this.ignoreNextScrollEvents = false;
    _this.viewLength = 0;
    _this.startX = 0;
    _this.lastX = 0;
    _this.vx = 0;
    _this.startY = 0;
    _this.isSwiping = undefined;
    _this.started = false;
    _this.startIndex = 0;
    _this.transitionListener = null;
    _this.touchMoveListener = null;
    _this.activeSlide = null;
    _this.indexCurrent = null;
    _this.firstRenderTimeout = null;

    _this.setRootNode = function (node) {
      _this.rootNode = node;
    };

    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };

    _this.setActiveSlide = function (node) {
      _this.activeSlide = node;

      _this.updateHeight();
    };

    _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;
      var touch = applyRotationMatrix(event.touches[0], axis);
      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;
      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);
        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);
        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
      }
    };

    _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);

        return;
      } // We are not supposed to hanlde this touch move.


      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;
      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.

      if (_this.isSwiping === undefined) {
        var dx = Math.abs(touch.pageX - _this.startX);
        var dy = Math.abs(touch.pageY - _this.startY);
        var isSwiping = dx > dy && dx > lib$1.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.

        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === React$1.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        } // We are likely to be swiping, let's prevent the scroll event.


        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > lib$1.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      } // We are swiping, let's prevent the scroll event.


      event.preventDefault(); // Low Pass filter.

      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, lib$1.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX; // Add support for native scroll elements.


      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        }); // We abort the touch move handler.

        if (hasFoundNativeHandler) {
          return;
        }
      } // We are moving toward the edges.


      if (startX) {
        _this.startX = startX;
      } else if (nodeWhoClaimedTheScroll === null) {
        nodeWhoClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    };

    _this.handleSwipeEnd = function () {
      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
      // Makes sure that a starting point is set.

      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;
      var indexNew; // Quick movement

      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = React$1.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);

      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        } // Manually calling handleTransitionEnd in that case as isn't otherwise.


        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    };

    _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }

      _this.handleSwipeStart(event);
    };

    _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }

      _this.handleSwipeEnd(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }

      event.persist();

      _this.handleSwipeStart(adaptMouse(event));
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }

      _this.handleSwipeEnd(adaptMouse(event));
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    };

    _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    };

    _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      } // Ignore events bubbling up.


      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
      _this.ignoreNextScrollEvents = true; // Reset the scroll position.

      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    };

    _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];

        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    };

    if (process.env.NODE_ENV !== 'production') {
      (0, lib$1.checkIndexBounds)(props);
    }

    _this.state = {
      indexLatest: props.index,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      renderOnlyActive: !props.disableLazyLoading,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    };

    _this.setIndexCurrent(props.index);

    return _this;
  }

  (0, _createClass2.default)(SwipeableViews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListener(this.containerNode, 'transitionend', function (event) {
        if (event.target !== _this2.containerNode) {
          return;
        }

        _this2.handleTransitionEnd();
      }); // Block the thread to handle that event.

      this.touchMoveListener = addEventListener(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this2.props.disabled) {
          return;
        }

        _this2.handleSwipeMove(event);
      }, {
        passive: false
      });

      if (!this.props.disableLazyLoading) {
        this.firstRenderTimeout = setTimeout(function () {
          _this2.setState({
            renderOnlyActive: false
          });
        }, 0);
      } // Send all functions in an object if action param is set.


      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    } // eslint-disable-next-line camelcase,react/sort-comp

  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (process.env.NODE_ENV !== 'production') {
          (0, lib$1.checkIndexBounds)(nextProps);
        }

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, lib$1.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: "getSwipeableViewsContext",
    value: function getSwipeableViewsContext() {
      var _this3 = this;

      return {
        slideUpdateHeight: function slideUpdateHeight() {
          _this3.updateHeight();
        }
      };
    }
  }, {
    key: "setIndexCurrent",
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;
        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      } // Filters out when changing the children


      if (this.state.displaySameSlide) {
        return;
      } // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.


      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props;
          _this$props2.action;
          var animateHeight = _this$props2.animateHeight,
          animateTransitions = _this$props2.animateTransitions,
          axis = _this$props2.axis,
          children = _this$props2.children,
          containerStyleProp = _this$props2.containerStyle,
          disabled = _this$props2.disabled;
          _this$props2.disableLazyLoading;
          var enableMouseEvents = _this$props2.enableMouseEvents;
          _this$props2.hysteresis;
          _this$props2.ignoreNativeScroll;
          _this$props2.index;
          _this$props2.onChangeIndex;
          _this$props2.onSwitching;
          _this$props2.onTransitionEnd;
          _this$props2.resistance;
          var slideStyleProp = _this$props2.slideStyle,
          slideClassName = _this$props2.slideClassName,
          springConfig = _this$props2.springConfig,
          style = _this$props2.style;
          _this$props2.threshold;
          var other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
      var _this$state = this.state,
          displaySameSlide = _this$state.displaySameSlide,
          heightLatest = _this$state.heightLatest,
          indexLatest = _this$state.indexLatest,
          isDragging = _this$state.isDragging,
          renderOnlyActive = _this$state.renderOnlyActive;
      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {}; // There is no point to animate if we are already providing a height.

      process.env.NODE_ENV !== "production" ? (0, _warning.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, "react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.") : void 0;
      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
      var transition;
      var WebkitTransition;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      }; // Apply the styles for SSR considerations

      if (!renderOnlyActive) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return React$1.createElement(SwipeableViewsContext.Provider, {
        value: this.getSwipeableViewsContext()
      }, React$1.createElement("div", (0, _extends2.default)({
        ref: this.setRootNode,
        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), React$1.createElement("div", {
        ref: this.setContainerNode,
        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
        className: "react-swipeable-view-container"
      }, React$1.Children.map(children, function (child, indexChild) {
        if (renderOnlyActive && indexChild !== indexLatest) {
          return null;
        }

        process.env.NODE_ENV !== "production" ? (0, _warning.default)(React$1.isValidElement(child), "react-swipeable-view: one of the children provided is invalid: ".concat(child, ".\n  We are expecting a valid React Element")) : void 0;
        var ref;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = _this4.setActiveSlide;
            slideStyle.overflowY = 'hidden';
          }
        }

        return React$1.createElement("div", {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          "aria-hidden": hidden,
          "data-swipeable": "true"
        }, child);
      }))));
    }
  }]);
  return SwipeableViews;
}(React$1.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updateHeight() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,

  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes.default.bool,

  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes.default.bool,

  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),

  /**
   * Use this property to provide your slides.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes.default.object,

  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes.default.bool,

  /**
   * This is the config used to disable lazyloding,
   * if `true` will render all the views in first rendering.
   */
  disableLazyLoading: _propTypes.default.bool,

  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes.default.bool,

  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes.default.number,

  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes.default.bool,

  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes.default.number,

  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   * @param {object} meta Meta data containing more information about the event.
   */
  onChangeIndex: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseUp: _propTypes.default.func,

  /**
   * @ignore
   */
  onScroll: _propTypes.default.func,

  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding
   * to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchEnd: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchMove: _propTypes.default.func,

  /**
   * @ignore
   */
  onTouchStart: _propTypes.default.func,

  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes.default.func,

  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes.default.bool,

  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes.default.string,

  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes.default.object,

  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes.default.shape({
    delay: _propTypes.default.string,
    duration: _propTypes.default.string,
    easeFunction: _propTypes.default.string
  }),

  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes.default.object,

  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes.default.number
} : {};
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
var _default = SwipeableViews;
exports.default = _default;
});

unwrapExports$1(SwipeableViews_1);
SwipeableViews_1.getDomTreeShapes;
SwipeableViews_1.findNativeHandler;
SwipeableViews_1.SwipeableViewsContext;

var lib$2 = createCommonjsModule$1(function (module, exports) {



Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SwipeableViews.default;
  }
});
Object.defineProperty(exports, "SwipeableViewsContext", {
  enumerable: true,
  get: function get() {
    return _SwipeableViews.SwipeableViewsContext;
  }
});

var _SwipeableViews = interopRequireWildcard(SwipeableViews_1);
});

var SwipeableViews = unwrapExports$1(lib$2);

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser$1 || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser$1 || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize$1(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize$1(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize$1(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser$1) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index$6 = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce$2;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$2 = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$3(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$3(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_throttle = throttle$1;

var withPolyfill = createCommonjsModule$1(function (module, exports) {
Object.defineProperty(exports,'__esModule',{value:true});function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}var $inject_window_ResizeObserver__default=/*#__PURE__*/_interopDefaultLegacy(index$6);var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var debounce__default=/*#__PURE__*/_interopDefaultLegacy(lodash_debounce);var throttle__default=/*#__PURE__*/_interopDefaultLegacy(lodash_throttle);/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var patchResizeHandler = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch (refreshMode) {
        case 'debounce':
            return debounce__default['default'](resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return throttle__default['default'](resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var isFunction = function (fn) { return typeof fn === 'function'; };
var isSSR = function () { return typeof window === 'undefined'; };
var isDOMElement = function (element) { return element instanceof Element || element instanceof HTMLDocument; };
var createNotifier = function (onResize, setSize, handleWidth, handleHeight) { return function (_a) {
    var width = _a.width, height = _a.height;
    setSize(function (prev) {
        if (prev.width === width && prev.height === height) {
            // skip if dimensions haven't changed
            return prev;
        }
        if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
            // process `handleHeight/handleWidth` props
            return prev;
        }
        if (onResize && isFunction(onResize)) {
            onResize(width, height);
        }
        return { width: width, height: height };
    });
}; };var ResizeDetector = /** @class */ (function (_super) {
    __extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function () {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function () {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if (isSSR()) {
                return;
            }
            if (targetRef && targetRef.current) {
                _this.targetRef.current = targetRef.current;
            }
            var element = _this.getElement();
            if (!element) {
                // can't find element to observe
                return;
            }
            if (_this.observableElement && _this.observableElement === element) {
                // element is already observed
                return;
            }
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function () {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if (isSSR())
                return null;
            // in case we pass a querySelector
            if (querySelector)
                return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && isDOMElement(targetDomEl))
                return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && isDOMElement(_this.targetRef.current))
                return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = reactDom.findDOMNode(_this);
            if (!currentElement)
                return null;
            var renderType = _this.getRenderType();
            switch (renderType) {
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function (entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight)
                return;
            var notifyResize = createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function () {
            var _a = _this.props, render = _a.render, children = _a.children;
            if (isFunction(render)) {
                // DEPRECATED. Use `Child Function Pattern` instead
                return 'renderProp';
            }
            if (isFunction(children)) {
                return 'childFunction';
            }
            if (React.isValidElement(children)) {
                return 'child';
            }
            if (Array.isArray(children)) {
                // DEPRECATED. Wrap children with a single parent
                return 'childArray';
            }
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = React.createRef();
        _this.observableElement = null;
        if (isSSR()) {
            return _this;
        }
        _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new $inject_window_ResizeObserver__default['default'](_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (isSSR()) {
            return;
        }
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = { width: width, height: height, targetRef: this.targetRef };
        var renderType = this.getRenderType();
        var typedChildren;
        switch (renderType) {
            case 'renderProp':
                return render && render(childProps);
            case 'childFunction':
                typedChildren = children;
                return typedChildren(childProps);
            case 'child':
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    var nativeProps = __rest(childProps, ["targetRef"]);
                    return React.cloneElement(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return React.cloneElement(typedChildren, childProps);
            case 'childArray':
                typedChildren = children;
                return typedChildren.map(function (el) { return !!el && React.cloneElement(el, childProps); });
            default:
                return React__default['default'].createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}(React.PureComponent));function withResizeDetector(ComponentInner, options) {
    if (options === void 0) { options = {}; }
    var ResizeDetectorHOC = /** @class */ (function (_super) {
        __extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = React.createRef();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function () {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = __rest(_a, ["forwardedRef"]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return (React__default['default'].createElement(ResizeDetector, __assign({}, options, { targetRef: targetRef }),
                React__default['default'].createElement(ComponentInner, __assign({ targetRef: targetRef }, rest))));
        };
        return ResizeDetectorHOC;
    }(React.Component));
    function forwardRefWrapper(props, ref) {
        return React__default['default'].createElement(ResizeDetectorHOC, __assign({}, props, { forwardedRef: ref }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(" + name + ")";
    return React.forwardRef(forwardRefWrapper);
}var useEnhancedEffect = isSSR() ? React.useEffect : React.useLayoutEffect;
function useResizeDetector(props) {
    if (props === void 0) { props = {}; }
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = React.useRef(skipOnMount);
    var localRef = React.useRef(null);
    var ref = (targetRef !== null && targetRef !== void 0 ? targetRef : localRef);
    var resizeHandler = React.useRef();
    var _e = React.useState({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    useEnhancedEffect(function () {
        if (isSSR()) {
            return;
        }
        var notifyResize = createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function (entries) {
            if (!handleWidth && !handleHeight)
                return;
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                skipResize.current = false;
            });
        };
        resizeHandler.current = patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new $inject_window_ResizeObserver__default['default'](resizeHandler.current);
        if (ref.current) {
            // Something wrong with typings here...
            resizeObserver.observe(ref.current, observerOptions);
        }
        return function () {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) {
                patchedResizeHandler.cancel();
            }
        };
    }, [refreshMode, refreshRate, refreshOptions, handleWidth, handleHeight, onResize, observerOptions, ref.current]);
    return __assign({ ref: ref }, size);
}exports.default=ResizeDetector;exports.useResizeDetector=useResizeDetector;exports.withResizeDetector=withResizeDetector;
});

var ReactResizeDetector = unwrapExports$1(withPolyfill);
withPolyfill.useResizeDetector;
withPolyfill.withResizeDetector;

/**
 * A single item for a horizontal tab menu
 */

var TabMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(TabMenuItem, _React$Component);

  var _super = _createSuper(TabMenuItem);

  function TabMenuItem() {
    var _this;

    _classCallCheck(this, TabMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      mouseOver: false
    });

    _defineProperty(_assertThisInitialized(_this), "_x", 0);

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        mouseOver: true
      });

      if (_this.props.onMouseEnter) _this.props.onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        mouseOver: false
      });

      if (_this.props.onMouseLeave) _this.props.onMouseLeave(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (e) {
      _this._x = e.screenX;
      if (_this.props.onMouseDown) _this.props.onMouseDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var delta = Math.abs(e.screenX - _this._x);

      if (delta > 10) {
        // If mouse moved more than threshold, ignore click (prevent dragging also triggering a click)
        e.preventDefault();
      }

      _this._x = 0;
      if (_this.props.onClick) _this.props.onClick(e);
    });

    return _this;
  }

  _createClass(TabMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          index = _this$props.index,
          link = _this$props.link,
          exact = _this$props.exact,
          icon = _this$props.icon;
          _this$props.match;
          var location = _this$props.location;
          _this$props.history;
          _this$props.staticContext;
          var children = _this$props.children,
          content = _this$props.content,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["index", "link", "exact", "icon", "match", "location", "history", "staticContext", "children", "content", "className"]);

      var linkProps = link ? {
        as: Link,
        to: link
      } : {};
      var active = link ? !!matchPath(location.pathname, {
        path: link.pathname || link,
        exact: exact
      }) : this.props.active;
      var hover = this.state.mouseOver;
      var output = typeof children === "function" ? children({
        index: index,
        active: active,
        hover: hover
      }) : children || content;
      return /*#__PURE__*/React.createElement(Menu.Item, _extends({}, otherProps, linkProps, {
        active: active,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        onMouseDown: this.onMouseDown,
        onClick: this.onClick,
        className: classnames("cin tab-menu-item", className, {
          hover: hover
        })
      }), /*#__PURE__*/React.createElement("div", {
        className: "tab"
      }, /*#__PURE__*/React.createElement("div", {
        className: "overflow"
      }, icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, typeof icon === "string" ? /*#__PURE__*/React.createElement(Icon, {
        name: icon
      }) : icon), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, output)) : output)));
    }
  }]);

  return TabMenuItem;
}(React.Component);

TabMenuItem.propTypes = {
  /**
   * Optional, turns the item into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * When used as a link, whether an exact or partial path match is required for the item to be active
   */
  exact: propTypes$1.bool,

  /**
   * Semantic UI icon name to display on the item, or a custom icon element to render
   */
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Item content to render, or a render function that will be passed the following parameters:
   * @param {boolean} `active` Whether the item link is matched by the current route
   * @param {boolean} `hover` Whether the mouse is currently hovering over the item
   */
  children: propTypes$1.any
};
var TabMenuItem$1 = withRouter(TabMenuItem);

/**
 * The default navigation control for a horizontal tab menu
 */

var TabMenuNav = function TabMenuNav(_ref) {
  var direction = _ref.direction,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["direction", "className"]);

  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    icon: "angle ".concat(direction),
    className: classnames("cin tab-menu-nav", className, direction)
  }));
};

TabMenuNav.propTypes = {
  /**
   * The intended direction of the navigation control
   */
  direction: propTypes$1.oneOf(["left", "right"]).isRequired,

  /**
   * Whether the navigation control should be disabled
   */
  disabled: propTypes$1.bool,

  /**
   * Event to call when the navigation control is clicked on
   */
  onClick: propTypes$1.func
};

/**
 * A horizontal tab-style menu for content links
 */

var TabMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(TabMenu, _React$Component);

  var _super = _createSuper(TabMenu);

  function TabMenu() {
    var _this;

    _classCallCheck(this, TabMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      width: 0,
      index: 0
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "_overscrollTimeout", null);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function (width) {
      if (width !== _this.state.width) {
        _this.setState({
          width: width
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeIndex", function (index) {
      _this.setState({
        index: index
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onTransitionEnd", function () {
      if (!_this._isMounted) return;
      var _this$props = _this.props,
          minTabWidth = _this$props.minTabWidth,
          navWidth = _this$props.navWidth,
          showNav = _this$props.showNav,
          children = _this$props.children;
      var _this$state = _this.state,
          width = _this$state.width,
          index = _this$state.index;
      var childCount = React.Children.count(children);

      if (width > 0) {
        var totalNavWidth = showNav !== false ? navWidth * 2 : 0;
        var widthMinusNav = Math.max(width - totalNavWidth, 0);
        var minVisibleItems = Math.floor(widthMinusNav / minTabWidth);
        var maxIndex = Math.max(childCount - minVisibleItems, 0);

        if (index > maxIndex) {
          _this.setState({
            index: maxIndex
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onNavLeft", function () {
      _this.setState({
        index: Math.max(_this.state.index - 1, 0)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNavRight", function () {
      var children = _this.props.children;
      var childCount = React.Children.count(children);

      _this.setState({
        index: Math.min(_this.state.index + 1, childCount - 1)
      });
    });

    return _this;
  }

  _createClass(TabMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // re-trigger transition check to prevent overscrolling past last visible tab
      // (delay to avoid causing infinite loop)
      clearTimeout(this._overscrollTimeout);
      this._overscrollTimeout = setTimeout(this.onTransitionEnd, 10);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          minTabWidth = _this$props2.minTabWidth,
          navWidth = _this$props2.navWidth,
          NavComponent = _this$props2.navComponent,
          showNav = _this$props2.showNav,
          enableMouseScroll = _this$props2.enableMouseScroll,
          layout = _this$props2.layout,
          stackedAlign = _this$props2.stackedAlign,
          className = _this$props2.className,
          children = _this$props2.children,
          otherProps = _objectWithoutProperties(_this$props2, ["minTabWidth", "navWidth", "navComponent", "showNav", "enableMouseScroll", "layout", "stackedAlign", "className", "children"]);

      var _this$state2 = this.state,
          width = _this$state2.width,
          index = _this$state2.index;
      var totalNavWidth = showNav !== false ? navWidth * 2 : 0;
      var widthMinusNav = Math.max(width - totalNavWidth, 0);
      var childCount = React.Children.count(children);
      var targetWidth = 0;
      var minVisibleItems = 1;
      var forceHideNav = false;

      if (width > 0) {
        minVisibleItems = Math.floor(widthMinusNav / minTabWidth);
        var minVisibleItemsWithoutNav = Math.floor(width / minTabWidth);

        if (minVisibleItemsWithoutNav >= childCount) {
          forceHideNav = true;
          minVisibleItems = minVisibleItemsWithoutNav;
        }

        if (minVisibleItems >= childCount) {
          targetWidth = minTabWidth;
        } else {
          targetWidth = widthMinusNav / Math.max(minVisibleItems, 1);
        }
      }

      var navigable = showNav === true || showNav !== false && childCount * targetWidth > widthMinusNav && !forceHideNav;
      var firstTabOffscreen = index > 0;
      var canScrollLeft = navigable && firstTabOffscreen;
      var lastTabOffscreen = (childCount - index) * targetWidth > widthMinusNav;
      var canScrollRight = navigable && lastTabOffscreen;
      var elements = React.Children.map(children, function (e, idx) {
        return /*#__PURE__*/React.cloneElement(e, {
          index: idx
        });
      }); // when only a single item render at 100% width (minus a few pixels)
      // this ensures the container can be resized correctly

      return /*#__PURE__*/React.createElement("div", {
        className: classnames("cin tab-menu", {
          navigable: navigable
        }, layout, layout === TabLayout.Stacked ? stackedAlign : null, className),
        style: {
          maxWidth: childCount * minTabWidth + (navigable ? totalNavWidth : 0)
        }
      }, /*#__PURE__*/React.createElement(ReactResizeDetector, {
        handleWidth: true,
        onResize: this.onResize
      }), /*#__PURE__*/React.createElement(Menu, _extends({
        pointing: true,
        secondary: true
      }, otherProps), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: navigable ? "0 ".concat(navWidth, "px") : 0,
          maxWidth: minVisibleItems > 1 ? "100%" : width - (navigable ? totalNavWidth : 0) - 20,
          paddingLeft: minVisibleItems > 1 ? 0 : 10
        }
      }, /*#__PURE__*/React.createElement(SwipeableViews, {
        style: {
          width: minVisibleItems > 1 ? targetWidth : "100%"
        },
        enableMouseEvents: enableMouseScroll,
        index: index,
        onChangeIndex: this.onChangeIndex,
        onTransitionEnd: this.onTransitionEnd,
        disabled: !firstTabOffscreen && !lastTabOffscreen
      }, elements)), navigable && /*#__PURE__*/React.createElement("div", {
        className: "nav-container",
        style: {
          left: 0
        }
      }, /*#__PURE__*/React.createElement(NavComponent, {
        direction: "left",
        disabled: !canScrollLeft,
        onClick: this.onNavLeft
      })), navigable && /*#__PURE__*/React.createElement("div", {
        className: "nav-container",
        style: {
          right: widthMinusNav - Math.min((childCount - index) * targetWidth, widthMinusNav)
        }
      }, /*#__PURE__*/React.createElement(NavComponent, {
        direction: "right",
        disabled: !canScrollRight,
        onClick: this.onNavRight
      }))));
    }
  }]);

  return TabMenu;
}(React.Component);

_defineProperty(TabMenu, "propTypes", {
  /**
   * The minimum width of an individual tab in pixels
   * (tabs may grow larger than this to fill available space)
   */
  minTabWidth: propTypes$1.number,

  /**
   * The width of the navigation controls in pixels when active
   */
  navWidth: propTypes$1.number,

  /**
   * Component to render for the navigation controls when active
   * Will be passed direction, disabled, and onClick props
   */
  navComponent: propTypes$1.oneOfType([propTypes$1.func, propTypes$1.element]),

  /**
   * Whether the navigation controls are visible
   * Can either be a boolean value or "auto" to only show when there is not enough space to show all of the tabs
   */
  showNav: propTypes$1.oneOfType([propTypes$1.bool, propTypes$1.string]),

  /**
   * Whether to allow scrolling using the mouse to drag
   */
  enableMouseScroll: propTypes$1.bool,

  /**
   * Controls the layout of individual tabs
   * @typedef TabLayout
   * @property {string} `inline` Tab content and icons will be displayed inline. If the content is too long it will be clipped with an ellipsis.
   * @property {string} `stacked` Tab content and icons will be stacked vertically. Content will not be clipped.
   */
  layout: propTypes$1.oneOf(Object.values(TabLayout)),

  /**
   * When using the stacked layout mode, controls the alignment of tab icons/content
   * @typedef StackedTabAlignment
   * @property {string} `top`
   * @property {string} `bottom`
   */
  stackedAlign: propTypes$1.oneOf(Object.values(StackedTabAlignment)),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(TabMenu, "defaultProps", {
  minTabWidth: 140,
  navWidth: 35,
  navComponent: TabMenuNav,
  showNav: "auto",
  enableMouseScroll: false,
  layout: "inline",
  stackedAlign: "top"
});

TabMenu.Item = TabMenuItem$1;

/**
 * Creates a division between menu items
 */

var NavMenuDivider = function NavMenuDivider(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(Divider, _extends({}, props, {
    className: classnames("cin nav-menu-divider", className)
  }));
};

NavMenuDivider.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

var BaseMenuHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseMenuHeader, _React$Component);

  var _super = _createSuper(BaseMenuHeader);

  function BaseMenuHeader() {
    var _this;

    _classCallCheck(this, BaseMenuHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      mouseOver: false
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        mouseOver: true
      });

      if (_this.props.onMouseEnter) _this.props.onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        mouseOver: false
      });

      if (_this.props.onMouseLeave) _this.props.onMouseLeave(e);
    });

    return _this;
  }

  _createClass(BaseMenuHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          exact = _this$props.exact,
          icon = _this$props.icon;
          _this$props.match;
          var location = _this$props.location;
          _this$props.history;
          _this$props.staticContext;
          var children = _this$props.children,
          content = _this$props.content,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["link", "exact", "icon", "match", "location", "history", "staticContext", "children", "content", "className"]);

      var linkProps = link ? {
        as: Link,
        to: link
      } : {};
      var active = link ? !!matchPath(location.pathname, {
        path: link.pathname || link,
        exact: exact
      }) : this.props.active;
      var hover = this.state.mouseOver;
      var output = typeof children === "function" ? children({
        active: active,
        hover: hover
      }) : children || content;
      return /*#__PURE__*/React.createElement(Header, _extends({}, otherProps, linkProps, {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: classnames(className, {
          active: active,
          hover: hover
        })
      }), icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, typeof icon === "string" ? /*#__PURE__*/React.createElement(Icon, {
        name: icon
      }) : icon), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, output)) : output);
    }
  }]);

  return BaseMenuHeader;
}(React.Component);

BaseMenuHeader.propTypes = {
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),
  exact: propTypes$1.bool,
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
};
var BaseMenuHeader$1 = withRouter(BaseMenuHeader);

var BaseMenuItem = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseMenuItem, _React$Component);

  var _super = _createSuper(BaseMenuItem);

  function BaseMenuItem() {
    var _this;

    _classCallCheck(this, BaseMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      mouseOver: false
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        mouseOver: true
      });

      if (_this.props.onMouseEnter) _this.props.onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        mouseOver: false
      });

      if (_this.props.onMouseLeave) _this.props.onMouseLeave(e);
    });

    return _this;
  }

  _createClass(BaseMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          exact = _this$props.exact,
          icon = _this$props.icon;
          _this$props.match;
          var location = _this$props.location;
          _this$props.history;
          _this$props.staticContext;
          var children = _this$props.children,
          content = _this$props.content,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["link", "exact", "icon", "match", "location", "history", "staticContext", "children", "content", "className"]);

      var linkProps = link ? {
        as: Link,
        to: link
      } : {};
      var active = link ? !!matchPath(location.pathname, {
        path: link.pathname || link,
        exact: exact
      }) : this.props.active;
      var hover = this.state.mouseOver;
      var output = typeof children === "function" ? children({
        active: active,
        hover: hover
      }) : children || content;
      return /*#__PURE__*/React.createElement(Menu.Item, _extends({}, otherProps, linkProps, {
        active: active,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: classnames(className, {
          hover: hover
        })
      }), icon ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, typeof icon === "string" ? /*#__PURE__*/React.createElement(Icon, {
        name: icon
      }) : icon), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, output)) : output);
    }
  }]);

  return BaseMenuItem;
}(React.Component);

BaseMenuItem.propTypes = {
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),
  exact: propTypes$1.bool,
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
};
var BaseMenuItem$1 = withRouter(BaseMenuItem);

/**
 * A heading for navigation menu items
 */

var NavMenuHeader = function NavMenuHeader(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(BaseMenuHeader$1, _extends({
    color: "grey",
    size: "small"
  }, props, {
    className: classnames("cin nav-menu-header", className)
  }));
};

NavMenuHeader.propTypes = {
  /**
   * Optional, turns the header into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * When used as a link, whether an exact or partial path match is required for the header to be active
   */
  exact: propTypes$1.bool,

  /**
   * Semantic UI icon name to display on the header, or a custom icon element to render
   */
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Header content to render, or a render function that will be passed the following parameters:
   * @param {boolean} `active` Whether the header link is matched by the current route
   * @param {boolean} `hover` Whether the mouse is currently hovering over the header
   */
  children: propTypes$1.any
};

/**
 * A footer item for a navigation menu
 */

var NavMenuFooter = function NavMenuFooter(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(BaseMenuHeader$1, _extends({
    color: "grey",
    size: "tiny"
  }, props, {
    className: classnames("cin nav-menu-footer", className)
  }));
};

NavMenuFooter.propTypes = {
  /**
   * Optional, turns the footer into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * When used as a link, whether an exact or partial path match is required for the footer to be active
   */
  exact: propTypes$1.bool,

  /**
   * Semantic UI icon name to display on the footer, or a custom icon element to render
   */
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Footer content to render, or a render function that will be passed the following parameters:
   * @param {boolean} `active` Whether the footer link is matched by the current route
   * @param {boolean} `hover` Whether the mouse is currently hovering over the footer
   */
  children: propTypes$1.any
};

/**
 * A single item for a navigation menu
 */

var NavMenuItem = function NavMenuItem(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement(BaseMenuItem$1, _extends({}, props, {
    className: classnames("cin nav-menu-item", className)
  }));
};

NavMenuItem.propTypes = {
  /**
   * Optional, turns the item into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * When used as a link, whether an exact or partial path match is required for the item to be active
   */
  exact: propTypes$1.bool,

  /**
   * Semantic UI icon name to display on the item, or a custom icon element to render
   */
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Item content to render, or a render function that will be passed the following parameters:
   * @param {boolean} `active` Whether the item link is matched by the current route
   * @param {boolean} `hover` Whether the mouse is currently hovering over the item
   */
  children: propTypes$1.any
};

/**
 * A menu for app navigation
 */

var NavMenu = function NavMenu(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin nav-menu", className)
  }, /*#__PURE__*/React.createElement(Menu, _extends({
    borderless: true,
    fluid: true
  }, props)));
};

NavMenu.propTypes = {
  /**
   * Whether the menu is displayed vertically or horizontally
   */
  vertical: propTypes$1.bool,

  /**
   * Adjusts the NavMenu styling to represent a secondary-level menu
   */
  secondary: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
NavMenu.defaultProps = {
  vertical: true
}; // bundle related sub-components

NavMenu.Divider = NavMenuDivider;
NavMenu.Header = NavMenuHeader;
NavMenu.Footer = NavMenuFooter;
NavMenu.Item = NavMenuItem;

var TwoButtonModal = function TwoButtonModal(_ref) {
  var header = _ref.header,
      loading = _ref.loading,
      submitting = _ref.submitting,
      slowLoading = _ref.slowLoading,
      slowSubmitting = _ref.slowSubmitting,
      error = _ref.error,
      submitLabel = _ref.submitLabel,
      submitIcon = _ref.submitIcon,
      cancelLabel = _ref.cancelLabel,
      cancelIcon = _ref.cancelIcon,
      submitDisabled = _ref.submitDisabled,
      cancelDisabled = _ref.cancelDisabled,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["header", "loading", "submitting", "slowLoading", "slowSubmitting", "error", "submitLabel", "submitIcon", "cancelLabel", "cancelIcon", "submitDisabled", "cancelDisabled", "onSubmit", "onCancel", "children"]);

  return /*#__PURE__*/React.createElement(Modal$1, otherProps, /*#__PURE__*/React.createElement(Modal$1.Header, {
    content: header
  }), /*#__PURE__*/React.createElement(Modal$1.Content, null, /*#__PURE__*/React.createElement(Dimmer.Dimmable, {
    dimmed: loading
  }, /*#__PURE__*/React.createElement(Dimmer, {
    active: loading,
    inverted: true
  }, (slowLoading || slowLoading === undefined) && /*#__PURE__*/React.createElement(Loader, {
    size: "large"
  })), children, /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error
  }))), /*#__PURE__*/React.createElement(Modal$1.Actions, null, onCancel && /*#__PURE__*/React.createElement(Button, {
    negative: true,
    onClick: function onClick(e) {
      e.stopPropagation();
      onCancel();
    },
    disabled: cancelDisabled
  }, typeof cancelIcon === "string" ? /*#__PURE__*/React.createElement(Icon, {
    name: cancelIcon
  }) : cancelIcon, cancelLabel), onSubmit && /*#__PURE__*/React.createElement(Button, {
    positive: true,
    onClick: function onClick(e) {
      e.stopPropagation();
      onSubmit();
    },
    loading: submitting && (slowSubmitting || slowSubmitting === undefined),
    disabled: loading || submitting || submitDisabled
  }, typeof submitIcon === "string" ? /*#__PURE__*/React.createElement(Icon, {
    name: submitIcon
  }) : submitIcon, submitLabel)));
};

TwoButtonModal.propTypes = {
  header: propTypes$1.node,
  loading: propTypes$1.bool,
  submitting: propTypes$1.bool,
  slowLoading: propTypes$1.bool,
  slowSubmitting: propTypes$1.bool,
  error: propTypes$1.any,
  submitLabel: propTypes$1.string,
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),
  cancelLabel: propTypes$1.string,
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),
  submitDisabled: propTypes$1.bool,
  cancelDisabled: propTypes$1.bool,
  onSubmit: propTypes$1.func,
  onCancel: propTypes$1.func
};

/**
 * A modal template for performing an add operation
 */

var AddModal = function AddModal(props) {
  return /*#__PURE__*/React.createElement(TwoButtonModal, props);
};

AddModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Force the cancel button to be disabled
   */
  cancelDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Event handler for when the cancel button is clicked
   */
  onCancel: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
AddModal.defaultProps = {
  header: "Add",
  submitLabel: "Add",
  cancelLabel: "Cancel",
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  size: "small",
  submitIcon: "checkmark",
  cancelIcon: "remove"
};

/**
 * A modal template for confirming some action
 */

var ConfirmationModal = function ConfirmationModal(_ref) {
  var content = _ref.content,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["content", "children"]);

  var modalContent = content ? typeof content === "string" ? /*#__PURE__*/React.createElement("p", null, content) : content : children;
  return /*#__PURE__*/React.createElement(TwoButtonModal, otherProps, modalContent);
};

ConfirmationModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Force the cancel button to be disabled
   */
  cancelDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Event handler for when the cancel button is clicked
   */
  onCancel: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Optional text or component to display within the modal
   */
  content: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
};
ConfirmationModal.defaultProps = {
  header: "Confirm",
  submitLabel: "Yes",
  cancelLabel: "No",
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  size: "tiny",
  submitIcon: "checkmark",
  cancelIcon: "remove"
};

/**
 * A modal template for performing a delete operation
 */

var DeleteModal = function DeleteModal(props) {
  return /*#__PURE__*/React.createElement(ConfirmationModal, props);
};

DeleteModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Force the cancel button to be disabled
   */
  cancelDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Event handler for when the cancel button is clicked
   */
  onCancel: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Optional text or component to display within the modal
   */
  content: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
};
DeleteModal.defaultProps = {
  header: "Delete",
  submitLabel: "Delete",
  cancelLabel: "Cancel",
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  size: "tiny",
  submitIcon: "checkmark",
  cancelIcon: "remove"
};

/**
 * A modal template for performing an edit operation
 */

var EditModal = function EditModal(props) {
  return /*#__PURE__*/React.createElement(TwoButtonModal, props);
};

EditModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Force the cancel button to be disabled
   */
  cancelDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Event handler for when the cancel button is clicked
   */
  onCancel: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
EditModal.defaultProps = {
  header: "Edit",
  submitLabel: "Update",
  cancelLabel: "Cancel",
  onSubmit: function onSubmit() {},
  onCancel: function onCancel() {},
  size: "small",
  submitIcon: "checkmark",
  cancelIcon: "remove"
};

/**
 * A modal template for displaying some information
 */

var InformationModal = function InformationModal(_ref) {
  var content = _ref.content,
      children = _ref.children;
      _ref.cancelLabel;
      _ref.cancelDisabled;
      _ref.onCancel;
      var otherProps = _objectWithoutProperties(_ref, ["content", "children", "cancelLabel", "cancelDisabled", "onCancel"]);

  var modalContent = content ? typeof content === "string" ? /*#__PURE__*/React.createElement("p", null, content) : content : children;
  return /*#__PURE__*/React.createElement(TwoButtonModal, _extends({}, otherProps, {
    onCancel: undefined
  }), modalContent);
};

InformationModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Optional text or component to display within the modal
   */
  content: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
};
InformationModal.defaultProps = {
  header: "Information",
  submitLabel: "OK",
  onSubmit: function onSubmit() {},
  size: "small",
  submitIcon: "checkmark"
};

/**
 * A modal template for uploading a file
 */

var UploadModal = function UploadModal(props) {
  return /*#__PURE__*/React.createElement(TwoButtonModal, props);
};

UploadModal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Semantic UI modal size
   */
  size: propTypes$1.string,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
UploadModal.defaultProps = {
  header: "Upload File",
  submitLabel: "Upload",
  cancelLabel: "Cancel",
  onSubmit: function onSubmit() {},
  size: "tiny",
  submitIcon: "checkmark",
  cancelIcon: "remove"
};

/**
 * A standard two-button modal
 */

var Modal = function Modal(props) {
  return /*#__PURE__*/React.createElement(TwoButtonModal, props);
};

Modal.propTypes = {
  /**
   * Modal title text
   */
  header: propTypes$1.node,

  /**
   * Indicates the modal is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the model is busy submitting data
   */
  submitting: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to load (a loading indicator will appear over any content)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Indicates the modal is taking a long time to submit (the submit button will show a busy indicator)
   */
  slowSubmitting: propTypes$1.bool,

  /**
   * Error message to display within the model when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Text to display on the submit button
   */
  submitLabel: propTypes$1.string,

  /**
   * Icon to display on the submit button
   */
  submitIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Text to display on the cancel button
   */
  cancelLabel: propTypes$1.string,

  /**
   *Icon to display on the cancel button
   */
  cancelIcon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element]),

  /**
   * Force the submit button to be disabled
   */
  submitDisabled: propTypes$1.bool,

  /**
   * Force the cancel button to be disabled
   */
  cancelDisabled: propTypes$1.bool,

  /**
   * Event handler for when the submit button is clicked
   */
  onSubmit: propTypes$1.func,

  /**
   * Event handler for when the cancel button is clicked
   */
  onCancel: propTypes$1.func,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
Modal.defaultProps = {
  submitLabel: "Submit",
  cancelLabel: "Cancel",
  submitIcon: "checkmark",
  cancelIcon: "remove"
}; // bundle related sub-components

Modal.Add = AddModal;
Modal.Delete = DeleteModal;
Modal.Edit = EditModal;
Modal.Confirmation = ConfirmationModal;
Modal.Information = InformationModal;
Modal.Upload = UploadModal;

/**
 * A single part of a breadcrumb trail
 */

var BreadcrumbItem = /*#__PURE__*/function (_React$Component) {
  _inherits(BreadcrumbItem, _React$Component);

  var _super = _createSuper(BreadcrumbItem);

  function BreadcrumbItem() {
    var _this;

    _classCallCheck(this, BreadcrumbItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          lookupRequest = _this$props.lookupRequest,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          lookupOptions = _this$props.lookupOptions,
          lookupData = _this$props.lookupData; // re-request if lookup was reset or params changed

      if (lookup && (lookup !== prevProps.lookup || !lookupData.date && prevProps.lookupData.date || !compareParams(lookupParams, prevProps.lookupParams))) {
        lookupRequest(lookup, lookupParams, lookupOptions);
      }
    });

    return _this;
  }

  _createClass(BreadcrumbItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          lookupRequest = _this$props2.lookupRequest,
          lookup = _this$props2.lookup,
          lookupParams = _this$props2.lookupParams,
          lookupOptions = _this$props2.lookupOptions;

      if (lookup) {
        lookupRequest(lookup, lookupParams, lookupOptions);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          lookup = _this$props3.lookup;
          _this$props3.lookupAction;
          _this$props3.lookupParams;
          _this$props3.lookupOptions;
          var lookupData = _this$props3.lookupData;
          _this$props3.lookupRequest;
          var props = _objectWithoutProperties(_this$props3, ["lookup", "lookupAction", "lookupParams", "lookupOptions", "lookupData", "lookupRequest"]);

      var inputProps = props;

      if (lookup) {
        if (lookupData && lookupData.response) {
          var lookupProps = _typeof(lookupData.response) === "object" ? lookupData.response : {
            content: lookupData.response
          };
          inputProps = _objectSpread2(_objectSpread2({}, inputProps), lookupProps);
        } else {
          inputProps = _objectSpread2(_objectSpread2({}, inputProps), {}, {
            content: ". . ."
          });
        }
      }

      var _inputProps = inputProps,
          link = _inputProps.link,
          icon = _inputProps.icon,
          children = _inputProps.children,
          content = _inputProps.content,
          otherProps = _objectWithoutProperties(_inputProps, ["link", "icon", "children", "content"]);

      var linkProps = link ? {
        as: Link,
        to: link
      } : {};
      return /*#__PURE__*/React.createElement(Breadcrumb$1.Section, _extends({}, otherProps, linkProps), icon && (typeof icon === "string" ? /*#__PURE__*/React.createElement(Icon, {
        name: icon
      }) : icon), children || content);
    }
  }]);

  return BreadcrumbItem;
}(React.Component);

_defineProperty(BreadcrumbItem, "propTypes", {
  /**
   * Optional, link for the breadcrumb item to navigate to
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * Optional, a lookup that has already been registered to use for the breadcrumb item content, not required when using the lookupAction prop
   */
  lookup: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.object]),

  /**
   * Optional API action creator to get lookup data, if specified a temporary lookup will be automatically registered instead of the one supplied to the lookup prop
   */
  lookupAction: propTypes$1.func,

  /**
   * Optional additional parameters to supply to the lookup's action
   */
  lookupParams: propTypes$1.any,

  /**
   * Optional additional configuration options for requesting or resetting the lookup data
   */
  lookupOptions: propTypes$1.object,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Custom icon element or name of a Semantic UI icon to display alongside the item
   */
  icon: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.element])
});

var mapStateToProps$d = function mapStateToProps(state, _ref) {
  var lookup = _ref.lookup,
      lookupParams = _ref.lookupParams,
      lookupOptions = _ref.lookupOptions;
  return {
    lookupData: lookup ? getLookupData(state, lookup, lookupParams, lookupOptions) : null
  };
};

var actions$6 = {
  lookupRequest: lookupRequest
};
var BreadcrumbItem$1 = compose(withLookup({
  autoNamePrefix: "BreadcrumbItem/",
  required: false
}), connect$1(mapStateToProps$d, actions$6))(BreadcrumbItem);

/**
 * Renders a breadcrumb navigation trail
 */

var Breadcrumb = /*#__PURE__*/function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    var _this;

    _classCallCheck(this, Breadcrumb);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderChildren", function (children) {
      var divider = _this.props.divider;
      if (!children) return null;
      return React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, index > 0 && /*#__PURE__*/React.createElement(Breadcrumb$1.Divider, null, divider), child);
      });
    });

    return _this;
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inverted = _this$props.inverted,
          className = _this$props.className,
          children = _this$props.children;
          _this$props.divider;
          var otherProps = _objectWithoutProperties(_this$props, ["inverted", "className", "children", "divider"]);

      return /*#__PURE__*/React.createElement("div", {
        className: classnames("cin breadcrumb", {
          inverted: inverted
        }, className)
      }, /*#__PURE__*/React.createElement(Breadcrumb$1, otherProps, this.renderChildren(children)));
    }
  }]);

  return Breadcrumb;
}(React.Component);

Breadcrumb.propTypes = {
  /**
   * Whether to invert the breadcrumb text for display on darker backgrounds
   */
  inverted: propTypes$1.bool,

  /**
   * The text or <Icon /> to divide Breadcumb items
   */
  divider: propTypes$1.node,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
Breadcrumb.defaultProps = {
  divider: /*#__PURE__*/React.createElement(Icon, {
    name: "right chevron"
  })
};
Breadcrumb.Item = BreadcrumbItem$1;

var NotificationPosition = {
  TopLeft: "topLeft",
  TopRight: "topRight",
  BottomLeft: "bottomLeft",
  BottomRight: "bottomRight"
};

var _templateObject$4, _templateObject2$3, _templateObject3$2;
var EventWrapper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"])), function (props) {
  return css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n      width: ", "px;\n    "])), props.width);
}, function (props) {
  return css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n      margin: ", "px;\n    "])), props.margin);
});

var NotificationStackItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationStackItem, _React$Component);

  var _super = _createSuper(NotificationStackItem);

  function NotificationStackItem() {
    var _this;

    _classCallCheck(this, NotificationStackItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showing: false,
      visible: false,
      hiding: false
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      var _this$props$event = _this.props.event,
          creation = _this$props$event.creation,
          expiry = _this$props$event.expiry;

      if (expiry > 0) {
        var dismissal = creation + expiry - Date.now();

        if (dismissal > 0) {
          // set timer to automatically dismiss in the future
          _this.timer = setTimeout(_this.onDismiss, dismissal);
        } else {
          // already expired
          _this.onDismiss();
        }
      }

      _this.setState({
        showing: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearTimeout(_this.timer);
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (_this.props.dismiss && !prevProps.dismiss) {
        _this.onDismiss();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function (nextProps, nextState) {
      return nextState.showing !== _this.state.showing || nextState.visible;
    });

    _defineProperty(_assertThisInitialized(_this), "truncateMessage", function (message) {
      var maxMessageLength = _this.props.maxMessageLength;
      return message.length > maxMessageLength ? message.substring(0, maxMessageLength) + "..." : message;
    });

    _defineProperty(_assertThisInitialized(_this), "getMessageProps", function () {
      switch (_this.props.event.type) {
        case EventType.Success:
          return {
            success: true,
            icon: "check circle"
          };

        case EventType.Info:
          return {
            info: true,
            icon: "info circle"
          };

        case EventType.Warning:
          return {
            warning: true,
            icon: "warning circle"
          };

        case EventType.Error:
          return {
            error: true,
            icon: "remove circle"
          };

        default:
          return {};
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getDisplayTime", function () {
      var creation = _this.props.event.creation;
      if (!creation) return "";
      var ageSeconds = Math.floor((Date.now() - creation) / 1000);
      var ageMinutes = Math.floor(ageSeconds / 60);

      if (ageMinutes < 1) {
        return "Just now";
      }

      return "".concat(ageMinutes, " minute").concat(ageMinutes > 1 ? "s" : "", " ago");
    });

    _defineProperty(_assertThisInitialized(_this), "onDismiss", function () {
      if (!_this.props.onDismiss || !_this._isMounted) return;

      _this.setState({
        showing: false,
        visible: false,
        hiding: true
      });

      clearTimeout(_this.timer);
    });

    _defineProperty(_assertThisInitialized(_this), "onTransitionComplete", function () {
      // prevent state changes after unmounting
      if (!_this._isMounted) return;

      _this.setState({
        visible: true
      });

      if (_this.state.hiding) {
        setTimeout(function () {
          return _this.props.onDismiss(_this.props.event);
        }, 10);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "defaultRenderEvent", function (data, state, events) {
      var messageProps = _this.getMessageProps();

      var isMessageTruncated = state.truncatedMessage !== data.message;
      var content = /*#__PURE__*/React.createElement("p", {
        style: isMessageTruncated ? {
          cursor: "pointer"
        } : {},
        onClick: isMessageTruncated ? events.onViewDetail : null
      }, state.truncatedMessage, /*#__PURE__*/React.createElement("span", {
        style: {
          float: "right",
          clear: "right",
          marginLeft: 10
        }
      }, state.displayTime));
      return /*#__PURE__*/React.createElement(Message, _extends({}, messageProps, {
        size: "small",
        header: data.title || data.type,
        content: content,
        onDismiss: _this.onDismiss
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onViewDetail", function () {
      _this.props.onViewDetail(_this.props.event);
    });

    return _this;
  }

  _createClass(NotificationStackItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          event = _this$props.event,
          width = _this$props.width,
          margin = _this$props.margin,
          transitionAnimation = _this$props.transitionAnimation,
          transitionDuration = _this$props.transitionDuration,
          renderEvent = _this$props.renderEvent;
      var truncatedMessage = this.truncateMessage(event.message);
      var displayTime = this.getDisplayTime();

      var data = _objectSpread2({}, event);

      var state = {
        displayTime: displayTime,
        truncatedMessage: truncatedMessage
      };
      var events = {
        onDismiss: this.onDismiss,
        onViewDetail: this.onViewDetail
      };
      var renderFunc = renderEvent ? renderEvent : this.defaultRenderEvent;
      return /*#__PURE__*/React.createElement(Transition, {
        animation: transitionAnimation,
        duration: transitionDuration,
        visible: this.state.showing,
        onComplete: this.onTransitionComplete
      }, /*#__PURE__*/React.createElement(EventWrapper, {
        width: width,
        margin: margin
      }, renderFunc(data, state, events) || this.defaultRenderEvent(data, state, events)));
    }
  }]);

  return NotificationStackItem;
}(React.Component);

_defineProperty(NotificationStackItem, "propTypes", {
  event: propTypes$1.shape({
    id: propTypes$1.number,
    title: propTypes$1.string,
    message: propTypes$1.string,
    type: propTypes$1.string.isRequired,
    creation: propTypes$1.number,
    expiry: propTypes$1.number
  }),
  width: propTypes$1.number,
  margin: propTypes$1.number,
  transitionAnimation: propTypes$1.string,
  transitionDuration: propTypes$1.number,
  dismiss: propTypes$1.bool,
  onDismiss: propTypes$1.func,
  onViewDetail: propTypes$1.func,
  renderEvent: propTypes$1.func,
  maxMessageLength: propTypes$1.number.isRequired
});

_defineProperty(NotificationStackItem, "defaultProps", {
  width: 400,
  margin: 0,
  transitionAnimation: "fade",
  transitionDuration: 500
});

var _templateObject$5, _templateObject2$4, _templateObject3$3, _templateObject4$2, _templateObject5$2;
var NotificationWrapper = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  position: ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.inline ? "absolute" : "fixed";
}, function (props) {
  return (props.position === NotificationPosition.TopLeft || props.position === NotificationPosition.TopRight) && css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n      top: ", "px;\n    "])), props.indent);
}, function (props) {
  return (props.position === NotificationPosition.BottomLeft || props.position === NotificationPosition.BottomRight) && css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n      bottom: ", "px;\n    "])), props.indent);
}, function (props) {
  return (props.position === NotificationPosition.TopLeft || props.position === NotificationPosition.BottomLeft) && css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n      left: ", "px;\n    "])), props.indent);
}, function (props) {
  return (props.position === NotificationPosition.TopRight || props.position === NotificationPosition.BottomRight) && css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n      right: ", "px;\n    "])), props.indent);
});
/**
 * Displays notifications in a stacked list
 */

var NotificationStack = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationStack, _React$Component);

  var _super = _createSuper(NotificationStack);

  function NotificationStack() {
    var _this;

    _classCallCheck(this, NotificationStack);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      eventDetail: false,
      eventDismiss: false,
      dismissAll: false
    });

    _defineProperty(_assertThisInitialized(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._isMounted = true;
      _this.timer = setInterval(_this.onRefresh, 10000);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.timer);
      _this._isMounted = false;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (_this.props.dismissOnNavigation && _this.props.location !== prevProps.location) {
        _this.setState({
          dismissAll: true
        });
      }

      if (prevState.dismissAll) {
        setTimeout(function () {
          if (!_this._isMounted) return;

          _this.setState({
            dismissAll: false
          });
        }, 10);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onRefresh", function () {
      // this is a bit hacky but we need to force the render method to run
      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "onDismissEvent", function (event) {
      var _this$state = _this.state,
          eventDetail = _this$state.eventDetail,
          dismissAll = _this$state.dismissAll;

      if (eventDetail && eventDetail.id === event.id && !dismissAll) {
        _this.setState({
          eventDetail: false,
          eventDismiss: false
        });
      }

      _this.props.removeNotification(event.id);
    });

    _defineProperty(_assertThisInitialized(_this), "onDismissAll", function () {
      _this.setState({
        dismissAll: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onShowDetail", function (event) {
      _this.setState({
        eventDetail: event,
        eventDismiss: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onHideDetail", function () {
      _this.setState({
        eventDetail: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDismissDetail", function () {
      _this.setState({
        eventDismiss: true
      });
    });

    return _this;
  }

  _createClass(NotificationStack, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          position = _this$props.position,
          inline = _this$props.inline,
          indent = _this$props.indent,
          spacing = _this$props.spacing,
          width = _this$props.width,
          className = _this$props.className,
          renderEvent = _this$props.renderEvent,
          maxMessageLength = _this$props.maxMessageLength,
          showClearAll = _this$props.showClearAll;
      var _this$state2 = this.state,
          eventDetail = _this$state2.eventDetail,
          eventDismiss = _this$state2.eventDismiss,
          dismissAll = _this$state2.dismissAll;

      var events = _toConsumableArray(this.props.events);

      if (position === NotificationPosition.BottomLeft || position === NotificationPosition.BottomRight) {
        events.reverse();
      }

      var eventAnimation = position === NotificationPosition.TopLeft || position === NotificationPosition.BottomLeft ? "fade right" : "fade left";
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationWrapper, {
        position: position,
        inline: inline,
        indent: indent,
        className: classnames("cin notification-stack", className)
      }, showClearAll && /*#__PURE__*/React.createElement(Transition, {
        animation: "fade up",
        duration: 500,
        visible: !dismissAll && events && events.length >= 2
      }, /*#__PURE__*/React.createElement(Button, {
        basic: true,
        onClick: this.onDismissAll,
        className: "clear-all"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "close"
      }), "Clear all")), events.map(function (e) {
        return /*#__PURE__*/React.createElement(NotificationStackItem, {
          key: e.id,
          event: e,
          margin: spacing,
          width: width,
          transitionAnimation: eventAnimation,
          dismiss: dismissAll || (eventDetail && e.id === eventDetail.id ? eventDismiss : false),
          onDismiss: _this2.onDismissEvent,
          onViewDetail: _this2.onShowDetail,
          renderEvent: renderEvent,
          maxMessageLength: maxMessageLength
        });
      })), !!eventDetail && !eventDismiss && /*#__PURE__*/React.createElement(Modal.Confirmation, {
        open: true,
        header: eventDetail.type,
        content: eventDetail.message,
        onCancel: this.onDismissDetail,
        onSubmit: this.onHideDetail,
        cancelLabel: "Dismiss",
        submitLabel: "OK"
      }));
    }
  }]);

  return NotificationStack;
}(React.Component);

_defineProperty(NotificationStack, "propTypes", {
  /**
   * The position on screen where the notifications should be displayed
   * @typedef NotificationPosition
   * @property {string} `topLeft`
   * @property {string} `topRight`
   * @property {string} `bottomLeft`
   * @property {string} `bottomRight`
   */
  position: propTypes$1.oneOf(Object.values(NotificationPosition)),

  /**
   * Whether the stack should appear inline relative to the parent element, otherwise it will be fixed to the viewport
   */
  inline: propTypes$1.bool,

  /**
   * Indentation of the stack in pixels from the edges of the browser window
   */
  indent: propTypes$1.number,

  /**
   * Spacing in pixels between notifications in the stack
   */
  spacing: propTypes$1.number,

  /**
   * Width in pixels for notifications in the stack
   */
  width: propTypes$1.number,

  /**
   * Maximum number of characters before notification messages are truncated
   */
  maxMessageLength: propTypes$1.number,

  /**
   * Whether notifications should automatically be cleared when the navigation location changes
   */
  dismissOnNavigation: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Custom event rendering function. Return false to render the default event style
   * @param {Object} `data` Notification data
   * @param {Object} `state` Notification state
   * @param {Object} `events` Notification callback events
   */
  renderEvent: propTypes$1.func,

  /**
   * Whether a clear all link should be displayed at the top when there are 2 or more notifications
   */
  showClearAll: propTypes$1.bool
});

_defineProperty(NotificationStack, "defaultProps", {
  position: "bottomRight",
  inline: false,
  indent: 15,
  spacing: 15,
  width: 400,
  maxMessageLength: 200,
  dismissOnNavigation: true,
  showClearAll: true
});

var actions$7 = {
  removeNotification: removeNotification
};

var mapStateToProps$e = function mapStateToProps(state) {
  var _getNotificationState = getNotificationState(state),
      events = _getNotificationState.events;

  return {
    events: events
  };
};

var NotificationStack$1 = withRouter(connect$1(mapStateToProps$e, actions$7)(NotificationStack));

/**
 * A fallback message for a 404 (not found) page
 */

var NotFound = function NotFound(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement(Content, {
    padding: "large",
    className: classnames("cin not-found", className)
  }, /*#__PURE__*/React.createElement(Header, {
    as: "h2"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "warning"
  }), /*#__PURE__*/React.createElement(Header.Content, null, "404 - Not Found")));
};

NotFound.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};

/**
 * A responsive container for presenting content for a single page
 */

var PageContent = function PageContent(_ref) {
  var center = _ref.center,
      right = _ref.right,
      compact = _ref.compact,
      narrow = _ref.narrow,
      wide = _ref.wide,
      fixed = _ref.fixed,
      fluid = _ref.fluid,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["center", "right", "compact", "narrow", "wide", "fixed", "fluid", "className", "children"]);

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: classnames("cin page-content", {
      right: right,
      narrow: narrow,
      wide: wide,
      fixed: fixed,
      fluid: fluid
    }, className)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames("column", {
      compact: compact,
      center: center
    })
  }, children));
};

PageContent.propTypes = {
  /**
   * Whether content within the container should be centered, otherwise it will take the width of the container
   */
  center: propTypes$1.bool,

  /**
   * Whether content within the container should be right-aligned
   */
  right: propTypes$1.bool,

  /**
   * Removes default padding to present content in a more compact layout
   */
  compact: propTypes$1.bool,

  /**
   * Narrows the overall width of the content container
   */
  narrow: propTypes$1.bool,

  /**
   * Widens the overall width of the content container
   */
  wide: propTypes$1.bool,

  /**
   * Whether the content container should have a fixed width rather than be responsive
   */
  fixed: propTypes$1.bool,

  /**
   * Whether the content container should take up the full width of its parent
   */
  fluid: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
PageContent.defaultProps = {
  center: false,
  right: false,
  compact: false,
  narrow: false,
  wide: false,
  fixed: false,
  fluid: false
};

/**
 * Displays a heading for a page
 */

var PageHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(PageHeader, _React$Component);

  var _super = _createSuper(PageHeader);

  function PageHeader() {
    _classCallCheck(this, PageHeader);

    return _super.apply(this, arguments);
  }

  _createClass(PageHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          lookup = _this$props.lookup,
          lookupParams = _this$props.lookupParams,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["lookup", "lookupParams", "className"]);

      if (lookup) {
        return /*#__PURE__*/React.createElement(Lookup, {
          lookup: lookup,
          lookupParams: lookupParams,
          render: function render(lookupData) {
            return /*#__PURE__*/React.createElement(Header, _extends({}, props, {
              className: classnames("cin page-header", className)
            }), lookupData.response || "");
          }
        });
      }

      return /*#__PURE__*/React.createElement(Header, _extends({}, props, {
        className: classnames("cin page-header", className)
      }));
    }
  }]);

  return PageHeader;
}(React.Component);

_defineProperty(PageHeader, "propTypes", {
  /**
   * Optional, name of a lookup that has already been registered to use for the header content
   */
  lookup: propTypes$1.string,

  /**
   * Optional additional parameters to supply to the lookup's action
   */
  lookupParams: propTypes$1.any,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

/**
 * Renders a loading indicator for page content
 */

var PageLoader = function PageLoader(_ref) {
  var animate = _ref.animate,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["animate", "className"]);

  var loaderContent = /*#__PURE__*/React.createElement(Loader, _extends({
    inline: true,
    active: true,
    size: "massive"
  }, props));
  return /*#__PURE__*/React.createElement("div", {
    className: classnames("cin page-loader", className)
  }, typeof animate === "number" && animate > 0 ? /*#__PURE__*/React.createElement(Transition, {
    animation: "fade",
    duration: animate,
    transitionOnMount: true
  }, loaderContent) : loaderContent);
};

PageLoader.propTypes = {
  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Time in milliseconds for the animation transition when the component mounts, or false to disable
   */
  animate: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool])
};
PageLoader.defaultProps = {
  animate: 300
};

/**
 * A dropdown menu for page size options
 */

var PageSize = function PageSize(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      options = _ref.options,
      upward = _ref.upward,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Dropdown$1, {
    compact: true,
    selection: true,
    value: value,
    onChange: function onChange(e, d) {
      return _onChange(d.value);
    },
    options: options.map(function (o) {
      return {
        text: o,
        value: o
      };
    }),
    selectOnBlur: false,
    upward: upward,
    className: classnames("cin page-size", className)
  });
};

PageSize.propTypes = {
  /**
   * The currently selected page size
   */
  value: propTypes$1.number,

  /**
   * Event handler called when the page size is changed
   */
  onChange: propTypes$1.func,

  /**
   * Array of page size options to choose from
   */
  options: propTypes$1.arrayOf(propTypes$1.number),

  /**
   * Whether the dropdown should open upwards
   */
  upward: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
};
PageSize.defaultProps = {
  options: [5, 10, 20, 50]
};

/**
 * A set of navigation buttons for changing the page number
 */

var PageNumber = /*#__PURE__*/function (_React$Component) {
  _inherits(PageNumber, _React$Component);

  var _super = _createSuper(PageNumber);

  function PageNumber() {
    var _this;

    _classCallCheck(this, PageNumber);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onPageChange", function (e, _ref) {
      var activePage = _ref.activePage;
      return _this.props.onChange(activePage);
    });

    return _this;
  }

  _createClass(PageNumber, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          pageSize = _this$props.pageSize,
          totalItems = _this$props.totalItems,
          prevItem = _this$props.prevItem,
          nextItem = _this$props.nextItem,
          className = _this$props.className,
          otherProps = _objectWithoutProperties(_this$props, ["value", "pageSize", "totalItems", "prevItem", "nextItem", "className"]);

      var totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 0;
      return /*#__PURE__*/React.createElement(Pagination$1, _extends({}, otherProps, {
        activePage: value,
        onPageChange: this.onPageChange,
        totalPages: totalPages,
        prevItem: _objectSpread2({
          disabled: value <= 1
        }, prevItem),
        nextItem: _objectSpread2({
          disabled: value >= totalPages
        }, nextItem),
        className: classnames("cin page-number", className)
      }));
    }
  }]);

  return PageNumber;
}(React.Component);

PageNumber.propTypes = {
  /**
   * The currently selected page
   */
  value: propTypes$1.number,

  /**
   * Event handler called when the page number is changed
   */
  onChange: propTypes$1.func,

  /**
   * The currently selected page size (used to calculate the total number of pages)
   */
  pageSize: propTypes$1.number,

  /**
   * The total number of items to navigate (used to calculate the total number of pages)
   */
  totalItems: propTypes$1.number,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string,

  /**
   * Semantic UI pagination size
   */
  size: propTypes$1.string,

  /**
   * Semantic UI pagination shorthand for the first item link
   */
  firstItem: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.node]),

  /**
   * Semantic UI pagination shorthand for the last item link
   */
  lastItem: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.node]),

  /**
   * Semantic UI pagination shorthand for the previous item link
   */
  prevItem: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.node]),

  /**
   * Semantic UI pagination shorthand for the next item link
   */
  nextItem: propTypes$1.oneOfType([propTypes$1.object, propTypes$1.node])
};
PageNumber.defaultProps = {
  size: "tiny",
  firstItem: null,
  lastItem: null,
  prevItem: {
    "aria-label": "Previous item",
    content: /*#__PURE__*/React.createElement(Icon, {
      name: "angle left"
    })
  },
  nextItem: {
    "aria-label": "Next item",
    content: /*#__PURE__*/React.createElement(Icon, {
      name: "angle right"
    })
  }
};

/**
 * Combines page number and size controls to provide page navigation
 */

var Pagination = /*#__PURE__*/function (_React$Component) {
  _inherits(Pagination, _React$Component);

  var _super = _createSuper(Pagination);

  function Pagination() {
    var _this;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onNumberChange", function (pageNumber) {
      _this.props.onChange({
        pageSize: _this.props.value.pageSize,
        pageNumber: pageNumber
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSizeChange", function (pageSize) {
      // ensure page number still valid
      var _this$props = _this.props,
          value = _this$props.value,
          totalItems = _this$props.totalItems;
      var totalPages = totalItems > 0 ? Math.ceil(totalItems / pageSize) : 0;

      _this.props.onChange({
        pageSize: pageSize,
        pageNumber: Math.min(totalPages, value.pageNumber || 1)
      });
    });

    return _this;
  }

  _createClass(Pagination, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          totalItems = _this$props2.totalItems,
          sizeOptions = _this$props2.sizeOptions,
          bottom = _this$props2.bottom,
          className = _this$props2.className;
      var pageSize = value.pageSize,
          pageNumber = value.pageNumber;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames("cin pagination-controls", className)
      }, /*#__PURE__*/React.createElement(PageNumber, {
        value: pageNumber,
        onChange: this.onNumberChange,
        pageSize: pageSize,
        totalItems: totalItems
      }), /*#__PURE__*/React.createElement(PageSize, {
        value: pageSize,
        onChange: this.onSizeChange,
        options: sizeOptions,
        upward: !!bottom
      }));
    }
  }]);

  return Pagination;
}(React.Component);

_defineProperty(Pagination, "propTypes", {
  /**
   * The currently selected page size and number
   */
  value: propTypes$1.shape({
    pageSize: propTypes$1.number,
    pageNumber: propTypes$1.number
  }),

  /**
   * Event handler called when either the page size or number are changed
   */
  onChange: propTypes$1.func,

  /**
   * The total number of items to navigate (used to calculate the total number of pages)
   */
  totalItems: propTypes$1.number,

  /**
   * Array of page size options to choose from
   */
  sizeOptions: propTypes$1.arrayOf(propTypes$1.number),

  /**
   * Whether the pagination controls are located beneath their controlling data
   */
  bottom: propTypes$1.bool,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

/**
 * Automatically updates responsive state on window resizing
 */

var ResponsiveScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(ResponsiveScreen, _React$Component);

  var _super = _createSuper(ResponsiveScreen);

  function ResponsiveScreen(props) {
    var _this;

    _classCallCheck(this, ResponsiveScreen);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onWindowResize", function () {
      var updateScreenSize = _this.props.updateScreenSize;
      updateScreenSize(window.innerWidth);
    });

    _defineProperty(_assertThisInitialized(_this), "shouldComponentUpdate", function () {
      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      return null;
    });

    _this.onWindowResize();

    window.addEventListener("resize", debounce(_this.onWindowResize, _this.props.debounce));
    return _this;
  }

  _createClass(ResponsiveScreen, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.onWindowResize);
    }
  }]);

  return ResponsiveScreen;
}(React.Component);

_defineProperty(ResponsiveScreen, "propTypes", {
  /**
   * Time in milliseconds for window resize events to be debounced, to avoid rapid state changes
   */
  debounce: propTypes$1.number
});

_defineProperty(ResponsiveScreen, "defaultProps", {
  debounce: 100
});

var actions$8 = {
  updateScreenSize: updateScreenSize
};
var ResponsiveScreen$1 = connect$1(null, actions$8)(ResponsiveScreen);

/**
 * Wrapper component that will only render its children when a responsive screen size is met
 */

var ScreenCheck = function ScreenCheck(_ref) {
  var size = _ref.size,
      screenSize = _ref.screenSize,
      screenConfig = _ref.screenConfig,
      renderAlt = _ref.renderAlt,
      children = _ref.children;
  var matchSizes = Array.isArray(size) ? size : [size];
  var valid = matchSizes.includes(screenSize);

  if (!valid) {
    return renderAlt ? renderAlt() : null;
  }

  if (typeof children === "function") {
    return children(screenSize, screenConfig);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

ScreenCheck.propTypes = {
  /**
   * The screen size to match, or an array of possible sizes to match
   */
  size: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.arrayOf(propTypes$1.string)]).isRequired,

  /**
   * Optional render function when the screen size does not match
   */
  renderAlt: propTypes$1.func,

  /**
   * Children that will be rendered when the screen check matches, or a render function that will be passed the following parameters:
   * @param {string} `screenSize` Screen size name
   * @param {Object} `screenConfig` Screen size configuration object
   */
  children: propTypes$1.any
};

var mapStateToProps$f = function mapStateToProps(state) {
  var _getResponsiveScreen = getResponsiveScreen(state),
      screenSize = _getResponsiveScreen.screenSize,
      screenConfig = _getResponsiveScreen.screenConfig;

  return {
    screenSize: screenSize,
    screenConfig: screenConfig
  };
};

var ScreenCheck$1 = connect$1(mapStateToProps$f)(ScreenCheck);

/**
 * Higher-order component to make components responsive
 * @param {React.Component} `Component` Component to wrap
 * @returns {React.Component} Component with additional props for the current screen state/config
 */

var withResponsive = function withResponsive(Component) {
  var mapStateToProps = function mapStateToProps(state) {
    var _getResponsiveScreen = getResponsiveScreen(state),
        screenSize = _getResponsiveScreen.screenSize,
        screenConfig = _getResponsiveScreen.screenConfig;

    return {
      screenSize: screenSize,
      screenConfig: screenConfig
    };
  };

  return connect$1(mapStateToProps, function () {
    return {};
  })(Component);
};

/**
 * Renders a single tile
 */

var Tile = /*#__PURE__*/function (_React$Component) {
  _inherits(Tile, _React$Component);

  var _super = _createSuper(Tile);

  function Tile() {
    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      mouseOver: false
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      _this.setState({
        mouseOver: true
      });

      if (_this.props.onMouseEnter) _this.props.onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        mouseOver: false
      });

      if (_this.props.onMouseLeave) _this.props.onMouseLeave(e);
    });

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          animate = _this$props.animate,
          link = _this$props.link,
          center = _this$props.center,
          selectable = _this$props.selectable,
          className = _this$props.className,
          children = _this$props.children,
          otherProps = _objectWithoutProperties(_this$props, ["animate", "link", "center", "selectable", "className", "children"]);

      var hover = this.state.mouseOver;
      var output = typeof children === "function" ? children({
        hover: hover
      }) : children;

      var tileProps = _objectSpread2(_objectSpread2({}, otherProps), {}, {
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: classnames("cin tile", {
          center: center,
          selectable: selectable
        }, className),
        children: output
      });

      var tileContent = link ? /*#__PURE__*/React.createElement(Link, _extends({}, tileProps, {
        to: link
      })) : /*#__PURE__*/React.createElement("div", tileProps);

      if (typeof animate === "number" && animate > 0) {
        return /*#__PURE__*/React.createElement(Transition, {
          animation: "fade",
          duration: animate,
          transitionOnMount: true
        }, tileContent);
      }

      return tileContent;
    }
  }]);

  return Tile;
}(React.Component);

_defineProperty(Tile, "propTypes", {
  /**
   * Time in milliseconds for tile animation transitions, or false to disable
   */
  animate: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.bool]),

  /**
   * Whether content within the tile should be centered
   */
  center: propTypes$1.bool,

  /**
   * Whether a tile should appear selectable
   */
  selectable: propTypes$1.bool,

  /**
   * Optional, turns the tile into a link to the specified path
   * Can be a path string or a React Router Link object:
   * @property {string} `pathname` The path to link to
   * @property {string} `search` Query parameters to append
   * @property {string} `hash` Hash string to append
   * @property {*} `state` State to persist in the location
   */
  link: propTypes$1.oneOfType([propTypes$1.string, propTypes$1.shape({
    pathname: propTypes$1.string
  })]),

  /**
   * Called when the tile is clicked on
   */
  onClick: propTypes$1.func,

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(Tile, "defaultProps", {
  animate: 400,
  center: false,
  selectable: false
});

var TileSize = {
  Small: "small",
  Medium: "medium",
  Large: "large"
};
var TilePadding = {
  None: "none",
  Medium: "medium",
  Large: "large"
};

var _templateObject$6, _templateObject2$5, _templateObject3$4;

var breakpointsCss = function breakpointsCss(breakpoints) {
  return breakpoints.map(function (bp, index) {
    var minWidth = bp;
    var flexBasis = 100 / (index + 2);
    return css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n      &&& > .cell {\n        @media (min-width: ", "px) {\n          flex-basis: ", "%;\n        }\n      }\n    "])), minWidth, flexBasis);
  });
};

var TileContainer = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return !!props.breakpoints && props.breakpoints.length > 0 && css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n      ", "\n    "])), breakpointsCss(props.breakpoints));
});
/**
 * A responsive grid of tiles
 */

var TileGrid = /*#__PURE__*/function (_React$Component) {
  _inherits(TileGrid, _React$Component);

  var _super = _createSuper(TileGrid);

  function TileGrid() {
    var _this;

    _classCallCheck(this, TileGrid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_keyWarning", false);

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.data !== _this.props.data || prevProps.dataKey !== _this.props.dataKey) {
        _this._keyWarning = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getItemKey", function (item) {
      var dataKey = _this.props.dataKey;
      var key = item[dataKey];

      if (!key && !_this._keyWarning) {
        console.warn("TileGrid dataKey is invalid");
        _this._keyWarning = true;
      }

      return key;
    });

    return _this;
  }

  _createClass(TileGrid, [{
    key: "renderError",
    value: function renderError() {
      var error = this.props.error;
      if (!error) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      }));
    }
  }, {
    key: "renderTiles",
    value: function renderTiles() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          loading = _this$props.loading,
          slowLoading = _this$props.slowLoading,
          emptyMessage = _this$props.emptyMessage,
          size = _this$props.size,
          padding = _this$props.padding,
          Component = _this$props.component,
          render = _this$props.render;
      var showLoading = loading && (slowLoading || slowLoading === undefined || !data || data.length === 0);

      if (showLoading) {
        return /*#__PURE__*/React.createElement(Loader, {
          size: "large",
          active: true,
          inline: true,
          className: "content"
        });
      }

      if (!data) return this.renderError();

      if (data.length === 0) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
          className: "content"
        }, emptyMessage), this.renderError());
      }

      return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(function (item, itemIndex) {
        var itemKey = _this2.getItemKey(item) || itemIndex;
        var tileState = {
          itemKey: itemKey,
          itemIndex: itemIndex
        };
        return /*#__PURE__*/React.createElement("div", {
          key: itemKey,
          className: classnames("cell", size, {
            "no-padding": padding === TilePadding.None,
            padded: padding === TilePadding.Large
          })
        }, render ? render(item, tileState) : Component ? /*#__PURE__*/React.createElement(Component, _extends({
          item: item
        }, tileState)) : null);
      }), this.renderError());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wide = _this$props2.wide,
          breakpoints = _this$props2.breakpoints,
          className = _this$props2.className;
      return /*#__PURE__*/React.createElement(TileContainer, {
        breakpoints: breakpoints,
        className: classnames("cin tile-grid", {
          wide: wide,
          "custom-breakpoints": !!breakpoints && breakpoints.length > 0
        }, className)
      }, this.renderTiles());
    }
  }]);

  return TileGrid;
}(React.Component);

_defineProperty(TileGrid, "propTypes", {
  /**
   * Array of tile data
   */
  data: propTypes$1.arrayOf(propTypes$1.object),

  /**
   * Property name for unique key in data, defaults to "key"
   */
  dataKey: propTypes$1.string,

  /**
   * Indicates the tile grid is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the tile grid is taking a long time to load (a loading indicator will appear)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Error message to display within the tile grid when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Message to display if the data contains no items
   */
  emptyMessage: propTypes$1.string,

  /**
   * Component to use to render each tile, receives the following props:
   * @property {object} `item` The current item being rendered
   * @property {*} `itemKey` Unique key value for tile item
   * @property {number} `itemIndex` Index of the tile item
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function to use to render each tile
   * @param {object} `item` The current item being rendered
   * @param {object} `state` An object representing the current state
   * @param {*} `state.itemKey` Unique key value for tile item
   * @param {number} `state.itemIndex` Index of the tile item
   */
  render: propTypes$1.func,

  /**
   * The size of the tiles to be rendered
   * Will be ignored if manually specifying breakpoints
   * @typedef TileSize
   * @property {string} `small`
   * @property {string} `medium`
   * @property {string} `large`
   */
  size: propTypes$1.oneOf(Object.values(TileSize)),

  /**
   * The padding size surrounding the tiles to be rendered
   * @typedef TilePadding
   * @property {string} `none`
   * @property {string} `medium`
   * @property {string} `large`
   */
  padding: propTypes$1.oneOf(Object.values(TilePadding)),

  /**
   * Whether tiles should have additional responsive constraints for wider screen layouts.
   * When set to true, more tiles will be visible on larger screens.
   * (Optimised for use with 'wide' PageContent components).
   * Will be ignored if manually specifying breakpoints
   */
  wide: propTypes$1.bool,

  /**
   * Optional, array of screen breakpoints to manually define points at which tiles will wrap onto a new row
   * e.g. [500, 750, 1000] will result in 2 tiles above 500px, 3 tiles above 750px, and 4 tiles above 1000px
   * When specified, the size and wide props will both be ignored
   */
  breakpoints: propTypes$1.arrayOf(propTypes$1.number),

  /**
   * Additional classes for styling
   */
  className: propTypes$1.string
});

_defineProperty(TileGrid, "defaultProps", {
  dataKey: "key",
  emptyMessage: "No Results",
  size: "medium",
  padding: "medium",
  wide: false
});

var WizardContext = /*#__PURE__*/React.createContext({
  activeStep: undefined
});

/**
 * Allows integration with navigation state for a wizard
 */

var WizardNav = function WizardNav(_ref) {
  var Component = _ref.component,
      render = _ref.render;
  return /*#__PURE__*/React.createElement(WizardContext.Consumer, null, function (props) {
    return Component ? /*#__PURE__*/React.createElement(Component, props) : render ? render(props) : null;
  });
};

WizardNav.propTypes = {
  /**
   * Component to be rendered, receives the following props:
   * @property {Array} `steps`
   * @property {string} `stepKey`
   * @property {Object} `activeStep`
   * @property {number} `activeStepIndex`
   * @property {boolean} `hasNextStep`
   * @property {boolean} `hasPreviousStep`
   * @property {function} `hasStep`
   * @property {function} `onGoToNextStep`
   * @property {function} `onGoToPreviousStep`
   * @property {function} `onGoToStep`
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function
   * @param {Object} `wizardContext` State and event context supplied by the parent Wizard component
   * @param {Array} `wizardContext.steps`
   * @param {string} `wizardContext.stepKey`
   * @param {Object} `wizardContext.activeStep`
   * @param {number} `wizardContext.activeStepIndex`
   * @param {boolean} `wizardContext.hasNextStep`
   * @param {boolean} `wizardContext.hasPreviousStep`
   * @param {function} `wizardContext.hasStep`
   * @param {function} `wizardContext.onGoToNextStep`
   * @param {function} `wizardContext.onGoToPreviousStep`
   * @param {function} `wizardContext.onGoToStep`
   */
  render: propTypes$1.func
};

var ActiveWizardStep = /*#__PURE__*/function (_React$Component) {
  _inherits(ActiveWizardStep, _React$Component);

  var _super = _createSuper(ActiveWizardStep);

  function ActiveWizardStep() {
    var _this;

    _classCallCheck(this, ActiveWizardStep);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_hasLoaded", false);

    return _this;
  }

  _createClass(ActiveWizardStep, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onActivate = _this$props.onActivate,
          onLoad = _this$props.onLoad,
          context = _this$props.context;
      var active = context.active,
          stepIndex = context.stepIndex,
          step = context.step;
      if (onActivate && active) onActivate(stepIndex, step);

      if (onLoad && active) {
        this._hasLoaded = true;
        onLoad(stepIndex, step);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          onDeactivate = _this$props2.onDeactivate,
          context = _this$props2.context;
      var active = context.active,
          stepIndex = context.stepIndex,
          step = context.step;
      if (onDeactivate && active) onDeactivate(stepIndex, step);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          onActivate = _this$props3.onActivate,
          onDeactivate = _this$props3.onDeactivate,
          onLoad = _this$props3.onLoad,
          context = _this$props3.context;
      var active = context.active,
          stepIndex = context.stepIndex,
          step = context.step;

      if (active && !prevProps.context.active) {
        if (onActivate) onActivate(stepIndex, step);

        if (onLoad && !this._hasLoaded) {
          this._hasLoaded = true;
          onLoad(stepIndex, step);
        }
      } else if (!active && prevProps.context.active) {
        if (onDeactivate) onDeactivate(stepIndex, step);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          Component = _this$props4.component,
          render = _this$props4.render,
          error = _this$props4.error,
          loading = _this$props4.loading,
          slowLoading = _this$props4.slowLoading,
          nextLoading = _this$props4.nextLoading,
          onNext = _this$props4.onNext,
          previousLoading = _this$props4.previousLoading,
          onPrevious = _this$props4.onPrevious,
          passThruProps = _this$props4.passThruProps,
          context = _this$props4.context;
      var active = context.active,
          step = context.step,
          stepIndex = context.stepIndex,
          hasNextStep = context.hasNextStep,
          hasPreviousStep = context.hasPreviousStep,
          hasStep = context.hasStep,
          onGoToNextStep = context.onGoToNextStep,
          onGoToPreviousStep = context.onGoToPreviousStep,
          onGoToStep = context.onGoToStep;
      if (!active) return null;
      var showLoading = loading && (slowLoading || slowLoading === undefined);

      var stepProps = _objectSpread2(_objectSpread2({}, passThruProps), {}, {
        step: step,
        stepIndex: stepIndex,
        hasNextStep: hasNextStep || onNext,
        hasPreviousStep: hasPreviousStep || onPrevious,
        onNextStep: function () {
          var _onNextStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var stepIndexOrKey,
                ready,
                _args = arguments;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    stepIndexOrKey = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;

                    if (!onNext) {
                      _context.next = 7;
                      break;
                    }

                    _context.next = 4;
                    return onNext(stepIndex, step);

                  case 4:
                    ready = _context.sent;

                    if (!(ready === false)) {
                      _context.next = 7;
                      break;
                    }

                    return _context.abrupt("return");

                  case 7:
                    if (stepIndexOrKey !== null && hasStep(stepIndexOrKey)) {
                      onGoToStep(stepIndexOrKey);
                    } else if (hasNextStep) {
                      onGoToNextStep();
                    }

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function onNextStep() {
            return _onNextStep.apply(this, arguments);
          }

          return onNextStep;
        }(),
        onPreviousStep: function () {
          var _onPreviousStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
            var stepIndexOrKey,
                ready,
                _args2 = arguments;
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    stepIndexOrKey = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;

                    if (!onPrevious) {
                      _context2.next = 7;
                      break;
                    }

                    _context2.next = 4;
                    return onPrevious(stepIndex, step);

                  case 4:
                    ready = _context2.sent;

                    if (!(ready === false)) {
                      _context2.next = 7;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 7:
                    if (stepIndexOrKey !== null && hasStep(stepIndexOrKey)) {
                      onGoToStep(stepIndexOrKey);
                    } else if (hasPreviousStep) {
                      onGoToPreviousStep();
                    }

                  case 8:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function onPreviousStep() {
            return _onPreviousStep.apply(this, arguments);
          }

          return onPreviousStep;
        }(),
        loadingNextStep: nextLoading,
        loadingPreviousStep: previousLoading
      });

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dimmer, {
        active: showLoading,
        inverted: true
      }, /*#__PURE__*/React.createElement(Loader, {
        inverted: true
      })), Component ? /*#__PURE__*/React.createElement(Component, stepProps) : render ? render(stepProps) : null, /*#__PURE__*/React.createElement(ErrorMessage, {
        error: error
      }));
    }
  }]);

  return ActiveWizardStep;
}(React.Component);
/**
 * Allows integration with a single step of a wizard
 */


var WizardStep = function WizardStep(_ref) {
  var step = _ref.step,
      props = _objectWithoutProperties(_ref, ["step"]);

  return /*#__PURE__*/React.createElement(WizardContext.Consumer, null, function (_ref2) {
    var activeStep = _ref2.activeStep,
        activeStepIndex = _ref2.activeStepIndex,
        steps = _ref2.steps,
        stepKey = _ref2.stepKey,
        otherValues = _objectWithoutProperties(_ref2, ["activeStep", "activeStepIndex", "steps", "stepKey"]);

    var isActive = activeStep && (activeStepIndex === step || activeStep[stepKey] === step);
    var thisStepIndex = steps.findIndex(function (s, i) {
      return i === step || s[stepKey] === step;
    });
    var thisStep = thisStepIndex >= 0 ? steps[thisStepIndex] : undefined;

    var context = _objectSpread2(_objectSpread2({}, otherValues), {}, {
      active: isActive,
      step: thisStep,
      stepIndex: thisStepIndex
    });

    return /*#__PURE__*/React.createElement(ActiveWizardStep, _extends({}, props, {
      context: context
    }));
  });
};

WizardStep.propTypes = {
  /**
   * Index or key name of this step
   */
  step: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * Component to be rendered, receives the following props:
   * @property {Object} `step`
   * @property {number} `stepIndex`
   * @property {boolean} `hasNextStep`
   * @property {boolean} `hasPreviousStep`
   * @property {function} `onNextStep`
   * @property {function} `onPreviousStep`
   * @property {boolean} `loadingNextStep`
   * @property {boolean} `loadingPreviousStep`
   */
  component: propTypes$1.elementType,

  /**
   * Optional render function
   * @param {Object} `wizardContext` State and event context supplied by the parent Wizard component
   * @param {Object} `wizardContext.step`
   * @param {number} `wizardContext.stepIndex`
   * @param {boolean} `wizardContext.hasNextStep`
   * @param {boolean} `wizardContext.hasPreviousStep`
   * @param {function} `wizardContext.onNextStep`
   * @param {function} `wizardContext.onPreviousStep`
   * @param {boolean} `wizardContext.loadingNextStep`
   * @param {boolean} `wizardContext.loadingPreviousStep`
   */
  render: propTypes$1.func,

  /**
   * Error message to display within the step when something has gone wrong
   */
  error: propTypes$1.any,

  /**
   * Indicates the step is busy loading data
   */
  loading: propTypes$1.bool,

  /**
   * Indicates the step is taking a long time to load (a loading indicator will appear)
   */
  slowLoading: propTypes$1.bool,

  /**
   * Callback function when this step has been activated for the first time
   * @param {number} `stepIndex` The step index
   * @param {Object} `step` The step object
   */
  onLoad: propTypes$1.func,

  /**
   * Callback function when this step is made active
   * @param {number} `stepIndex` The step index
   * @param {Object} `step` The step object
   */
  onActivate: propTypes$1.func,

  /**
   * Callback function when this step is being made inactive
   * @param {number} `stepIndex` The step index
   * @param {Object} `step` The step object
   */
  onDeactivate: propTypes$1.func,

  /**
   * Whether moving to the next step is busy loading
   */
  nextLoading: propTypes$1.bool,

  /**
   * Callback function when a transition to the next step is requested
   * @param {number} `stepIndex` The step index
   * @param {Object} `step` The step object
   */
  onNext: propTypes$1.func,

  /**
   * Whether moving to the previous step is busy loading
   */
  previousLoading: propTypes$1.bool,

  /**
   * Callback function when a transition to the previous step is requested
   * @param {number} `stepIndex` The step index
   * @param {Object} `step` The step object
   */
  onPrevious: propTypes$1.func
};

/**
 * A multi-step wizard for interactive workflows
 */

var Wizard = /*#__PURE__*/function (_React$Component) {
  _inherits(Wizard, _React$Component);

  var _super = _createSuper(Wizard);

  function Wizard(_props) {
    var _this;

    _classCallCheck(this, Wizard);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "findStepIndex", function (steps, stepIndexOrKey) {
      var stepKey = _this.props.stepKey;
      var index = -1;

      if (typeof stepIndexOrKey === "number") {
        index = stepIndexOrKey >= 0 && stepIndexOrKey < steps.length ? stepIndexOrKey : -1;
      } else {
        index = steps.findIndex(function (s) {
          return s[stepKey] === stepIndexOrKey;
        });
      }

      return index;
    });

    _defineProperty(_assertThisInitialized(_this), "hasStep", function (stepIndexOrKey) {
      var steps = _this.props.steps;
      return _this.findStepIndex(steps, stepIndexOrKey) >= 0;
    });

    _defineProperty(_assertThisInitialized(_this), "activeStepIndex", function () {
      var _this$props = _this.props,
          steps = _this$props.steps,
          step = _this$props.step;

      if (step !== undefined) {
        return _this.findStepIndex(steps, step);
      }

      return _this.state.stepIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "defaultState", function (props) {
      var stepIndex = _this.findStepIndex(props.steps, props.defaultStep);

      return {
        stepIndex: stepIndex
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onGoToNextStep", function () {
      var _this$props2 = _this.props,
          steps = _this$props2.steps,
          onStepChange = _this$props2.onStepChange;

      var stepIndex = _this.activeStepIndex();

      if (stepIndex < 0) return;

      var nextIndex = _this.findStepIndex(steps, stepIndex + 1);

      if (nextIndex >= 0) {
        _this.setState({
          stepIndex: nextIndex
        });

        if (onStepChange) onStepChange(nextIndex, stepIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGoToPreviousStep", function () {
      var _this$props3 = _this.props,
          steps = _this$props3.steps,
          onStepChange = _this$props3.onStepChange;

      var stepIndex = _this.activeStepIndex();

      if (stepIndex < 0) return;

      var prevIndex = _this.findStepIndex(steps, stepIndex - 1);

      if (prevIndex >= 0) {
        _this.setState({
          stepIndex: prevIndex
        });

        if (onStepChange) onStepChange(prevIndex, stepIndex);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGoToStep", function (stepIndexOrKey) {
      var _this$props4 = _this.props,
          steps = _this$props4.steps,
          onStepChange = _this$props4.onStepChange;

      var stepIndex = _this.activeStepIndex();

      var targetIndex = _this.findStepIndex(steps, stepIndexOrKey);

      if (targetIndex >= 0) {
        _this.setState({
          stepIndex: targetIndex
        });

        if (onStepChange) onStepChange(targetIndex, stepIndex);
      }
    });

    _this.state = _this.defaultState(_props);
    return _this;
  }

  _createClass(Wizard, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
          steps = _this$props5.steps,
          defaultStep = _this$props5.defaultStep;

      if (steps.length !== prevProps.steps.length) {
        // re-validate internal step index if number of steps changed
        var stepIndex = this.state.stepIndex;
        var newStepIndex = this.findStepIndex(steps, stepIndex === -1 ? defaultStep : stepIndex);
        this.setState({
          stepIndex: newStepIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          steps = _this$props6.steps,
          stepKey = _this$props6.stepKey;
      var stepIndex = this.activeStepIndex();
      if (stepIndex < 0 || stepIndex >= steps.length) return null;
      var activeStep = steps[stepIndex];
      var context = {
        steps: steps,
        stepKey: stepKey,
        activeStep: activeStep,
        activeStepIndex: stepIndex,
        hasNextStep: stepIndex < steps.length - 1,
        hasPreviousStep: stepIndex > 0,
        hasStep: this.hasStep,
        onGoToNextStep: this.onGoToNextStep,
        onGoToPreviousStep: this.onGoToPreviousStep,
        onGoToStep: this.onGoToStep
      };
      return /*#__PURE__*/React.createElement(WizardContext.Provider, {
        value: context
      }, children);
    }
  }]);

  return Wizard;
}(React.Component);

_defineProperty(Wizard, "propTypes", {
  /**
   * Array of objects representing each step in the workflow
   */
  steps: propTypes$1.arrayOf(propTypes$1.object),

  /**
   * Optional, name of unique key property in step objects.
   * Can be used to allow steps to be navigated by key name.
   * If key does not exist, steps can still be navigated by index.
   */
  stepKey: propTypes$1.string,

  /**
   * Index or key name of initial step, when used as an 'uncontrolled' wizard.
   * By default the wizard will manage the current step internally.
   */
  defaultStep: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * Index or key name of current step, when supplied the wizard will act as a 'controlled' component.
   * Use in combination with the onStepChange prop.
   */
  step: propTypes$1.oneOfType([propTypes$1.number, propTypes$1.string]),

  /**
   * Callback function when the current step has changed
   * @param {number} `newStepIndex` The new step index
   * @param {number} `previousStepIndex` The previous step index
   */
  onStepChange: propTypes$1.func
});

_defineProperty(Wizard, "defaultProps", {
  stepKey: "key",
  defaultStep: 0
});

Wizard.Nav = WizardNav;
Wizard.Step = WizardStep;

/**
 * Configures and enables logging for Sentry
 * @param {string} `dataSourceName` Sentry data source name
 */

var enableSentryLogger = function enableSentryLogger(dataSourceName) {
  return addLogger( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var module;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import(
            /* webpackChunkName: "sentry" */
            './sentry-24f15b4e.js');

          case 2:
            module = _context.sent;

            if (!(!module || typeof module.default !== "function")) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", null);

          case 5:
            return _context.abrupt("return", module.default(_objectSpread2(_objectSpread2({}, getLoggingOptions()), {}, {
              dataSourceName: dataSourceName
            })));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
};
/**
 * Configures and enables logging for Segment
 * @param {string} `apiKey` Segment API key
 */

var enableSegmentLogger = function enableSegmentLogger(apiKey) {
  return addLogger( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var module;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import(
            /* webpackChunkName: "segment" */
            './segment-67c43e8b.js');

          case 2:
            module = _context2.sent;

            if (!(!module || typeof module.default !== "function")) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", null);

          case 5:
            return _context2.abrupt("return", module.default(_objectSpread2(_objectSpread2({}, getLoggingOptions()), {}, {
              apiKey: apiKey
            })));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
};
/**
 * Configures and enables logging for Hotjar
 * @param {string} `siteId` Hotjar site ID
 */

var enableHotjarLogger = function enableHotjarLogger(siteId) {
  return addLogger( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var module;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return import(
            /* webpackChunkName: "hotjar" */
            './hotjar-4caa32e1.js');

          case 2:
            module = _context3.sent;

            if (!(!module || typeof module.default !== "function")) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt("return", null);

          case 5:
            return _context3.abrupt("return", module.default(_objectSpread2(_objectSpread2({}, getLoggingOptions()), {}, {
              siteId: siteId
            })));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  })));
};
/**
 * Configures and enables logging for Google Analytics
 * @param {string} `propertyId` Google Analytics Tracking ID
 */

var enableGoogleAnalyticsLogger = function enableGoogleAnalyticsLogger(propertyId) {
  return addLogger( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var module;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return import(
            /* webpackChunkName: "analytics" */
            './analytics-6cab71db.js');

          case 2:
            module = _context4.sent;

            if (!(!module || typeof module.default !== "function")) {
              _context4.next = 5;
              break;
            }

            return _context4.abrupt("return", null);

          case 5:
            return _context4.abrupt("return", module.default(_objectSpread2(_objectSpread2({}, getLoggingOptions()), {}, {
              propertyId: propertyId
            })));

          case 6:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  })));
};

// core configuration and re-export
setDefaultBuilderLoadable(Loadable);
setDefaultAuthLoadable(Loadable);
setTokenStoreProvider(WebTokenStoreProvider);

export { addLogger as $, ADD as A, ListBuilder as B, ClaimCheck as C, DebounceMap as D, EventType as E, FieldTrigger as F, ListBuilderResetStateType as G, Lookup as H, utils$1 as I, MockArrayData as J, ModalBuilder as K, LoggerType as L, MOCK_REQUEST as M, ModuleConfig as N, ModuleIntegration as O, ModuleIntegrationPipeline as P, PreferenceLoader as Q, PreferenceSaver as R, PropagateUpdatesMethod as S, REMOVE as T, REMOVE_ALL as U, ScreenSize as V, TriggerAction as W, TriggerBuilder as X, TriggerEvent as Y, WizardBuilder as Z, WizardBuilderStep as _, commonjsGlobal$1 as a, lookupExists as a$, addNotification as a0, ajaxActionsFor as a1, apiDelete as a2, apiGet as a3, apiPatch as a4, apiPost as a5, apiPut as a6, apiRequest as a7, apiRequests as a8, authenticate as a9, getDefaultReducers as aA, getJwtOptions as aB, getLoggingOptions as aC, getLookupCache as aD, getLookupData as aE, getLookupState as aF, getNotificationState as aG, getParamsKey as aH, getPreferenceDefaults as aI, getPreferenceOptions as aJ, getPreferenceSource as aK, getPreferenceState as aL, getPreferenceValue as aM, getResponsiveOptions as aN, getResponsiveScreen as aO, getResponsiveState as aP, getTokenStoreProvider as aQ, isAjaxAbort as aR, isAjaxError as aS, isAjaxReset as aT, isAjaxSlow as aU, isAjaxStart as aV, isAjaxSuccess as aW, loadPreferences as aX, logError as aY, logNavigation as aZ, loggerExists as a_, clearUserIdentity as aa, compareParams as ab, concurrentPromise as ac, connectForm as ad, createAutoName as ae, createDefaultReduxStore as af, createReduxStore as ag, createTypedConnect as ah, deauthenticate as ai, debounce as aj, enableCustomAuth as ak, enableCustomLogger as al, enableJwtAuth as am, enablePreferencesFromApi as an, enablePreferencesFromLocalStorage as ao, findLookup as ap, getApiOptions as aq, getAuthClaim as ar, getAuthClaims as as, getAuthIntegrations as at, getAuthOptions as au, getAuthRefreshToken as av, getAuthState as aw, getDefaultAuthLoadable as ax, getDefaultBuilderLoadable as ay, getDefaultMiddleware as az, AJAX_ABORT as b, withForm as b$, lookupRequest as b0, lookupReset as b1, lookupSet as b2, mockError as b3, mockRequest as b4, mockSuccess as b5, notifyError as b6, notifyInfo as b7, notifySuccess as b8, notifyWarning as b9, setUserIdentity as bA, unregisterLookup as bB, updatePreference as bC, updateReducers as bD, updateScreenSize as bE, useApiAction as bF, useApiDelete as bG, useApiGet as bH, useApiPatch as bI, useApiPost as bJ, useApiPut as bK, useApiRequest as bL, useAuthClaims as bM, useAuthState as bN, useCustomAuth as bO, useFormEffect as bP, useFormField as bQ, useFormState as bR, useJwtAuth as bS, useLoggedIn as bT, useLookup as bU, useLookupAction as bV, usePreferenceValue as bW, usePreferences as bX, usePreferencesFromApi as bY, usePreferencesFromLocalStorage as bZ, useResponsive as b_, refreshJwt$1 as ba, registerLookup as bb, removeAllNotifications as bc, removeNotification as bd, requestAbortedAt as be, requestError as bf, requestErrorHasCode as bg, requestIsAborted as bh, requestIsBusy as bi, requestIsSlow as bj, requestIsSuccess as bk, requestReceivedAt as bl, requestResponse as bm, requestSentAt as bn, requestStatus as bo, resetPreferences as bp, savePreferences as bq, setApiOptions as br, setAuthOptions as bs, setDefaultAuthLoadable as bt, setDefaultBuilderLoadable as bu, setJwtOptions as bv, setLoggingOptions as bw, setPreferenceDefaults as bx, setResponsiveOptions as by, setTokenStoreProvider as bz, createCommonjsModule$1 as c, Breadcrumb as c$, withFormArray as c0, withFormObject as c1, withLookup as c2, ErrorMessage as c3, AuthenticatedSwitch$1 as c4, PrivateRoute$1 as c5, PublicRoute$1 as c6, ActionButton as c7, DataList as c8, DataListItem as c9, MenuBar as cA, MenuBarSpace as cB, NavSidebar$1 as cC, SideColumn as cD, SidePanel as cE, NavigationLogger$1 as cF, PageLogger$1 as cG, LookupDropdown$1 as cH, LookupTypeAhead$1 as cI, ActionMenu as cJ, ActionMenuDivider as cK, ActionMenuHeader as cL, ActionMenuItem as cM, TabMenu as cN, TabMenuItem$1 as cO, NavMenu as cP, NavMenuDivider as cQ, NavMenuHeader as cR, NavMenuFooter as cS, NavMenuItem as cT, Modal as cU, AddModal as cV, DeleteModal as cW, EditModal as cX, ConfirmationModal as cY, InformationModal as cZ, UploadModal as c_, Loadable as ca, TreeView as cb, DateTimeInstant$1 as cc, DateInstant$1 as cd, DateTimeLocal as ce, DateLocal as cf, TimeLocal as cg, Format as ch, DateFormatter as ci, DateTimeFormatter as cj, TimeFormatter as ck, NumberFormatter$1 as cl, index$2 as cm, index$3 as cn, index$4 as co, index$5 as cp, Form as cq, Field as cr, FieldClearer as cs, FieldError as ct, FieldGroup as cu, ActionBar as cv, ActionBarItem as cw, ActionBarSpace as cx, Content as cy, HorizontalLine as cz, AJAX_ERROR as d, BreadcrumbItem$1 as d0, NotificationStack$1 as d1, NotFound as d2, PageContent as d3, PageHeader as d4, PageLoader as d5, PageSize as d6, PageNumber as d7, Pagination as d8, ResponsiveScreen$1 as d9, enableSentryLogger as dA, ScreenCheck$1 as da, withResponsive as db, Table as dc, TableContext as dd, TableColumn as de, SelectableColumn as df, ActionCell as dg, MenuCell as dh, MenuCellItem as di, TableRow as dj, HeaderRow as dk, FooterRow as dl, ExpandedRow as dm, Tile as dn, TileGrid as dp, Wizard as dq, WizardNav as dr, WizardStep as ds, WebTokenStoreProvider as dt, getTokenStorageMethod as du, setTokenStorageMethod as dv, TokenStorageMethod as dw, enableGoogleAnalyticsLogger as dx, enableHotjarLogger as dy, enableSegmentLogger as dz, AJAX_RESET as e, AJAX_SLOW as f, AJAX_START as g, AJAX_SUCCESS as h, API_REQUEST as i, AddMethod as j, ApiError as k, ApiRequestMethod as l, ApiRequestsErrorPriority as m, actions as n, events as o, AuthIntegrationAction as p, AuthIntegrationEvent as q, AuthenticatedApp as r, ConcurrentPromiseMap as s, ContentBuilder as t, FormBuilder as u, FormBuilderResetStateType as v, FormContext as w, utils as x, index$1 as y, index as z };
